(function () {
  var root = document.querySelector('[data-order-app-shell]');
  var bootstrapEl = document.getElementById('StackhouseOrderBootstrap');

  if (!root || !bootstrapEl) {
    return;
  }

  var bootstrap = {};

  try {
    bootstrap = JSON.parse(bootstrapEl.textContent || '{}');
  } catch (error) {
    console.error('Unable to parse Stackhouse order bootstrap data.', error);
  }

  var PRODUCT_ALIASES = {
    'gallery-wrapped-prints': 'gallery-wrapped-canvas-prints',
    'photo-prints': 'professional-photo-prints',
    'loose-canvas-prints': 'rolled-canvas-prints'
  };
  var GENERATED_PRODUCT_HANDLES = {
    'giclee-fine-art-prints': true,
    'professional-photo-prints': true,
    'rolled-canvas-prints': true,
    'mounted-prints': true,
    'gallery-wrapped-canvas-prints': true
  };

  var SIZE_POLICY_BY_HANDLE = {
    'giclee-fine-art-prints': {
      standard: ['4x4', '4x5', '4x6', '5x5', '5x7', '6x6', '6x8', '6x9', '8x8', '8x10', '8x12', '8.5x11', '9x12', '10x10', '10x13', '11x14', '11x17', '12x12', '12x16', '12x18', '13x19', '14x18', '16x16', '16x20', '16x24', '18x24', '20x20', '20x24', '20x30', '24x24', '24x30', '24x36', '30x30', '30x40'],
      extended: ['7x10', '8x24', '8.3x11.7', '10x12', '10x15', '10x20', '10x30', '11x11', '11.7x16.5', '12x15', '12x24', '12x36', '14x14', '15x20', '16x22', '16.5x23.4', '18x18', '20x40', '22x28', '24x48', '30x45', '32x40', '36x36', '36x48', '40x60'],
      customOnly: ['16x48', '20x60', '30x60', '36x54', '36x60'],
      custom: { maxShortSide: 40, maxLongSide: 60 }
    },
    'professional-photo-prints': {
      standard: ['4x4', '4x6', '5x5', '5x7', '6x6', '6x8', '6x9', '8x8', '8x10', '8x12', '8.5x11', '9x12', '10x10', '10x13', '11x14', '11x17', '12x12', '12x16', '12x18', '13x19', '14x18', '16x16', '16x20', '16x24', '18x24', '20x20', '20x24', '20x30', '24x24', '24x30', '24x36', '30x30', '30x40'],
      extended: ['7x10', '10x12', '10x15', '10x20', '12x15', '12x24', '14x14', '15x20', '16x48', '40x60'],
      customOnly: ['8x24', '10x30', '12x36', '20x40', '20x60', '24x48', '30x45', '30x60', '32x40', '36x36', '36x48', '36x54', '36x60'],
      custom: { maxShortSide: 40, maxLongSide: 60 }
    },
    'rolled-canvas-prints': {
      standard: ['4x4', '4x6', '5x5', '5x7', '6x6', '6x8', '6x9', '8x8', '8x10', '8x12', '8.5x11', '9x12', '10x10', '10x13', '11x14', '11x17', '12x12', '12x16', '12x18', '13x19', '14x18', '16x16', '16x20', '16x24', '18x24', '20x20', '20x30', '24x24', '24x30', '24x36', '30x30', '30x40'],
      custom: { maxShortSide: 40, maxLongSide: 60 }
    },
    'mounted-prints': {
      standard: ['8x8', '8x10', '8x12', '8.5x11', '9x12', '10x10', '10x13', '11x14', '11x17', '12x12', '12x16', '12x18', '13x19', '14x18', '16x16', '16x20', '16x24', '18x24', '20x20', '20x24', '20x30', '24x24', '24x30', '24x36', '30x30', '30x40'],
      custom: { maxShortSide: 32, maxLongSide: 40 }
    },
    'gallery-wrapped-canvas-prints': {
      standard: ['8x10', '8x12', '9x12', '10x10', '10x13', '11x14', '11x17', '12x12', '12x16', '12x18', '13x19', '14x18', '16x16', '16x20', '16x24', '18x24', '20x20', '20x24', '20x30', '24x24', '24x30', '24x36', '30x30', '30x40'],
      custom: { maxShortSide: 36, maxLongSide: 60 }
    },
    'mini-prints': {
      standard: ['2.25x3.25', '3x2.5'],
      custom: null
    },
    'clear-bagged-prints': {
      standard: ['4x6', '5x5', '5x7', '6x6', '6x8', '8x8', '8x10', '8x12', '9x12', '10x12', '10x10', '10x13', '10x20', '11x14', '11x17', '12x12', '12x16', '12x18', '13x19', '14x18', '16x16', '16x20'],
      custom: null
    },
    'retail-ready-prints': {
      standard: ['4x6', '5x5', '5x7', '6x6', '6x8', '8x8', '8x10', '8x12', '9x12', '10x10', '10x12', '10x13', '10x20', '11x14', '11x17', '12x12', '12x16', '12x18', '13x19', '14x18', '16x16', '16x20'],
      custom: null
    },
    'matting-package-prints': {
      standard: ['4x4', '4x5', '4x6', '5x5', '5x7', '6x6', '6x8', '6x9', '8x8', '8x10', '8x12', '9x12', '10x10', '10x15', '11x11', '11x17', '12x12', '11x14', '12x16', '13x16'],
      custom: null
    },
    'framed-prints': {
      standard: ['8x10', '11x14', '12x16', '16x20', '18x24'],
      custom: null
    },
    'test-print': {
      standard: ['4x5', '4x6', '5x7', '8x10', '11x14'],
      custom: null
    }
  };

  var FINE_ART_MEDIA = [
    { name: 'Hot Press Bright', spec: 'Smooth Matte | 300gsm | 16 mil | 100% Cotton Rag', tone: 'warm', sheet: '#f5ead8', swatch: ['#f5ead8', '#e8d6b0', '#d8b97a'], image: 'https://thestackhouse.com/cdn/shop/files/paper1_440x295.webp?v=1728383842' },
    { name: 'Cold Press Bright', spec: 'Textured Matte | 305gsm | 19 mil | 100% Cotton Rag', tone: 'matte', sheet: '#e9e0ce', swatch: ['#e9e0ce', '#cdbfa1', '#90805f'], image: 'https://thestackhouse.com/cdn/shop/files/paper2_440x295.webp?v=1728383842' },
    { name: 'Photo Rag', spec: 'Textured Matte | 308 gsm | 18.9 mil | 100% Cotton Fiber', tone: 'rag', sheet: '#efe9dc', swatch: ['#efe9dc', '#d8cdb6', '#9c8c6b'], image: 'https://thestackhouse.com/cdn/shop/files/paper3_440x295.webp?v=1728383842' },
    { name: 'William Turner', spec: 'Textured Matte | 310 gsm | 24.4 mil | 100% Cotton Fiber', tone: 'cool', sheet: '#e1ebe7', swatch: ['#e1ebe7', '#b9c9c2', '#7c948a'], image: 'https://thestackhouse.com/cdn/shop/files/paper4_440x295.webp?v=1728383842' },
    { name: 'FineArt Baryta', spec: 'Textured Glossy | 325 gsm | 16.14 mil | 100% Alpha Cellulose', tone: 'baryta', sheet: '#3a3530', swatch: ['#3a3530', '#2a2622', '#191714'], image: 'https://thestackhouse.com/cdn/shop/files/paper5_440x295.webp?v=1728383842' }
  ];

  var PHOTO_MEDIA = [
    { name: 'Luster', spec: 'Luster Finish (orange peel) | 260 gsm | 10 mil | Resin Coated Paper', tone: 'photo-luster', sheet: '#f0f2f3', swatch: ['#f7f8f8', '#c8d0d4', '#87959d'], image: 'https://thestackhouse.com/cdn/shop/files/Luster_DSC4340-575x450_4f593bb0-1328-4507-befe-c43bf150fc4d_440x295.png?v=1723771039' },
    { name: 'Glossy', spec: 'High Gloss Finish | 250 gsm | 10 mil | Resin Coated Paper', tone: 'photo-gloss', sheet: '#f6f7f8', swatch: ['#ffffff', '#c9d8e4', '#7593a8'], image: 'https://thestackhouse.com/cdn/shop/files/Glossy_DSC4329-575x450_440x295.png?v=1723756578' },
    { name: 'Metallic Glossy', spec: 'High-Gloss Pearlescent Finish | 255 gsm | 10.4 mil | Resin Coated Paper', tone: 'photo-metallic', sheet: '#e6eaed', swatch: ['#f8fafb', '#b9c3cb', '#687682'], image: 'https://thestackhouse.com/cdn/shop/files/Metallic_DSC4332-575x450.png?crop=center&height=295&v=1723756563&width=440' },
    { name: 'Photo Matt Fibre', spec: 'Natural White Matte Finish | 200 gsm | 11.8 mil | 100% Alpha-Cellulose', tone: 'photo-matte', sheet: '#eee9df', swatch: ['#f2eee6', '#d6cab8', '#a39175'], image: 'https://thestackhouse.com/cdn/shop/files/Detail_Photo_Matt_Fibre_200-scaled-e1684507451390-575x450_440x295.png?v=1723756547' }
  ];

  var CANVAS_MEDIA = [
    { name: 'Canvas Satin', spec: 'Low-Sheen Finish | Boosts Vibrancy | Scratch & Moisture Resistant', tone: 'canvas-satin', sheet: '#f0eadc', swatch: ['#f7f0e2', '#d4c29e', '#947b55'], image: 'https://thestackhouse.com/cdn/shop/files/Satin_Web_440x295.jpg?v=1720532561' },
    { name: 'Canvas Matte', spec: 'Glare-Free Surface | UV Protection | Smooth, Contemporary Look', tone: 'canvas-matte', sheet: '#eee4d1', swatch: ['#efe4d0', '#cbb58d', '#7d6647'], image: 'https://thestackhouse.com/cdn/shop/files/Satin_Web_440x295.jpg?v=1720532561' }
  ];

  var MAT_MEDIA = [
    { name: 'White Mat', spec: '4-ply conservation mat', tone: 'mat-white', sheet: '#f6f4ec', swatch: ['#fbfaf5', '#ebe6d8', '#cfc6b4'] },
    { name: 'Warm White Mat', spec: 'Soft gallery white', tone: 'mat-warm', sheet: '#f3eadb', swatch: ['#f8f0e2', '#e3d3bb', '#bba585'] },
    { name: 'Black Mat', spec: 'Modern black mat', tone: 'mat-black', sheet: '#2c2926', swatch: ['#3a3631', '#282522', '#111111'] }
  ];

  var PAPER_BORDERS = [
    { label: 'Borderless', inch: 0 },
    { label: '1/4-Inch Border', inch: 0.25 },
    { label: '1-Inch Border', inch: 1 },
    { label: '2-Inch Border', inch: 2 }
  ];
  var TEST_PRINT_BORDERS = [
    { label: 'Borderless', inch: 0 },
    { label: '1/4-Inch Unprinted Border', inch: 0.25 }
  ];
  var STANDARD_CROP_MAX_ASPECT = 1.5;

  var WRAP_EDGES = [
    { label: 'Mirrored', inch: 0, edge: 'mirror', spec: 'Image reflects onto the canvas sides.' },
    { label: 'White', inch: 0, edge: 'white', spec: 'Canvas sides print white; the front image size stays unchanged.' },
    { label: 'Black', inch: 0, edge: 'black', spec: 'Canvas sides print black; the front image size stays unchanged.' }
  ];

  var MATTING_PACKAGE_SIZES = [
    { label: '8x10', material: { outer: { width: 8, height: 10 }, mat: { color: '#ffffff' } } },
    { label: '9x12', material: { outer: { width: 9, height: 12 }, mat: { color: '#ffffff' } } },
    { label: '10x10', material: { outer: { width: 10, height: 10 }, mat: { color: '#ffffff' } } },
    { label: '11x14', material: { outer: { width: 11, height: 14 }, mat: { color: '#ffffff' } } },
    { label: '12x12', material: { outer: { width: 12, height: 12 }, mat: { color: '#ffffff' } } },
    { label: '12x16', material: { outer: { width: 12, height: 16 }, mat: { color: '#ffffff' } } },
    { label: '14x18', material: { outer: { width: 14, height: 18 }, mat: { color: '#ffffff' } } },
    { label: '16x16', material: { outer: { width: 16, height: 16 }, mat: { color: '#ffffff' } } },
    { label: '16x20', material: { outer: { width: 16, height: 20 }, mat: { color: '#ffffff' } } }
  ];

  var MINI_PRINT_BORDER_INSETS = {
    top: 0.25,
    right: 0.25,
    bottom: 0.5,
    left: 0.25
  };
  var MINI_PRINT_SIZE_PRESETS = {
    '2.25x3.25': { label: 'Horizontal', width: 3.25, height: 2.25 },
    '3x2.5': { label: 'Vertical', width: 2.5, height: 3 }
  };

  var PRESENTATION_PREVIEW_SURFACES = {
    'matting-package': {
      matColor: '#ffffff',
      matEdgeColor: '#e2e2e2',
      apertureLineColor: 'rgba(72, 72, 72, 0.18)',
      frameColor: 'transparent',
      frameWidthPx: 0
    },
    'framed-print': {
      matColor: '#ffffff',
      matEdgeColor: '#e2e2e2',
      apertureLineColor: 'rgba(72, 72, 72, 0.2)',
      frameColor: '#40372d',
      frameWidthInches: 0,
      frameWidthPx: 12
    }
  };

  var VOLUME_TIERS = [
    { min: 10, off: 10 },
    { min: 50, off: 15 },
    { min: 100, off: 20 }
  ];
  var DEFAULT_PRINT_DPI = 300;
  var MINIMUM_PRINT_PPI = 150;
  var DEFAULT_MAX_CROP_ZOOM = 3;
  var REVIEW_INSPECT_MIN_ZOOM = 1;
  var REVIEW_INSPECT_MAX_ZOOM = 2.5;
  var REVIEW_INSPECT_ZOOM_STEP = 0.1;
  var SVG_NS = 'http://www.w3.org/2000/svg';

  var PRODUCT_PRESETS = {
    'test-print': {
      title: 'Test Print',
      mediaTitle: 'Media',
      borderTitle: 'Border',
      media: PHOTO_MEDIA.concat(FINE_ART_MEDIA, CANVAS_MEDIA),
      borders: TEST_PRINT_BORDERS,
      previewMode: 'paper',
      helper: 'Choose Borderless or a 1/4-inch unprinted border for this evaluation print.',
      minPrice: 5,
      pricePerSqIn: 0,
      supportsCustom: false,
      fixedQuantity: 1,
      volumeEligible: false
    },
    'giclee-fine-art-prints': {
      title: 'Giclee Fine Art Prints',
      mediaTitle: 'Paper',
      borderTitle: 'Border',
      media: FINE_ART_MEDIA,
      borders: PAPER_BORDERS,
      previewMode: 'paper',
      helper: 'The border is unprinted paper. Watch the preview update as you choose.',
      minPrice: 5.25,
      pricePerSqIn: 0.1,
      supportsCustom: true
    },
    'professional-photo-prints': {
      title: 'Professional Photo Prints',
      mediaTitle: 'Media',
      borderTitle: 'Border',
      media: PHOTO_MEDIA,
      borders: PAPER_BORDERS,
      previewMode: 'paper',
      helper: 'The border is unprinted paper around the image.',
      minPrice: 4.5,
      pricePerSqIn: 0.075,
      supportsCustom: true
    },
    'mini-prints': {
      title: 'Mini Prints',
      mediaTitle: 'Paper',
      borderTitle: 'Border',
      media: PHOTO_MEDIA.concat(FINE_ART_MEDIA),
      borders: [],
      previewMode: 'paper',
      helper: 'Mini prints use a fixed compact format with a 1/4-inch border and 1/2-inch bottom weight.',
      minPrice: 2,
      pricePerSqIn: 0.1,
      supportsCustom: false
    },
    'rolled-canvas-prints': {
      title: 'Rolled Canvas Prints',
      mediaTitle: 'Canvas',
      borderTitle: 'Border',
      media: CANVAS_MEDIA,
      borders: PAPER_BORDERS,
      previewMode: 'paper',
      helper: 'Rolled canvas ships unstretched, with optional unprinted border for stretching.',
      minPrice: 12,
      pricePerSqIn: 0.16,
      supportsCustom: true
    },
    'gallery-wrapped-canvas-prints': {
      title: 'Gallery Wrapped Canvas Prints',
      mediaTitle: 'Canvas',
      borderTitle: 'Wrap edge',
      media: CANVAS_MEDIA,
      borders: WRAP_EDGES,
      previewMode: 'gallery-wrap',
      helper: 'Choose how the image continues around the canvas edge.',
      minPrice: 58,
      pricePerSqIn: 0.28,
      supportsCustom: true
    },
    'mounted-prints': {
      title: 'Mounted Prints',
      mediaTitle: 'Surface',
      borderTitle: 'Border',
      media: PHOTO_MEDIA,
      borders: PAPER_BORDERS,
      previewMode: 'paper',
      helper: 'Mounted print preview shows the print as a rigid presentation panel.',
      minPrice: 18,
      pricePerSqIn: 0.18,
      supportsCustom: true
    },
    'clear-bagged-prints': {
      title: 'Clear Bagged Prints',
      mediaTitle: 'Paper',
      borderTitle: 'Packaging',
      media: FINE_ART_MEDIA.slice(0, 3),
      borders: [],
      previewMode: 'paper',
      helper: 'Clear bagged prints are sleeved for clean handling and retail bins.',
      minPrice: 5.5,
      pricePerSqIn: 0.11,
      supportsCustom: false,
      hiddenOptionKinds: ['border', 'packaging']
    },
    'retail-ready-prints': {
      title: 'Retail Ready Prints',
      mediaTitle: 'Paper',
      borderTitle: 'Packaging',
      media: FINE_ART_MEDIA.slice(0, 3),
      borders: [],
      previewMode: 'paper',
      helper: 'Retail ready prints include clear bagging and a backing board.',
      minPrice: 9,
      pricePerSqIn: 0.13,
      supportsCustom: false,
      hiddenOptionKinds: ['border', 'packaging']
    },
    'matting-package-prints': {
      title: 'Matting Package Prints',
      mediaTitle: 'Media Type',
      borderTitle: 'Matting Package Size',
      media: PHOTO_MEDIA.concat(FINE_ART_MEDIA),
      borders: MATTING_PACKAGE_SIZES,
      previewMode: 'matting-package',
      helper: 'Choose the finished mat package size around the selected print.',
      minPrice: 11.5,
      pricePerSqIn: 0.16,
      supportsCustom: false
    },
    'framed-prints': {
      title: 'Framed Prints',
      mediaTitle: 'Media Type',
      borderTitle: 'Frame & Mat',
      media: PHOTO_MEDIA.concat(FINE_ART_MEDIA),
      borders: [],
      previewMode: 'framed-print',
      helper: 'Choose the frame finish and optional 2-inch white mat. The selected size is the finished frame size.',
      minPrice: 70,
      pricePerSqIn: 0,
      supportsCustom: false
    }
  };

  var requestedParameters = new URLSearchParams(window.location.search);
  var requestedProductHandle = canonicalHandle(requestedParameters.get('product') || '');
  var requestedSizeKey = sizeKeyFromText(requestedParameters.get('size') || '');
  var requestedLibraryImageId = String(requestedParameters.get('image_id') || '').trim();
  var cartEditKey = String(requestedParameters.get('cart_edit') || '');
  var cartEditSession = null;
  var cartEditCropNeedsApply = false;
  var generatedCartProductRetry = null;
  var state = {
    productHandle: requestedProductHandle,
    productSelectionPending: !requestedProductHandle,
    productAssistantStep: requestedParameters.get('browse') === 'all' ? 3 : 1,
    productAssistantSubject: '',
    productAssistantFinish: '',
    productAssistantBrowseAll: requestedParameters.get('browse') === 'all',
    photo: null,
    photoTab: requestedLibraryImageId ? 'library' : 'upload',
    librarySearch: '',
    librarySort: 'newest',
    libraryPage: 0,
    sizeMode: 'standard',
    size: null,
    customW: '',
    customH: '',
    customLocked: true,
    customRatio: null,
    media: null,
    border: null,
    options: {},
    open: 'photo',
    previewView: 'layout',
    reviewOpen: false,
    reviewZoom: false,
    reviewZoomScale: REVIEW_INSPECT_MIN_ZOOM,
    cropOpen: false,
    cropApplied: false,
    cropAutoOpened: false,
    zoom: 1,
    cropX: 0,
    cropY: 0,
    cropRotation: 0,
    libraryLoading: false,
    libraryLoaded: false,
    libraryError: '',
    librarySelection: null,
    libraryLoadAttempt: 0,
    libraryLoadWorkflowId: '',
    guestClaiming: false,
    guestClaimError: '',
    batchUploadNotice: '',
    uploadTitle: '',
    uploadStatus: '',
    uploadError: '',
    uploadHelpLink: '',
    uploading: false,
    uploadTriggerMethod: '',
    uploadAttemptId: 0,
    failedUploadAssetId: '',
    failedUploadRetryAvailableAt: 0,
    qty: 1,
    adding: false,
    cartWriteSucceeded: false,
    added: false,
    addedCartItemCount: null,
    addError: '',
    customPricePending: false,
    customPriceValue: null,
    customPriceError: '',
    customPriceFormula: '',
    customPriceType: '',
    customPriceKey: '',
    committedSizeRatio: null
  };

  var assistantTelemetry = window.StackhouseAssistantTelemetry
    ? window.StackhouseAssistantTelemetry.create(trackBetaBuilderEvent) : null;
  var cropOffsetFit = null;
  var customSizeInputCrop = null;
  var pendingOrientationIntent = null;
  var draftRestoreCancelled = false;
  var draftReady = false;
  var restoringDraft = false;
  var draftNotice = '';
  var draftStorageWarning = false;
  var cropDrag = null;
  var workspaceFrame = null;
  var customPriceTimer = null;
  var customPriceRequestId = 0;
  var libraryPerPage = 8;
  var guestLibraryStorageKey = 'orderPageImages';
  var guestLibraryBridgeKey = 'orderPageImages_loginBridge';
  var legacyGuestLibraryDecisionKey = 'stackhouse:order-app:guest-library-decision:v1';
  var guestLibraryRaw = [];
  var guestLibraryPhotos = [];
  var batchUploadItems = [];
  var batchUploadActive = 0;
  var batchUploadSequence = 0;
  var batchUploadMaxConcurrent = 2;
  var batchUploadLimit = 10;
  var failedUploadFile = null;
  var failedUploadTelemetryAttemptId = null;
  var activeLocalPreviewUrl = '';
  var classicChoiceStorageKey = 'stackhouse:order-builder-choice:v1';
  var classicSwitchPreviousFocus = null;
  var classicSwitchDestination = '';
  var floatingWidgetSelectors = [
    '#stackhouse-chat-root',
    '#stackhouse-chat-loader',
    '.stackhouse-chat-loader',
    '#stackhouse-chat-widget-script',
    '#smile-ui-container',
    '#smile-ui-lite-container',
    '.smile-launcher-frame-container',
    'iframe.smile-launcher-frame',
    'iframe#launcher',
    '[id*="smile-ui" i]',
    '[class*="smile-launcher" i]'
  ];

  var els = {
    preview: root.querySelector('.order-app-preview'),
    configHeader: root.querySelector('.order-app-config__header'),
    steps: root.querySelector('.order-app-steps'),
    productTitle: root.querySelector('[data-order-product-title]'),
    productEdit: root.querySelector('[data-order-product-edit]'),
    productIntro: root.querySelector('[data-order-product-intro]'),
    productAssistant: root.querySelector('[data-order-product-assistant]'),
    productAssistantProgress: root.querySelector('[data-order-assistant-progress]'),
    productAssistantBack: root.querySelector('[data-order-assistant-back]'),
    productAssistantQuestions: Array.prototype.slice.call(root.querySelectorAll('[data-order-assistant-question]')),
    productAssistantResult: root.querySelector('[data-order-assistant-result]'),
    productAssistantSkip: root.querySelector('.order-app-product-assistant__skip'),
    productPicker: root.querySelector('[data-order-product-picker]'),
    productButtons: Array.prototype.slice.call(root.querySelectorAll('[data-order-product-option]')),
    productGroupHeadings: Array.prototype.slice.call(root.querySelectorAll('[data-order-product-group-heading]')),
    productResources: Array.prototype.slice.call(root.querySelectorAll('[data-order-product-resource]')),
    previewStage: root.querySelector('[data-order-preview-stage]'),
    previewViewToggle: root.querySelector('[data-order-preview-view-toggle]'),
    previewViewButtons: Array.prototype.slice.call(root.querySelectorAll('[data-order-preview-view]')),
    previewEmpty: root.querySelector('[data-order-preview-empty]'),
    previewUploading: root.querySelector('[data-order-preview-uploading]'),
    previewPrint: root.querySelector('[data-order-preview-print]'),
    previewSheet: root.querySelector('[data-order-preview-sheet]'),
    previewImage: root.querySelector('[data-order-preview-image]'),
    presentationMockup: null,
    cropContext: root.querySelector('[data-order-crop-context]'),
    cropContextImage: root.querySelector('[data-order-crop-context-image]'),
    cropFrameLabel: root.querySelector('[data-order-crop-frame-label]'),
    previewBadge: root.querySelector('[data-order-preview-badge]'),
    previewCaption: root.querySelector('.order-app-preview__caption'),
    cropGuides: root.querySelector('[data-order-crop-guides]'),
    cropToolbar: root.querySelector('[data-order-crop-toolbar]'),
    cropStart: root.querySelector('[data-order-crop-start]'),
    cropDone: root.querySelector('[data-order-crop-done]'),
    cropRotate: root.querySelector('[data-order-crop-rotate]'),
    cropRecenter: root.querySelector('[data-order-crop-recenter]'),
    zoomOut: root.querySelector('[data-order-zoom-out]'),
    zoomIn: root.querySelector('[data-order-zoom-in]'),
    toolbarScale: root.querySelector('[data-order-toolbar-scale]'),
    toolbarZoom: root.querySelector('[data-order-toolbar-zoom]'),
    toolbarZoomValue: root.querySelector('[data-order-toolbar-zoom-value]'),
    previewFile: root.querySelector('[data-order-preview-file]'),
    previewSpec: root.querySelector('[data-order-preview-spec]'),
    imagePicker: root.querySelector('[data-order-image-picker]'),
    imagePickerLabel: root.querySelector('[data-order-image-picker-label]'),
    photoTabsGroup: root.querySelector('[data-order-photo-tabs]'),
    photoTabs: Array.prototype.slice.call(root.querySelectorAll('[data-order-photo-tab]')),
    photoUploadPanel: root.querySelector('[data-order-photo-panel="upload"]'),
    photoLibraryPanel: root.querySelector('[data-order-photo-panel="library"]'),
    fileInput: root.querySelector('[data-order-file-input]'),
    uploadTrigger: root.querySelector('[data-order-upload-trigger]'),
    batchUploadSummary: root.querySelector('[data-order-upload-batch-summary]'),
    libraryToolbar: root.querySelector('[data-order-library-toolbar]'),
    libraryGuest: root.querySelector('[data-order-library-guest]'),
    libraryGuestCopy: root.querySelector('[data-order-library-guest-copy]'),
    librarySignIn: root.querySelector('[data-order-library-sign-in]'),
    libraryClaim: root.querySelector('[data-order-library-claim]'),
    libraryClaimTitle: root.querySelector('[data-order-library-claim-title]'),
    libraryClaimCopy: root.querySelector('[data-order-library-claim-copy]'),
    libraryClaimAdd: root.querySelector('[data-order-library-claim-add]'),
    libraryClaimClear: root.querySelector('[data-order-library-claim-clear]'),
    libraryClaimStatus: root.querySelector('[data-order-library-claim-status]'),
    librarySearchWrap: root.querySelector('[data-order-library-search-wrap]'),
    librarySearch: root.querySelector('[data-order-library-search]'),
    librarySort: root.querySelector('[data-order-library-sort]'),
    libraryGrid: root.querySelector('[data-order-library-grid]'),
    libraryCount: root.querySelector('[data-order-library-count]'),
    libraryPage: root.querySelector('[data-order-library-page]'),
    libraryPrev: root.querySelector('[data-order-library-prev]'),
    libraryNext: root.querySelector('[data-order-library-next]'),
    libraryFooter: root.querySelector('[data-order-library-footer]'),
    uploadProgress: root.querySelector('[data-order-upload-progress]'),
    uploadTitle: root.querySelector('[data-order-upload-title]'),
    uploadStatus: root.querySelector('[data-order-upload-status]'),
    uploadHelp: root.querySelector('[data-order-upload-help]'),
    uploadRetry: root.querySelector('[data-order-upload-retry]'),
    fileCard: root.querySelector('[data-order-file-card]'),
    fileThumb: root.querySelector('[data-order-file-thumb]'),
    fileName: root.querySelector('[data-order-file-name]'),
    fileMeta: root.querySelector('[data-order-file-meta]'),
    lowresWarning: root.querySelector('[data-order-lowres-warning]'),
    lowresCopy: root.querySelector('[data-order-lowres-copy]'),
    photoReplace: root.querySelector('[data-order-photo-replace]'),
    galleryWrapSizeHelp: root.querySelector('[data-order-gallery-size-help]'),
    galleryWrapSizeHelpToggle: root.querySelector('[data-order-gallery-size-help-toggle]'),
    sizeModes: Array.prototype.slice.call(root.querySelectorAll('[data-order-size-mode-option]')),
    sizeGrid: root.querySelector('[data-order-size-grid]'),
    customSize: root.querySelector('[data-order-custom-size]'),
    customWidth: root.querySelector('[data-order-custom-width]'),
    customHeight: root.querySelector('[data-order-custom-height]'),
    customApply: root.querySelector('[data-order-custom-apply]'),
    customActual: root.querySelector('[data-order-custom-actual]'),
    customSwap: root.querySelector('[data-order-custom-swap]'),
    customLock: root.querySelector('[data-order-custom-lock]'),
    resolutionNote: root.querySelector('[data-order-resolution-note]'),
    resolutionRecovery: root.querySelector('[data-order-resolution-recovery]'),
    resolutionSuggestion: root.querySelector('[data-order-resolution-suggestion]'),
    resolutionUseSize: root.querySelector('[data-order-resolution-use-size]'),
    cropToggle: root.querySelector('[data-order-crop-toggle]'),
    cropCard: root.querySelector('[data-order-crop-card]'),
    cropMessage: root.querySelector('[data-order-crop-message]'),
    cropApply: root.querySelector('[data-order-crop-apply]'),
    cropCancel: root.querySelector('[data-order-crop-cancel]'),
    zoom: root.querySelector('[data-order-zoom]'),
    zoomValue: root.querySelector('[data-order-zoom-value]'),
    sizeNext: root.querySelector('[data-order-size-next]'),
    mediaTitle: root.querySelector('[data-order-media-title]'),
    mediaList: root.querySelector('[data-order-media-list]'),
    paperNext: root.querySelector('[data-order-paper-next]'),
    borderTitle: root.querySelector('[data-order-border-title]'),
    borderGrid: root.querySelector('[data-order-border-grid]'),
    borderHelper: root.querySelector('[data-order-border-helper]'),
    borderNext: root.querySelector('[data-order-border-next]'),
    dock: root.querySelector('[data-order-dock]'),
    volume: root.querySelector('[data-order-volume]'),
    volumeText: root.querySelector('[data-order-volume-text]'),
    volumeMeter: root.querySelector('[data-order-volume-meter]'),
    dockSummary: root.querySelector('[data-order-dock-summary]'),
    reviewPanel: root.querySelector('[data-order-review-panel]'),
    reviewDetails: root.querySelector('[data-order-review-details]'),
    reviewZoom: root.querySelector('[data-order-review-zoom]'),
    reviewZoomClose: root.querySelector('[data-order-review-zoom-close]'),
    reviewInspector: root.querySelector('[data-order-review-inspector]'),
    reviewZoomFit: root.querySelector('[data-order-review-zoom-fit]'),
    reviewZoomOut: root.querySelector('[data-order-review-zoom-out]'),
    reviewZoomIn: root.querySelector('[data-order-review-zoom-in]'),
    reviewZoomScale: root.querySelector('[data-order-review-zoom-scale]'),
    reviewZoomValue: root.querySelector('[data-order-review-zoom-value]'),
    qty: root.querySelector('[data-order-qty]'),
    qtyValue: root.querySelector('[data-order-qty-value]'),
    qtyMinus: root.querySelector('[data-order-qty-minus]'),
    qtyPlus: root.querySelector('[data-order-qty-plus]'),
    price: root.querySelector('[data-order-price]'),
    startOver: root.querySelector('[data-order-start-over]'),
    addedPanel: root.querySelector('[data-order-added]'),
    addedTitle: root.querySelector('[data-order-added-title]'),
    addedDescription: root.querySelector('[data-order-added-description]'),
    addedProduct: root.querySelector('[data-order-added-product]'),
    addedDetails: root.querySelector('[data-order-added-details]'),
    addedCart: root.querySelector('[data-order-added-cart]'),
    add: root.querySelector('[data-order-add]'),
    classicLink: root.querySelector('[data-order-classic-builder]'),
    classicModal: root.querySelector('[data-order-classic-modal]'),
    classicPanel: root.querySelector('[data-order-classic-panel]'),
    classicDescription: root.querySelector('[data-order-classic-description]'),
    classicReason: root.querySelector('[data-order-classic-reason]'),
    classicConfirm: root.querySelector('[data-order-classic-confirm]')
  };

  var sections = Array.prototype.slice.call(root.querySelectorAll('[data-order-step]'));
  var summaryEls = {
    photo: root.querySelector('[data-order-step-summary="photo"]'),
    size: root.querySelector('[data-order-step-summary="size"]'),
    paper: root.querySelector('[data-order-step-summary="paper"]'),
    border: root.querySelector('[data-order-step-summary="border"]')
  };

  var library = [];

  // Store only the recipe in this tab. The image library remains the image authority.
  function draftStorageKey() {
    return 'stackhouse:order-draft:v1:' + (customerId() || 'guest') + ':' + canonicalHandle(state.productHandle) + (cartEditKey ? ':edit:' + cartEditKey : '');
  }

  function showDraftNotice(message, compact) {
    draftNotice = message || '';
    var notice = root.querySelector('[data-order-draft-notice]');
    if (!notice && els.configHeader) {
      notice = document.createElement('div');
      notice.className = 'order-app-draft-notice';
      notice.setAttribute('data-order-draft-notice', '');
      var copy = document.createElement('p');
      copy.setAttribute('role', 'status');
      copy.setAttribute('data-order-draft-copy', '');
      var discard = document.createElement('button');
      discard.type = 'button';
      discard.className = 'order-app-link-button';
      discard.textContent = 'Discard draft';
      discard.hidden = !!cartEditKey;
      discard.addEventListener('click', function () {
        clearDraft();
        showDraftNotice('');
        resetPhoto();
      });
      notice.appendChild(copy);
      var dismiss = document.createElement('button');
      dismiss.type = 'button';
      dismiss.className = 'order-app-link-button';
      dismiss.textContent = 'Dismiss';
      dismiss.setAttribute('data-order-draft-dismiss', '');
      dismiss.addEventListener('click', function () {
        showDraftNotice('');
        var currentStep = root.querySelector('[data-order-step-toggle="' + state.open + '"]');
        if (currentStep) currentStep.focus({ preventScroll: true });
      });
      notice.appendChild(dismiss);
      notice.appendChild(discard);
      if (cartEditKey) {
        var back = document.createElement('a');
        back.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
        back.className = 'order-app-link-button';
        back.textContent = 'Back to cart';
        notice.appendChild(back);
      }
      els.configHeader.appendChild(notice);
    }
    if (notice) {
      notice.hidden = !draftNotice;
      notice.classList.toggle('is-compact', !!compact);
      var copyNode = notice.querySelector('[data-order-draft-copy]');
      copyNode.textContent = compact ? (cartEditKey ? 'Saved print restored.' : 'Draft restored.') : draftNotice;
      copyNode.title = compact ? draftNotice : '';
      notice.querySelector('[data-order-draft-dismiss]').hidden = !compact || !!cartEditKey;
    }
  }

  function clearDraft() {
    try { window.sessionStorage.removeItem(draftStorageKey()); } catch (error) { /* Storage may be disabled. */ }
  }

  function captureDraftCrop() {
    var fit = previewFitForRatio(activeRatio().ratio).imageFit;
    syncCropPositionToFit(fit);
    return { x: fit.w ? state.cropX / fit.w : 0, y: fit.h ? state.cropY / fit.h : 0 };
  }

  function restoreDraftCrop(position) {
    var fit = previewFitForRatio(activeRatio().ratio).imageFit;
    syncCropPositionToFit(fit);
    state.cropX = position.x * fit.w;
    state.cropY = position.y * fit.h;
    clampActiveCrop();
  }

  function persistDraft() {
    if (!draftReady || restoringDraft) return;
    if (state.added || state.cartWriteSucceeded) { clearDraft(); return; }
    if (!state.photo || state.photo === 'uploading') return;
    var sourceId = imageOrderValue(state.photo.backend) || imageOrderValue(state.photo);
    if (!sourceId || /[/:?]/.test(sourceId)) return;
    var options = {};
    selectedOptionsList().forEach(function (option) { options[option.kind] = option.label || option.name; });
    var recipe = {
      version: 1,
      product: canonicalHandle(state.productHandle),
      sourceId: sourceId,
      sizeMode: state.sizeMode,
      sizeKey: state.size && state.size.key || '',
      customW: String(state.customW), customH: String(state.customH),
      customLocked: state.customLocked,
      options: options,
      crop: captureDraftCrop(),
      cropAudit: cropTracker() ? cropTracker().exportState() : null,
      zoom: state.zoom, rotation: state.cropRotation,
      cropApplied: state.cropApplied, cropOpen: state.cropOpen,
      quantity: state.qty, step: state.open,
      updatedAt: Date.now()
    };
    try {
      window.sessionStorage.setItem(draftStorageKey(), JSON.stringify(recipe));
    } catch (error) {
      if (!draftStorageWarning) {
        draftStorageWarning = true;
        showDraftNotice('This browser could not save your draft. Keep this page open until you add your print to cart.');
      }
    }
  }

  async function restoreDraft() {
    if (requestedLibraryImageId || !state.productHandle) { draftReady = true; return; }
    var recipe;
    try {
      var raw = window.sessionStorage.getItem(draftStorageKey());
      if (!raw) { draftReady = true; return; }
      recipe = JSON.parse(raw);
      if (!recipe || recipe.version !== 1 || recipe.product !== state.productHandle ||
          typeof recipe.sourceId !== 'string' || !/^[a-zA-Z0-9_-]{1,160}$/.test(recipe.sourceId) ||
          !Number.isFinite(recipe.updatedAt) || Date.now() - recipe.updatedAt > 86400000 ||
          !Number.isSafeInteger(recipe.quantity) || recipe.quantity < 1 ||
          !recipe.crop || !Number.isFinite(recipe.crop.x) || !Number.isFinite(recipe.crop.y) ||
          Math.abs(recipe.crop.x) > 1000 || Math.abs(recipe.crop.y) > 1000 ||
          !Number.isFinite(recipe.zoom) || recipe.zoom < 1 || recipe.zoom > 100 ||
          [0, 90].indexOf(recipe.rotation) === -1 ||
          ['standard', 'extended', 'custom'].indexOf(recipe.sizeMode) === -1 ||
          !recipe.options || typeof recipe.options !== 'object' || Array.isArray(recipe.options)) {
        throw new Error('Invalid draft');
      }
    } catch (error) {
      draftReady = true;
      showDraftNotice('Your saved draft could not be restored. Choose an image to start again, or discard the saved draft.');
      return;
    }
    // A direct link to another size is an intentional new configuration.
    if (requestedSizeKey && recipe.sizeKey !== requestedSizeKey) { draftReady = true; return; }
    restoringDraft = true;
    try {
      if (customerId()) {
        var response = await window.stackhouseCustomerFetch(window.stackhouseAuthorizeCustomerUrl(
          apiBaseUrl() + '/api/get_customer_data/?customer_id=' + encodeURIComponent(customerId()) + '&page=1&q=' + encodeURIComponent(recipe.sourceId)
        ), { headers: window.stackhouseCustomerAccessHeaders() });
        if (!response.ok) throw new Error('Saved image lookup failed');
        var data = await response.json();
        if (draftRestoreCancelled) return;
        var photos = Array.isArray(data.images) ? data.images.map(normalizeLibraryImage).filter(Boolean) : [];
        library = mergeLibraryPhotos(library.concat(photos));
      }
      var photo = library.find(function (item) {
        return (imageOrderValue(item.backend) || imageOrderValue(item)) === recipe.sourceId;
      });
      if (!photo) {
        showDraftNotice('Your saved draft is still in this tab, but its image is unavailable. Sign in to the same account or choose an image to continue.');
        return;
      }
      state.photo = photo;
      state.productSelectionPending = false;
      state.sizeMode = recipe.sizeMode;
      state.size = recipe.sizeKey ? findSize(recipe.sizeKey, recipe.sizeMode) : null;
      state.customW = String(recipe.customW || '').slice(0, 20);
      state.customH = String(recipe.customH || '').slice(0, 20);
      state.customLocked = recipe.customLocked !== false;
      state.customRatio = null;
      var changed = !!recipe.sizeKey && !state.size;
      if (state.sizeMode === 'custom' && (!supportsCustomSizes() || customSizeError())) {
        state.sizeMode = 'standard'; state.size = null; changed = true;
      }
      resetSelectedOptions();
      var groups = optionGroupsByKind();
      Object.keys(recipe.options).forEach(function (kind) {
        var group = groups[kind];
        var option = group && group.values.find(function (value) {
          return (value.label || value.name) === recipe.options[kind];
        });
        if (option) setSelectedOption(kind, option);
        else changed = true;
      });
      state.qty = normalizeCartQuantity(recipe.quantity);
      if (currentPreset().fixedQuantity) state.qty = currentPreset().fixedQuantity;
      state.cropRotation = cropRotationAllowed() ? recipe.rotation : 0;
      state.zoom = Math.min(recipe.zoom, maxCropZoom());
      changed = changed || state.zoom !== recipe.zoom || state.cropRotation !== recipe.rotation;
      state.cropApplied = !!recipe.cropApplied;
      state.cropOpen = !!recipe.cropOpen || changed;
      state.open = ['photo', 'size', 'paper', 'border'].indexOf(recipe.step) !== -1 ? recipe.step : 'size';
      if (changed) state.open = 'size';
      state.committedSizeRatio = selectedPrintRatio();
      state.reviewOpen = false;
      state.reviewZoom = false;
      resetAddState();
      resetCustomPricePreview();
      renderOptions();
      render();
      restoreDraftCrop(recipe.crop);
      if (cropTracker()) cropTracker().restore(recipe.cropAudit);
      if (cartEditSession) {
        if (!changed && !state.cropOpen && recipe.cropApplied && recipe.cropAudit && recipe.cropAudit.current) {
          var draftCrop = buildCropPayload();
          var draftRestoration = window.StackhouseCartEdit.cropRestoration({
            crop: {x: Number(draftCrop._Crop_X), y: Number(draftCrop._Crop_Y), width: Number(draftCrop._Crop_Width), height: Number(draftCrop._Crop_Height)},
            image: {id: state.photo.backend.ID || state.photo.backend.id},
            crop_audit: {client: Object.assign({}, recipe.cropAudit.current, {
              applied: recipe.cropAudit.applied,
              crop_applied_revision: recipe.cropAudit.applied && recipe.cropAudit.applied.crop_revision,
              crop_sequence: recipe.cropAudit.sequence
            })}
          }, photoPixelDimensions());
          restoreCartCrop(draftRestoration);
        } else {
          cartEditCropNeedsApply = true;
          state.cropOpen = true;
          state.open = 'size';
        }
      }
      render();
      if (state.sizeMode === 'custom') scheduleCustomPricePreview();
      showDraftNotice(cartEditSession && cartEditCropNeedsApply
        ? 'Review and apply your crop before updating this saved print.'
        : changed
        ? 'Your image and available choices were restored. Some size or option choices changed. Check the crop and complete your selections before reviewing.'
        : cartEditKey
          ? 'Your edits were restored. Review the crop, options and current price before updating your cart.'
          : 'Draft restored. Review your crop and options before adding your print to cart.', !changed && !cartEditCropNeedsApply);
    } catch (error) {
      if (!draftRestoreCancelled) showDraftNotice('Your draft is saved, but the image could not be loaded. Check your connection and refresh to retry, or choose an image.');
    } finally {
      restoringDraft = false;
      draftReady = true;
    }
  }

  function restoreCartCrop(restoration) {
    var crop = restoration.crop;
    if (restoration.rotation !== undefined) {
      if (restoration.rotation !== 0 && !cropRotationAllowed()) throw new Error('Review the saved crop orientation before updating this print.');
      state.cropRotation = restoration.rotation;
    }
    var ratio = activeRatio().ratio;
    var restoredFit = previewFitForRatio(ratio).imageFit;
    syncCropPositionToFit(restoredFit);
    var position = window.StackhouseCartEdit.cropPosition(crop, photoPixelDimensions(), ratio, restoredFit, maxCropZoom());
    state.zoom = position.zoom;
    state.cropX = position.x;
    state.cropY = position.y;
    clampActiveCrop();
    var actual = buildCropPayload();
    ['x', 'y', 'width', 'height'].forEach(function (key) {
      var property = '_Crop_' + key.charAt(0).toUpperCase() + key.slice(1);
      if (Math.abs(Number(actual[property]) - crop[key]) > .01) throw new Error('The saved crop could not be restored exactly. Your cart item is preserved.');
    });
    if (cropTracker()) cropTracker().restore(restoration.auditState);
    cartEditCropNeedsApply = restoration.requiresApply;
    if (cartEditCropNeedsApply) {
      state.cropApplied = false;
      state.cropOpen = true;
      state.open = 'size';
    }
  }

  async function restoreCartRecipe() {
    restoringDraft = true;
    showDraftNotice('Loading the print saved in your cart...');
    try {
      if (!window.StackhouseCartEdit || typeof window.StackhouseCartEdit.cropRestoration !== 'function') throw new Error('The cart editor could not load. Refresh to retry.');
      var saved = await window.StackhouseCartEdit.read(cartEditKey, apiBaseUrl());
      var recipe = saved.recipe;
      var family = canonicalHandle(recipe.family);
      if (!productByHandle(family) || (requestedProductHandle && family !== requestedProductHandle)) {
        throw new Error('The saved product could not be matched. Your cart item is preserved.');
      }
      state.productHandle = family;
      state.productSelectionPending = false;
      var photo = normalizeLibraryImage(recipe.image);
      if (!photo || !recipe.image.converted_file) throw new Error('The saved artwork is unavailable.');
      photo.src = recipe.image.converted_file;
      state.photo = photo;
      library = mergeLibraryPhotos([photo].concat(library));
      var sizeProduct = currentSizeProducts().find(function (product) { return product.handle === recipe.product_handle; });
      var custom = recipe.custom_size || {};
      if (recipe.mode === 'generated_custom' && recipe.size_mode === 'custom') {
        state.sizeMode = 'custom';
        state.size = null;
        state.customW = String(custom.width || '');
        state.customH = String(custom.height || '');
        state.customLocked = true;
        state.customRatio = Number(custom.width) / Number(custom.height);
        if (!supportsCustomSizes() || customSizeError()) throw new Error('This saved custom size is no longer available.');
      } else {
        var sizeKey = sizeProductKey(sizeProduct) || sizeKeyFromText(custom.source_size_key);
        state.size = allCurrentSizes().find(function (size) { return size.key === sizeKey; }) || null;
        if (!state.size || ['standard', 'extended'].indexOf(state.size.bucket) === -1) throw new Error('The saved size is no longer available.');
        state.sizeMode = state.size.bucket;
      }
      resetSelectedOptions();
      var groups = optionGroupsByKind(), choices = {};
      if (Array.isArray(recipe.options)) recipe.options.forEach(function (option) { choices[optionKind(option.name)] = option.value; });
      else Object.keys(recipe.options || {}).forEach(function (key) {
        if (key.endsWith('_label') && recipe.options[key]) choices[key.slice(0, -6)] = recipe.options[key];
      });
      Object.keys(choices).forEach(function (kind) {
        if (kind === 'title' || kind === 'size' || kind === 'print_size') return;
        var group = groups[kind];
        // Packaged prints use a fixed borderless finish. The classic catalog
        // records it explicitly even though this builder hides that control.
        if (!group && kind === 'border' && isOptionKindHidden(kind) &&
            /^(borderless|no border|full bleed)$/i.test(String(choices[kind]).trim())) return;
        var option = group && group.values.find(function (value) { return normalizeOptionText(value.label || value.name) === normalizeOptionText(choices[kind]); });
        if (!option) throw new Error('A saved ' + kind.replace(/_/g, ' ') + ' option is no longer available. Your cart item is preserved.');
        setSelectedOption(kind, option);
      });
      state.qty = normalizeCartQuantity(saved.line.quantity);
      if (fixedQuantity()) state.qty = fixedQuantity();
      state.cropRotation = 0;
      var restoration = window.StackhouseCartEdit.cropRestoration(recipe, photoPixelDimensions());
      var crop = restoration.crop;
      var ratio = activeRatio().ratio;
      if (Math.abs(ratio[0] / ratio[1] - crop.width / crop.height) > .0001 && cropRotationAllowed()) state.cropRotation = 90;
      state.cropApplied = true;
      state.cropOpen = false;
      state.open = 'size';
      state.reviewOpen = false;
      state.added = false;
      renderOptions();
      render();
      restoreCartCrop(restoration);
      state.committedSizeRatio = selectedPrintRatio();
      resetCustomPricePreview();
      cartEditSession = saved;
      if (restoration.recoveredApplied) trackBetaBuilderEvent('crop_cart_edit_applied_restored', cropAuditDetails('cart_edit_open'));
      trackBetaBuilderEvent('crop_cart_edit_open', cropAuditDetails('cart_edit_open'));
      render();
      if (state.sizeMode === 'custom') scheduleCustomPricePreview();
      showDraftNotice(cartEditCropNeedsApply
        ? 'Review and apply your crop before updating this saved print.'
        : restoration.recoveredApplied
          ? 'Your last applied crop was restored. Review it and your options before updating your cart.'
          : 'Editing your saved print. Review the crop, options and current price before updating your cart.', !cartEditCropNeedsApply);
      // Edits use a separate draft key. Refresh first verifies the original cart
      // line, then restores any work still saved in this tab.
      restoringDraft = false;
      await restoreDraft();
    } catch (error) {
      cartEditSession = null;
      state.addError = error.message || 'The saved print could not be restored.';
      showDraftNotice(state.addError + ' Return to your cart to keep the original item.');
      render();
    } finally {
      restoringDraft = false;
      draftReady = !!cartEditSession;
    }
  }

  function canonicalHandle(handle) {
    var value = String(handle || '').trim();
    return PRODUCT_ALIASES[value] || value;
  }

  function productByHandle(handle) {
    var resolved = canonicalHandle(handle);
    var products = bootstrap.productFamilies || [];
    for (var i = 0; i < products.length; i += 1) {
      if (products[i].handle === resolved || products[i].handle === handle) {
        return products[i];
      }
    }
    return null;
  }

  function productIsBuilderReady(product) {
    return !!(
      product &&
      product.productId &&
      Array.isArray(product.sizeProducts) &&
      product.sizeProducts.length
    );
  }

  function firstBuilderReadyHandle() {
    var products = bootstrap.productFamilies || [];

    for (var i = 0; i < products.length; i += 1) {
      if (productIsBuilderReady(products[i])) {
        return canonicalHandle(products[i].handle);
      }
    }

    return '';
  }

  function currentProduct() {
    return productByHandle(state.productHandle) || {};
  }

  function currentVariantId() {
    var selectedVariant = sourcePricingVariant();
    var value = selectedVariant && selectedVariant.id ? selectedVariant.id : '';
    var numeric = parseInt(value, 10);

    return Number.isFinite(numeric) && numeric > 0 ? String(numeric) : '';
  }

  function normalizeLookupText(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/&quot;|&#34;/g, '"')
      .replace(/[”“]/g, '"')
      .replace(/[’']/g, '')
      .replace(/\s+/g, ' ');
  }

  function normalizeOptionText(value) {
    return normalizeLookupText(value)
      .replace(/\binches\b/g, 'inch')
      .replace(/\s*-\s*/g, ' ')
      .replace(/[^a-z0-9/.]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function canonicalOptionText(kind, value) {
    var normalized = normalizeOptionText(value);
    var mediaAliases = {
      metallic: 'metallic glossy',
      'matte fibre': 'photo matt fibre',
      'matte fiber': 'photo matt fibre',
      'photo matte fibre': 'photo matt fibre',
      'photo matte fiber': 'photo matt fibre'
    };

    return kind === 'media' ? mediaAliases[normalized] || normalized : normalized;
  }

  function sizeKeyFromText(value) {
    var match = normalizeLookupText(value).match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/);

    return match ? match[1] + 'x' + match[2] : '';
  }

  function sizeProductKey(sizeProduct) {
    return sizeKeyFromText(sizeProduct && (sizeProduct.title || sizeProduct.handle));
  }

  function currentSizeProducts() {
    var product = currentProduct();

    return Array.isArray(product.sizeProducts) ? product.sizeProducts : [];
  }

  function sizeProductForSize(size) {
    var key = sizeKeyFromText(size && (size.key || size.label));
    var products = currentSizeProducts();

    for (var i = 0; i < products.length; i += 1) {
      if (sizeProductKey(products[i]) === key) {
        return products[i];
      }
    }

    return null;
  }

  function variantOptionNames(sizeProduct) {
    return Array.isArray(sizeProduct && sizeProduct.options) ? sizeProduct.options.map(function (option) {
      return option && option.name ? option.name : '';
    }) : [];
  }

  function variantOptionValues(variant) {
    if (Array.isArray(variant && variant.options)) {
      return variant.options;
    }

    return [variant && variant.option1, variant && variant.option2, variant && variant.option3].filter(function (value) {
      return value !== undefined && value !== null && value !== '';
    });
  }

  function variantTitleText(variant) {
    if (variant && variant.title) {
      return variant.title;
    }

    return variantOptionValues(variant).filter(Boolean).join(' / ');
  }

  function optionKind(optionName) {
    var normalized = normalizeOptionText(optionName);

    if (normalized.indexOf('media') !== -1 || normalized.indexOf('medium') !== -1 || normalized.indexOf('paper') !== -1 || normalized.indexOf('finish') !== -1 || normalized.indexOf('canvas') !== -1 || normalized.indexOf('surface') !== -1) {
      return 'media';
    }
    if (normalized.indexOf('stretcher') !== -1 || normalized.indexOf('depth') !== -1) {
      return 'wrap_depth';
    }
    if (normalized.indexOf('edge') !== -1 || normalized.indexOf('wrap') !== -1) {
      return 'edge_treatment';
    }
    if (normalized.indexOf('matting') !== -1 || normalized.indexOf('mat ') !== -1) {
      return 'matting_package';
    }
    if (normalized.indexOf('frame') !== -1) {
      return 'frame_package';
    }
    if (normalized.indexOf('mount') !== -1) {
      return 'mount';
    }
    if (normalized.indexOf('border') !== -1) {
      return 'border';
    }

    return normalized.replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
  }

  function hiddenOptionKinds() {
    var hidden = currentPreset().hiddenOptionKinds;
    return Array.isArray(hidden) ? hidden : [];
  }

  function isOptionKindHidden(kind) {
    return hiddenOptionKinds().indexOf(kind) !== -1;
  }

  function mediaDescriptor(name) {
    var pools = [FINE_ART_MEDIA, PHOTO_MEDIA, CANVAS_MEDIA, MAT_MEDIA];
    var lookup = canonicalOptionText('media', name);
    var fallback = {
      name: name,
      label: name,
      kind: 'media',
      spec: '',
      tone: 'neutral',
      sheet: '#f5ead8',
      swatch: ['#f7f3ea', '#ddd2be', '#b8a586']
    };

    for (var i = 0; i < pools.length; i += 1) {
      for (var j = 0; j < pools[i].length; j += 1) {
        if (canonicalOptionText('media', pools[i][j].name) === lookup) {
          return Object.assign({}, pools[i][j], {
            kind: 'media',
            label: pools[i][j].name
          });
        }
      }
    }

    return fallback;
  }

  function optionInches(value) {
    var text = String(value || '').toLowerCase().replace(/,/g, '.');
    var fraction = text.match(/(\d+)\s*\/\s*(\d+)/);
    var decimal = text.match(/(\d+(?:\.\d+)?|\.\d+)\s*(?:(?:-|\s)?in(?:ch(?:es)?)?\b|")/);

    if (text.indexOf('borderless') !== -1 || text.indexOf('full bleed') !== -1 || text.indexOf('no mat') !== -1) {
      return 0;
    }
    if (fraction) {
      return parseFloat(fraction[1]) / parseFloat(fraction[2]);
    }
    if (decimal) {
      return parseFloat(decimal[1]);
    }
    return 0;
  }

  function edgeCode(value) {
    var normalized = normalizeOptionText(value);

    if (normalized.indexOf('white') !== -1) {
      return 'white';
    }
    if (normalized.indexOf('black') !== -1) {
      return 'black';
    }
    if (normalized.indexOf('mirror') !== -1 || normalized.indexOf('mirrored') !== -1) {
      return 'mirror';
    }
    return normalizedOptionValue(value);
  }

  function isGalleryWrapProduct() {
    return canonicalHandle(state.productHandle) === 'gallery-wrapped-canvas-prints';
  }

  function isFramedPrintProduct() {
    return canonicalHandle(state.productHandle) === 'framed-prints';
  }

  function isTestPrintProduct() {
    return canonicalHandle(state.productHandle) === 'test-print';
  }

  function fixedQuantity() {
    var value = parseInt(currentPreset().fixedQuantity, 10);
    return Number.isFinite(value) && value > 0 ? value : 0;
  }

  function volumeDiscountsAvailable() {
    return currentPreset().volumeEligible !== false;
  }

  function framedPrintFrameColor(value) {
    var normalized = normalizeOptionText(value);

    if (normalized.indexOf('white') !== -1) {
      return '#eeeae1';
    }
    if (normalized.indexOf('walnut') !== -1) {
      return '#6a4933';
    }
    return '#20201f';
  }

  function isMiniPrintProduct() {
    return canonicalHandle(state.productHandle) === 'mini-prints';
  }

  function cropRotationAllowed() {
    return !isMiniPrintProduct();
  }

  function miniPrintSizePresetForKey(key) {
    return MINI_PRINT_SIZE_PRESETS[String(key || '').trim()] || null;
  }

  function miniPrintSizePreset(size) {
    var key = size && (size.key || sizeKeyFromText(size.label));

    return isMiniPrintProduct() ? miniPrintSizePresetForKey(key) : null;
  }

  function sizeSelectionKey(size) {
    return size ? String(size.key || sizeKeyFromText(size.label) || size.label || '') : '';
  }

  function sizeDisplayLabel(size) {
    var miniPreset = miniPrintSizePreset(size);

    if (miniPreset) {
      return miniPreset.label;
    }

    return size && size.label ? size.label : '';
  }

  function sizesMatch(a, b) {
    var aKey = sizeSelectionKey(a);
    var bKey = sizeSelectionKey(b);

    return !!aKey && aKey === bKey;
  }

  function isAllowedGalleryWrapEdgeOption(option) {
    var edge = option && option.edge ? option.edge : edgeCode(option && (option.label || option.name));

    return edge === 'mirror' || edge === 'white' || edge === 'black';
  }

  function filterOptionValuesForProduct(kind, values) {
    if (isGalleryWrapProduct() && kind === 'edge_treatment') {
      return values.filter(isAllowedGalleryWrapEdgeOption);
    }
    return values;
  }

  function optionDescriptor(kind, optionName, value) {
    var descriptor = kind === 'media'
      ? mediaDescriptor(value)
      : {
        name: value,
        label: value,
        kind: kind,
        spec: '',
        inch: optionInches(value)
      };

    descriptor.kind = kind;
    descriptor.optionName = optionName;
    descriptor.name = descriptor.name || value;
    descriptor.label = descriptor.label || value;

    if (kind === 'edge_treatment') {
      descriptor.edge = edgeCode(value);
    }
    if (kind === 'wrap_depth') {
      descriptor.inch = optionInches(value);
    }
    if (kind === 'frame_package') {
      descriptor.material = {
        frame: { color: framedPrintFrameColor(value) }
      };
    }
    if (kind === 'matting_package' && isFramedPrintProduct()) {
      descriptor.inch = optionInches(value);
      descriptor.material = {
        mat: { color: '#ffffff' }
      };
    }

    return descriptor;
  }

  function optionHelpText(option, group) {
    var kind = option && option.kind ? option.kind : group && group.kind;
    var label = normalizeOptionText(option && (option.label || option.name));

    if (kind === 'media') {
      if (label.indexOf('hot press') !== -1) {
        return 'Smooth cotton rag for crisp detail and clean color.';
      }
      if (label.indexOf('cold press') !== -1 || label.indexOf('photo rag') !== -1 || label.indexOf('william turner') !== -1) {
        return 'Textured matte paper for artwork with visible surface depth.';
      }
      if (label.indexOf('baryta') !== -1) {
        return 'Glossy fine-art paper for deeper blacks and contrast.';
      }
      if (label.indexOf('luster') !== -1) {
        return 'Classic photo finish with subtle texture and low glare.';
      }
      if (label.indexOf('glossy') !== -1) {
        return 'High-shine photo finish for saturated color and contrast.';
      }
      if (label.indexOf('metallic') !== -1) {
        return 'Pearlescent photo finish with extra depth in highlights.';
      }
      if (label.indexOf('matt fibre') !== -1 || label.indexOf('matte fibre') !== -1) {
        return 'Soft matte photo paper with a natural white base.';
      }
      if (label.indexOf('canvas') !== -1) {
        return 'Canvas surface for rolled or wrapped presentation.';
      }
      return 'Choose the surface that best matches the final presentation.';
    }

    if (kind === 'border') {
      return option && option.inch > 0
        ? 'Adds unprinted paper around the image.'
        : 'The image prints to the edge of the selected size.';
    }

    if (kind === 'edge_treatment') {
      return 'Controls what appears on the canvas sides.';
    }

    if (kind === 'wrap_depth') {
      return 'Sets the stretcher bar depth for the finished canvas.';
    }

    if (kind === 'mount') {
      return 'Adds a rigid backing for ready-to-display prints.';
    }

    if (kind === 'frame_package') {
      return 'Sets the visible frame finish around the completed print.';
    }

    if (kind === 'matting_package' && isFramedPrintProduct()) {
      return option && option.inch > 0
        ? 'Adds a 2-inch white mat inside the selected frame size.'
        : 'Places the print directly inside the selected frame.';
    }

    if (kind === 'matting_package' || kind === 'frame_package') {
      return 'Choose the finished outside presentation size.';
    }

    return '';
  }

  function fallbackOptionGroups() {
    var preset = currentPreset();
    var groups = [];
    var borderKind;
    var borderValues;

    if (Array.isArray(preset.media) && preset.media.length) {
      groups.push({
        kind: 'media',
        name: preset.mediaTitle || 'Media',
        values: preset.media.map(function (media) {
          return optionDescriptor('media', preset.mediaTitle || 'Media', media.name);
        })
      });
    }
    if (Array.isArray(preset.borders) && preset.borders.length) {
      borderKind = optionKind(preset.borderTitle || 'Border') || 'border';
      borderValues = preset.borders.map(function (border) {
        return Object.assign(optionDescriptor(borderKind, preset.borderTitle || 'Border', border.label), border);
      });
      borderValues = filterOptionValuesForProduct(borderKind, borderValues);

      if (borderValues.length) {
        groups.push({
          kind: borderKind,
          name: preset.borderTitle || 'Border',
          values: borderValues
        });
      }
    }

    return groups.filter(function (group) {
      return !isOptionKindHidden(group.kind);
    });
  }

  function optionGroupsForSize(size) {
    var sizeProduct = sizeProductForSize(size) || currentSizeProducts()[0];
    var variants = Array.isArray(sizeProduct && sizeProduct.variants) ? sizeProduct.variants : [];
    var options = Array.isArray(sizeProduct && sizeProduct.options) ? sizeProduct.options : [];
    var groups = [];

    if (!options.length) {
      return fallbackOptionGroups();
    }

    options.forEach(function (option, index) {
      var kind = optionKind(option && option.name);
      var seen = {};
      var values = [];

      if (!kind || isOptionKindHidden(kind)) {
        return;
      }

      variants.forEach(function (variant) {
        var optionValue = variantOptionValues(variant)[index];
        var key = normalizeOptionText(optionValue);

        if (variant.available === false || !key || seen[key]) {
          return;
        }
        seen[key] = true;
        values.push(optionDescriptor(kind, option.name, optionValue));
      });

      if (!values.length && Array.isArray(option.values)) {
        option.values.forEach(function (optionValue) {
          var key = normalizeOptionText(optionValue);
          if (key && !seen[key]) {
            seen[key] = true;
            values.push(optionDescriptor(kind, option.name, optionValue));
          }
        });
      }

      values = filterOptionValuesForProduct(kind, values);

      if (values.length) {
        groups.push({
          kind: kind,
          name: option.name,
          values: values
        });
      }
    });

    return groups;
  }

  function currentOptionGroups() {
    return optionGroupsForSize(state.size);
  }

  function optionGroupsByKind() {
    var groups = {};
    currentOptionGroups().forEach(function (group) {
      groups[group.kind] = group;
    });
    return groups;
  }

  function selectedOption(kind) {
    return state.options && state.options[kind] ? state.options[kind] : null;
  }

  function selectedOptionsList() {
    return currentOptionGroups().map(function (group) {
      return selectedOption(group.kind);
    }).filter(Boolean);
  }

  function stepIsAvailable(key) {
    if (key === 'border') {
      return requiredOptionGroups('secondary').length > 0;
    }

    return true;
  }

  function closeUnavailableOpenStep() {
    if (state.open && !stepIsAvailable(state.open)) {
      state.open = null;
    }
  }

  function selectedOptionLabel(kind, selections) {
    var selected = (selections || state.options || {})[kind];
    return selected && (selected.label || selected.name) ? selected.label || selected.name : '';
  }

  function setSelectedOption(kind, option) {
    state.options = state.options || {};
    state.options[kind] = option;

    if (kind === 'media') {
      state.media = option;
    }
    if (kind === 'border' || kind === 'edge_treatment' || kind === 'mount' || kind === 'matting_package' || kind === 'frame_package') {
      state.border = option;
    }
  }

  function resetSelectedOptions() {
    state.options = {};
    state.media = null;
    state.border = null;
  }

  function pruneSelectedOptions() {
    var groups = optionGroupsByKind();
    var next = {};

    Object.keys(state.options || {}).forEach(function (kind) {
      var selected = state.options[kind];
      var group = groups[kind];
      var stillAvailable = group && group.values.some(function (option) {
        return normalizeOptionText(option.label || option.name) === normalizeOptionText(selected && (selected.label || selected.name));
      });

      if (stillAvailable) {
        next[kind] = selected;
      }
    });

    state.options = next;
    state.media = next.media || null;
    state.border = next.border || next.edge_treatment || next.mount || next.matting_package || next.frame_package || null;
  }

  function requiredOptionGroups(kindFilter) {
    return currentOptionGroups().filter(function (group) {
      if (kindFilter === 'media') {
        return group.kind === 'media';
      }
      if (kindFilter === 'secondary') {
        return group.kind !== 'media';
      }
      return true;
    });
  }

  function optionGroupsComplete(kindFilter) {
    return requiredOptionGroups(kindFilter).every(function (group) {
      return !!selectedOption(group.kind);
    });
  }

  function nextMissingOptionLabel(kindFilter) {
    var missing = requiredOptionGroups(kindFilter).filter(function (group) {
      return !selectedOption(group.kind);
    });

    return missing.length ? missing[0].name.toLowerCase() : '';
  }

  function optionSummary(kindFilter) {
    return requiredOptionGroups(kindFilter).map(function (group) {
      var selected = selectedOption(group.kind);
      return selected ? selected.label || selected.name : '';
    }).filter(Boolean).join(' - ');
  }

  function variantMatchesSelections(sizeProduct, variant, selections) {
    var names = variantOptionNames(sizeProduct);
    var values = variantOptionValues(variant);

    for (var i = 0; i < names.length; i += 1) {
      var kind = optionKind(names[i]);
      var selectedValue = selectedOptionLabel(kind, selections);

      if (selectedValue && canonicalOptionText(kind, values[i]) !== canonicalOptionText(kind, selectedValue)) {
        return false;
      }
    }

    return true;
  }

  function priceValueFromText(value) {
    var match = String(value || '').replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
    var price = match ? parseFloat(match[1]) : 0;

    return Number.isFinite(price) ? price : 0;
  }

  function variantPriceValue(variant) {
    var formattedPrice = priceValueFromText(variant && variant.priceFormatted);
    var price = parseFloat(variant && variant.price);

    if (formattedPrice > 0) {
      return formattedPrice;
    }

    if (!Number.isFinite(price)) {
      return 0;
    }

    return price > 100 ? price / 100 : price;
  }

  function moneyText(value) {
    var price = parseFloat(value);

    if (!Number.isFinite(price)) {
      return '$-';
    }
    if (Math.abs(price - Math.round(price)) < 0.001) {
      return '$' + Math.round(price);
    }
    return '$' + price.toFixed(2);
  }

  function selectedPricingVariantForSize(size, selections) {
    var sizeProduct = sizeProductForSize(size);
    var variants = Array.isArray(sizeProduct && sizeProduct.variants) ? sizeProduct.variants : [];
    var selected = selections || state.options || {};

    for (var i = 0; i < variants.length; i += 1) {
      if (variants[i].available !== false && variantMatchesSelections(sizeProduct, variants[i], selected)) {
        return variants[i];
      }
    }

    return null;
  }

  function selectedPricingVariant() {
    return state.size ? selectedPricingVariantForSize(state.size) : null;
  }

  function sourcePricingVariant() {
    return state.sizeMode === 'custom'
      ? seedVariantForCustomPricing()
      : selectedPricingVariant();
  }

  function lowestVariantPriceForSize(size) {
    var sizeProduct = sizeProductForSize(size);
    var variants = Array.isArray(sizeProduct && sizeProduct.variants) ? sizeProduct.variants : [];
    var lowest = null;

    variants.forEach(function (variant) {
      var price = variantPriceValue(variant);

      if (variant.available !== false && price > 0 && (lowest === null || price < lowest)) {
        lowest = price;
      }
    });

    return lowest;
  }

  function clearCustomPriceTimer() {
    if (customPriceTimer) {
      window.clearTimeout(customPriceTimer);
      customPriceTimer = null;
    }
  }

  function resetCustomPricePreview() {
    clearCustomPriceTimer();
    customPriceRequestId += 1;
    state.customPricePending = false;
    state.customPriceValue = null;
    state.customPriceError = '';
    state.customPriceFormula = '';
    state.customPriceType = '';
    state.customPriceKey = '';
  }

  function seedVariantForCustomPricing() {
    var products = currentSizeProducts();
    var selected = state.options || {};

    for (var i = 0; i < products.length; i += 1) {
      var sizeProduct = products[i];
      var variants = Array.isArray(sizeProduct && sizeProduct.variants) ? sizeProduct.variants : [];

      for (var j = 0; j < variants.length; j += 1) {
        if (variants[j].available !== false && variantMatchesSelections(sizeProduct, variants[j], selected)) {
          return variants[j];
        }
      }
    }

    return null;
  }

  function customPriceInput() {
    var w = parseFloat(state.customW);
    var h = parseFloat(state.customH);
    var sizeError;
    var media = selectedOption('media');
    var product = currentProduct();
    var seedVariant;
    var variantTitle;
    var borderCode;
    var optionDetails = selectedOptionsList().map(function (option) {
      return option.label || option.name;
    });

    if (state.sizeMode !== 'custom') {
      return null;
    }
    if (!(w > 0) || !(h > 0) || !media || !optionGroupsComplete()) {
      return null;
    }

    sizeError = customSizeError();
    if (sizeError) {
      return {
        error: sizeError
      };
    }

    seedVariant = seedVariantForCustomPricing();
    variantTitle = variantTitleText(seedVariant);
    borderCode = borderCodeFromSelection();

    if (!seedVariant || !variantTitle) {
      return {
        error: 'Choose an available option combination to load custom pricing.'
      };
    }

    return {
      width: w,
      height: h,
      productFamily: canonicalHandle(state.productHandle),
      productTitle: product.title || productTitle(state.productHandle),
      variantTitle: variantTitle,
      media: media.name,
      borderCode: borderCode,
      key: [
        canonicalHandle(state.productHandle),
        formatInches(w),
        formatInches(h),
        optionDetails.join('/'),
        borderCode,
        variantTitle
      ].join('|')
    };
  }

  function scheduleCustomPricePreview(options) {
    var input = customPriceInput();
    var delay = options && Number.isFinite(options.debounceMs) ? options.debounceMs : 350;

    // Keep the scheduled or in-flight request when Set size repeats its inputs.
    if (state.sizeMode === 'custom' && input && !input.error &&
        state.customPriceKey === input.key && (state.customPricePending || state.customPriceValue > 0)) {
      return;
    }

    clearCustomPriceTimer();

    if (state.sizeMode !== 'custom') {
      resetCustomPricePreview();
      return;
    }

    if (!input) {
      state.customPricePending = false;
      state.customPriceValue = null;
      state.customPriceError = '';
      state.customPriceFormula = '';
      state.customPriceType = '';
      state.customPriceKey = '';
      return;
    }

    if (input.error) {
      state.customPricePending = false;
      state.customPriceValue = null;
      state.customPriceError = input.error;
      state.customPriceFormula = '';
      state.customPriceType = '';
      state.customPriceKey = '';
      return;
    }

    state.customPricePending = true;
    state.customPriceValue = null;
    state.customPriceError = '';
    state.customPriceFormula = '';
    state.customPriceType = '';
    state.customPriceKey = input.key;

    var requestId = customPriceRequestId + 1;
    customPriceRequestId = requestId;
    customPriceTimer = window.setTimeout(function () {
      customPriceTimer = null;
      requestCustomPricePreview(input, requestId);
    }, Math.max(0, delay));
  }

  function requestCustomPricePreview(input, requestId) {
    return fetchJson(apiBaseUrl() + '/create-orders/ajax/calculate-custom-price/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        width: input.width,
        height: input.height,
        product_family: input.productFamily,
        product_title: input.productTitle,
        variant_title: input.variantTitle,
        media: input.media,
        border_code: input.borderCode
      })
    }).then(function (responseData) {
      var price = parseFloat(responseData.price);

      if (requestId !== customPriceRequestId || state.customPriceKey !== input.key) {
        return;
      }

      if (!(price > 0)) {
        throw new Error('Pricing unavailable for this custom size.');
      }

      state.customPricePending = false;
      state.customPriceValue = roundPrice(price);
      state.customPriceError = '';
      state.customPriceFormula = responseData.formula || '';
      state.customPriceType = responseData.type || '';
      trackBetaBuilderEvent('custom_price_preview_succeeded', {
        image_size: input.width + 'x' + input.height,
        border_code: input.borderCode,
        media: input.media,
        price: state.customPriceValue,
        status: responseData.type || ''
      });
      renderDock();
    }).catch(function (error) {
      if (requestId !== customPriceRequestId || state.customPriceKey !== input.key) {
        return;
      }

      state.customPricePending = false;
      state.customPriceValue = null;
      state.customPriceError = error && error.message ? error.message : 'Custom pricing unavailable.';
      state.customPriceFormula = '';
      state.customPriceType = '';
      trackBetaBuilderEvent('custom_price_preview_failed', {
        image_size: input.width + 'x' + input.height,
        border_code: input.borderCode,
        media: input.media,
        error_code: error && error.errorCode ? error.errorCode : '',
        status_code: error && error.statusCode ? error.statusCode : '',
        error_message: state.customPriceError
      });
      renderDock();
    });
  }

  function supportsGeneratedCartProduct() {
    return state.sizeMode === 'custom' &&
      !!GENERATED_PRODUCT_HANDLES[canonicalHandle(state.productHandle)];
  }

  function currentPreset() {
    var handle = canonicalHandle(state.productHandle || '');
    if (PRODUCT_PRESETS[handle]) {
      return PRODUCT_PRESETS[handle];
    }
    if (handle.indexOf('canvas') !== -1) {
      return PRODUCT_PRESETS['rolled-canvas-prints'];
    }
    if (handle.indexOf('mat') !== -1 || handle.indexOf('frame') !== -1) {
      return PRODUCT_PRESETS['matting-package-prints'];
    }
    return PRODUCT_PRESETS['giclee-fine-art-prints'];
  }

  function productTitle(handle) {
    var resolved = canonicalHandle(handle);
    var preset = PRODUCT_PRESETS[resolved];
    var product = productByHandle(resolved);

    if (preset && preset.title) {
      return preset.title;
    }

    return product && product.title ? product.title : titleize(resolved);
  }

  function titleize(value) {
    return String(value || 'Custom print')
      .replace(/-/g, ' ')
      .replace(/\b\w/g, function (match) { return match.toUpperCase(); });
  }

  function apiBaseUrl() {
    return String(bootstrap.apiBaseUrl || 'https://backend.thestackhouse.com').replace(/\/$/, '');
  }

  function uploadV2Enabled() {
    return bootstrap.uploadV2Enabled === true;
  }

  function customerId() {
    return bootstrap.customer && bootstrap.customer.id ? String(bootstrap.customer.id) : '';
  }

  function customerLoginUrl() {
    var returnTarget = window.location.pathname + window.location.search + window.location.hash;

    if (!returnTarget || returnTarget === '/') {
      returnTarget = '/pages/start-order';
    }

    return '/account/login?return_url=' + encodeURIComponent(returnTarget);
  }

  function numericValue() {
    for (var i = 0; i < arguments.length; i += 1) {
      var value = parseFloat(arguments[i]);

      if (Number.isFinite(value) && value > 0) {
        return value;
      }
    }

    return null;
  }

  function fileSizeMb(bytes) {
    var value = parseFloat(bytes);

    if (Number.isFinite(value) && value > 0) {
      return Math.round(value / 1024 / 1024 * 10) / 10;
    }

    return null;
  }

  function accelerateS3Url(url) {
    return String(url || '').replace('.s3.amazonaws.com', '.s3-accelerate.amazonaws.com');
  }

  function imageOrderValue(image) {
    return image && (image.order || image.unique_id || image.uniqueId || image.id) ? String(image.order || image.unique_id || image.uniqueId || image.id) : '';
  }

  function photoId(photo) {
    return photo && (photo.id || photo.order || photo.src || photo.name) ? String(photo.id || photo.order || photo.src || photo.name) : '';
  }

  function stableCustomerThumbnailUrl(image, fallback) {
    return window.StackhouseLibraryThumbnails.url(image, fallback);
  }

  function normalizeLibraryImage(image) {
    if (!image || typeof image !== 'object') {
      return null;
    }

    var metadata = image.metadata || image.image_metadata || {};
    var directSrc = accelerateS3Url(image.converted_file || image.cropped_file_thumb || image.thumbnail_file || image.preview_file || image.original_file || image.public_url || '');
    var w = numericValue(
      image.source_oriented_width,
      image.original_width,
      image.width,
      metadata.source_oriented_width,
      metadata.original_width,
      metadata.width
    );
    var h = numericValue(
      image.source_oriented_height,
      image.original_height,
      image.height,
      metadata.source_oriented_height,
      metadata.original_height,
      metadata.height
    );
    var mb = fileSizeMb(image.file_size || image.size || metadata.file_size || metadata.size);
    var order = imageOrderValue(image);
    var name = image.original_file_name || image.file_name || image.name || (order ? 'Upload ' + order : 'Uploaded image');
    var maxInch = w && h ? Math.max(4, Math.floor(Math.min(w, h) / 300)) : 99;
    var src = stableCustomerThumbnailUrl(image, directSrc);

    if (!src) {
      return null;
    }

    return {
      id: order || src,
      order: order,
      name: name,
      src: src,
      thumbnailSrc: typeof window.StackhouseLibraryThumbnails.gridUrl === 'function'
        ? window.StackhouseLibraryThumbnails.gridUrl(image, directSrc) : src,
      w: w || 0,
      h: h || 0,
      mb: mb,
      lowRes: w && h ? maxInch < 8 : false,
      maxInch: maxInch,
      backend: image
    };
  }

  function waitForLibraryReadiness(delayMs) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, delayMs);
    });
  }

  async function requestLibraryArtworkReadiness(payload) {
    for (var requestAttempt = 0; requestAttempt < 3; requestAttempt += 1) {
      try {
        return await fetchJson(apiBaseUrl() + '/api/library-artwork/readiness/', {
          method: 'POST',
          headers: window.stackhouseCustomerAccessHeaders({ 'Content-Type': 'application/json' }),
          body: JSON.stringify(payload)
        });
      } catch (error) {
        var code = error && (error.errorCode || error.code);
        if (code === 'CUSTOMER_AUTH_INVALID' || code === 'GUEST_SESSION_INVALID') {
          error.message = 'Your secure artwork session expired or could not be verified. Refresh this page, then choose your artwork again if prompted.';
          throw error;
        }
        var interrupted = error && error.name === 'TypeError' && !error.statusCode &&
          /failed to fetch|load failed|networkerror|network request failed/i.test(error.message || '');
        var unavailable = error && error.retryable === true &&
          [408, 429, 500, 502, 503, 504].indexOf(error.statusCode) !== -1;
        if (!interrupted && !unavailable) throw error;
        if (requestAttempt === 2) {
          if (interrupted) {
            error.errorCode = 'LIBRARY_READINESS_NETWORK_ERROR';
            error.retryable = true;
            error.message = 'The connection was interrupted while checking your artwork. Check your connection and try again. Your cart was not changed by this artwork check.';
          }
          throw error;
        }
        trackBetaBuilderEvent('library_readiness_request_retried', {
          failure_phase: 'artwork_readiness',
          error_code: code || 'LIBRARY_READINESS_NETWORK_ERROR',
          response_status: error.statusCode || 0,
          attempt: requestAttempt + 1
        });
        await waitForLibraryReadiness(500 * (requestAttempt + 1));
      }
    }
  }

  async function requireLibraryArtworkReady(photo) {
    var backend = photo && photo.backend && typeof photo.backend === 'object' ? photo.backend : {};
    var orderId = imageOrderValue(backend) || imageOrderValue(photo);
    var imageId = backend.id || backend.image_id || backend.pk || '';

    if (!orderId || !imageId) {
      var identityError = new Error('We could not verify this saved file. Choose it again or upload it again.');
      identityError.code = 'LIBRARY_ARTWORK_IDENTITY_INVALID';
      throw identityError;
    }

    for (var attempt = 0; attempt < 60; attempt += 1) {
      var payload = {
        order_id: String(orderId),
        image_id: String(imageId),
        upload_surface: 'order_builder'
      };
      if (customerId()) {
        payload.customer_id = customerId();
      }
      if (typeof window.stackhouseAuthorizeCustomerPayload === 'function') {
        payload = window.stackhouseAuthorizeCustomerPayload(payload);
      }
      var readiness = await requestLibraryArtworkReadiness(payload);

      if (readiness.status === 'ready') {
        var verifiedWidth = Number(readiness.source_width);
        var verifiedHeight = Number(readiness.source_height);
        if (!(verifiedWidth > 0 && verifiedHeight > 0)) {
          var dimensionsError = new Error('We could not verify this file\'s pixel dimensions. Try again or upload a new copy.');
          dimensionsError.code = 'LIBRARY_SOURCE_DIMENSIONS_UNAVAILABLE';
          throw dimensionsError;
        }
        if (photo === state.photo && photo.w && photo.h &&
            (photo.w !== verifiedWidth || photo.h !== verifiedHeight)) {
          var changedError = new Error('This file\'s dimensions changed. Choose it again before ordering.');
          changedError.code = 'LIBRARY_SOURCE_DIMENSIONS_CHANGED';
          throw changedError;
        }
        photo.w = verifiedWidth;
        photo.h = verifiedHeight;
        photo.libraryReadiness = {
          sourceIdentity: readiness.source_identity || '',
          policyVersion: readiness.policy_version || '',
          evidence: readiness.evidence || ''
        };
        return readiness;
      }
      if (readiness.status !== 'processing') {
        var rejected = new Error(readiness.message || 'This saved file did not pass the current artwork requirements.');
        rejected.code = readiness.error_code || 'LIBRARY_VALIDATION_FAILED';
        rejected.helpLink = readiness.help_link || '';
        throw rejected;
      }
      await waitForLibraryReadiness(2000);
    }

    var timeoutError = new Error('Validation is taking longer than expected. Try this saved file again in a moment.');
    timeoutError.code = 'LIBRARY_VALIDATION_TIMEOUT';
    throw timeoutError;
  }

  function clearLibrarySelection() {
    state.librarySelection = null;
  }

  function librarySelectionIsCurrent(selection) {
    return state.librarySelection === selection
      && selection.owner === customerId()
      && selection.accessOwner === libraryCustomerId()
      && (!selection.isCurrent || selection.isCurrent());
  }

  function beginLibrarySelection(photo, source, isCurrent) {
    var selection = {
      photo: photo,
      source: source || 'account_image_library',
      isCurrent: isCurrent,
      owner: customerId(),
      accessOwner: libraryCustomerId(),
      status: 'checking',
      message: '',
      helpLink: ''
    };
    state.librarySelection = selection;
    renderLibrary();
    return selection;
  }

  function failLibrarySelection(selection, error) {
    if (!librarySelectionIsCurrent(selection)) return;
    selection.status = 'failed';
    selection.message = error && error.message
      ? error.message
      : 'We could not verify this saved file. Upload it again or choose another image.';
    selection.helpLink = error && error.helpLink ? error.helpLink : '';
    trackBetaBuilderEvent('library_photo_validation_failed', {
      source: selection.source,
      error_code: error && (error.errorCode || error.code),
      error_message: selection.message
    });
    renderLibrary();
  }

  async function selectLibraryPhoto(photo, source, isCurrent) {
    if (librarySelectionBlocked()) return;
    var selection = beginLibrarySelection(photo, source, isCurrent);
    try {
      await requireLibraryArtworkReady(photo);
      if (!librarySelectionIsCurrent(selection)) return;
      if (librarySelectionBlocked()) {
        clearLibrarySelection();
        renderLibrary();
        return;
      }
      setPhoto(photo);
      trackBetaBuilderEvent('library_photo_selected', {
        source: selection.source,
        file_extension: fileExtensionFromName(photo.name || ''),
        image_size: photo.w && photo.h ? photo.w + 'x' + photo.h : ''
      });
    } catch (error) {
      failLibrarySelection(selection, error);
    }
  }

  async function retryLibrarySelection() {
    var selection = state.librarySelection;
    if (!selection || selection.status !== 'failed' || !librarySelectionIsCurrent(selection)) return;
    if (selection.lookupId) await selectLibraryDeepLink(selection.lookupId);
    else await selectLibraryPhoto(selection.photo, selection.source, selection.isCurrent);
  }

  function parseBackendImage(value) {
    if (!value) {
      return null;
    }

    if (typeof value === 'string') {
      try {
        return JSON.parse(value);
      } catch (error) {
        return null;
      }
    }

    return typeof value === 'object' ? value : null;
  }

  function updateUploadStatus(title, status) {
    state.uploadTitle = title || '';
    state.uploadStatus = status || '';

    if (els.uploadTitle) {
      els.uploadTitle.textContent = state.uploadTitle || 'Uploading file...';
    }
    if (els.uploadStatus) {
      els.uploadStatus.textContent = friendlyUploadErrorMessage(state.uploadStatus) || 'Creating a validation-ready upload session.';
    }
  }

  function friendlyUploadErrorMessage(message) {
    return String(message || '').replace(
      /^L color mode is not supported\./i,
      'Grayscale color mode is not supported.'
    );
  }

  function uploadHelpUrl(value) {
    try {
      var url = new URL(String(value || ''));
      return url.protocol === 'https:' && !url.username && !url.password ? url.href : '';
    } catch (_error) {
      return '';
    }
  }

  function configureUploadHelp(link, value) {
    var href = uploadHelpUrl(value);
    link.hidden = !href;
    if (href) link.href = href;
    else link.removeAttribute('href');
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
  }

  function revokeLocalPreviewUrl() {
    if (activeLocalPreviewUrl && activeLocalPreviewUrl.indexOf('blob:') === 0) {
      URL.revokeObjectURL(activeLocalPreviewUrl);
    }
    activeLocalPreviewUrl = '';
  }

  function isTiffFile(file) {
    var name = file && file.name ? file.name.toLowerCase() : '';
    var type = file && file.type ? file.type.toLowerCase() : '';

    return type === 'image/tiff' || type === 'image/tif' || /\.(tif|tiff)$/.test(name);
  }

  function waitForTiffDecoder() {
    return new Promise(function (resolve) {
      var attempts = 0;

      function check() {
        if (window.UTIF) {
          resolve(window.UTIF);
          return;
        }
        attempts += 1;
        if (attempts >= 30) {
          resolve(null);
          return;
        }
        window.setTimeout(check, 100);
      }

      check();
    });
  }

  function blobFromCanvas(canvas, type) {
    return new Promise(function (resolve) {
      if (!canvas || !canvas.toBlob) {
        resolve(null);
        return;
      }
      canvas.toBlob(function (blob) {
        resolve(blob);
      }, type || 'image/png');
    });
  }

  async function readTiffLocalImageMetadata(file) {
    var UTIF = await waitForTiffDecoder();

    if (!UTIF) {
      return {
        localUrl: '',
        mb: Math.round(file.size / 1024 / 1024 * 10) / 10,
        previewError: 'TIFF preview decoder did not load.'
      };
    }

    return new Promise(function (resolve) {
      var reader = new FileReader();

      reader.onload = async function (event) {
        try {
          var buffer = event.target.result;
          var ifds = UTIF.decode(buffer);
          var ifd = ifds && ifds[0];
          var width;
          var height;
          var rgba;
          var sourceCanvas;
          var sourceContext;
          var previewCanvas;
          var previewContext;
          var maxPreviewSide = 1800;
          var scale;
          var previewWidth;
          var previewHeight;
          var previewBlob;

          if (!ifd) {
            throw new Error('No TIFF image directory found.');
          }

          UTIF.decodeImage(buffer, ifd);
          width = ifd.width || (ifd.t256 && ifd.t256[0]) || 0;
          height = ifd.height || (ifd.t257 && ifd.t257[0]) || 0;

          if (!(width > 0) || !(height > 0)) {
            throw new Error('TIFF dimensions could not be read.');
          }

          rgba = UTIF.toRGBA8(ifd);
          sourceCanvas = document.createElement('canvas');
          sourceCanvas.width = width;
          sourceCanvas.height = height;
          sourceContext = sourceCanvas.getContext('2d');
          sourceContext.putImageData(new ImageData(new Uint8ClampedArray(rgba), width, height), 0, 0);

          scale = Math.min(1, maxPreviewSide / Math.max(width, height));
          previewWidth = Math.max(1, Math.round(width * scale));
          previewHeight = Math.max(1, Math.round(height * scale));
          previewCanvas = document.createElement('canvas');
          previewCanvas.width = previewWidth;
          previewCanvas.height = previewHeight;
          previewContext = previewCanvas.getContext('2d');
          previewContext.drawImage(sourceCanvas, 0, 0, previewWidth, previewHeight);
          previewBlob = await blobFromCanvas(previewCanvas, 'image/png');

          resolve({
            localUrl: previewCanvas.toDataURL('image/png'),
            previewBlob: previewBlob,
            previewW: previewWidth,
            previewH: previewHeight,
            w: width,
            h: height,
            mb: Math.round(file.size / 1024 / 1024 * 10) / 10
          });
        } catch (error) {
          resolve({
            localUrl: '',
            w: 0,
            h: 0,
            mb: Math.round(file.size / 1024 / 1024 * 10) / 10,
            previewError: error && error.message ? error.message : 'TIFF preview could not be generated.'
          });
        }
      };
      reader.onerror = function () {
        resolve({
          localUrl: '',
          w: 0,
          h: 0,
          mb: Math.round(file.size / 1024 / 1024 * 10) / 10,
          previewError: 'TIFF file could not be read.'
        });
      };
      reader.readAsArrayBuffer(file);
    });
  }

  function validateUploadFile(file) {
    var name = file && file.name ? file.name.toLowerCase() : '';
    var type = file && file.type ? file.type.toLowerCase() : '';
    var allowedType = /^image\/(jpeg|png|tiff?|heic|heif)$/.test(type);
    var allowedExtension = /\.(jpe?g|png|tiff?|heic|heif)$/.test(name);

    if (!file) {
      return 'Choose an image file to upload.';
    }
    if (!allowedType && !allowedExtension) {
      return 'Please upload a supported JPEG, PNG, TIFF, or HEIC photo.';
    }
    if (file.size < 1024) {
      return 'That file is too small to be a valid print image.';
    }
    if (file.size > 1024 * 1024 * 1024) {
      return 'Image file is too large. Maximum size is 1 GB.';
    }
    return '';
  }

  function readLocalImageMetadata(file, existingLocalUrl) {
    return new Promise(function (resolve) {
      if (!file) {
        resolve({});
        return;
      }

      if (isTiffFile(file)) {
        readTiffLocalImageMetadata(file).then(resolve);
        return;
      }

      var localUrl = existingLocalUrl || URL.createObjectURL(file);
      var image = new Image();
      var settled = false;

      function finish(metadata) {
        if (settled) {
          return;
        }
        settled = true;
        resolve(Object.assign({
          localUrl: localUrl,
          mb: Math.round(file.size / 1024 / 1024 * 10) / 10
        }, metadata || {}));
      }

      image.onload = function () {
        finish({ w: image.naturalWidth || 0, h: image.naturalHeight || 0 });
      };
      image.onerror = function () {
        finish({ w: 0, h: 0 });
      };
      image.src = localUrl;
    });
  }

  function uploadResponsePhoto(file, result, localMeta) {
    var imageObject = parseBackendImage(result && result.image_object);
    var normalized = normalizeLibraryImage(imageObject);
    var localUrl = localMeta && localMeta.localUrl ? localMeta.localUrl : '';

    if (normalized) {
      if (!normalized.src && localUrl) {
        normalized.src = localUrl;
      }
      if (!normalized.w && localMeta && localMeta.w) {
        normalized.w = localMeta.w;
      }
      if (!normalized.h && localMeta && localMeta.h) {
        normalized.h = localMeta.h;
      }
      if (!normalized.mb && localMeta && localMeta.mb) {
        normalized.mb = localMeta.mb;
      }
      normalized.backend = Object.assign({}, result || {}, imageObject || {});
      return normalized;
    }

    return {
      id: (result && (result.uniqueId || result.unique_id)) || file.name,
      order: (result && (result.uniqueId || result.unique_id)) || '',
      name: file.name,
      src: localUrl,
      w: localMeta && localMeta.w ? localMeta.w : 0,
      h: localMeta && localMeta.h ? localMeta.h : 0,
      mb: localMeta && localMeta.mb ? localMeta.mb : null,
      lowRes: false,
      maxInch: localMeta && localMeta.w && localMeta.h ? Math.max(4, Math.floor(Math.min(localMeta.w, localMeta.h) / DEFAULT_PRINT_DPI)) : 99,
      backend: result || {}
    };
  }

  function fetchJson(url, options) {
    return (window.stackhouseCustomerFetch || fetch)(url, options).then(function (response) {
      return response.json().catch(function () {
        return {};
      }).then(function (data) {
        if (!response.ok) {
          var error = new Error(data.error || data.detail || data.message || 'Request failed with status ' + response.status);
          error.statusCode = response.status;
          error.errorCode = data.error_code || data.error_type || data.code || '';
          error.helpLink = data.help_link || data.support_link || '';
          if (typeof data.retryable === 'boolean') error.retryable = data.retryable;
          throw error;
        }
        return data;
      });
    });
  }

  function betaBuilderDetails(extra) {
    var product = currentProduct();
    var frameSize = selectedSizeDimensions();
    var imageSize = selectedPrintOpeningDimensions() || frameSize;
    var finalSize = imageSize ? finalSizeDimensions(imageSize) : null;
    var selectedVariant = sourcePricingVariant();
    var mediaOption = selectedOption('media');
    var borderOption = selectedOption('border') || selectedOption('edge_treatment') || selectedOption('mount') || selectedOption('matting_package') || selectedOption('frame_package');
    var details = {
      builder: 'beta_order_builder',
      source: 'single-order-page-preview',
      step: state.open || '',
      product_handle: canonicalHandle(state.productHandle),
      product_id: product.productId || product.id || '',
      product_title: productTitle(state.productHandle),
      variant_id: currentVariantId(),
      variant_title: selectedVariant && selectedVariant.title ? selectedVariant.title : '',
      image_size: imageSize ? imageSize.label : '',
      final_size: finalSize ? finalSize.label : '',
      media: mediaOption && (mediaOption.label || mediaOption.name),
      border: borderOption && (borderOption.label || borderOption.name),
      option_selections: selectedOptionsList().map(function (option) {
        return { name: option.name || option.kind || '', value: option.label || option.name || '' };
      }),
      quantity: state.qty,
      price: currentPrice() || '',
      currency: bootstrap.currency || '',
      test_print: isTestPrintProduct() ? 'Yes' : '',
      test_print_version: isTestPrintProduct() ? 'test-print-v1' : ''
    };

    return Object.assign(details, assistantTelemetry ? assistantTelemetry.snapshot(state) : {}, extra || {});
  }

  // Crop evidence observes the recipe and never changes cart or render inputs.
  var cropAuditTracker;
  var cropAuditPayloadId = '';
  var cropAuditAcknowledgedRevision = '';
  function cropTracker() {
    if (!cropAuditTracker && window.StackhouseCropTelemetry) cropAuditTracker = window.StackhouseCropTelemetry.createTracker();
    return cropAuditTracker;
  }
  function cropAuditFacts(stage) {
    var crop = buildCropPayload();
    var dimensions = photoPixelDimensions() || {};
    var backend = state.photo && state.photo.backend || {};
    var fit = previewFitForRatio(activeRatio().ratio).imageFit;
    return {
      crop_x: crop._Crop_X, crop_y: crop._Crop_Y,
      crop_width: crop._Crop_Width, crop_height: crop._Crop_Height,
      crop_space: 'oriented', crop_source_id: String(backend.ID || backend.id || imageOrderValue(backend) || ''),
      crop_source_width: dimensions.w, crop_source_height: dimensions.h,
      crop_zoom: state.zoom, crop_offset_x: state.cropX, crop_offset_y: state.cropY,
      crop_preview_width: fit.w, crop_preview_height: fit.h, crop_rotation: state.cropRotation,
      crop_stage: stage || 'state',
      crop_trace_id: window.StackhouseOperationalTelemetry ? window.StackhouseOperationalTelemetry.traceId() : ''
    };
  }
  function cropAuditDetails(stage, action) {
    try {
      var tracker = cropTracker();
      if (!tracker) return {};
      var facts = cropAuditFacts(stage);
      var result = action === 'apply' ? tracker.apply(facts) : action === 'request' ? tracker.request(facts) : tracker.snapshot(facts);
      if (action !== 'request' && result.crop_revision === cropAuditAcknowledgedRevision) result.production_payload_id = cropAuditPayloadId;
      if (cartEditSession && cartEditSession.line) result.previous_payload_id = cartEditSession.line.properties['_Production Payload ID'];
      return result;
    } catch (error) { return {}; }
  }
  function rememberCropAcknowledgement(response) {
    try {
      var audit = response.crop_audit || {};
      cropAuditPayloadId = String(response.production_payload_id || '');
      cropAuditAcknowledgedRevision = audit.client && audit.client.crop_revision || '';
      trackBetaBuilderEvent('crop_cart_ack', {
        production_payload_id: cropAuditPayloadId,
        crop_revision: cropAuditAcknowledgedRevision,
        crop_stage: 'cart_ack',
        crop_matches_server: audit.client_matches_server,
        crop_matches_applied: audit.applied_matches_server
      });
    } catch (error) { /* Observability must not interrupt a verified cart response. */ }
  }

  function trackBetaBuilderEvent(eventName, details) {
    if (/^(crop_|size_|photo_|library_photo_|review_|add_to_cart|cart_api_|cart_edit_)/.test(eventName)) {
      details = Object.assign({}, cropAuditDetails('state'), details || {});
    }
    if (window.stackhouseTracking && typeof window.stackhouseTracking.emit === 'function') {
      window.stackhouseTracking.emit(eventName, betaBuilderDetails(details));
    } else {
      window.pendingStackhouseEmitQueue = Array.isArray(window.pendingStackhouseEmitQueue)
        ? window.pendingStackhouseEmitQueue
        : [];
      window.pendingStackhouseEmitQueue.push({
        eventName: eventName,
        details: betaBuilderDetails(details)
      });
    }
  }

  function fileExtensionFromName(name) {
    var match = String(name || '').split('?')[0].split('#')[0].match(/\.([A-Za-z0-9]{1,12})$/);
    return match ? match[1].toLowerCase() : '';
  }

  function resilientUpload(file, uploadData, plan, title, options) {
    var uploadResilience = window.StackhouseUploadResilience;
    var settings = options || {};
    var attemptId = settings.attemptId || state.uploadAttemptId;
    var reporter = typeof settings.reporter === 'function'
      ? settings.reporter
      : function (status) { updateUploadStatus(title, status); };

    if (!uploadResilience || typeof uploadResilience.upload !== 'function') {
      throw new Error('The uploader could not start. Please refresh the page and try again.');
    }

    return uploadResilience.upload({
      file: file,
      urls: uploadData.preSignedUrls,
      plan: plan,
      setContentType: true,
      eventDetails: {
        source: 'beta_order_builder',
        upload_attempt_id: attemptId
      },
      onProgress: function onUploadProgress(percent) {
        reporter('Sending file to Stackhouse storage - ' + percent + '%.', percent);
      },
      onRetry: function onUploadRetry(partNumber, attempt) {
        reporter('Connection interrupted. Retrying part ' + partNumber + ' (' + attempt + '/3)...');
      }
    });
  }

  function uploadImageMetadataForPreview(file, localMeta) {
    return {
      original_mode: file.type || 'image/tiff',
      original_format: file.name && file.name.indexOf('.') > -1 ? file.name.split('.').pop().toLowerCase() : 'tif',
      original_width: localMeta && localMeta.w ? localMeta.w : null,
      original_height: localMeta && localMeta.h ? localMeta.h : null,
      resize_width: localMeta && localMeta.previewW ? localMeta.previewW : null,
      resize_height: localMeta && localMeta.previewH ? localMeta.previewH : null,
      image_size: file.size ? (Math.round(file.size / 1024 / 1024 * 10) / 10) + ' MB' : '',
      s3_metadata: {
        ContentType: file.type || 'image/tiff',
        LastModified: file.lastModified ? new Date(file.lastModified).toISOString() : '',
        ContentLength: file.size || 0
      }
    };
  }

  async function uploadTiffDisplayPreview(file, uniqueId, localMeta, policyVersion, options) {
    var previewFile;
    var payload;
    var id;
    var email;
    var uploadData;
    var uploadPlan;
    var uploadResult;
    var completeData;
    var generatedImageObject;

    if (!isTiffFile(file) || !uniqueId || !localMeta || !localMeta.previewBlob) {
      return null;
    }

    previewFile = new File([localMeta.previewBlob], file.name.replace(/\.(tif|tiff)$/i, '.png'), { type: 'image/png' });
    uploadPlan = window.StackhouseUploadResilience.createPlan(previewFile);
    payload = {
      file_name: file.name,
      file_type: file.type || 'image/tiff',
      file_size: file.size,
      upload_policy_version: policyVersion,
      resize_file_type: 'image/png',
      total_chunks: uploadPlan.totalParts,
      folder_name: 'fast_uploads',
      unique_id: uniqueId,
      original_width: localMeta.w || null,
      original_height: localMeta.h || null,
      resize_width: localMeta.previewW || null,
      resize_height: localMeta.previewH || null,
      image_metadata: uploadImageMetadataForPreview(file, localMeta)
    };
    id = customerId();
    email = bootstrap.customer && bootstrap.customer.email ? bootstrap.customer.email : '';

    if (id) {
      payload.customer_id = id;
      payload.customer_email = email;
    }

    uploadData = await fetchJson(apiBaseUrl() + '/api/uploads/generate-presigned-url/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    generatedImageObject = parseBackendImage(uploadData && uploadData.image_object);
    uploadResult = await resilientUpload(
      previewFile,
      uploadData,
      uploadPlan,
      'Processing ' + file.name + '...',
      options
    );

    completeData = await fetchJson(apiBaseUrl() + '/api/uploads/complete-upload/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        uploadId: uploadData.uploadId,
        folder_name: uploadData.folder_name || 'fast_uploads',
        file_name: file.name,
        file_size: previewFile.size,
        parts: uploadResult.parts,
        uniqueId: uploadData.uniqueId || uniqueId,
        workflow_instance_id: options && options.attemptId || state.uploadAttemptId
      })
    });

    if (!parseBackendImage(completeData && completeData.image_object) && generatedImageObject) {
      completeData.image_object = JSON.stringify(generatedImageObject);
      completeData.uniqueId = uploadData.uniqueId || uniqueId;
    }

    return completeData;
  }

  function photoMeta(photo) {
    var parts = [];

    if (photo.w && photo.h) {
      parts.push(photo.w + ' x ' + photo.h + ' px');
    }
    if (photo.mb) {
      parts.push(photo.mb + ' MB');
    }
    if (!parts.length && photo.order) {
      parts.push('Upload ID ' + photo.order);
    }

    return parts.join(' - ');
  }

  function mergeLibraryPhotos(photos) {
    var seen = {};
    var merged = [];

    photos.forEach(function (photo) {
      var id = photoId(photo);

      if (!id || seen[id]) {
        return;
      }

      seen[id] = true;
      merged.push(photo);
    });

    return merged;
  }

  function parseStoredGuestImages(value) {
    if (!value) {
      return [];
    }

    try {
      var parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed.filter(function (image) {
        return image && typeof image === 'object';
      }) : [];
    } catch (error) {
      return [];
    }
  }

  function mergeStoredGuestImages(images) {
    var seen = {};
    var merged = [];

    images.forEach(function (image) {
      var normalized = normalizeLibraryImage(image);
      var id = imageOrderValue(image) || photoId(normalized);

      if (!id || seen[id]) {
        return;
      }

      seen[id] = true;
      merged.push(image);
    });

    return merged;
  }

  function readGuestLibraryStorage() {
    var sessionImages = [];
    var bridgedImages = [];

    try {
      sessionImages = parseStoredGuestImages(window.sessionStorage.getItem(guestLibraryStorageKey));
      window.sessionStorage.removeItem(legacyGuestLibraryDecisionKey);
    } catch (error) {
      // Continue with the in-memory gallery when browser storage is unavailable.
    }

    if (customerId()) {
      try {
        bridgedImages = parseStoredGuestImages(window.localStorage.getItem(guestLibraryBridgeKey));
      } catch (error) {
        bridgedImages = [];
      }
    }

    var images = mergeStoredGuestImages(sessionImages.concat(bridgedImages));

    if (customerId() && bridgedImages.length) {
      try {
        window.sessionStorage.setItem(guestLibraryStorageKey, JSON.stringify(images));
      } catch (error) {
        // The in-memory gallery still works when browser storage is unavailable.
      }
    }

    return images;
  }

  function hydrateGuestLibrary() {
    guestLibraryRaw = readGuestLibraryStorage();
    guestLibraryPhotos = guestLibraryRaw.map(normalizeLibraryImage).filter(Boolean);
  }

  function persistGuestPhoto(photo) {
    if (!photo || customerId()) {
      return;
    }

    var image = photo.backend && typeof photo.backend === 'object'
      ? photo.backend
      : {
          unique_id: photo.order || photo.id,
          file_name: photo.name,
          converted_file: photo.src,
          original_width: photo.w,
          original_height: photo.h,
          file_size: photo.mb ? photo.mb * 1024 * 1024 : null
        };
    var next = mergeStoredGuestImages([image].concat(guestLibraryRaw));

    try {
      window.sessionStorage.setItem(guestLibraryStorageKey, JSON.stringify(next));
      window.sessionStorage.removeItem(legacyGuestLibraryDecisionKey);
    } catch (error) {
      // Keep the newly uploaded image available in memory for this page.
    }

    guestLibraryRaw = next;
    guestLibraryPhotos = next.map(normalizeLibraryImage).filter(Boolean);
  }

  function rememberCompletedPhoto(photo) {
    persistGuestPhoto(photo);
    library = mergeLibraryPhotos([photo].concat(guestLibraryPhotos, library));
  }

  function clearGuestLibraryStorage() {
    try {
      window.sessionStorage.removeItem(guestLibraryStorageKey);
      window.sessionStorage.removeItem(legacyGuestLibraryDecisionKey);
      window.sessionStorage.removeItem('selectedImageId');
    } catch (error) {
      // Continue clearing the in-memory state.
    }

    try {
      window.localStorage.removeItem(guestLibraryBridgeKey);
      window.localStorage.removeItem('selectedImageId_loginBridge');
    } catch (error) {
      // Continue clearing the in-memory state.
    }

    guestLibraryRaw = [];
    guestLibraryPhotos = [];
  }

  async function clearGuestUploads() {
    var guestIds = {};

    guestLibraryPhotos.forEach(function (photo) {
      guestIds[photoId(photo)] = true;
    });

    clearGuestLibraryStorage();
    library = library.filter(function (photo) {
      return !guestIds[photoId(photo)];
    });
    state.libraryPage = 0;
    state.guestClaimError = '';
    renderLibrary();
    trackBetaBuilderEvent('guest_library_decision', { decision: 'clear_uploads' });

    if (customerId()) {
      state.libraryLoaded = false;
      await loadCustomerLibrary(true);
    }
  }

  async function claimGuestUploads() {
    if (!customerId() || state.guestClaiming) {
      return;
    }

    var imageIds = guestLibraryRaw.map(imageOrderValue).filter(Boolean).slice(0, 50);

    if (!imageIds.length) {
      await clearGuestUploads();
      return;
    }

    state.guestClaiming = true;
    state.guestClaimError = '';
    renderLibrary();

    try {
      var payload = { customer_id: customerId(), image_ids: imageIds };

      if (typeof window.stackhouseAuthorizeCustomerPayload === 'function') {
        payload = window.stackhouseAuthorizeCustomerPayload(payload);
      }

      var result = await fetchJson(apiBaseUrl() + '/api/claim-guest-images/', {
        method: 'POST',
        headers: window.stackhouseCustomerAccessHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(payload)
      });

      clearGuestLibraryStorage();
      state.libraryLoaded = false;
      await loadCustomerLibrary(true);
      trackBetaBuilderEvent('guest_library_decision', {
        decision: 'add_to_library',
        image_count: imageIds.length,
        claimed_count: result && result.claimed ? result.claimed : 0
      });
    } catch (error) {
      state.guestClaimError = error && error.message
        ? error.message
        : 'We could not add these uploads to your Library. They are still available in this browser session.';
    } finally {
      state.guestClaiming = false;
      renderLibrary();
    }
  }

  var libraryPager = null;
  var libraryPagerView = null;
  var libraryDeepLinkController = null;

  function libraryCustomerId() {
    var access = window.STACKHOUSE_CUSTOMER_ACCESS;
    // A changed or cleared signed-in identity requires a page reload. Never
    // keep rendering cached artwork under another account's credentials.
    if (access && String(access.id || '') !== customerId()) return '';
    return customerId();
  }

  function recentLibraryPhotos() {
    return mergeLibraryPhotos(batchUploadItems.map(function (item) {
      return item.status === 'complete' ? item.photo : null;
    }).filter(Boolean).concat(guestLibraryPhotos));
  }

  var libraryPagerGeneration = 0;
function resetRepeatPrintLibrary() {
    libraryPagerGeneration += 1;
    if (libraryPager) libraryPager.dispose();
    libraryPager = null;
    libraryPagerView = null;
    state.librarySearch = '';
    state.libraryPage = 0;
    state.libraryLoading = false;
    state.libraryLoaded = !libraryCustomerId();
    state.libraryError = '';
    if (els.librarySearch) els.librarySearch.value = '';
    library = libraryCustomerId()
      ? recentLibraryPhotos()
      : mergeLibraryPhotos(guestLibraryPhotos);
  }
function customerLibraryPager() {
    if (!libraryPager) {
      var generation = libraryPagerGeneration;
      libraryPager = window.StackhouseLibraryPager.create({
        pageSize: libraryPerPage,
        customerId: libraryCustomerId,
        sort: function () { return state.librarySort; },
        request: requestCustomerLibraryPage,
        normalize: normalizeLibraryImage,
        onChange: function (view) {
          if (generation !== libraryPagerGeneration) return;
          libraryPagerView = view;
          state.libraryLoading = view.loading;
          state.libraryLoaded = view.loaded;
          state.libraryError = view.error;
          state.libraryPage = view.page;
          library = libraryCustomerId()
            ? mergeLibraryPhotos(recentLibraryPhotos().concat(view.photos))
            : mergeLibraryPhotos(guestLibraryPhotos);
          renderLibrary();
        }
      });
    }
    return libraryPager;
  }

  async function requestCustomerLibraryPage(request) {
    state.libraryLoadAttempt += 1;
    state.libraryLoadWorkflowId = state.libraryLoadWorkflowId || 'library-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
    var workflowId = state.libraryLoadWorkflowId;
    var attempt = state.libraryLoadAttempt;
    var startedAt = Date.now();
    var phase = 'library_request';
    var responseStatus;

    function reportLibraryLoad(status, error) {
      var telemetry = window.StackhouseOperationalTelemetry;
      if (!telemetry || typeof telemetry.emit !== 'function') return;
      var renewalReason = error && error.renewalReason;
      var safeReason = /^(invalid_proof|expired_proof|future_proof|invalid_response|network|timeout|redirect|rejection_timeout|http_[1-5][0-9]{2})$/.test(renewalReason || '') ? renewalReason : '';
      var code = error && error.errorCode;
      var safeCode = /^[A-Z][A-Z0-9_]{0,79}$/.test(code || '') ? code : 'LIBRARY_LOAD_FAILED';
      try {
        telemetry.emit({
          workflow: 'customer_library',
          workflow_instance_id: workflowId,
          attempt_id: workflowId + '-' + attempt,
          component: 'order-builder-library',
          stage: 'library_load',
          event: 'customer_library_load_' + status,
          status: status,
          error_code: error ? safeCode : '',
          safe_message: error ? 'Customer Library could not load.' : '',
          status_code: error && error.statusCode || responseStatus,
          duration_ms: Date.now() - startedAt,
          retry_count: attempt - 1,
          retryable: !!error,
          safe_context: {
            builder: 'beta_order_builder',
            endpoint_family: 'image_library',
            endpoint_operation: 'library_read',
            failure_phase: error ? (renewalReason ? 'credential_renewal' : phase) : '',
            diagnostic_result: safeReason,
            recovery_attempted: attempt > 1,
            recovery_outcome: attempt > 1 ? status : '',
            recovery_source: attempt > 1 ? 'library_reload' : ''
          }
        });
      } catch (_monitoringError) {}
    }

    reportLibraryLoad('started');
    try {
      var response = await window.stackhouseCustomerFetch(
        window.stackhouseAuthorizeCustomerUrl(
          apiBaseUrl() + '/api/get_customer_data/?customer_id=' + encodeURIComponent(libraryCustomerId())
            + '&page=' + request.page + '&page_size=' + request.pageSize + '&q=' + encodeURIComponent(request.query)
            + '&sort=' + encodeURIComponent(request.sort || 'newest')
        ),
        { headers: window.stackhouseCustomerAccessHeaders(), signal: request.signal }
      );
      responseStatus = response.status;
      if (!response.ok) {
        throw Object.assign(new Error('Customer library request failed with status ' + response.status), {
          errorCode: 'LIBRARY_HTTP_ERROR', statusCode: response.status
        });
      }
      phase = 'library_parse';
      var data = await response.json();
      if (request.signal && request.signal.aborted) {
        throw Object.assign(new Error('Library request cancelled.'), { name: 'AbortError' });
      }
      if (!window.StackhouseLibraryPager.valid(data, request.pageSize, request.sort || 'newest')) {
        throw Object.assign(new Error('Your Library needs an update. Please try again shortly.'), {
          errorCode: 'LIBRARY_PAGINATION_UNAVAILABLE'
        });
      }
      reportLibraryLoad('succeeded');
      state.libraryLoadAttempt = 0;
      state.libraryLoadWorkflowId = '';
      return data;
    } catch (error) {
      reportLibraryLoad(request.signal && request.signal.aborted ? 'abandoned' : 'failed', error);
      throw error;
    }
  }

  async function loadCustomerLibrary(force) {
    if (!libraryCustomerId()) {
      if (libraryPager) libraryPager.syncOwner();
      library = mergeLibraryPhotos(guestLibraryPhotos);
      state.libraryLoaded = true;
      state.libraryError = '';
      renderLibrary();
      return;
    }
    var pager = customerLibraryPager();
    if (force) pager.invalidate();
    // Upload completion invalidates private page caches without fetching a
    // hidden picker. The next visit loads fresh data.
    if (state.photo && !state.choosingReplacement && !requestedLibraryImageId) return;
    if (state.libraryLoaded && !force && !requestedLibraryImageId) return;
    var requestedId = requestedLibraryImageId;
    requestedLibraryImageId = '';
    var loaded = pager.load(state.librarySearch, state.libraryPage, !!force);
    if (requestedId) await selectLibraryDeepLink(requestedId, loaded);
    await loaded;
    renderLibrary();
  }

  async function selectLibraryDeepLink(requestedId, loaded) {
    if (librarySelectionBlocked()) return;
    if (libraryDeepLinkController) libraryDeepLinkController.abort();
    var owner = libraryCustomerId();
    var controller = new AbortController();
    libraryDeepLinkController = controller;
    var selection = beginLibrarySelection(null, 'account_image_library_deeplink', function () {
      return !controller.signal.aborted && owner === libraryCustomerId();
    });
    selection.lookupId = requestedId;
    try {
      var data = await requestCustomerLibraryPage({ query: requestedId, page: 1, pageSize: libraryPerPage, signal: controller.signal });
      await loaded;
      if (!librarySelectionIsCurrent(selection)) return;
      var photo = data.images.map(normalizeLibraryImage).filter(Boolean).find(function (item) {
        return photoId(item) === requestedId;
      });
      if (!photo) throw new Error('We could not find that saved file. Choose another image from your library.');
      await selectLibraryPhoto(photo, selection.source, selection.isCurrent);
    } catch (error) {
      await loaded;
      failLibrarySelection(selection, error);
    } finally {
      if (libraryDeepLinkController === controller) libraryDeepLinkController = null;
    }
  }

  function cancelLibraryDeepLink() {
    if (libraryDeepLinkController) libraryDeepLinkController.abort();
    libraryDeepLinkController = null;
    clearLibrarySelection();
  }

  function isDone(key) {
    if (key === 'photo') {
      return !!state.photo && state.photo !== 'uploading';
    }
    if (key === 'size') {
      var customError = customSizeError();
      var hasSize = state.sizeMode === 'custom'
        ? !!(parseFloat(state.customW) > 0 && parseFloat(state.customH) > 0)
        : !!state.size;

      if (!hasSize) {
        return false;
      }
      if (customError) {
        return false;
      }

      var resolution = selectedBaseResolution();
      return !!resolution && resolution.allowed;
    }
    if (key === 'paper') {
      return optionGroupsComplete('media');
    }
    if (key === 'border') {
      return optionGroupsComplete('secondary');
    }
    return false;
  }

  function resetAddState() {
    state.adding = false;
    state.cartWriteSucceeded = false;
    state.added = false;
    state.addedCartItemCount = null;
    state.addError = '';
  }

  function isLocked(key) {
    var order = ['photo', 'size', 'paper', 'border'];
    var idx = order.indexOf(key);

    if (state.cropOpen && (key === 'paper' || key === 'border')) {
      return true;
    }

    for (var i = 0; i < idx; i += 1) {
      if (!isDone(order[i])) {
        return true;
      }
    }

    return false;
  }

  function photoRatioData() {
    var dimensions = photoPixelDimensions();

    if (dimensions) {
      return { ratio: [dimensions.w, dimensions.h], long: Math.max(dimensions.w, dimensions.h) };
    }

    return null;
  }

  function photoPixelDimensions() {
    var photo = state.photo;

    if (!photo || photo === 'uploading') {
      return null;
    }

    var w = numericValue(photo.w, photo.width);
    var h = numericValue(photo.h, photo.height);

    if (w > 0 && h > 0) {
      return { w: w, h: h };
    }

    return null;
  }

  function photoDpi(axis) {
    var photo = state.photo && state.photo !== 'uploading' ? state.photo : {};
    var backend = photo.backend || {};
    var metadata = backend.metadata || backend.image_metadata || photo.metadata || photo.image_metadata || {};
    var horizontal = axis === 'x';

    return numericValue(
      horizontal ? photo.dpiX : photo.dpiY,
      horizontal ? photo.dpi_x : photo.dpi_y,
      horizontal ? photo.x_dpi : photo.y_dpi,
      horizontal ? backend.dpi_x : backend.dpi_y,
      horizontal ? metadata.dpi_x : metadata.dpi_y,
      horizontal ? metadata.x_dpi : metadata.y_dpi,
      photo.dpi,
      backend.dpi,
      metadata.dpi
    ) || DEFAULT_PRINT_DPI;
  }

  function actualPhotoSize() {
    var dimensions = photoPixelDimensions();

    if (!dimensions) {
      return null;
    }

    return {
      w: dimensions.w / photoDpi('x'),
      h: dimensions.h / photoDpi('y')
    };
  }

  function formatInches(value) {
    var numeric = parseFloat(value);

    if (!Number.isFinite(numeric) || numeric <= 0) {
      return '';
    }

    return String(Math.round(numeric * 100) / 100)
      .replace(/(\.\d*?)0+$/, '$1')
      .replace(/\.$/, '');
  }

  function dimensionsFromText(value) {
    var match = String(value || '').match(/(\d+(?:\.\d+)?)\s*(?:in|")?\s*[x×]\s*(\d+(?:\.\d+)?)/i);
    var width;
    var height;

    if (!match) {
      return null;
    }

    width = parseFloat(match[1]);
    height = parseFloat(match[2]);

    if (!(width > 0) || !(height > 0)) {
      return null;
    }

    return {
      width: width,
      height: height,
      label: formatInches(width) + 'x' + formatInches(height)
    };
  }

  function normalizeMaterialDimensions(value) {
    var width;
    var height;

    if (!value) {
      return null;
    }

    if (typeof value === 'string') {
      return dimensionsFromText(value);
    }

    width = numericValue(value.width, value.w);
    height = numericValue(value.height, value.h);

    if (!(width > 0) || !(height > 0)) {
      return null;
    }

    return {
      width: width,
      height: height,
      label: value.label || (formatInches(width) + 'x' + formatInches(height))
    };
  }

  function materialDimensions(option, role) {
    var candidates = [];
    var material = option && option.material;
    var materials = option && option.materials;
    var dimensions = option && option.dimensions;

    if (!option) {
      return null;
    }

    if (role) {
      candidates.push(option[role]);
      candidates.push(material && material[role]);
      candidates.push(materials && materials[role]);
      candidates.push(dimensions && dimensions[role]);
    }

    candidates.push(dimensions);
    candidates.push(material);
    candidates.push(option);
    candidates.push(option.label || option.name);

    for (var i = 0; i < candidates.length; i += 1) {
      var normalized = normalizeMaterialDimensions(candidates[i]);
      if (normalized) {
        return normalized;
      }
    }

    return null;
  }

  function materialOrientationPolicy(option) {
    var material = option && option.material;
    var materials = option && option.materials;
    var dimensions = option && option.dimensions;
    var outer = material && material.outer ? material.outer : option && option.outer;
    var policy = option && (option.orientation || option.orientationPolicy)
      || (material && (material.orientation || material.orientationPolicy))
      || (materials && (materials.orientation || materials.orientationPolicy))
      || (dimensions && (dimensions.orientation || dimensions.orientationPolicy))
      || (outer && (outer.orientation || outer.orientationPolicy))
      || 'auto';

    return normalizeOptionText(policy);
  }

  function dimensionsOrientation(dimensions) {
    if (!dimensions || !(dimensions.width > 0) || !(dimensions.height > 0)) {
      return '';
    }

    if (dimensions.width > dimensions.height) {
      return 'landscape';
    }
    if (dimensions.height > dimensions.width) {
      return 'portrait';
    }
    return 'square';
  }

  function swapDimensions(dimensions) {
    return {
      width: dimensions.height,
      height: dimensions.width,
      label: formatInches(dimensions.height) + 'x' + formatInches(dimensions.width)
    };
  }

  function orientDimensions(dimensions, referenceSize, option) {
    var policy = materialOrientationPolicy(option);
    var current = dimensionsOrientation(dimensions);
    var target = dimensionsOrientation(referenceSize);

    if (!dimensions || current === 'square' || policy === 'fixed' || policy === 'locked') {
      return dimensions;
    }

    if (policy === 'portrait' || policy === 'landscape') {
      return current === policy ? dimensions : swapDimensions(dimensions);
    }

    if ((policy === 'auto' || policy === 'match_print' || policy === 'match') && target && target !== 'square' && current !== target) {
      return swapDimensions(dimensions);
    }

    return dimensions;
  }

  function materialLayer(option, layer) {
    if (!option || !layer) {
      return null;
    }

    return option[layer]
      || (option.material && option.material[layer])
      || (option.materials && option.materials[layer])
      || null;
  }

  function materialLayerColor(option, layer) {
    var data = materialLayer(option, layer);

    return data && (data.color || data.fill || data.hex) ? data.color || data.fill || data.hex : '';
  }

  function materialFrameWidthInches(option) {
    var frame = materialLayer(option, 'frame');
    var width = frame ? numericValue(frame.widthInches, frame.inches, frame.inch, frame.width) : 0;

    return width > 0 ? width : 0;
  }

  function currentCustomRatio() {
    var customW = parseFloat(state.customW);
    var customH = parseFloat(state.customH);
    var photoRatio = photoRatioData();

    if (customW > 0 && customH > 0) {
      return customW / customH;
    }

    if (state.customRatio > 0) {
      return state.customRatio;
    }

    if (photoRatio) {
      return photoRatio.ratio[0] / photoRatio.ratio[1];
    }

    return null;
  }

  function normalizeCustomSizeDimensions(width, height) {
    var w = parseFloat(width);
    var h = parseFloat(height);
    var limits = customSizeLimits();
    var longSide;
    var shortSide;
    var scale;

    if (!(w > 0) || !(h > 0)) {
      return null;
    }

    if (w < limits.min || h < limits.min) {
      scale = limits.min / Math.min(w, h);
      w *= scale;
      h *= scale;
    }

    longSide = Math.max(w, h);
    shortSide = Math.min(w, h);
    scale = Math.min(
      longSide > limits.maxLongSide ? limits.maxLongSide / longSide : 1,
      shortSide > limits.maxShortSide ? limits.maxShortSide / shortSide : 1
    );

    if (scale < 1) {
      w *= scale;
      h *= scale;
    }

    return {
      w: parseFloat(formatInches(w)),
      h: parseFloat(formatInches(h))
    };
  }

  function customSizeError() {
    var w = parseFloat(state.customW);
    var h = parseFloat(state.customH);
    var limits = customSizeLimits();
    var longSide;
    var shortSide;

    if (state.sizeMode !== 'custom') {
      return '';
    }
    if (!(w > 0) || !(h > 0)) {
      return 'Enter width and height to preview a custom size.';
    }
    if (w < limits.min || h < limits.min) {
      return 'Minimum orderable size is ' + formatInches(limits.min) + 'x' + formatInches(limits.min) + ' in.';
    }

    longSide = Math.max(w, h);
    shortSide = Math.min(w, h);
    if (longSide > limits.maxLongSide || shortSide > limits.maxShortSide) {
      return 'Maximum orderable size is ' + formatInches(limits.maxShortSide) + 'x' + formatInches(limits.maxLongSide) + ' in.';
    }
    return '';
  }

  function setCustomSize(width, height, source) {
    var dimensions = normalizeCustomSizeDimensions(width, height);
    var previousRatio = state.committedSizeRatio;
    var cropPosition;

    if (!dimensions) {
      return false;
    }

    customSizeInputCrop = null;
    state.cropRotation = 0;
    cropPosition = captureNormalizedCropPosition();
    state.customW = formatInches(dimensions.w);
    state.customH = formatInches(dimensions.h);
    state.customRatio = dimensions.w / dimensions.h;
    state.size = null;
    state.sizeMode = 'custom';
    resetAddState();
    scheduleCustomPricePreview();
    commitSizeRatio(previousRatio, [dimensions.w, dimensions.h], cropPosition, source || 'custom_size');
    return true;
  }

  function setActualSize() {
    var actual = actualPhotoSize();

    if (actual && setCustomSize(actual.w, actual.h, 'custom_actual_size')) {
      render();
    }
  }

  function swapCustomSize() {
    var customW = parseFloat(state.customW);
    var customH = parseFloat(state.customH);

    if (customW > 0 && customH > 0 && setCustomSize(customH, customW, 'custom_swap')) {
      render();
    }
  }

  function rotateCustomSize() {
    var customW = parseFloat(state.customW);
    var customH = parseFloat(state.customH);

    if (!(customW > 0) || !(customH > 0)) {
      return false;
    }

    state.cropRotation = 0;
    state.cropX = 0;
    state.cropY = 0;

    if (!setCustomSize(customH, customW, 'custom_rotate')) {
      return false;
    }

    state.cropOpen = cropReady();
    state.cropApplied = true;
    state.cropAutoOpened = false;
    clampZoomToResolution();
    return true;
  }

  function toggleCustomLock() {
    state.customLocked = !state.customLocked;

    if (state.customLocked) {
      state.customRatio = currentCustomRatio();
    }

    render();
  }

  function updateCustomSizeInput(axis, value) {
    var numeric = parseFloat(value);
    var ratio = currentCustomRatio();
    // Retain the last valid crop while a number is cleared or partly typed.
    // Raw offsets belong to the old preview fit, even for a locked aspect ratio.
    if (!customSizeInputCrop && cropReady()) {
      customSizeInputCrop = {
        ratio: activeRatio().ratio.slice(),
        frame: captureDraftCrop(),
        position: captureNormalizedCropPosition()
      };
    }

    if (axis === 'width') {
      state.customW = value;
      if (state.customLocked && numeric > 0 && ratio > 0) {
        state.customH = formatInches(numeric / ratio);
      }
    } else {
      state.customH = value;
      if (state.customLocked && numeric > 0 && ratio > 0) {
        state.customW = formatInches(numeric * ratio);
      }
    }

    if (state.customLocked && ratio > 0) {
      state.customRatio = ratio;
    }

    state.size = null;
    resetAddState();
    scheduleCustomPricePreview();
    if (cropReady()) {
      var nextRatio = selectedPrintRatio();
      var previous = customSizeInputCrop;
      if (previous && printRatiosMatch(previous.ratio, nextRatio)) {
        state.committedSizeRatio = nextRatio;
        clampZoomToResolution();
        restoreDraftCrop(previous.frame);
      } else {
        commitSizeRatio(previous ? previous.ratio : state.committedSizeRatio,
          nextRatio, previous ? previous.position : {x: 0, y: 0}, 'custom_input');
      }
      customSizeInputCrop = null;
    }
    render();
  }

  function activeRatio() {
    var ratioData = null;
    var selectedPrintSize;

    if (state.sizeMode === 'custom') {
      var w = parseFloat(state.customW);
      var h = parseFloat(state.customH);

      if (w > 0 && h > 0) {
        ratioData = { ratio: [w, h], long: Math.max(w, h) };
      }
    }

    if (!ratioData && state.size) {
      selectedPrintSize = selectedPrintOpeningDimensions();
      ratioData = selectedPrintSize
        ? {
          ratio: [selectedPrintSize.width, selectedPrintSize.height],
          long: Math.max(selectedPrintSize.width, selectedPrintSize.height)
        }
        : { ratio: state.size.ratio, long: state.size.long };
    }

    if (!ratioData) {
      ratioData = photoRatioData();
    }

    if (!ratioData) {
      ratioData = { ratio: [1, 1], long: 4 };
    }

    if (state.cropRotation % 180 !== 0) {
      ratioData = {
        ratio: [ratioData.ratio[1], ratioData.ratio[0]],
        long: ratioData.long
      };
    }

    return ratioData;
  }

  function normalizePrintRatio(ratio) {
    var width = ratio && parseFloat(ratio[0]);
    var height = ratio && parseFloat(ratio[1]);

    if (!(width > 0) || !(height > 0)) {
      return null;
    }

    return [width, height];
  }

  function selectedPrintRatio() {
    var selectedPrintSize;

    if (state.sizeMode === 'custom') {
      return normalizePrintRatio([state.customW, state.customH]);
    }

    selectedPrintSize = selectedPrintOpeningDimensions();

    return selectedPrintSize
      ? normalizePrintRatio([selectedPrintSize.width, selectedPrintSize.height])
      : state.size ? normalizePrintRatio(state.size.ratio) : null;
  }

  function printRatiosMatch(first, second) {
    var a = normalizePrintRatio(first);
    var b = normalizePrintRatio(second);
    var firstAspect;
    var secondAspect;

    if (!a || !b) {
      return false;
    }

    firstAspect = a[0] / a[1];
    secondAspect = b[0] / b[1];
    return Math.abs(firstAspect - secondAspect) <= Math.max(0.001, Math.max(firstAspect, secondAspect) * 0.001);
  }

  function sizeRatioRequiresCrop(previousRatio, nextRatio, fileRatio) {
    var comparisonRatio = normalizePrintRatio(previousRatio) || normalizePrintRatio(fileRatio);
    var normalizedNext = normalizePrintRatio(nextRatio);

    return !!comparisonRatio && !!normalizedNext && !printRatiosMatch(comparisonRatio, normalizedNext);
  }

  function captureNormalizedCropPosition() {
    var ratioData;
    var previewFit;
    var geometry;

    if (!cropReady()) {
      return { x: 0, y: 0 };
    }

    ratioData = activeRatio();
    previewFit = previewFitForRatio(ratioData.ratio);
    geometry = cropImageGeometry(previewFit.fit, previewFit.insetsPx);

    return {
      x: geometry && geometry.maxX > 0 ? clamp(state.cropX / geometry.maxX, -1, 1) : 0,
      y: geometry && geometry.maxY > 0 ? clamp(state.cropY / geometry.maxY, -1, 1) : 0
    };
  }

  function restoreNormalizedCropPosition(position) {
    var ratioData;
    var previewFit;
    var geometry;

    if (!cropReady()) {
      return;
    }

    ratioData = activeRatio();
    previewFit = previewFitForRatio(ratioData.ratio);
    geometry = cropImageGeometry(previewFit.fit, previewFit.insetsPx);
    state.cropX = geometry ? clamp(position && position.x || 0, -1, 1) * geometry.maxX : 0;
    state.cropY = geometry ? clamp(position && position.y || 0, -1, 1) * geometry.maxY : 0;
    clampCropToFit(previewFit.fit, previewFit.insetsPx);
  }

  function setCropOpenPreservingPosition(open) {
    var nextOpen = !!open;
    var position;

    if (state.cropOpen === nextOpen) {
      return;
    }

    position = captureNormalizedCropPosition();
    state.cropOpen = nextOpen;
    restoreNormalizedCropPosition(position);
  }

  function commitSizeRatio(previousRatio, nextRatio, cropPosition, changeSource) {
    var normalizedNext = normalizePrintRatio(nextRatio);
    var fileRatioData = photoRatioData();
    var ratioChanged = sizeRatioRequiresCrop(previousRatio, normalizedNext, fileRatioData && fileRatioData.ratio);
    var shouldOpenCrop = ratioChanged && cropReady();

    state.committedSizeRatio = normalizedNext;
    clampZoomToResolution();
    if (shouldOpenCrop) {
      state.cropOpen = true;
    }
    restoreNormalizedCropPosition(cropPosition);

    if (!shouldOpenCrop) {
      return false;
    }

    state.cropApplied = true;
    state.cropAutoOpened = true;
    state.open = 'size';
    trackBetaBuilderEvent('crop_started', {
      source: 'size_ratio_change',
      change_source: changeSource || ''
    });
    queueOpenStepIntoView(state.open);
    return true;
  }

  function currentSizePolicy() {
    return SIZE_POLICY_BY_HANDLE[canonicalHandle(state.productHandle)] || SIZE_POLICY_BY_HANDLE['giclee-fine-art-prints'];
  }

  function supportsCustomSizes() {
    var policy = currentSizePolicy();
    return currentPreset().supportsCustom !== false && !!(policy && policy.custom);
  }

  function customSizeMinimum() {
    return canonicalHandle(state.productHandle) === 'gallery-wrapped-canvas-prints' ? 8 : 4;
  }

  function customSizeLimits() {
    var policy = currentSizePolicy();
    var custom = policy && policy.custom ? policy.custom : {};

    return {
      min: customSizeMinimum(),
      maxShortSide: custom.maxShortSide || 42,
      maxLongSide: custom.maxLongSide || 80
    };
  }

  function normalizeSizeBucket(value, actionValue) {
    var bucket = String(value || '').trim();
    var action = String(actionValue || '').trim();

    if (bucket === 'standard' || bucket === 'extended' || bucket === 'custom_only' || bucket === 'review') {
      return bucket;
    }
    if (action === 'keep_family_specific_exception' || action === 'keep_family_specific_non_core') {
      return 'extended';
    }
    if (action === 'custom_tool_supported_not_default' || action === 'move_to_custom_tool_candidate') {
      return 'custom_only';
    }
    if (action === 'production_review_before_standardizing') {
      return 'review';
    }
    return 'standard';
  }

  function fallbackSizeBucket(key, currentBucket) {
    var policy = currentSizePolicy();
    var normalizedKey = sizeKeyFromText(key);

    if (!policy || !normalizedKey) {
      return currentBucket || 'standard';
    }
    if (Array.isArray(policy.customOnly) && policy.customOnly.indexOf(normalizedKey) !== -1) {
      return 'custom_only';
    }
    if (Array.isArray(policy.review) && policy.review.indexOf(normalizedKey) !== -1) {
      return 'review';
    }
    if (Array.isArray(policy.extended) && policy.extended.indexOf(normalizedKey) !== -1) {
      return 'extended';
    }
    if (Array.isArray(policy.standard) && policy.standard.indexOf(normalizedKey) !== -1) {
      return 'standard';
    }
    if (canonicalHandle(state.productHandle) === 'framed-prints') {
      return 'review';
    }
    return currentBucket || 'extended';
  }

  function sizeBucketSortValue(bucket) {
    if (bucket === 'standard') {
      return 10;
    }
    if (bucket === 'extended') {
      return 20;
    }
    if (bucket === 'review') {
      return 30;
    }
    if (bucket === 'custom_only') {
      return 40;
    }
    return 50;
  }

  function sizeBucketLabel(bucket) {
    if (bucket === 'custom_only') {
      return 'Custom';
    }
    if (bucket === 'extended' || bucket === 'review') {
      return 'Extended';
    }
    return 'Standard';
  }

  function sizeBucketVisible(bucket) {
    return bucket === 'standard';
  }

  function parseSizeKey(key) {
    var parts = String(key || '').split('x');
    var w = parseFloat(parts[0]);
    var h = parseFloat(parts[1]);

    if (!(w > 0) || !(h > 0)) {
      return null;
    }

    return { key: key, w: w, h: h };
  }

  function roundPrice(value) {
    return Math.round(value * 100) / 100;
  }

  function priceForSize(size, preset) {
    var catalogPrice = lowestVariantPriceForSize(size);
    var base = preset.priceBase || 0;
    var rate = preset.pricePerSqIn || 0.14;
    var minimum = preset.minPrice || 4.5;

    if (catalogPrice !== null && catalogPrice > 0) {
      return roundPrice(catalogPrice);
    }

    return roundPrice(Math.max(minimum, base + size.w * size.h * rate));
  }

  function makeSize(key, preset, bucket, sourceIndex) {
    var parsed = parseSizeKey(key);
    var miniPreset = isMiniPrintProduct() ? miniPrintSizePresetForKey(key) : null;
    var displayW;
    var displayH;

    if (!parsed) {
      return null;
    }

    displayW = miniPreset ? miniPreset.width : parsed.w;
    displayH = miniPreset ? miniPreset.height : parsed.h;

    return {
      key: key,
      label: key + ' in',
      displayLabel: miniPreset ? miniPreset.label : key + ' in',
      price: priceForSize(parsed, preset),
      ratio: [displayW, displayH],
      long: Math.max(displayW, displayH),
      w: displayW,
      h: displayH,
      sourceW: parsed.w,
      sourceH: parsed.h,
      bucket: bucket || 'standard',
      sourceIndex: sourceIndex || 0
    };
  }

  function allCurrentSizes() {
    var policy = currentSizePolicy();
    var preset = currentPreset();
    var sizeProducts = currentSizeProducts();
    var sizes = [];
    var mapped = [];
    var seen = {};

    sizeProducts.forEach(function (sizeProduct, index) {
      var key = sizeProductKey(sizeProduct);
      var bucket = fallbackSizeBucket(key, normalizeSizeBucket(sizeProduct.sizeBucket, sizeProduct.sizeAction));
      var size;

      if (!key || seen[key]) {
        return;
      }
      seen[key] = true;
      size = makeSize(key, preset, bucket, index);

      if (size) {
        mapped.push(size);
      }
    });

    sizes = []
      .concat(policy && policy.standard ? policy.standard : SIZE_POLICY_BY_HANDLE['giclee-fine-art-prints'].standard)
      .concat(policy && policy.extended ? policy.extended : [])
      .concat(policy && policy.review ? policy.review : [])
      .concat(policy && policy.customOnly ? policy.customOnly : []);

    sizes.forEach(function (key, index) {
      var bucket = fallbackSizeBucket(key, 'standard');
      var size;

      if (seen[key]) {
        return;
      }
      seen[key] = true;
      size = makeSize(key, preset, bucket, sizeProducts.length + index);

      if (size) {
        mapped.push(size);
      }
    });

    mapped.sort(function (a, b) {
      var bucketDiff = sizeBucketSortValue(a.bucket) - sizeBucketSortValue(b.bucket);

      if (bucketDiff !== 0) {
        return bucketDiff;
      }
      return a.sourceIndex - b.sourceIndex;
    });

    return mapped;
  }

  function currentSizes() {
    return allCurrentSizes().filter(function (size) {
      return sizeBucketVisible(size.bucket);
    });
  }

  function selectedSizeIsVisible() {
    if (!state.size) {
      return true;
    }
    return allCurrentSizes().some(function (size) {
      return sizesMatch(size, state.size) && sizeBucketVisible(size.bucket);
    });
  }

  function ensureVisibleSizeSelection() {
    if (selectedSizeIsVisible()) {
      return;
    }
    state.size = currentSizes()[0] || null;
    pruneSelectedOptions();
    resetAddState();
    resetCustomPricePreview();
    state.committedSizeRatio = selectedPrintRatio();
    state.cropOpen = false;
    state.cropAutoOpened = false;
    clampActiveCrop();
  }

  function currentPrice() {
    var selectedVariant = selectedPricingVariant();

    if (state.sizeMode === 'custom') {
      var customPrice = parseFloat(state.customPriceValue);

      if (customPrice > 0) {
        return roundPrice(customPrice);
      }

      return 0;
    }

    if (selectedVariant) {
      return roundPrice(variantPriceValue(selectedVariant));
    }

    return 0;
  }

  function selectedSizeDimensions() {
    var w = 0;
    var h = 0;
    var label;
    var sourceLabel;
    var displayLabel;

    if (state.sizeMode === 'custom') {
      w = parseFloat(state.customW);
      h = parseFloat(state.customH);
    } else if (state.size) {
      w = state.size.w;
      h = state.size.h;
    }

    if (!(w > 0) || !(h > 0)) {
      return null;
    }

    label = formatInches(w) + 'x' + formatInches(h);
    sourceLabel = state.sizeMode === 'custom' ? label : sizeSelectionKey(state.size) || label;
    displayLabel = state.sizeMode === 'custom' ? label + ' in' : sizeDisplayLabel(state.size);

    return {
      width: w,
      height: h,
      label: label,
      sourceLabel: sourceLabel,
      displayLabel: displayLabel
    };
  }

  function selectedDisplaySizeDimensions(size) {
    return normalizePrintDimensions(
      size || selectedSizeDimensions(),
      state.cropRotation % 180 !== 0
    );
  }

  function normalizePrintDimensions(size, rotated) {
    if (!size) {
      return null;
    }

    var w = numericValue(size.width, size.w);
    var h = numericValue(size.height, size.h);

    if (!(w > 0) || !(h > 0)) {
      return null;
    }

    if (rotated) {
      return {
        width: h,
        height: w,
        label: formatInches(h) + 'x' + formatInches(w)
      };
    }

    return {
      width: w,
      height: h,
      label: formatInches(w) + 'x' + formatInches(h)
    };
  }

  function framedPrintMatInsetInches() {
    var matting = selectedOption('matting_package');
    var inset = matting ? optionInches(matting.label || matting.name) : 0;

    return isFramedPrintProduct() && inset > 0 ? inset : 0;
  }

  function framedPrintOpeningDimensions(size) {
    var dimensions = normalizePrintDimensions(size, false);
    var inset = framedPrintMatInsetInches();
    var width;
    var height;

    if (!dimensions || !isFramedPrintProduct() || !(inset > 0)) {
      return dimensions;
    }

    width = dimensions.width - inset * 2;
    height = dimensions.height - inset * 2;

    if (!(width > 0) || !(height > 0)) {
      return dimensions;
    }

    return {
      width: width,
      height: height,
      label: formatInches(width) + 'x' + formatInches(height)
    };
  }

  function selectedPrintOpeningDimensions() {
    return framedPrintOpeningDimensions(selectedSizeDimensions());
  }

  function resolutionForDimensions(size, zoom) {
    var dimensions = photoPixelDimensions();
    var printSize = normalizePrintDimensions(size, false);

    if (!dimensions || !printSize) {
      return null;
    }

    var sourceW = dimensions.w;
    var sourceH = dimensions.h;
    var printW = printSize.width;
    var printH = printSize.height;
    var sourceAspect = sourceW / sourceH;
    var printAspect = printW / printH;
    var cropW = sourceW;
    var cropH = sourceH;
    var activeZoom = parseFloat(zoom);

    if (!(sourceW > 0) || !(sourceH > 0) || !(printW > 0) || !(printH > 0)) {
      return null;
    }

    if (!Number.isFinite(activeZoom) || activeZoom < 1) {
      activeZoom = 1;
    }

    if (sourceAspect > printAspect) {
      cropW = sourceH * printAspect;
    } else {
      cropH = sourceW / printAspect;
    }

    cropW = clamp(cropW / activeZoom, 1, sourceW);
    cropH = clamp(cropH / activeZoom, 1, sourceH);

    var ppiX = cropW / printW;
    var ppiY = cropH / printH;
    var ppi = Math.min(ppiX, ppiY);
    var classification = resolutionClassification(ppi);
    var rounded = Math.max(1, Math.floor(ppi));

    return {
      ppi: ppi,
      rounded: rounded,
      ppiX: ppiX,
      ppiY: ppiY,
      cropW: cropW,
      cropH: cropH,
      allowed: classification.available,
      status: classification.status
    };
  }

  function resolutionClassification(ppi) {
    var uploadPolicy = window.StackhouseUploadPolicy;
    if (!uploadPolicy || typeof uploadPolicy.qualityForPpi !== 'function') {
      return { available: false, status: 'blocked' };
    }
    var classification = uploadPolicy.qualityForPpi(ppi);
    var legacyStatus = classification.status === 'warning'
      ? 'warn'
      : classification.status === 'recommended'
        ? 'good'
        : classification.status;
    return {
      available: classification.available === true,
      status: legacyStatus || 'blocked'
    };
  }

  function resolutionForSize(size) {
    return resolutionForDimensions(size, 1);
  }

  function sizeCardUsesLiveResolution(size) {
    return !!(
      state.sizeMode === 'standard' &&
      state.size &&
      size &&
      state.size.label === size.label
    );
  }

  function resolutionForSizeCard(size) {
    if (sizeCardUsesLiveResolution(size)) {
      return selectedCropResolution() || resolutionForSize(size);
    }

    return resolutionForSize(size);
  }

  function selectedPrintSizeForResolution(rotated) {
    return normalizePrintDimensions(selectedPrintOpeningDimensions(), rotated);
  }

  function selectedBaseResolution() {
    return resolutionForDimensions(selectedPrintSizeForResolution(state.cropRotation % 180 !== 0), 1);
  }

  function selectedCropResolution() {
    return resolutionForDimensions(selectedPrintSizeForResolution(state.cropRotation % 180 !== 0), state.zoom);
  }

  function resolutionLabel(resolution) {
    return resolution ? resolution.rounded + ' PPI' : '';
  }

  function resolutionStatusLabel(status) {
    if (status === 'blocked') {
      return 'Below 150 PPI';
    }
    if (status === 'low') {
      return '150-199 PPI';
    }
    if (status === 'warn') {
      return '200-299 PPI';
    }
    if (status === 'good') {
      return '300+ PPI';
    }
    return '';
  }

  function resolutionCardText(resolution, live) {
    if (!resolution) {
      return '';
    }

    var statusLabel = resolution.allowed && resolution.ppi < MINIMUM_PRINT_PPI
      ? 'Within print tolerance'
      : resolutionStatusLabel(resolution.status);
    var qualityLabel = { blocked: 'Too low', low: 'Good', warn: 'Better', good: 'Best' }[resolution.status] || statusLabel;
    return resolutionLabel(resolution) + ' \u2022 ' + qualityLabel;
  }

  function resolutionMessage(resolution, context) {
    if (!resolution) {
      return '';
    }
    if (resolution.status === 'blocked') {
      return 'This ' + context + ' would print at ' + resolutionLabel(resolution) + '. You can preview and crop it, but choose a smaller size or upload a larger file before ordering.';
    }
    if (resolution.allowed && resolution.ppi < MINIMUM_PRINT_PPI) {
      return 'This ' + context + ' is ' + resolutionLabel(resolution) + ', just below ' + MINIMUM_PRINT_PPI + ' PPI. It is within our print tolerance, but may look soft.';
    }
    if (resolution.status === 'low') {
      return 'This ' + context + ' is ' + resolutionLabel(resolution) + '. It meets the minimum, but may look soft.';
    }
    if (resolution.status === 'warn') {
      return 'This ' + context + ' is ' + resolutionLabel(resolution) + '. We recommend 300 PPI when possible.';
    }
    return 'This ' + context + ' is ' + resolutionLabel(resolution) + '.';
  }

  function maxCropZoom() {
    var baseResolution = selectedBaseResolution();

    if (!baseResolution) {
      return DEFAULT_MAX_CROP_ZOOM;
    }

    // Previewing a tighter crop is allowed even when it cannot yet be ordered.
    // assertPrintResolution and the order readiness checks still enforce quality.
    return Math.max(DEFAULT_MAX_CROP_ZOOM, Math.floor(baseResolution.ppi / MINIMUM_PRINT_PPI * 100) / 100);
  }

  function resolutionSizeSuggestion() {
    var size = selectedDisplaySizeDimensions();
    var resolution = selectedCropResolution();
    if (!supportsCustomSizes() || !hasPreviewSize() || !size || !resolution ||
        !(resolution.ppi > 0) || resolution.ppi >= MINIMUM_PRINT_PPI) {
      return null;
    }
    var limits = customSizeLimits();
    var scale = Math.min(
      resolution.ppi / MINIMUM_PRINT_PPI,
      limits.maxShortSide / Math.min(size.width, size.height),
      limits.maxLongSide / Math.max(size.width, size.height)
    );
    // Round down so the suggested size never crosses back below the target PPI.
    var width = Math.floor(size.width * scale * 100) / 100;
    var height = Math.floor(size.height * scale * 100) / 100;
    if (width < limits.min || height < limits.min) {
      return null;
    }
    return { width: width, height: height };
  }

  function useSuggestedResolutionSize() {
    var suggestion = resolutionSizeSuggestion();
    if (!suggestion) return;
    var position = captureNormalizedCropPosition();
    if (setCustomSize(suggestion.width, suggestion.height, 'resolution_suggestion')) {
      restoreNormalizedCropPosition(position);
      render();
      trackBetaBuilderEvent('resolution_size_suggestion_used', {
        image_size: formatInches(suggestion.width) + 'x' + formatInches(suggestion.height)
      });
    }
  }

  function clampZoomToResolution() {
    var maximum = maxCropZoom();

    if (state.zoom > maximum) {
      state.zoom = maximum;
      clampActiveCrop();
    }

    return maximum;
  }

  function orientationLabel(size) {
    if (!size) {
      return '';
    }
    if (size.width > size.height) {
      return 'landscape';
    }
    if (size.height > size.width) {
      return 'portrait';
    }
    return 'square';
  }

  function currentOrientationIntent() {
    var source = photoPixelDimensions();
    var crop = buildCropPayload();
    var sourceOrientation = source
      ? dimensionsOrientation({ width: source.w, height: source.h })
      : '';
    var printOrientation = dimensionsOrientation({
      width: Number(crop._Crop_Width),
      height: Number(crop._Crop_Height)
    });

    if (!sourceOrientation || !printOrientation) {
      throw new Error('We could not verify the artwork and print orientation. Choose the image and crop again.');
    }

    return {
      source_orientation: sourceOrientation,
      print_orientation: printOrientation,
      status: sourceOrientation !== 'square' && printOrientation !== 'square' && sourceOrientation !== printOrientation
        ? 'unconfirmed_mismatch' : 'matched'
    };
  }

  function reviewedOrientationIntent() {
    var intent = currentOrientationIntent();

    if (intent.status === 'unconfirmed_mismatch') {
      intent.status = 'confirmed_mismatch';
    }

    return intent;
  }

  function appendProperty(properties, key, value) {
    if (!key || value === null || value === undefined) {
      return;
    }

    var stringValue = String(value).trim();

    if (stringValue) {
      properties.push({ key: key, value: stringValue });
    }
  }

  function propertyEntriesToObject(propertyEntries) {
    return (propertyEntries || []).reduce(function (properties, entry) {
      if (!entry || !entry.key || entry.value === null || entry.value === undefined) {
        return properties;
      }

      var value = String(entry.value).trim();

      if (value) {
        properties[entry.key] = value;
      }

      return properties;
    }, {});
  }

  function normalizeCartVariantId(value) {
    var variantId = String(value || '').trim();
    return /^\d+$/.test(variantId) ? variantId : '';
  }

  function normalizedOptionName(optionName) {
    var kind = optionKind(optionName);
    var normalized = String(optionName || '').trim().toLowerCase();

    if (kind) {
      return kind;
    }

    return normalized.replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
  }

  function normalizedOptionValue(optionValue) {
    return String(optionValue || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }

  function selectedOptionsPayload() {
    var payload = {
      options: {
        media_key: null,
        media_label: null,
        border_key: null,
        border_label: null,
        mount_key: null,
        mount_label: null,
        wrap_depth_key: null,
        wrap_depth_label: null,
        edge_treatment_key: null,
        edge_treatment_label: null,
        matting_package_key: null,
        matting_package_label: null,
        frame_package_key: null,
        frame_package_label: null
      },
      properties: []
    };

    function addOption(label, value) {
      var optionName = normalizedOptionName(label);

      if (!optionName || !value) {
        return;
      }

      payload.options[optionName + '_key'] = normalizedOptionValue(value);
      payload.options[optionName + '_label'] = value;
      payload.properties.push({ key: label, value: value });
    }

    currentOptionGroups().forEach(function (group) {
      var selected = selectedOption(group.kind);
      if (selected) {
        addOption(group.name, selected.label || selected.name);
      }
    });

    var borderCode = borderCodeFromSelection();
    if (borderCode) {
      payload.options.border_code = borderCode;
    }

    return payload;
  }

  function borderCodeFromSelection() {
    var border = selectedOption('border') || {};
    var label = String(border.label || '').toLowerCase();
    var inch = parseFloat(border.inch);

    if (!label) {
      return '';
    }
    if (label.indexOf('borderless') !== -1 || label.indexOf('full bleed') !== -1 || inch === 0) {
      return 'B0';
    }
    if (inch === 0.25 || label.indexOf('1/4') !== -1 || label.indexOf('quarter') !== -1) {
      return 'B1';
    }
    if (inch === 0.5 || label.indexOf('1/2') !== -1 || label.indexOf('half') !== -1) {
      return 'B4';
    }
    if (inch === 1 || label.indexOf('1-inch') !== -1 || label.indexOf('1 inch') !== -1) {
      return 'B2';
    }
    if (inch === 2 || label.indexOf('2-inch') !== -1 || label.indexOf('2 inch') !== -1) {
      return 'B3';
    }
    return '';
  }

  function testPrintSourceFamily() {
    var media = selectedOption('media');
    var label = normalizeOptionText(media && (media.label || media.name));
    var canvasMatch = CANVAS_MEDIA.some(function (option) {
      return normalizeOptionText(option.name) === label;
    });
    var photoMatch = PHOTO_MEDIA.some(function (option) {
      return normalizeOptionText(option.name) === label;
    });

    if (canvasMatch) return 'Rolled Canvas Prints';
    if (photoMatch) return 'Professional Photo Prints';
    return label ? 'Giclee Fine Art Prints' : '';
  }

  function publicAssetUrl(url) {
    var value = accelerateS3Url(url || '');
    return value.indexOf('blob:') === 0 ? '' : value;
  }

  function buildUploadPayload(photo) {
    var selectedPhoto = photo || state.photo;
    var backend = selectedPhoto && selectedPhoto !== 'uploading' ? selectedPhoto.backend || {} : {};
    var orderId = imageOrderValue(backend) || imageOrderValue(selectedPhoto);
    var imageId = backend.id || backend.image_id || backend.pk || (selectedPhoto && selectedPhoto.id) || '';
    var displayName = backend.original_file_name || backend.file_name || (selectedPhoto && selectedPhoto.name) || '';
    var displayThumbnail = publicAssetUrl(
      backend.cropped_file_thumb ||
      backend.thumbnail_file ||
      backend.preview_file ||
      backend.converted_file ||
      backend.public_url ||
      (selectedPhoto && selectedPhoto.src)
    );
    var displayOriginal = publicAssetUrl(
      backend.original_file ||
      backend.public_url ||
      backend.converted_file ||
      (selectedPhoto && selectedPhoto.src)
    );

    if (!orderId || !displayThumbnail || !displayOriginal) {
      throw new Error('This file has not finished processing. Please upload it again or choose a saved library file.');
    }

    var mediaOrderId = encodeURIComponent(orderId);
    var thumbnail = apiBaseUrl() + '/api/get_thumb_url/?orderId=' + mediaOrderId;
    var original = apiBaseUrl() + '/api/media/original/?orderId=' + mediaOrderId;

    return {
      '_Thumbnail': thumbnail,
      '_OrderID': orderId,
      '_Original Image': original,
      'ID': imageId,
      'Image': displayName,
      '_Print Ready File': apiBaseUrl() + '/api/download/?orderId=' + encodeURIComponent(orderId)
    };
  }

  function cropValue(value) {
    var numeric = parseFloat(value);

    if (!Number.isFinite(numeric)) {
      return '';
    }
    if (Math.abs(numeric - Math.round(numeric)) < 0.001) {
      return String(Math.round(numeric));
    }
    return String(Math.round(numeric * 1000) / 1000);
  }

  function buildCropPayload() {
    var dimensions = photoPixelDimensions();
    var ratioData = activeRatio();

    if (!dimensions || !ratioData || !ratioData.ratio) {
      return {};
    }

    var sourceW = dimensions.w;
    var sourceH = dimensions.h;
    var frameW = ratioData.ratio[0];
    var frameH = ratioData.ratio[1];
    var previewFit = previewFitForRatio([frameW, frameH]);
    var fit = previewFit.imageFit;
    syncCropPositionToFit(fit);
    var sourceAspect = sourceW / sourceH;
    var frameAspect = frameW / frameH;
    var drawW = frameW;
    var drawH = frameH;

    if (sourceAspect > frameAspect) {
      drawH = frameH;
      drawW = frameH * sourceAspect;
    } else {
      drawW = frameW;
      drawH = frameW / sourceAspect;
    }

    drawW *= state.zoom;
    drawH *= state.zoom;

    var translateX = fit.w ? state.cropX / fit.w * frameW : 0;
    var translateY = fit.h ? state.cropY / fit.h * frameH : 0;
    var imageLeft = (frameW - drawW) / 2 + translateX;
    var imageTop = (frameH - drawH) / 2 + translateY;
    var cropX = clamp(-imageLeft / drawW * sourceW, 0, sourceW);
    var cropY = clamp(-imageTop / drawH * sourceH, 0, sourceH);
    var cropW = clamp(frameW / drawW * sourceW, 1, sourceW);
    var cropH = clamp(frameH / drawH * sourceH, 1, sourceH);

    if (cropX + cropW > sourceW) {
      cropX = Math.max(0, sourceW - cropW);
    }
    if (cropY + cropH > sourceH) {
      cropY = Math.max(0, sourceH - cropH);
    }

    return {
      '_Crop_X': cropValue(cropX),
      '_Crop_Y': cropValue(cropY),
      '_Crop_Width': cropValue(cropW),
      '_Crop_Height': cropValue(cropH)
    };
  }

  function buildResolutionPayload() {
    var resolution = selectedCropResolution();
    var policy = window.StackhouseUploadPolicy;
    var requirements = policy && typeof policy.ppiRequirements === 'function'
      ? policy.ppiRequirements() : null;

    if (!resolution) {
      return {};
    }

    return {
      output_ppi: resolution.rounded,
      minimum_output_ppi: requirements ? requirements.orderMinimum : MINIMUM_PRINT_PPI,
      nominal_minimum_output_ppi: MINIMUM_PRINT_PPI,
      ppi_tolerance: requirements ? requirements.tolerance : 0,
      recommended_output_ppi: DEFAULT_PRINT_DPI,
      status: resolution.status,
      crop_width_px: Math.round(resolution.cropW),
      crop_height_px: Math.round(resolution.cropH)
    };
  }

  function assertPrintResolution() {
    var baseResolution = selectedBaseResolution();
    var cropResolution = selectedCropResolution();

    if (!baseResolution || !cropResolution) {
      throw new Error('We could not verify this file\'s pixel dimensions. Choose it again or upload a new copy.');
    }

    if (baseResolution && !baseResolution.allowed) {
      throw new Error(resolutionMessage(baseResolution, 'size'));
    }

    if (cropResolution && !cropResolution.allowed) {
      throw new Error(resolutionMessage(cropResolution, 'crop'));
    }
  }

  function buildGeneratedCartProductPayload() {
    var size = selectedSizeDimensions();
    var optionsPayload = selectedOptionsPayload();
    var product = currentProduct();
    var uploadPayload = buildUploadPayload();
    var cropPayload = buildCropPayload();
    var resolutionPayload = buildResolutionPayload();
    var unit = currentPrice();
    var finalSize = finalSizeDimensions(size);
    var selectedVariant = sourcePricingVariant();
    var priceFormula = state.sizeMode === 'custom'
      ? state.customPriceFormula || 'custom_price_preview_api'
      : selectedVariant ? 'shopify_variant_matrix' : 'single_order_page_preview_fallback_v1';

    if (!size) {
      throw new Error('Please choose a print size before adding this order to cart.');
    }

    return {
      product_handle: canonicalHandle(state.productHandle),
      product_title: productTitle(state.productHandle),
      product_image_url: product.featuredImage || product.image || '',
      base_tags: Array.isArray(product.tags) ? product.tags : [],
      quantity: state.qty,
      selected_variant_id: selectedVariant && selectedVariant.id ? String(selectedVariant.id) : '',
      selected_variant_title: selectedOptionsList().map(function (option) {
        return option.label || option.name;
      }).join(' / '),
      source_variant_title: selectedVariant && selectedVariant.title ? selectedVariant.title : '',
      custom_size: {
        image_size: size.label,
        source_size_key: size.sourceLabel || size.label,
        display_size: size.displayLabel || size.label,
        width: size.width,
        height: size.height,
        final_size: finalSize ? finalSize.label : size.label,
        final_width: finalSize ? finalSize.width : size.width,
        final_height: finalSize ? finalSize.height : size.height
      },
      options: optionsPayload.options,
      upload: uploadPayload,
      crop: cropPayload,
      crop_audit: cropAuditDetails('cart_request', 'request'),
      orientation_intent: pendingOrientationIntent || currentOrientationIntent(),
      resolution: resolutionPayload,
      price_preview: {
        formula: priceFormula,
        type: state.sizeMode === 'custom' ? state.customPriceType || '' : '',
        price: unit > 0 ? unit.toFixed(2) : ''
      }
    };
  }

  var reviewPreparation = null;
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) { renderReviewState(); renderDock(); }
  });
  var pricingPreviewCart = null;
  function preparationFlags() {
    return { review: root.getAttribute('data-review-preparation') === 'true',
      pricing: root.getAttribute('data-metadata-pricing') === 'true' };
  }
  function preparationApiBaseUrl() {
    return String(root.getAttribute('data-preparation-api') || apiBaseUrl()).replace(/\/$/, '');
  }
  function preparationSnapshot() {
    var payload = buildGeneratedCartProductPayload();
    payload.size_mode = state.sizeMode;
    payload.cart_source_order = payload.upload._OrderID;
    payload.edited_line = cartEditKey || '';
    payload.pricing_policy_version = 'print-pricing-v1';
    payload.preparation_protocol = 1;
    payload.customer_scope = customerId();
    payload.quoted_customer_pricing = {status:String(bootstrap.customer && bootstrap.customer.proStatus || ''),
      tier:String(bootstrap.customer && bootstrap.customer.proTier || '')};
    payload.orientation_intent = reviewedOrientationIntent();
    return payload;
  }
  function preparationKey(snapshot) {
    var value = Object.assign({}, snapshot);
    delete value.crop_audit;
    return window.StackhouseReviewPreparation.stable(value);
  }
  async function preparationContext() {
    var token = window.StackhouseCartEdit ? await window.StackhouseCartEdit.binding() : '';
    var cart = await fetchJson(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js', {cache: 'no-store'});
    if (!token || String(cart.token || '') !== token) throw new Error('Your cart could not be verified. Please try again.');
    pricingPreviewCart = cart;
    window.requestAnimationFrame(function () { renderReviewState(); renderDock(); });
    var content = window.StackhouseReviewPreparation.stable({
      items: (cart.items || []).map(function (line) { return {key: line.key, id: line.variant_id,
        quantity: line.quantity, price: line.original_price, properties: line.properties}; }),
      attributes: cart.attributes, note: cart.note, codes: cart.discount_codes
    });
    var bytes = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(content));
    var revision = Array.from(new Uint8Array(bytes)).map(function (b) { return b.toString(16).padStart(2, '0'); }).join('');
    return {cart_token: token, cart_revision: revision, cart_product_ids: Array.from(new Set((cart.items || []).map(function(line){return String(line.product_id);}))).sort()};
  }
  async function fetchPreparationJson(url, options) {
    if (customerId() && window.stackhouseEnsureCustomerAccess) await window.stackhouseEnsureCustomerAccess();
    if (window.stackhouseCustomerAccessHeaders) options.headers = window.stackhouseCustomerAccessHeaders(options.headers);
    var base = preparationApiBaseUrl();
    var override = base !== apiBaseUrl();
    if (override && (base !== 'http://127.0.0.1:8766' || !window.Shopify || !window.Shopify.theme ||
        ['development','unpublished'].indexOf(window.Shopify.theme.role) === -1)) {
      throw new Error('The preparation connection could not be verified. Please refresh the page.');
    }
    var request = override ? window.fetch.bind(window) : (window.stackhouseCustomerFetch || window.fetch.bind(window));
    var response = await request(url, options);
    var data = await response.json();
    if (!response.ok) {
      var error = new Error(data.error || data.detail || data.message || 'This print could not be prepared.');
      error.statusCode = response.status;
      error.errorCode = data.error_code || '';
      error.pricingProfile = data.pricing_profile || null;
      throw error;
    }
    return data;
  }
  async function requestPreparation(attempt, adding, context) {
    var started = Date.now();
    while (Date.now() - started < 120000) {
      try {
        var headers = {'Content-Type': 'application/json', 'Idempotency-Key': attempt.id};
        if (adding) {
          headers['X-Stackhouse-Preparation-Use'] = 'add';
          headers['X-Stackhouse-Cart-Binding'] = context.cart_token;
          headers['X-Stackhouse-Cart-Revision'] = context.cart_revision;
          headers['X-Stackhouse-Edited-Line'] = attempt.body.edited_line || '';
        }
        var data = await fetchPreparationJson(preparationApiBaseUrl() + '/create-orders/ajax/generate-custom-cart-product/', {
          method: 'POST', headers: headers, body: JSON.stringify(attempt.body)
        });
        if (!data.ok || !data.variant_id || !String(data.production_payload_id || '').trim() ||
            !String(data.thumbnail_url || '').includes('payloadId=' + encodeURIComponent(data.production_payload_id))) {
          throw new Error(data.message || 'This custom print could not be verified. Please try again.');
        }
        if (!adding) await window.StackhouseGeneratedDiscountReadiness.waitFor({
          apiBaseUrl: preparationApiBaseUrl(), product: data, fetch: window.stackhouseCustomerFetch || fetch
        });
        return data;
      } catch (error) {
        if (['CART_PREVIEW_PROCESSING', 'GENERATED_DISCOUNT_PENDING'].indexOf(error.errorCode) === -1) throw error;
        await new Promise(function (resolve) { window.setTimeout(resolve, 1000); });
      }
    }
    throw new Error('Your print is still being prepared. Please try adding it again in a moment.');
  }
  function preparationCoordinator() {
    if (reviewPreparation) return reviewPreparation;
    if (!window.StackhouseReviewPreparation || !window.StackhouseGeneratedDiscountReadiness) {
      throw new Error('Please refresh the page before adding this custom print.');
    }
    var storageKey = 'stackhouse-review-preparation-v1:' + (customerId() || 'guest') + ':' + (cartEditKey || 'new');
    reviewPreparation = window.StackhouseReviewPreparation.create({
      key: preparationKey, context: preparationContext, request: requestPreparation,
      id: function () { return window.crypto.randomUUID(); },
      load: function () { var value = JSON.parse(window.sessionStorage.getItem(storageKey) || 'null');
        return value && value.version === 1 && Date.now() - value.createdAt < 3600000 ? value : null; },
      save: function (value) { try {
        if (value) window.sessionStorage.setItem(storageKey, JSON.stringify(value));
        else window.sessionStorage.removeItem(storageKey);
      } catch (_) {} },
      onBackgroundError: function () { trackBetaBuilderEvent('review_preparation_unavailable'); }
    });
    var coordinator = reviewPreparation;
    window.addEventListener('pagehide', function () {
      coordinator.stop();
      if (reviewPreparation === coordinator) reviewPreparation = null;
    }, {once:true});
    return reviewPreparation;
  }
  function syncReviewPreparation() {
    if (!preparationFlags().review || state.adding) return;
    try {
      var valid = state.reviewOpen && reviewReady() && !state.customPricePending && !state.added &&
        supportsGeneratedCartProduct() && !(cartEditSession && cartEditCropNeedsApply);
      if (valid) { assertPrintResolution(); preparationCoordinator().observe(preparationSnapshot()); }
      else if (reviewPreparation) reviewPreparation.observe(null);
    } catch (_) { if (reviewPreparation) reviewPreparation.observe(null); }
  }

  async function createGeneratedCartProduct() {
    var responseData;
    if (preparationFlags().review || preparationFlags().pricing) {
      var snapshot = preparationSnapshot();
      var identity = preparationKey(snapshot);
      var coordinator = preparationCoordinator();
      var pendingWrite = coordinator.pendingWrite();
      if (pendingWrite) {
        var recovered = await fetchJson(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js', {cache:'no-store'});
        var expected = pendingWrite.product || {};
        var matches = (recovered.items || []).filter(function (line) { return String(line.variant_id) === String(expected.variant_id) &&
          line.properties && line.properties['_Production Payload ID'] === expected.production_payload_id; });
        var originalPresent = cartEditKey && (recovered.items || []).some(function(line){return line.key === cartEditKey;});
        if (pendingWrite.key === identity && String(recovered.token) === String(pendingWrite.body.cart_token) &&
            matches.length === 1 && matches[0].quantity === pendingWrite.body.quantity && !originalPresent &&
            Object.keys(pendingWrite.body.crop || {}).every(function(key){return String(matches[0].properties[key]) === String(pendingWrite.body.crop[key]);})) {
          return Object.assign({}, expected, {confirmed_cart: recovered});
        }
        var uncertain = new Error('Please check your cart before adding this print again. We could not confirm the last update.');
        uncertain.cartWriteUncertain = true;
        throw uncertain;
      }
      responseData = await coordinator.take(snapshot);
      if (preparationKey(preparationSnapshot()) !== identity) throw window.StackhouseReviewPreparation.reviewRequired();
      rememberCropAcknowledgement(responseData);
      return responseData;
    }

    try {
      var cartPayload = buildGeneratedCartProductPayload();
      cartPayload.cart_token = window.StackhouseCartEdit ? await window.StackhouseCartEdit.binding() : '';
      cartPayload.size_mode = state.sizeMode;
      cartPayload.cart_source_order = cartPayload.upload._OrderID;
      var retryKey = JSON.stringify({ payload: cartPayload, cartEditKey: cartEditKey });
      if (generatedCartProductRetry && generatedCartProductRetry.key === retryKey) {
        return generatedCartProductRetry.product;
      }
      generatedCartProductRetry = null;
      trackBetaBuilderEvent('generated_product_started');
      responseData = await fetchJson(apiBaseUrl() + '/create-orders/ajax/generate-custom-cart-product/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cartPayload)
      });
    } catch (error) {
      trackBetaBuilderEvent('generated_product_failed', {
        error_message: error && error.message ? error.message : 'Generated product request failed.'
      });
      throw error;
    }

    if (!responseData.ok || !responseData.variant_id || !String(responseData.production_payload_id || '').trim()
        || !String(responseData.thumbnail_url || '').includes('payloadId=' + encodeURIComponent(responseData.production_payload_id))) {
      var responseError = new Error(responseData.message || responseData.error || 'Custom product generation did not return complete production identity.');
      trackBetaBuilderEvent('generated_product_failed', {
        error_message: responseError.message
      });
      throw responseError;
    }

    rememberCropAcknowledgement(responseData);
    trackBetaBuilderEvent('generated_product_succeeded', {
      variant_id: responseData.variant_id,
      template: responseData.production_filename_template,
      final_size: responseData.custom_size && responseData.custom_size.final_size,
      border: responseData.resolved_options && responseData.resolved_options.border_label,
      border_code: responseData.resolved_options && responseData.resolved_options.border_code
    });

    generatedCartProductRetry = { key: retryKey, product: responseData };
    return responseData;
  }

  function standardVariantExpectation() {
    var sizeProduct = sizeProductForSize(state.size) || {};
    var variant = selectedPricingVariant();

    return {
      product_handle: sizeProduct.handle || '',
      variant_id: variant && variant.id ? String(variant.id) : '',
      sku: variant && variant.sku ? String(variant.sku) : '',
      option_names: variantOptionNames(sizeProduct),
      option_values: variantOptionValues(variant),
      displayed_unit_price: currentPrice()
    };
  }

  async function fetchStandardCartLineMetadataProperties(uploadPayload, quantity, variantId) {
    if (!variantId) {
      throw new Error('This print combination could not be matched to a production variant. Please choose the options again.');
    }

    var responseData = await fetchJson(apiBaseUrl() + '/create-orders/ajax/standard-cart-line-metadata/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        cart_token: window.StackhouseCartEdit ? await window.StackhouseCartEdit.binding() : '',
        cart_source_order: uploadPayload._OrderID,
        variant_id: variantId,
        image_id: uploadPayload.ID || '',
        quantity: quantity,
        upload: uploadPayload,
        crop: buildCropPayload(),
        crop_audit: cropAuditDetails('cart_request', 'request'),
        orientation_intent: pendingOrientationIntent || currentOrientationIntent(),
        resolution: buildResolutionPayload(),
        expected_variant: standardVariantExpectation()
      })
    });
    var payloadId = String(responseData.production_payload_id || '').trim();
    var properties = Array.isArray(responseData.properties) ? responseData.properties : [];
    var hasPayloadProperty = properties.some(function (entry) {
      return entry && entry.key === '_Production Payload ID' && String(entry.value || '').trim() === payloadId;
    });
    var hasCropThumbnail = properties.some(function (entry) {
      return entry && entry.key === '_Thumbnail'
        && String(entry.value || '').includes('payloadId=' + encodeURIComponent(payloadId));
    });

    if (!responseData.ok || !payloadId || !hasPayloadProperty || !hasCropThumbnail) {
      throw new Error(responseData.message || "We couldn't prepare this print for production. Please try again.");
    }

    rememberCropAcknowledgement(responseData);
    return properties;
  }

  function buildCartPropertyEntries(generatedProduct) {
    var size = selectedSizeDimensions();
    var displaySize = selectedDisplaySizeDimensions(size);
    var imageSize = framedPrintOpeningDimensions(displaySize) || displaySize;
    var preset = currentPreset();
    var uploadPayload = buildUploadPayload();
    var cropPayload = buildCropPayload();
    var resolutionPayload = buildResolutionPayload();
    var optionsPayload = selectedOptionsPayload();
    var properties = [];
    var canonicalSizeLabel = size ? size.label + '"' : '';
    var displaySizeLabel = imageSize ? imageSize.label + '"' : canonicalSizeLabel;
    var finalSize = finalSizeDimensions(imageSize);
    var finalSizeLabel = finalSize ? finalSize.label + '"' : displaySizeLabel;
    var sourceVariant = sourcePricingVariant();
    var priceFormula = state.sizeMode === 'custom'
      ? state.customPriceFormula || 'custom_price_preview_api'
      : sourceVariant ? 'shopify_variant_matrix' : 'single_order_page_preview_fallback_v1';

    appendProperty(properties, '_Production Payload ID', generatedProduct && generatedProduct.production_payload_id);
    appendProperty(properties, '_Crop Audit Revision', generatedProduct && generatedProduct.crop_audit && generatedProduct.crop_audit.client && generatedProduct.crop_audit.client.crop_revision);
    appendProperty(properties, '_Cart Edit Token', generatedProduct && generatedProduct.cart_edit_token);
    Object.keys(uploadPayload).forEach(function (key) {
      appendProperty(properties, key, key === '_Thumbnail' && generatedProduct
        ? generatedProduct.thumbnail_url : uploadPayload[key]);
    });
    Object.keys(cropPayload).forEach(function (key) {
      appendProperty(properties, key, cropPayload[key]);
    });
    appendProperty(properties, '_Output PPI', resolutionPayload.output_ppi);
    appendProperty(properties, '_Output PPI Status', resolutionPayload.status);
    appendProperty(properties, '_Minimum Output PPI', resolutionPayload.minimum_output_ppi);
    appendProperty(properties, '_Recommended Output PPI', resolutionPayload.recommended_output_ppi);

    appendProperty(properties, 'Product', productTitle(state.productHandle));
    appendProperty(properties, 'Size', canonicalSizeLabel);
    appendProperty(properties, 'Image Size', displaySizeLabel);
    appendProperty(properties, 'Final Size', finalSizeLabel);
    appendProperty(properties, 'Orientation', orientationLabel(imageSize));
    appendProperty(properties, '_Orientation Intent', (pendingOrientationIntent || currentOrientationIntent()).status);
    appendProperty(properties, '_Source Orientation', (pendingOrientationIntent || currentOrientationIntent()).source_orientation);
    appendProperty(properties, '_Print Orientation', (pendingOrientationIntent || currentOrientationIntent()).print_orientation);
    appendProperty(properties, '_Order App Size Key', size && size.sourceLabel);
    appendProperty(properties, '_Order App Size Label', size && size.displayLabel);
    appendProperty(properties, '_Product Handle', canonicalHandle(state.productHandle));
    appendProperty(properties, '_Order App Source', 'single-order-page-preview');
    appendProperty(properties, '_Order App Size Mode', state.sizeMode === 'custom' ? 'Custom size' : 'Standard size');
    appendProperty(properties, '_Order App Cart Strategy', generatedProduct ? 'Generated cart product' : 'Standard Shopify variant');
    appendProperty(properties, '_Custom Size Mode', state.sizeMode === 'custom' ? (generatedProduct ? 'Generated custom cart product' : 'Custom size standard variant') : '');
    appendProperty(properties, '_Custom Price Preview', currentPrice() > 0 ? moneyText(currentPrice()) : '');
    appendProperty(properties, '_Custom Price Formula', priceFormula);
    appendProperty(properties, '_Custom Price Type', state.sizeMode === 'custom' ? state.customPriceType : '');
    appendProperty(properties, '_Source Variant ID', sourceVariant && sourceVariant.id);
    appendProperty(properties, '_Source Variant Title', sourceVariant && sourceVariant.title);
    appendProperty(properties, '_shipping_bucket', generatedProduct && generatedProduct.bucket_code);
    appendProperty(properties, '_Production SLA Days', generatedProduct && generatedProduct.production_sla_days);
    appendProperty(properties, '_Production Filename Template', generatedProduct && generatedProduct.production_filename_template);

    if (isTestPrintProduct()) {
      appendProperty(properties, '_Test Print', 'Yes');
      appendProperty(properties, '_Test Print Version', 'test-print-v1');
      appendProperty(properties, '_Source Product Family', testPrintSourceFamily());
    }

    optionsPayload.properties.forEach(function (entry) {
      appendProperty(properties, entry.key, entry.value);
    });

    return properties;
  }

  function cartAddUrl() {
    var route = (bootstrap.routes && bootstrap.routes.cartAdd) || '/cart/add';
    return route.indexOf('.js') === -1 ? route.replace(/\/?$/, '.js') : route;
  }

  function cartAddErrorMessage(responseText) {
    var rawResponseText = String(responseText || '');
    if (/^\s*</.test(rawResponseText)) {
      return 'Cart is temporarily unavailable. Please retry in a moment.';
    }
    try {
      var payload = JSON.parse(rawResponseText || '{}');
      return payload.description || payload.message || payload.error || '';
    } catch (error) {
      return rawResponseText || '';
    }
  }

  function cartResponseKind(response, responseText) {
    var contentType = response && response.headers && response.headers.get
      ? String(response.headers.get('Content-Type') || '').toLowerCase()
      : '';
    var text = String(responseText || '');
    if (contentType.indexOf('json') !== -1) return 'json';
    if (contentType.indexOf('html') !== -1 || /^\s*</.test(text)) return 'html';
    if (!text.trim()) return 'empty';
    return 'text';
  }

  function normalizeCartQuantity(value) {
    if (typeof value === 'number' && Number.isInteger(value) && value > 0) return value;
    var stringValue = String(value || '').trim();
    if (!/^[1-9]\d*$/.test(stringValue)) return 1;
    return Number(stringValue);
  }

  async function addToShopifyCart(variantId, quantity, propertyEntries, onCartWriteSucceeded, options) {
    var normalizedVariantId = normalizeCartVariantId(variantId);

    if (!normalizedVariantId) {
      throw new Error('Unable to determine the Shopify variant for this order.');
    }

    trackBetaBuilderEvent('cart_api_add_started', {
      variant_id: normalizedVariantId,
      quantity: normalizeCartQuantity(quantity)
    });

    var integrity = window.StackhouseCartLineIntegrity;
    if (!integrity || typeof integrity.addConfiguredItem !== 'function') {
      var integrityUnavailableError = new Error("We couldn't verify the artwork attached to this print. Please refresh the page and try again.");
      integrityUnavailableError.code = 'CART_LINE_INTEGRITY_UNAVAILABLE';
      integrityUnavailableError.cartIntegrityError = true;
      throw integrityUnavailableError;
    }

    try {
      var payload = await integrity.addConfiguredItem({
        variantId: normalizedVariantId,
        quantity: normalizeCartQuantity(quantity),
        propertyEntries: propertyEntries,
        cartAddUrl: cartAddUrl(),
        onCartWriteSucceeded: onCartWriteSucceeded,
        retryGeneratedVariantPropagation: Boolean(options && options.retryGeneratedVariantPropagation)
      });
      trackBetaBuilderEvent('cart_api_add_succeeded', {
        variant_id: normalizedVariantId,
        quantity: normalizeCartQuantity(quantity),
        cart_item_count: payload.item_count
      });
      return payload;
    } catch (error) {
      trackBetaBuilderEvent('cart_api_add_failed', {
        variant_id: normalizedVariantId,
        quantity: normalizeCartQuantity(quantity),
        status_code: error && (error.statusCode || error.status),
        response_kind: error && error.responseKind,
        error_message: error && error.message,
        error_code: error && error.code
      });
      throw error;
    }
  }

  async function addConfiguredItemToCart() {
    if (state.uploading) return;
    if (cartEditSession && (cartEditCropNeedsApply || state.cropOpen || cropAuditDetails('state').crop_matches_applied === false)) {
      cartEditCropNeedsApply = true;
      state.addError = 'Review and apply your crop before updating this saved print.';
      state.cropOpen = true;
      state.open = 'size';
      render();
      return;
    }
    var ready = isDone('photo') && isDone('size') && isDone('paper') && isDone('border') && !cropError() && currentPrice() > 0;

    if (state.adding) {
      return;
    }
    if (!ready) {
      return;
    }

    if (state.sizeMode === 'custom' && !supportsGeneratedCartProduct()) {
      state.addError = 'Custom sizes are not available for this product.';
      render();
      return;
    }

    if (cartEditKey && !cartEditSession) {
      state.addError = 'Open the saved print from your cart before updating it.';
      render();
      return;
    }
    state.adding = true;
    state.cartWriteSucceeded = false;
    state.addError = '';
    updateCartProgress('preparing');
    trackBetaBuilderEvent('add_to_cart_started');
    renderDock();
    renderReviewState();

    try {
      var generatedProduct = null;
      var variantId = currentVariantId();
      await requireLibraryArtworkReady(state.photo);
      var uploadPayload = buildUploadPayload();
      var propertyEntries;

      assertPrintResolution();
      pendingOrientationIntent = reviewedOrientationIntent();
      updateCartProgress('preparing_print');

      if (supportsGeneratedCartProduct()) {
        generatedProduct = await createGeneratedCartProduct();
        if (!window.StackhouseGeneratedDiscountReadiness) {
          throw new Error('Please refresh the page before adding this custom print.');
        }
        if (!generatedProduct.confirmed_cart) await window.StackhouseGeneratedDiscountReadiness.waitFor({
          apiBaseUrl: preparationFlags().pricing || preparationFlags().review ? preparationApiBaseUrl() : apiBaseUrl(), product: generatedProduct,
          fetch: window.stackhouseCustomerFetch || fetch
        });
        variantId = generatedProduct.variant_id;
      } else {
        generatedCartProductRetry = null;
      }

      propertyEntries = buildCartPropertyEntries(generatedProduct);

      if (!generatedProduct) {
        var metadataProperties = await fetchStandardCartLineMetadataProperties(uploadPayload, state.qty, variantId);
        var metadataKeys = new Set(metadataProperties.map(function (entry) { return entry && entry.key; }));
        propertyEntries = propertyEntries.filter(function (entry) { return !metadataKeys.has(entry.key); });
        metadataProperties.forEach(function (entry) {
          appendProperty(propertyEntries, entry && entry.key, entry && entry.value);
        });
      }

      updateCartProgress('saving');
      var confirmedCart = generatedProduct && generatedProduct.confirmed_cart || null;
      if (generatedProduct && reviewPreparation && !confirmedCart) reviewPreparation.markWrite();
      if (confirmedCart) {
        clearDraft();
      } else if (cartEditSession) {
        await window.StackhouseCartEdit.replace({original: cartEditSession.line, cartToken: cartEditSession.cartToken,
          variantId: variantId, quantity: state.qty, propertyEntries: propertyEntries,
          retryGeneratedVariantPropagation: Boolean(generatedProduct)});
        trackBetaBuilderEvent('crop_cart_edit_saved', cropAuditDetails('cart_edit_saved'));
        clearDraft();
      } else {
        confirmedCart = await addToShopifyCart(variantId, state.qty, propertyEntries, function cartWriteSucceeded() {
          state.cartWriteSucceeded = true;
          updateCartProgress('confirming');
          clearDraft();
          renderDock();
          renderReviewState();
        }, {retryGeneratedVariantPropagation: Boolean(generatedProduct)});
      }
      await updateCartProgress('complete');
      state.adding = false;
      state.cartWriteSucceeded = false;
      state.added = true;
      state.addedCartItemCount = confirmedCart && Number.isInteger(confirmedCart.item_count)
        ? confirmedCart.item_count : null;
      state.addError = '';
      generatedCartProductRetry = null;
      if (reviewPreparation) reviewPreparation.clear();
      pendingOrientationIntent = null;
      trackBetaBuilderEvent('add_to_cart_succeeded', {
        variant_id: variantId,
        quantity: state.qty,
        template: generatedProduct && generatedProduct.production_filename_template
      });
      render();
    } catch (error) {
      updateCartProgress('error');
      if (!(error && error.generatedDiscountPending) &&
          (Number(error && (error.statusCode || error.status)) !== 422 ||
           String(error && error.message || '').trim() !== 'Cannot find variant')) {
        generatedCartProductRetry = null;
      }
      state.adding = false;
      state.cartWriteSucceeded = false;
      state.added = false;
      pendingOrientationIntent = null;
      state.addError = error && error.message ? error.message : 'Unable to add this print to cart.';
      state.cartWriteUncertain = Boolean(error && error.cartWriteUncertain);
      if (reviewPreparation && error && Number(error.statusCode || error.status) === 422 && !error.cartIntegrityError) {
        reviewPreparation.cancelWrite();
      }
      if (error && ['PREPARATION_REVIEW_REQUIRED', 'PRICE_REVIEW_REQUIRED'].indexOf(error.errorCode) !== -1) {
        if (reviewPreparation) reviewPreparation.clear();
        state.reviewOpen = false;
        if (error.pricingProfile && bootstrap.customer) {
          bootstrap.customer.proStatus = String(error.pricingProfile.status || '');
          bootstrap.customer.proTier = String(error.pricingProfile.tier || '');
        }
        state.customPriceKey = '';
        scheduleCustomPricePreview({debounceMs: 0});
      }
      if (error && error.cartEditUncertain) {
        cartEditSession = null;
        showDraftNotice(state.addError);
      }
      console.error('Single order page add to cart failed.', error);
      trackBetaBuilderEvent('add_to_cart_failed', {
        quantity: state.qty,
        error_message: state.addError,
        error_code: error && (error.errorCode || error.code),
        status_code: error && (error.statusCode || error.status),
        response_kind: error && error.responseKind
      });
      render();
    }
  }

  function updateCartProgress(stage) {
    try {
      if (!window.StackhouseCartProgress) return Promise.resolve();
      return Promise.resolve(window.StackhouseCartProgress.update(root, stage, Boolean(cartEditKey))).catch(function () {});
    } catch (error) {
      return Promise.resolve();
    }
  }

  function cropError() {
    var resolution = selectedCropResolution();

    return !!resolution && !resolution.allowed;
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function resetCrop() {
    customSizeInputCrop = null;
    state.cropOpen = false;
    state.cropApplied = false;
    state.cropAutoOpened = false;
    state.zoom = 1;
    state.cropX = 0;
    state.cropY = 0;
    state.cropRotation = 0;
    if (cropTracker()) cropTracker().reset();
    trackBetaBuilderEvent('crop_reset', cropAuditDetails('reset'));
  }

  function previewInsetsPixels(imageSize, imageFit, insetsInches) {
    var scale = imageSize && imageSize.width > 0 ? imageFit.w / imageSize.width : 0;

    return {
      top: Math.max(0, Math.round((insetsInches.top || 0) * scale)),
      right: Math.max(0, Math.round((insetsInches.right || 0) * scale)),
      bottom: Math.max(0, Math.round((insetsInches.bottom || 0) * scale)),
      left: Math.max(0, Math.round((insetsInches.left || 0) * scale))
    };
  }

  function sheetFitFromImageFit(imageFit, insetsPx) {
    return {
      w: Math.round(imageFit.w + insetsPx.left + insetsPx.right),
      h: Math.round(imageFit.h + insetsPx.top + insetsPx.bottom)
    };
  }

  function previewFitForRatio(ratio) {
    var imageSize = imageSizeFromRatio(ratio);
    var imageFit = fitPrint(ratio[0], ratio[1]);
    var insetsInches = previewInsetsInches(imageSize);
    var insetsPx = previewInsetsPixels(imageSize, imageFit, insetsInches);
    var fit = sheetFitFromImageFit(imageFit, insetsPx);
    var limits = previewFitLimits();
    var fitScale;
    var i;

    for (i = 0; i < 4; i += 1) {
      fitScale = Math.min(1, limits.maxW / fit.w, limits.maxH / fit.h);

      if (fitScale >= 1) {
        break;
      }
      imageFit = {
        w: Math.max(1, Math.floor(imageFit.w * fitScale)),
        h: Math.max(1, Math.floor(imageFit.h * fitScale))
      };
      insetsPx = previewInsetsPixels(imageSize, imageFit, insetsInches);
      fit = sheetFitFromImageFit(imageFit, insetsPx);
    }

    return {
      imageFit: imageFit,
      insetsPx: insetsPx,
      insetsInches: insetsInches,
      fit: fit
    };
  }

  function syncCropPositionToFit(imageFit) {
    if (!imageFit || !(imageFit.w > 0) || !(imageFit.h > 0)) return;
    var identity = photoId(state.photo) + ':' + activeRatio().ratio.join(':');
    var previous = cropOffsetFit;
    if (previous && previous.identity === identity) {
      var scaleX = imageFit.w / previous.w;
      var scaleY = imageFit.h / previous.h;
      state.cropX *= scaleX;
      state.cropY *= scaleY;
      // A pointer gesture belongs to its original layout. Keep its last crop
      // when that layout changes, then let the customer start a new gesture.
      if (cropDrag && (scaleX !== 1 || scaleY !== 1)) {
        cropDrag = null;
        if (els.previewStage) els.previewStage.classList.remove('is-dragging');
      }
    }
    cropOffsetFit = {identity: identity, w: imageFit.w, h: imageFit.h};
  }

  function cropImageGeometry(fit, insetsPx) {
    var dimensions = photoPixelDimensions();
    var insets = insetsPx || blankPreviewInsets();

    if (!dimensions || !fit) {
      return null;
    }

    var frameW = fit.w;
    var frameH = fit.h;
    var imageW = Math.max(1, frameW - insets.left - insets.right);
    var imageH = Math.max(1, frameH - insets.top - insets.bottom);
    syncCropPositionToFit({w: imageW, h: imageH});
    var sourceAspect = dimensions.w / dimensions.h;
    // Match request serialization: rounded display dimensions must not change
    // the source-space crop bounds when review or Inspect changes the layout.
    var ratio = activeRatio().ratio;
    var frameAspect = ratio[0] / ratio[1];
    var drawW = imageW;
    var drawH = imageH;

    if (!(sourceAspect > 0) || !(frameAspect > 0)) {
      return null;
    }

    if (sourceAspect > frameAspect) {
      drawH = imageH;
      drawW = imageW * sourceAspect / frameAspect;
    } else {
      drawW = imageW;
      drawH = imageH * frameAspect / sourceAspect;
    }

    drawW *= state.zoom;
    drawH *= state.zoom;

    return {
      frameW: frameW,
      frameH: frameH,
      imageW: drawW,
      imageH: drawH,
      left: insets.left + (imageW - drawW) / 2 + state.cropX,
      top: insets.top + (imageH - drawH) / 2 + state.cropY,
      maxX: Math.max(0, (drawW - imageW) / 2),
      maxY: Math.max(0, (drawH - imageH) / 2)
    };
  }

  function cropPreviewClipInsets(fit, insetsPx, geometry) {
    var insets = insetsPx || blankPreviewInsets();

    if (!fit || !geometry) {
      return null;
    }

    return {
      top: Math.max(0, insets.top - geometry.top),
      right: Math.max(0, geometry.left + geometry.imageW - (fit.w - insets.right)),
      bottom: Math.max(0, geometry.top + geometry.imageH - (fit.h - insets.bottom)),
      left: Math.max(0, insets.left - geometry.left)
    };
  }

  function clampCropToFit(fit, insetsPx) {
    var geometry = cropImageGeometry(fit, insetsPx || blankPreviewInsets());
    var maxX = geometry ? geometry.maxX : Math.max(0, (state.zoom - 1) * fit.w / 2);
    var maxY = geometry ? geometry.maxY : Math.max(0, (state.zoom - 1) * fit.h / 2);

    state.cropX = clamp(state.cropX, -maxX, maxX);
    state.cropY = clamp(state.cropY, -maxY, maxY);
  }

  function hasPreviewSize() {
    return !!selectedSizeDimensions() && !customSizeError();
  }

  function cropReady() {
    return isDone('photo') && hasPreviewSize();
  }

  function zoomLabel() {
    return Math.round(state.zoom * 100) + '%';
  }

  function cropHasAdjustment() {
    return Math.abs(state.zoom - 1) > 0.001 || Math.abs(state.cropX) > 0.01 || Math.abs(state.cropY) > 0.01;
  }

  function updateCropRecenterControl() {
    if (!els.cropRecenter) {
      return;
    }

    var hasAdjustment = cropHasAdjustment();
    els.cropRecenter.hidden = !state.cropOpen;
    els.cropRecenter.disabled = !state.cropOpen || !hasAdjustment;
  }

  function clampActiveCrop() {
    var ratioData = activeRatio();
    var previewFit = previewFitForRatio(ratioData.ratio);

    clampCropToFit(previewFit.fit, previewFit.insetsPx);
  }

  function setCropZoom(value) {
    var nextZoom = parseFloat(value);
    var maximum = maxCropZoom();

    if (!Number.isFinite(nextZoom)) {
      nextZoom = 1;
    }

    state.zoom = clamp(nextZoom, 1, maximum);
    resetAddState();
    state.cropApplied = state.cropApplied || state.zoom !== 1 || state.cropX !== 0 || state.cropY !== 0;
    clampActiveCrop();
    render();
  }

  function zoomBy(delta) {
    setCropZoom(state.zoom + delta);
  }

  function recenterCrop() {
    state.cropX = 0;
    state.cropY = 0;
    state.zoom = 1;
    resetAddState();
    state.cropApplied = state.cropRotation !== 0;
    if (cropTracker()) cropTracker().reset();
    trackBetaBuilderEvent('crop_reset', cropAuditDetails('reset'));
    render();
  }

  function openCropTool() {
    if (!cropReady()) {
      return;
    }

    setCropOpenPreservingPosition(true);
    state.cropApplied = true;
    state.cropAutoOpened = false;
    state.open = 'size';
    render();
    queueOpenStepIntoView(state.open);
  }

  function closeCropTool() {
    setCropOpenPreservingPosition(false);
    state.cropAutoOpened = false;
    render();
  }

  function applyCrop() {
    setCropOpenPreservingPosition(false);
    state.cropApplied = true;
    if (cartEditCropNeedsApply) state.addError = '';
    cartEditCropNeedsApply = false;
    state.cropAutoOpened = false;
    trackBetaBuilderEvent('crop_applied', cropAuditDetails('apply', 'apply'));
    render();
  }

  function rotateCrop() {
    if (!isDone('photo') || !cropRotationAllowed()) {
      return;
    }

    if (state.sizeMode === 'custom') {
      if (rotateCustomSize()) {
        render();
      }
      return;
    }

    state.cropRotation = state.cropRotation === 0 ? 90 : 0;
    resetAddState();
    state.cropOpen = cropReady();
    state.cropApplied = state.cropRotation !== 0 || state.zoom !== 1 || state.cropX !== 0 || state.cropY !== 0;
    state.cropX = 0;
    state.cropY = 0;
    clampZoomToResolution();
    render();
  }

  function currentPrintPricing() {
    if (!preparationFlags().pricing || state.sizeMode !== 'custom' || !window.StackhousePrintPricing) return null;
    var types = {'Giclee Fine Art Prints':'giclee-fine-art-prints', 'Professional Photo Prints':'professional-photo-prints',
      'Rolled Canvas Prints':'rolled-canvas-prints', 'Mini Prints':'mini-prints', 'Mounted Prints':'mounted-prints',
      'Gallery Wrapped Canvas Prints':'gallery-wrapped-canvas-prints', 'Clear Bagged Prints':'clear-bagged-prints',
      'Retail Ready Prints':'retail-ready-prints', 'Matting Package Prints':'matting-package-prints'};
    var loose = ['giclee-fine-art-prints','professional-photo-prints','rolled-canvas-prints','mini-prints'];
    function line(id, quantity, unit, family, properties, productId, sku) {
      properties = properties || {};
      return {id:id,quantity:quantity,cost:{amountPerQuantity:{amount:String(unit)}},
        testPrint:{value:properties['_Test Print']},boxSet:{value:properties['_Print Box Set ID']},
        merchandise:{__typename:'ProductVariant',sku:sku || '',product:{id:'gid://shopify/Product/'+productId,
          productType:family ? 'Print' : 'Excluded',isGiftCard:false,
          eligibility:{jsonValue:{version:1,policy:'print-pricing-v1',volume:!!family,pro:!!family,second_copy:loose.indexOf(family)!==-1}}}}};
    }
    var lines = (pricingPreviewCart && pricingPreviewCart.items || []).filter(function(item){return item.key !== cartEditKey;}).map(function(item){
      return line(item.key,item.quantity,item.original_price/100,types[item.product_type],item.properties,item.product_id,item.sku);
    });
    lines.unshift(line('builder-current-print',state.qty,currentPrice(),canonicalHandle(state.productHandle),{},'builder',''));
    var customer = bootstrap.customer || {};
    var result = window.StackhousePrintPricing.evaluatePolicies({cart:{lines:lines,
      buyerIdentity:{customer:{proStatus:{value:customer.proStatus},proTier:{value:customer.proTier}}}}});
    var winner = result.best;
    var gross = Math.round(currentPrice()*100)*state.qty;
    var savings = 0;
    if (winner && winner.candidate.targets.some(function(target){return target.cartLine.id==='builder-current-print';})) {
      savings = window.StackhousePrintPricing.lineSavings(winner, lines, 'builder-current-print');
    }
    return {net:(gross-savings)/100,savings:savings,label:savings ? winner.candidate.message : ''};
  }

  function volumeTotal(unit, quantity, off) {
    var unitCents = Math.round(unit * 100);
    // The native 10+ offer rounds the line saving; Pro and higher tiers round each copy.
    if (off === 10) {
      var grossCents = unitCents * quantity;
      return (grossCents - Math.floor(grossCents * off / 100)) / 100;
    }
    var savingsCents = Math.floor(unitCents * off / 100);
    return (unitCents - savingsCents) * quantity / 100;
  }

  function tierFor(qty) {
    var current = { min: 1, off: 0 };

    if (!volumeDiscountsAvailable()) {
      return current;
    }

    for (var i = 0; i < VOLUME_TIERS.length; i += 1) {
      if (qty >= VOLUME_TIERS[i].min) {
        current = VOLUME_TIERS[i];
      }
    }

    return current;
  }

  function nextTier(qty) {
    if (!volumeDiscountsAvailable()) {
      return null;
    }
    for (var i = 0; i < VOLUME_TIERS.length; i += 1) {
      if (qty < VOLUME_TIERS[i].min) {
        return VOLUME_TIERS[i];
      }
    }
    return null;
  }

  function matchingCurrentStandardSize(size) {
    var key = size && (sizeKeyFromText(size.label || size.key) || size.key);
    var sizes;

    if (!key) {
      return null;
    }

    sizes = currentSizes();
    for (var i = 0; i < sizes.length; i += 1) {
      if ((sizeKeyFromText(sizes[i].label || sizes[i].key) || sizes[i].key) === key) {
        return sizes[i];
      }
    }

    return null;
  }

  function replaceProductQuery(handle) {
    var url = new URL(window.location.href);

    url.searchParams.set('product', handle);
    window.history.replaceState({}, '', url.toString());
  }

  function productAssistantRecommendation() {
    var subject = state.productAssistantSubject;
    var finish = state.productAssistantFinish;
    var recommendations = {
      loose: subject === 'photography'
        ? ['professional-photo-prints', 'giclee-fine-art-prints']
        : subject === 'artwork'
          ? ['giclee-fine-art-prints', 'rolled-canvas-prints']
          : ['test-print', 'giclee-fine-art-prints', 'professional-photo-prints'],
      hang: ['framed-prints', 'gallery-wrapped-canvas-prints', 'mounted-prints'],
      mounted: ['mounted-prints', 'gallery-wrapped-canvas-prints'],
      sell: ['retail-ready-prints', 'matting-package-prints']
    };
    var descriptions = {
      loose: subject === 'photography'
        ? 'For photographic work that you plan to frame or finish yourself, start with these two surfaces.'
        : subject === 'artwork'
          ? 'For artwork that you plan to frame or finish yourself, start with these two archival options.'
          : 'These are the most useful loose-print starting points when you are still deciding on a surface.',
      hang: 'For a finished wall piece, start with a framed print, stretched canvas, or rigid mounted print.',
      mounted: 'For a flat, rigid presentation, mounted prints are the best match. A gallery wrap is the closest dimensional alternative.',
      sell: 'For artwork that should arrive protected and presentation-ready, start with these packaged options.'
    };

    return {
      handles: recommendations[finish] || [],
      description: descriptions[finish] || 'Choose a product to continue into the print builder.'
    };
  }

  function productAssistantReason(handle) {
    var reasons = {
      'giclee-fine-art-prints': 'Best for archival artwork reproduction and fine art paper choices.',
      'test-print': 'A small production print for evaluating one image, surface, crop, and border.',
      'professional-photo-prints': 'Best for crisp detail and a polished photographic finish.',
      'rolled-canvas-prints': 'Canvas texture that you can stretch, frame, or finish yourself.',
      'gallery-wrapped-canvas-prints': 'A finished canvas with wrapped edges that arrives ready to hang.',
      'framed-prints': 'A made-to-order framed print with an optional white mat and hanging hardware included.',
      'mounted-prints': 'A rigid, flat print that is easy to handle and display.',
      'retail-ready-prints': 'Includes backing board and a clear bag for a sturdy sale-ready presentation.',
      'matting-package-prints': 'A matted and protected presentation sized for a standard frame.'
    };

    return reasons[handle] || '';
  }

  function answerProductAssistant(kind, value) {
    if (assistantTelemetry) assistantTelemetry.action('product_assistant_answered', state, {question: kind, answer: value});
    if (kind === 'subject') {
      state.productAssistantSubject = value;
      state.productAssistantFinish = '';
      state.productAssistantBrowseAll = false;
      state.productAssistantStep = 2;
    } else if (kind === 'finish') {
      state.productAssistantFinish = value;
      state.productAssistantBrowseAll = false;
      state.productAssistantStep = 3;
    }

    renderProduct();
  }

  function browseAllProducts() {
    if (assistantTelemetry) assistantTelemetry.action('product_assistant_browse_all', state);
    state.productAssistantBrowseAll = true;
    state.productAssistantStep = 3;
    renderProduct();
  }

  function resetProductAssistant() {
    if (assistantTelemetry) assistantTelemetry.action('product_assistant_reset', state);
    state.productAssistantStep = 1;
    state.productAssistantSubject = '';
    state.productAssistantFinish = '';
    state.productAssistantBrowseAll = false;
    renderProduct();
  }

  function backProductAssistant() {
    if (assistantTelemetry) assistantTelemetry.action('product_assistant_back', state);
    if (state.productAssistantBrowseAll && state.productAssistantSubject && state.productAssistantFinish) {
      state.productAssistantBrowseAll = false;
      state.productAssistantStep = 3;
    } else if (state.productAssistantStep === 3 && state.productAssistantSubject) {
      state.productAssistantStep = 2;
      state.productAssistantFinish = '';
      state.productAssistantBrowseAll = false;
    } else {
      resetProductAssistant();
      return;
    }

    renderProduct();
  }

  function setProductPickerGroupsVisible(visible) {
    els.productGroupHeadings.forEach(function (heading) {
      heading.hidden = !visible;
    });

    els.productResources.forEach(function (resource) {
      resource.hidden = !visible;
    });
  }

  function setProductPickerOpen(open) {
    var isOpen = Boolean(open && els.productPicker);

    if (els.productPicker) {
      els.productPicker.hidden = !isOpen;
    }

    setProductPickerGroupsVisible(isOpen && (!state.productSelectionPending || state.productAssistantBrowseAll));

    root.classList.toggle('is-product-picker-open', isOpen && !state.productSelectionPending);

    if (els.productEdit) {
      els.productEdit.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
  }

  function setProduct(handle, updateUrl) {
    var previousSize = state.size;
    var previousSizeMode = state.sizeMode;
    var preservedSize = null;
    var nextProduct;
    handle = canonicalHandle(handle);

    if (!handle) {
      return;
    }

    nextProduct = productByHandle(handle);
    if (!productIsBuilderReady(nextProduct)) {
      return;
    }

    if (canonicalHandle(state.productHandle) === handle) {
      if (state.productSelectionPending) {
        state.productSelectionPending = false;
        if (updateUrl) {
          replaceProductQuery(handle);
        }
        setProductPickerOpen(false);
        render();
      }
      return;
    }

    state.productHandle = handle;
    state.productSelectionPending = false;
    if (!cropRotationAllowed()) {
      state.cropRotation = 0;
    }
    if (previousSizeMode !== 'custom') {
      preservedSize = matchingCurrentStandardSize(previousSize);
    }

    state.size = preservedSize;
    state.sizeMode = 'standard';
    state.customW = '';
    state.customH = '';
    state.customLocked = true;
    state.customRatio = null;
    state.committedSizeRatio = preservedSize ? normalizePrintRatio(preservedSize.ratio) : null;
    resetSelectedOptions();
    state.open = isDone('photo') ? (state.size ? 'paper' : 'size') : 'photo';
    resetAddState();
    resetCustomPricePreview();
    if (!preservedSize) {
      resetCrop();
    } else {
      state.cropOpen = false;
      clampZoomToResolution();
    }

    els.productButtons.forEach(function (button) {
      button.classList.toggle('is-active', canonicalHandle(button.getAttribute('data-product-handle')) === handle);
    });

    if (els.productTitle) {
      els.productTitle.textContent = productTitle(handle);
    }

    if (updateUrl) {
      replaceProductQuery(handle);
    }

    setProductPickerOpen(false);

    renderOptions();
    render();
    queueOpenStepIntoView(state.open);

    if (isTestPrintProduct()) {
      trackBetaBuilderEvent('test_print_builder_start', {
        test_print: 'Yes',
        input_method: 'product_selection'
      });
    }
  }

  function setOpen(section) {
    if (!stepIsAvailable(section)) {
      return;
    }

    if (isLocked(section)) {
      return;
    }

    state.open = state.open === section ? null : section;
    state.reviewOpen = false;
    state.reviewZoom = false;
    setCropOpenPreservingPosition(false);
    render();
    queueOpenStepIntoView(state.open);
  }

  function setPreviewView(view) {
    if (view !== 'mockup') {
      view = 'layout';
    }

    if (state.previewView === view) {
      return;
    }

    state.previewView = view;
    render();
  }

  function workspaceUsesDocumentScroll() {
    return window.matchMedia('(max-width: 980px)').matches
      || root.classList.contains('is-scrollable-workspace');
  }

  function queueOpenStepIntoView(section) {
    if (!section || !els.steps || state.productSelectionPending) {
      return;
    }

    window.requestAnimationFrame(function () {
      var active = root.querySelector('[data-order-step="' + section + '"]');
      var header;
      var railRect;
      var headerRect;
      var topDelta;
      var bottomDelta;
      var behavior;

      if (!active || state.open !== section) {
        return;
      }

      header = active.querySelector('.order-app-step__header') || active;
      if (workspaceUsesDocumentScroll()) {
        var destination = state.cropOpen ? els.previewStage.closest('.order-app-preview') : header;
        var offset = state.cropOpen ? mobileHeaderOffset() : mobileOptionsOffset();
        var rect = destination.getBoundingClientRect();
        if (rect.top < offset || rect.top > window.innerHeight * 0.5) {
          window.scrollTo({ top: window.scrollY + rect.top - offset - 12, behavior: 'auto' });
        }
        return;
      }

      railRect = els.steps.getBoundingClientRect();
      headerRect = header.getBoundingClientRect();
      topDelta = headerRect.top - railRect.top;
      bottomDelta = headerRect.bottom - railRect.bottom;

      if (topDelta >= 8 && bottomDelta <= -12 && topDelta <= railRect.height * 0.55) {
        return;
      }

      behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      els.steps.scrollTo({
        top: els.steps.scrollTop + topDelta - 8,
        behavior: behavior
      });
    });
  }

  function queueDockIntoView() {
    if (!els.dock || window.matchMedia('(max-width: 980px)').matches) {
      return;
    }

    window.requestAnimationFrame(function () {
      els.dock.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'nearest'
      });
    });
  }

  function setPhoto(photo) {
    clearLibrarySelection();
    if (photo && photo !== 'uploading' && !state.uploading && batchUploadItems.length
        && batchUploadItems.every(function (item) { return item.status === 'complete'; })) {
      clearPreviousBatchUploadItems();
    }
    showDraftNotice('');
    state.photo = photo;
    state.choosingReplacement = false;
    resetAddState();
    state.uploadError = '';
    state.uploadHelpLink = '';
    resetCrop();

    if (photo && photo !== 'uploading') {
      if (!state.customW && !state.customH) {
        state.customRatio = null;
      }
      state.open = 'size';
    }

    render();
    queueOpenStepIntoView(state.open);
  }

  function preparationProgress(asset) {
    return asset && asset.preparation && asset.preparation.status !== 'ready'
      ? 'Upload complete. Preparing your print copy. Your original is safe.'
      : 'Upload complete. Preparing your reusable preview.';
  }

  function uploadFailureMessage(error, isBatch) {
    var message = error && error.message ? error.message : 'Upload failed. Please try again.';
    if (/^(failed to fetch|load failed|networkerror.*)$/i.test(message)) {
      message = 'The upload connection was interrupted. Check your connection and try again.';
      if (!isBatch && state.photo && state.photo !== 'uploading') {
        message += ' Your previous image is still selected.';
      }
    }
    return message;
  }

  function uploadFailureCode(error, phase) {
    var supplied = error && (error.errorCode || error.code);
    var operationFallback = {
      session_create: 'UPLOAD_SESSION_FAILED',
      asset_create: 'UPLOAD_REGISTRATION_FAILED',
      asset_parts: 'UPLOAD_PART_AUTHORIZATION_FAILED',
      asset_transfer: 'UPLOAD_PART_FAILED',
      asset_finalize: 'UPLOAD_FINALIZATION_FAILED',
      asset_status: 'UPLOAD_STATUS_CHECK_FAILED',
      asset_retry_processing: 'UPLOAD_PROCESSING_RETRY_FAILED'
    };
    var fallback = {
      validation: 'UPLOAD_VALIDATION_FAILED',
      session: 'UPLOAD_SESSION_FAILED',
      presign: 'UPLOAD_PRESIGN_FAILED',
      transfer: 'UPLOAD_PART_FAILED',
      finalization: 'UPLOAD_FINALIZATION_FAILED',
      processing: 'UPLOAD_PROCESSING_FAILED',
      preview: 'UPLOAD_PREVIEW_FAILED'
    };
    return supplied || operationFallback[error && error.uploadRequestOperation] || fallback[phase] || 'UPLOAD_FAILED';
  }

  function uploadFailureStatus(error) {
    return error && (error.statusCode || error.status) || undefined;
  }

  function uploadV2FailurePhase(error, fallbackPhase) {
    if (error && error.uploadFailurePhase) return error.uploadFailurePhase;
    var operationPhase = {
      session_create: 'session', asset_create: 'registration', asset_parts: 'presign',
      asset_transfer: 'transfer', asset_finalize: 'finalization', asset_status: 'status',
      asset_retry_processing: 'processing'
    };
    if (error && operationPhase[error.uploadRequestOperation]) return operationPhase[error.uploadRequestOperation];
    var code = String(error && (error.errorCode || error.code) || '');

    if (/^PROCESSING_|^FILE_SIGNATURE_UNAVAILABLE$/.test(code)) {
      return 'photo';
    }
    if (/PRESIGN/.test(code)) {
      return 'presign';
    }
    if (/FINALIZATION|CONFIRM/.test(code)) {
      return 'finalization';
    }
    if (/PART|TRANSFER|NETWORK|TIMEOUT/.test(code)) {
      return 'transfer';
    }
    return fallbackPhase || 'upload_v2';
  }

  function batchUploadIsPending(item) {
    return item && (item.status === 'queued' || item.status === 'uploading');
  }

  function batchUploadText(key, count) {
    var defaults = {
      starting: 'Starting upload',
      uploading: 'Uploading',
      queued: 'Queued',
      confirming: 'Confirming upload',
      processing: 'Preparing preview',
      preview: 'Loading preview',
      title: 'Uploads in progress',
      ready_one: '{{ count }} file ready. Choose an image to continue.',
      ready_many: '{{ count }} files ready. Choose an image to continue.',
      uploading_one: '{{ count }} file uploading.',
      uploading_many: '{{ count }} files uploading.',
      preparing_one: '{{ count }} file preparing.',
      preparing_many: '{{ count }} files preparing.',
      queued_one: '{{ count }} file queued.',
      queued_many: '{{ count }} files queued.',
      failed_one: '{{ count }} file needs attention.',
      failed_many: '{{ count }} files need attention.',
      ready_while_waiting: 'You can configure ready images while other files finish.',
      successful_ready: 'Successful uploads are ready to use.'
    };
    var copy = bootstrap.uploadCopy || {};
    return String(copy[key] || defaults[key] || '').replace('__COUNT__', String(count)).replace('{{ count }}', String(count));
  }

  function batchUploadIsPreparing(item) {
    return item.status === 'uploading' && ['finalization', 'processing', 'preview'].indexOf(item.stage) !== -1;
  }

  function batchUploadStageLabel(item) {
    if (item.status === 'queued') return batchUploadText('queued');
    if (item.stage === 'finalization') return batchUploadText('confirming');
    if (item.stage === 'processing') return batchUploadText('processing');
    if (item.stage === 'preview') return batchUploadText('preview');
    if (item.stage === 'transfer') return item.progress + '%';
    return batchUploadText('starting');
  }

  function librarySelectionBlocked() {
    return state.adding || (state.uploading && !batchUploadItems.some(batchUploadIsPending));
  }

  function batchUploadItemById(id) {
    return batchUploadItems.find(function (item) {
      return item.id === id;
    }) || null;
  }

  function updateBatchUploadItem(item, status, message, progress) {
    if (!item) {
      return;
    }
    if (status) {
      item.status = status;
    }
    if (message !== undefined) {
      item.message = message || '';
    }
    if (typeof progress === 'number' && Number.isFinite(progress)) {
      item.progress = Math.max(0, Math.min(100, Math.round(progress)));
    }
    renderLibrary();
  }

  function uploadStatusReporter(batchItem, title) {
    if (!batchItem) {
      return function (status) {
        updateUploadStatus(title, status);
      };
    }
    return function (status, progress, stage) {
      if (stage) batchItem.stage = stage;
      updateBatchUploadItem(batchItem, 'uploading', status, progress);
      updateUploadStatus(batchUploadText('title'), batchUploadSummaryText());
    };
  }

  function batchUploadSummaryText() {
    var completed = batchUploadItems.filter(function (item) { return item.status === 'complete'; }).length;
    var failed = batchUploadItems.filter(function (item) { return item.status === 'failed'; }).length;
    var preparing = batchUploadItems.filter(batchUploadIsPreparing).length;
    var uploading = batchUploadItems.filter(function (item) { return item.status === 'uploading'; }).length - preparing;
    var queued = batchUploadItems.filter(function (item) { return item.status === 'queued'; }).length;
    var parts = [];

    if (completed) parts.push(batchUploadText(completed === 1 ? 'ready_one' : 'ready_many', completed));
    if (uploading) parts.push(batchUploadText(uploading === 1 ? 'uploading_one' : 'uploading_many', uploading));
    if (preparing) parts.push(batchUploadText(preparing === 1 ? 'preparing_one' : 'preparing_many', preparing));
    if (queued) parts.push(batchUploadText(queued === 1 ? 'queued_one' : 'queued_many', queued));
    if (completed && (uploading || preparing || queued)) parts.push(batchUploadText('ready_while_waiting'));
    if (failed) {
      parts.push(batchUploadText(failed === 1 ? 'failed_one' : 'failed_many', failed));
      if (completed) parts.push(batchUploadText('successful_ready'));
    }
    if (state.batchUploadNotice) {
      parts.push(state.batchUploadNotice);
    }

    return parts.join(' ');
  }

  function syncBatchUploadState() {
    var pending = batchUploadItems.some(batchUploadIsPending);

    state.uploading = pending;
    if (!pending && customerId() && batchUploadItems.some(function (item) { return item.status === 'complete'; })) {
      state.libraryLoaded = false;
      loadCustomerLibrary(true);
    }
    render();
  }

  function batchUploadRetryDelay(error) {
    var seconds = Math.max(0, Number(error && error.retryAfterSeconds) || 0);
    // Admission's idle-expiry estimate is not a required cooldown. Capacity can
    // open immediately when another transfer completes. Keep manual retries
    // bounded and let the backend enforce its unchanged three-transfer cap.
    if (error && (error.errorCode || error.code) === 'UPLOAD_CONCURRENCY_LIMIT') seconds = Math.min(5, seconds);
    return seconds * 1000;
  }

  function processBatchUploadQueue() {
    var next;

    while (batchUploadActive < batchUploadMaxConcurrent) {
      next = batchUploadItems.find(function (item) { return item.status === 'queued'; });
      if (!next) {
        break;
      }

      batchUploadActive += 1;
      next.status = 'uploading';
      next.stage = 'session';
      next.message = 'Preparing upload...';
      next.progress = 0;

      (function (item) {
        uploadSelectedFile(item.file, item.triggerMethod, false, item).then(function (photo) {
          if (!photo) {
            throw new Error('The upload finished without a reusable image. Please try again.');
          }
          item.photo = photo;
          item.status = 'complete';
          item.message = 'Ready';
          item.progress = 100;
          state.libraryPage = 0;
          if (item.previewUrl && photo.src !== item.previewUrl && item.previewUrl.indexOf('blob:') === 0) {
            URL.revokeObjectURL(item.previewUrl);
            item.previewUrl = '';
          }
        }).catch(function (error) {
          if (window.StackhouseUploadV2 && window.StackhouseUploadV2.isSelectionCancelled(error)) {
            if (item.previewUrl && item.previewUrl.indexOf('blob:') === 0) URL.revokeObjectURL(item.previewUrl);
            batchUploadItems = batchUploadItems.filter(function (candidate) { return candidate !== item; });
            state.batchUploadNotice = 'File skipped. Choose another file when you are ready.';
            return;
          }
          item.status = 'failed';
          item.error = error && error.message ? error.message : 'Upload failed. Please try again.';
          item.message = item.error;
          item.helpLink = error && error.helpLink || '';
          item.retryable = !error || error.retryable !== false;
          item.errorCode = error && (error.errorCode || error.code) || '';
          item.retryAvailableAt = Date.now() + batchUploadRetryDelay(error);
          if (item.errorCode === 'UPLOAD_CONCURRENCY_LIMIT' && item.retryAvailableAt) {
            window.setTimeout(render, Math.max(0, item.retryAvailableAt - Date.now()) + 50);
          }
        }).finally(function () {
          batchUploadActive = Math.max(0, batchUploadActive - 1);
          processBatchUploadQueue();
          syncBatchUploadState();
        });
      })(next);
    }

    syncBatchUploadState();
  }

  function clearPreviousBatchUploadItems() {
    batchUploadItems.forEach(function (item) {
      if (item.previewUrl && item.previewUrl.indexOf('blob:') === 0 && (!item.photo || item.photo.src !== item.previewUrl)) {
        URL.revokeObjectURL(item.previewUrl);
      }
    });
    batchUploadItems = [];
    batchUploadActive = 0;
    state.batchUploadNotice = '';
  }

  function queueBatchUploadFiles(files, triggerMethod) {
    if (state.uploading) return;
    cancelLibraryDeepLink();
    var selected = Array.prototype.slice.call(files || []);
    var accepted = selected.slice(0, batchUploadLimit);

    clearPreviousBatchUploadItems();
    if (selected.length > batchUploadLimit) {
      state.batchUploadNotice = 'Only the first ' + batchUploadLimit + ' files were added to this batch.';
    }

    batchUploadItems = accepted.map(function (file) {
      batchUploadSequence += 1;
      return {
        id: 'batch-upload-' + batchUploadSequence,
        file: file,
        name: file.name,
        status: 'queued',
        stage: 'queued',
        message: 'Queued',
        progress: 0,
        error: '',
        photo: null,
        previewUrl: isTiffFile(file) ? '' : URL.createObjectURL(file),
        triggerMethod: triggerMethod || 'file_input'
      };
    });

    trackBetaBuilderEvent('file_upload_batch_started', {
      file_count: accepted.length,
      skipped_count: Math.max(0, selected.length - accepted.length),
      max_concurrent_uploads: batchUploadMaxConcurrent,
      trigger_method: triggerMethod || 'file_input'
    });
    processBatchUploadQueue();
  }

  function retryBatchUpload(id) {
    var item = batchUploadItemById(id);

    if (
      !item
      || item.status !== 'failed'
      || item.retryable === false
      || (item.retryAvailableAt && Date.now() < item.retryAvailableAt)
    ) {
      return;
    }
    item.status = 'queued';
    item.stage = 'queued';
    item.retryCount = (item.retryCount || 0) + 1;
    item.retryAvailableAt = 0;
    item.message = 'Queued';
    item.progress = 0;
    item.error = '';
    processBatchUploadQueue();
  }

  function dismissBatchUpload(id) {
    var item = batchUploadItemById(id);

    if (!item || batchUploadIsPending(item)) {
      return;
    }
    if (item.previewUrl && item.previewUrl.indexOf('blob:') === 0 && (!item.photo || item.photo.src !== item.previewUrl)) {
      URL.revokeObjectURL(item.previewUrl);
    }
    batchUploadItems = batchUploadItems.filter(function (candidate) { return candidate.id !== id; });
    render();
  }

  function ensureUploadedPreview(photo) {
    return new Promise(function (resolve, reject) {
      if (!photo || !photo.src || !photo.w || !photo.h) {
        reject(new Error('The new image is not ready. Your previous artwork is still available.'));
        return;
      }
      var image = new Image();
      var timer = window.setTimeout(function () { image.src = ''; reject(new Error('The new preview took too long. Please retry.')); }, 30000);
      image.onload = function () { window.clearTimeout(timer); resolve(); };
      image.onerror = function () { window.clearTimeout(timer); reject(new Error('The new preview could not load. Please retry.')); };
      image.src = photo.src;
    });
  }

  function applyBuilderUploadPolicy(policy) {
    var summary = root.querySelector('[data-stackhouse-upload-policy-summary]');
    if (summary && policy && policy.summary) {
      summary.textContent = policy.summary;
      summary.setAttribute('data-builder-upload-policy', 'true');
    }
    // Restored artwork may have rendered before the shared PPI policy arrived.
    render();
  }

  function rememberFailedUpload(file, error, assetId, originalAttemptId) {
    var retryable = error && error.retryable !== false;
    failedUploadFile = retryable ? file : null;
    if (originalAttemptId !== undefined) failedUploadTelemetryAttemptId = retryable ? originalAttemptId : null;
    state.failedUploadAssetId = retryable ? (error.assetId || assetId || '') : '';
    var delay = retryable ? batchUploadRetryDelay(error) : 0;
    state.failedUploadRetryAvailableAt = Date.now() + delay;
    if (delay) window.setTimeout(render, delay + 50);
  }

  async function uploadSelectedFileV2(file, triggerMethod, batchItem) {
    var method = triggerMethod || state.uploadTriggerMethod || 'file_input';
    var isBatch = Boolean(batchItem);
    var attemptId;
    var validationError = validateUploadFile(file);
    var controller = window.StackhouseUploadV2;
    var failurePhase = 'validation';
    var uploadTitle = 'Uploading and preparing ' + file.name + '...';
    var report = uploadStatusReporter(batchItem, uploadTitle);

    if (state.uploading && !isBatch) {
      renderPhoto();
      return;
    }

    attemptId = isBatch && batchItem.uploadAttemptId || state.uploadAttemptId + 1;
    state.uploadAttemptId = Math.max(state.uploadAttemptId, attemptId);
    if (isBatch) batchItem.uploadAttemptId = attemptId;
    if (!isBatch) {
      state.failedUploadAssetId = '';
      failedUploadFile = null;
    }

    if (validationError) {
      if (isBatch) {
        var batchValidationError = new Error(validationError);
        batchValidationError.code = 'UPLOAD_VALIDATION_FAILED';
        batchValidationError.retryable = false;
        trackBetaBuilderEvent('file_upload_failed', {
          fileName: file && file.name,
          fileSizeBytes: file && file.size,
          file_type: file && file.type,
          trigger_method: method,
          upload_attempt_id: attemptId,
          upload_pipeline: 'upload_v2',
          error_code: batchValidationError.code,
          failure_phase: 'validation',
          status_code: 422,
          error_message: validationError
        });
        throw batchValidationError;
      }
      state.uploadError = validationError;
      state.uploadHelpLink = '';
      updateUploadStatus('Upload failed', validationError);
      renderPhoto();
      return;
    }

    if (!controller || typeof controller.upload !== 'function') {
      if (isBatch) {
        throw new Error('The large-image uploader could not start. Refresh the page and try again.');
      }
      state.uploadError = 'The large-image uploader could not start. Refresh the page and try again.';
      updateUploadStatus('Upload failed', state.uploadError);
      renderPhoto();
      return;
    }

    if (!isBatch) {
      state.uploading = true;
      state.uploadTriggerMethod = '';
      state.uploadError = '';
      state.uploadHelpLink = '';
      render();
    }
    report('Creating a secure upload session.', 1, 'session');
    trackBetaBuilderEvent('file_upload_started', {
      fileName: file.name,
      fileSizeBytes: file.size,
      file_type: file.type,
      trigger_method: method,
      upload_attempt_id: attemptId,
      retry_count: isBatch ? batchItem.retryCount || 0 : 0,
      upload_pipeline: 'upload_v2'
    });

    try {
      var result = await controller.upload({
        apiBaseUrl: apiBaseUrl(),
        uploadSurface: 'order_builder',
        onPolicy: applyBuilderUploadPolicy,
        file: file,
        eventDetails: {
          upload_attempt_id: attemptId,
          trigger_method: method
        },
        onStage: function (stage) {
          failurePhase = stage;
          if (stage === 'processing') {
            report('Upload complete. Preparing your reusable preview.', 100, stage);
          } else if (stage === 'finalization') {
            report('Finalizing upload.', 100, stage);
          } else if (stage === 'transfer') {
            report('Sending file to Stackhouse storage.', undefined, stage);
          }
        },
        onProgress: function (percent) {
          report('Uploading file, ' + percent + '%.', percent, 'transfer');
        },
        onRetry: function (partNumber, attempt) {
          report('Connection interrupted. Retrying part ' + partNumber + ' (' + attempt + '/3)...');
        },
        onProcessing: function (asset) {
          report(preparationProgress(asset), 100, 'processing');
        }
      });
      failurePhase = 'preview';
      var source = result.source || {};
      var photo = uploadResponsePhoto(file, result, {
        localUrl: '',
        w: source.width || 0,
        h: source.height || 0,
        mb: fileSizeMb(result.file_size_bytes || file.size)
      });

      if (!isBatch && state.uploadAttemptId !== attemptId) return;
      if (isBatch) report(batchUploadText('preview'), 100, 'preview');
      await ensureUploadedPreview(photo);
      if (!isBatch && state.uploadAttemptId !== attemptId) return;
      rememberCompletedPhoto(photo);
      if (!isBatch) {
        state.failedUploadAssetId = '';
        failedUploadFile = null;
        setPhoto(photo);
      }
      trackBetaBuilderEvent('file_upload_completed', {
        fileName: file.name,
        fileSizeBytes: file.size,
        file_type: file.type,
        trigger_method: method,
        upload_attempt_id: attemptId,
        retry_count: isBatch ? batchItem.retryCount || 0 : 0,
        upload_pipeline: 'upload_v2',
        upload_asset_id: result.asset_id || '',
        image_size: photo && photo.w && photo.h ? photo.w + 'x' + photo.h : ''
      });
      if (customerId() && !isBatch) {
        state.libraryLoaded = false;
        loadCustomerLibrary(true);
      }
      return photo;
    } catch (error) {
      if (!isBatch && state.uploadAttemptId !== attemptId) return;
      if (controller.isSelectionCancelled && controller.isSelectionCancelled(error)) {
        if (isBatch) throw error;
        state.uploadError = '';
        state.uploadHelpLink = '';
        state.failedUploadAssetId = '';
        failedUploadFile = null;
        updateUploadStatus('Choose an image', 'Choose another file when you are ready.');
        return;
      }
      var failureCode = uploadFailureCode(error, failurePhase);
      if (!(await controller.unifiedAvailable()) && (
        failureCode === 'CUSTOMER_NOT_ENROLLED'
        || failureCode === 'CUSTOMER_AUTH_INVALID'
        || failureCode === 'CUSTOMER_AUTH_REQUIRED'
      )) {
        if (!isBatch) {
          state.uploadError = '';
          state.uploadHelpLink = '';
          state.failedUploadAssetId = '';
          failedUploadFile = null;
        }
        trackBetaBuilderEvent('file_upload_v2_fallback_started', {
          fileName: file.name,
          fileSizeBytes: file.size,
          file_type: file.type,
          trigger_method: method,
          upload_attempt_id: attemptId,
          upload_pipeline: 'upload_v2',
          error_code: failureCode,
          status_code: uploadFailureStatus(error)
        });
        if (!isBatch && state.uploadAttemptId === attemptId) {
          state.uploading = false;
        }
        if (!isBatch) {
          state.uploadTriggerMethod = '';
        }
        return await uploadSelectedFile(file, method, true, batchItem);
      }
      var uploadErrorMessage = uploadFailureMessage(error, isBatch);
      if (!isBatch) {
        state.uploadError = uploadErrorMessage;
        state.uploadHelpLink = error && error.helpLink || '';
        rememberFailedUpload(file, error, '', attemptId);
        updateUploadStatus('Upload or processing failed', state.uploadError);
      }
      trackBetaBuilderEvent('file_upload_failed', {
        fileName: file.name,
        fileSizeBytes: file.size,
        file_type: file.type,
        trigger_method: method,
        upload_attempt_id: attemptId,
        retry_count: isBatch ? batchItem.retryCount || 0 : 0,
        upload_pipeline: 'upload_v2',
        upload_asset_id: error && error.assetId || '',
        error_code: failureCode,
        failure_phase: uploadV2FailurePhase(error, failurePhase),
        upload_read_failure: error && error.uploadReadFailure,
        request_id: error && error.uploadRequestId,
        endpoint_operation: error && error.uploadRequestOperation,
        status_code: uploadFailureStatus(error),
        error_message: uploadErrorMessage
      });
      if (isBatch) {
        throw error;
      }
    } finally {
      if (!isBatch && state.uploadAttemptId === attemptId) {
        state.uploading = false;
      }
      if (!isBatch) {
        state.uploadTriggerMethod = '';
        render();
      }
    }
  }

  async function retryFailedUploadProcessing() {
    var controller = window.StackhouseUploadV2;
    var assetId = state.failedUploadAssetId;
    var file = failedUploadFile;

    if (!file || state.uploading || !controller || Date.now() < state.failedUploadRetryAvailableAt) {
      return;
    }
    var attemptId = ++state.uploadAttemptId;
    state.uploading = true;
    state.uploadError = '';
    state.uploadHelpLink = '';
    updateUploadStatus('Preparing ' + file.name + '...', assetId ? 'Checking your existing upload.' : 'Retrying secure upload.');
    render();

    try {
      var result = await controller.retryProcessing({
        apiBaseUrl: apiBaseUrl(),
        uploadSurface: 'order_builder',
        assetId: assetId,
        file: file,
        eventDetails: { upload_attempt_id: attemptId },
        onStage: function (stage) {
          updateUploadStatus('Preparing ' + file.name + '...', stage === 'finalization' ? 'Finishing your upload.' : 'Preparing secure upload.');
        },
        onProgress: function (percent) {
          updateUploadStatus('Uploading ' + file.name + '...', 'Uploading file, ' + percent + '%.');
        },
        onProcessing: function (asset) {
          updateUploadStatus('Preparing ' + file.name + '...', preparationProgress(asset));
        }
      });
      var source = result.source || {};
      var photo = uploadResponsePhoto(file, result, {
        localUrl: '',
        w: source.width || 0,
        h: source.height || 0,
        mb: fileSizeMb(result.file_size_bytes || file.size)
      });
      if (state.uploadAttemptId !== attemptId) return;
      await ensureUploadedPreview(photo);
      if (state.uploadAttemptId !== attemptId) return;
      rememberCompletedPhoto(photo);
      state.failedUploadAssetId = '';
      failedUploadFile = null;
      setPhoto(photo);
      trackBetaBuilderEvent('file_upload_processing_retry_completed', {
        upload_pipeline: 'upload_v2',
        retry_of_upload_attempt_id: failedUploadTelemetryAttemptId,
        upload_asset_id: assetId
      });
    } catch (error) {
      if (state.uploadAttemptId !== attemptId) return;
      if (controller.isSelectionCancelled && controller.isSelectionCancelled(error)) {
        state.uploadError = '';
        state.uploadHelpLink = '';
        state.failedUploadAssetId = '';
        failedUploadFile = null;
        updateUploadStatus('Choose an image', 'Choose another file when you are ready.');
        return;
      }
      state.uploadError = error && error.message ? error.message : 'Processing failed again.';
      state.uploadHelpLink = error && error.helpLink || '';
      rememberFailedUpload(file, error, assetId);
      updateUploadStatus('Upload or processing failed', state.uploadError);
      trackBetaBuilderEvent('file_upload_processing_retry_failed', {
        upload_pipeline: 'upload_v2',
        upload_asset_id: error && error.assetId || assetId,
        upload_attempt_id: attemptId,
        failure_phase: uploadV2FailurePhase(error, 'preview'),
        request_id: error && error.uploadRequestId,
        endpoint_operation: error && error.uploadRequestOperation,
        status_code: uploadFailureStatus(error),
        error_code: uploadFailureCode(error, 'preview'),
        error_message: state.uploadError
      });
    } finally {
      if (state.uploadAttemptId === attemptId) state.uploading = false;
      render();
    }
  }

  async function uploadSelectedFile(file, triggerMethod, forceLegacy, batchItem) {
    if (!batchItem) cancelLibraryDeepLink();
    var unifiedUploads;
    try {
      unifiedUploads = window.StackhouseUploadV2 && await window.StackhouseUploadV2.unifiedAvailable();
    } catch (error) {
      if (batchItem) throw error;
      state.uploadError = error.message || 'Upload requirements are temporarily unavailable. Please try again.';
      state.uploadHelpLink = '';
      updateUploadStatus('Upload failed', state.uploadError);
      renderPhoto();
      return;
    }
    if (unifiedUploads || (uploadV2Enabled() && forceLegacy !== true && customerId())) {
      return uploadSelectedFileV2(file, triggerMethod, batchItem);
    }
    var method = triggerMethod || state.uploadTriggerMethod || 'file_input';
    var isBatch = Boolean(batchItem);
    var attemptId;
    var failurePhase = 'validation';
    var validationError = validateUploadFile(file);
    var uploadTitle = 'Uploading ' + file.name + '...';
    var report = uploadStatusReporter(batchItem, uploadTitle);

    if (state.uploading && !isBatch) {
      trackBetaBuilderEvent('file_upload_ignored', {
        fileName: file && file.name,
        fileSizeBytes: file && file.size,
        file_type: file && file.type,
        trigger_method: method,
        upload_attempt_id: state.uploadAttemptId,
        error_message: 'Upload already in progress.'
      });
      renderPhoto();
      return;
    }

    attemptId = isBatch && batchItem.uploadAttemptId || state.uploadAttemptId + 1;
    state.uploadAttemptId = Math.max(state.uploadAttemptId, attemptId);
    if (isBatch) batchItem.uploadAttemptId = attemptId;

    if (validationError) {
      trackBetaBuilderEvent('file_upload_failed', {
        fileName: file && file.name,
        fileSizeBytes: file && file.size,
        file_type: file && file.type,
        trigger_method: method,
        upload_attempt_id: attemptId,
        error_code: 'UPLOAD_VALIDATION_FAILED',
        failure_phase: 'validation',
        status_code: 422,
        error_message: validationError
      });
      if (isBatch) {
        var batchValidationError = new Error(validationError);
        batchValidationError.code = 'UPLOAD_VALIDATION_FAILED';
        batchValidationError.retryable = false;
        throw batchValidationError;
      }
      state.uploadError = validationError;
      state.uploadHelpLink = '';
      updateUploadStatus('Upload failed', validationError);
      renderPhoto();
      return;
    }

    if (!isBatch) {
      state.uploading = true;
      state.uploadTriggerMethod = '';
      state.uploadError = '';
      state.uploadHelpLink = '';
      render();
    }
    report('Preparing secure upload.', 1, 'session');
    trackBetaBuilderEvent('file_upload_started', {
      fileName: file.name,
      fileSizeBytes: file.size,
      file_type: file.type,
      trigger_method: method,
      upload_attempt_id: attemptId,
      retry_count: isBatch ? batchItem.retryCount || 0 : 0
    });

    try {
      var uploadPolicy = window.StackhouseUploadPolicy;
      if (!uploadPolicy) {
        throw new Error('Image validation is temporarily unavailable. Your file was not uploaded. Please refresh the page and try again.');
      }
      report('Checking file format, color mode, transparency, and size.');
      var policyValidation = await uploadPolicy.validateBeforeUpload(file, {
        onProgress: function (percent) { report(percent < 100 ? 'Sending validation sample, ' + percent + '%.' : 'Checking image metadata.'); }
      });
      if (!policyValidation.valid) {
        var policyError = new Error(policyValidation.error || 'The image could not be validated.');
        policyError.code = policyValidation.error_code || policyValidation.error_type || 'UPLOAD_VALIDATION_FAILED';
        policyError.helpLink = policyValidation.help_link || '';
        policyError.retryable = Boolean(policyValidation.retryable);
        policyError.validationDurationMs = policyValidation.duration_ms;
        policyError.retryCount = policyValidation.retry_count;
        throw policyError;
      }
      var localMeta = await readLocalImageMetadata(file, isBatch && batchItem ? batchItem.previewUrl : '');
      var uploadResilience = window.StackhouseUploadResilience;
      if (!uploadResilience || typeof uploadResilience.createPlan !== 'function') {
        throw new Error('The uploader could not start. Please refresh the page and try again.');
      }
      var uploadPlan = uploadResilience.createPlan(file);
      var payload = {
        file_name: file.name,
        file_type: file.type || 'application/octet-stream',
        file_size: file.size,
        upload_policy_version: policyValidation.policy_version,
        total_chunks: uploadPlan.totalParts,
        folder_name: 'uploads'
      };
      var id = customerId();
      var email = bootstrap.customer && bootstrap.customer.email ? bootstrap.customer.email : '';

      if (id) {
        payload.customer_id = id;
        payload.customer_email = email;
      }

      failurePhase = 'presign';
      report('Creating a secure upload session.');
      var uploadData = await fetchJson(apiBaseUrl() + '/api/uploads/generate-presigned-url/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        stackhouseWorkflowInstanceId: String(attemptId)
      });

      failurePhase = 'transfer';
      report('Sending file to Stackhouse storage.', undefined, 'transfer');
      var resilienceOptions = {
        attemptId: attemptId,
        reporter: function (status, progress) { report(status, progress); }
      };
      var uploadResult = await resilientUpload(
        file,
        uploadData,
        uploadPlan,
        uploadTitle,
        resilienceOptions
      );

      failurePhase = 'finalization';
      report('Finalizing upload and reading image metadata.', 100, 'finalization');
      var completeData = await fetchJson(apiBaseUrl() + '/api/uploads/complete-upload/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        stackhouseWorkflowInstanceId: String(attemptId),
        body: JSON.stringify({
          uploadId: uploadData.uploadId,
          folder_name: uploadData.folder_name || 'uploads',
          file_name: file.name,
          file_size: file.size,
          parts: uploadResult.parts,
          uniqueId: uploadData.uniqueId,
          workflow_instance_id: attemptId
        })
      });
      if (isTiffFile(file) && localMeta.previewBlob) {
        failurePhase = 'preview';
        report('Preparing a browser-safe TIFF preview.', 100, 'processing');
        completeData = await uploadTiffDisplayPreview(
          file,
          uploadData.uniqueId,
          localMeta,
          policyValidation.policy_version,
          resilienceOptions
        ) || completeData;
      }
      var photo = uploadResponsePhoto(file, completeData, localMeta);


      if (!isBatch && state.uploadAttemptId !== attemptId) {
        if (localMeta.localUrl) URL.revokeObjectURL(localMeta.localUrl);
        return;
      }
      if (isBatch) report(batchUploadText('preview'), 100, 'preview');
      await ensureUploadedPreview(photo);
      if (!isBatch && state.uploadAttemptId !== attemptId) return;
      if (!isBatch) {
        revokeLocalPreviewUrl();
        activeLocalPreviewUrl = photo.src === localMeta.localUrl ? localMeta.localUrl : '';
      }
      if (localMeta.localUrl && photo.src !== localMeta.localUrl) URL.revokeObjectURL(localMeta.localUrl);
      rememberCompletedPhoto(photo);
      if (!isBatch) {
        setPhoto(photo);
      }
      trackBetaBuilderEvent('file_upload_completed', {
        fileName: file.name,
        fileSizeBytes: file.size,
        file_type: file.type,
        trigger_method: method,
        upload_attempt_id: attemptId,
        retry_count: isBatch ? batchItem.retryCount || 0 : 0,
        image_size: photo && photo.w && photo.h ? photo.w + 'x' + photo.h : ''
      });

      if (customerId() && !isBatch) {
        state.libraryLoaded = false;
        loadCustomerLibrary(true);
      }
      return photo;
    } catch (error) {
      if (localMeta && localMeta.localUrl) URL.revokeObjectURL(localMeta.localUrl);
      if (!isBatch && state.uploadAttemptId !== attemptId) return;
      var uploadErrorMessage = uploadFailureMessage(error, isBatch);
      if (!isBatch) {
        state.uploadError = uploadErrorMessage;
        state.uploadHelpLink = error && error.helpLink || '';
        updateUploadStatus('Upload failed', state.uploadError);
      }
      trackBetaBuilderEvent('file_upload_failed', {
        fileName: file && file.name,
        fileSizeBytes: file && file.size,
        file_type: file && file.type,
        trigger_method: method,
        upload_attempt_id: attemptId,
        error_code: uploadFailureCode(error, failurePhase),
        failure_phase: failurePhase,
        status_code: uploadFailureStatus(error),
        duration_ms: error && error.validationDurationMs,
        retry_count: isBatch ? batchItem.retryCount || 0 : error && error.retryCount,
        error_message: uploadErrorMessage
      });
      if (isBatch) {
        throw error;
      }
    } finally {
      if (!isBatch && state.uploadAttemptId === attemptId) {
        state.uploading = false;
      }
      if (!isBatch) {
        state.uploadTriggerMethod = '';
        render();
      }
    }
  }

  function resetPhoto() {
    cancelLibraryDeepLink();
    clearDraft();
    showDraftNotice('');
    state.uploadAttemptId += 1;
    revokeLocalPreviewUrl();
    state.photo = null;
    state.photoTab = 'upload';
    state.uploadError = '';
    state.uploadHelpLink = '';
    state.uploading = false;
    state.uploadTriggerMethod = '';
    state.failedUploadAssetId = '';
    failedUploadFile = null;
    updateUploadStatus('', '');
    if (els.fileInput) {
      els.fileInput.value = '';
    }
    state.size = null;
    state.customW = '';
    state.customH = '';
    state.customLocked = true;
    state.customRatio = null;
    state.committedSizeRatio = null;
    resetSelectedOptions();
    resetCustomPricePreview();
    resetCrop();
    state.open = 'photo';
    resetAddState();
    renderOptions();
    render();
    queueOpenStepIntoView(state.open);
  }

  function startOverAfterAdd() {
    if (cartEditKey) {
      clearDraft();
      window.location.href = window.location.pathname + '?browse=all';
      return;
    }
    if (!state.added) {
      return;
    }

    trackBetaBuilderEvent('builder_started_over', { source: 'post_add' });
    state.qty = 1;
    state.reviewOpen = false;
    state.reviewZoom = false;
    state.reviewZoomScale = REVIEW_INSPECT_MIN_ZOOM;
    state.previewView = 'layout';
    resetRepeatPrintLibrary();
    state.productSelectionPending = true;
    state.productAssistantSubject = '';
    state.productAssistantFinish = '';
    state.productAssistantBrowseAll = true;
    state.productAssistantStep = 3;
    var url = new URL(window.location.href);
    ['product', 'size', 'image_id', 'cart_edit'].forEach(function (name) { url.searchParams.delete(name); });
    url.searchParams.set('browse', 'all');
    window.history.replaceState({}, '', url.toString());
    resetPhoto();

    window.requestAnimationFrame(function () {
      var firstProduct = els.productButtons.find(function (button) { return !button.hidden && !button.disabled; });
      if (firstProduct) firstProduct.focus();
    });
  }

  function renderOptions() {
    renderSizes();
    renderMedia();
    renderBorders();
  }

  function testPrintMediaFamily(media) {
    var label = normalizeOptionText(media && (media.label || media.name));

    if (CANVAS_MEDIA.some(function (option) { return normalizeOptionText(option.name) === label; })) {
      return { key: 'canvas', label: 'Canvas' };
    }
    if (PHOTO_MEDIA.some(function (option) { return normalizeOptionText(option.name) === label; })) {
      return { key: 'photo', label: 'Photo papers' };
    }
    return { key: 'fine-art', label: 'Fine art papers' };
  }

  function renderSelectedSizeSummary() {
    if (!els.sizeGrid || !els.sizeGrid.parentNode) return;
    var summary = root.querySelector('[data-order-selected-size]');
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'order-app-selected-size';
      summary.setAttribute('data-order-selected-size', '');
      var copy = document.createElement('span');
      copy.setAttribute('data-order-selected-size-copy', '');
      var reveal = document.createElement('button');
      reveal.type = 'button';
      reveal.className = 'order-app-link-button';
      reveal.textContent = 'Show in list';
      reveal.addEventListener('click', function () {
        var selected = els.sizeGrid.querySelector('[aria-pressed="true"]');
        if (!selected) return;
        selected.focus({ preventScroll: true });
        selected.scrollIntoView({ block: 'center', inline: 'nearest' });
      });
      summary.appendChild(copy);
      summary.appendChild(reveal);
      els.sizeGrid.before(summary);
    }
    summary.hidden = state.sizeMode !== 'standard' || !state.size;
    if (!summary.hidden) {
      var resolution = resolutionForSizeCard(state.size);
      summary.querySelector('[data-order-selected-size-copy]').textContent =
        'Selected: ' + sizeDisplayLabel(state.size) +
        (resolution ? ' · ' + resolutionCardText(resolution, sizeCardUsesLiveResolution(state.size)) : '');
    }
  }

  function renderSizes() {
    if (!els.sizeGrid) {
      return;
    }

    renderSelectedSizeSummary();
    els.sizeGrid.innerHTML = '';

    currentSizes().forEach(function (size) {
      var button = document.createElement('button');
      var liveResolution = sizeCardUsesLiveResolution(size);
      var resolution = resolutionForSizeCard(size);
      button.type = 'button';
      button.className = 'order-app-size-card';
      button.classList.add('is-size-' + (size.bucket || 'standard'));
      button.setAttribute('data-order-size', sizeSelectionKey(size));
      button.setAttribute('data-order-size-bucket', size.bucket || 'standard');
      button.setAttribute('aria-pressed', String(Boolean(state.size && sizesMatch(state.size, size))));

      if (state.size && sizesMatch(state.size, size)) {
        button.classList.add('is-active');
      }

      if (resolution) {
        button.classList.add('is-resolution-' + resolution.status);
        button.classList.toggle('is-live-resolution', liveResolution);
        button.title = resolutionMessage(resolution, liveResolution ? 'crop' : 'size');

      }

      var label = document.createElement('strong');
      label.textContent = sizeDisplayLabel(size);
      var price = document.createElement('small');
      price.textContent = 'From ' + moneyText(size.price);
      button.appendChild(label);
      button.appendChild(price);
      if (size.bucket && size.bucket !== 'standard') {
        var bucket = document.createElement('small');
        bucket.className = 'order-app-size-card__bucket';
        bucket.textContent = sizeBucketLabel(size.bucket);
        button.appendChild(bucket);
      }
      if (resolution || (state.photo && state.photo !== 'uploading')) {
        var resolutionText = document.createElement('small');
        resolutionText.className = 'order-app-size-card__resolution';
        resolutionText.textContent = resolution ? resolutionCardText(resolution, liveResolution) : 'Resolution unavailable';
        button.appendChild(resolutionText);
      }
      els.sizeGrid.appendChild(button);
    });
  }

  function renderMedia() {
    var groups = currentOptionGroups();
    var mediaGroup = groups.find(function (group) {
      return group.kind === 'media';
    });

    if (els.mediaTitle) {
      els.mediaTitle.textContent = mediaGroup ? mediaGroup.name : currentPreset().mediaTitle;
    }

    if (els.paperNext) {
      var borderAvailable = stepIsAvailable('border');
      var paperCanContinue = isDone('paper');
      var nextSecondaryLabel = nextMissingOptionLabel('secondary') || (currentPreset().borderTitle || 'options').toLowerCase();

      els.paperNext.hidden = !paperCanContinue;
      els.paperNext.disabled = !paperCanContinue;
      els.paperNext.textContent = borderAvailable && !isDone('border')
        ? 'Next: choose ' + nextSecondaryLabel
        : 'Review print';
    }

    if (!els.mediaList) {
      return;
    }

    els.mediaList.innerHTML = '';

    if (!mediaGroup) {
      return;
    }

    var previousMediaFamily = '';

    mediaGroup.values.forEach(function (media) {
      var button = document.createElement('button');
      var swatch = document.createElement('span');
      var copy = document.createElement('span');
      var name = document.createElement('strong');
      var spec = document.createElement('small');
      var help = document.createElement('span');
      var helpText = optionHelpText(media, mediaGroup);
      var mediaFamily = isTestPrintProduct() ? testPrintMediaFamily(media) : null;

      if (mediaFamily && mediaFamily.key !== previousMediaFamily) {
        var familyHeading = document.createElement('h3');
        familyHeading.className = 'order-app-option-group-title order-app-media-family-title';
        familyHeading.textContent = mediaFamily.label;
        els.mediaList.appendChild(familyHeading);
        previousMediaFamily = mediaFamily.key;
      }

      button.type = 'button';
      button.className = 'order-app-media-card';
      button.setAttribute('data-order-option-kind', mediaGroup.kind);
      button.setAttribute('data-order-option-value', media.label || media.name);
      if (selectedOption(mediaGroup.kind) && normalizeOptionText(selectedOption(mediaGroup.kind).label || selectedOption(mediaGroup.kind).name) === normalizeOptionText(media.label || media.name)) {
        button.classList.add('is-active');
      }

      if (media.image) {
        var mediaImage = document.createElement('img');
        swatch.className = 'order-app-media-card__image';
        mediaImage.src = media.image;
        mediaImage.alt = '';
        mediaImage.loading = 'lazy';
        swatch.appendChild(mediaImage);
      } else {
        swatch.className = 'order-app-media-card__swatch';
        swatch.style.setProperty('--swatch-a', media.swatch[0]);
        swatch.style.setProperty('--swatch-b', media.swatch[1]);
        swatch.style.setProperty('--swatch-c', media.swatch[2]);
      }

      copy.className = 'order-app-media-card__copy';
      name.textContent = media.label || media.name;
      spec.textContent = media.spec;
      copy.appendChild(name);
      copy.appendChild(spec);
      if (helpText) {
        help.className = 'order-app-option-help';
        help.textContent = helpText;
        copy.appendChild(help);
      }
      button.appendChild(swatch);
      button.appendChild(copy);
      els.mediaList.appendChild(button);
    });
  }

  function renderBorders() {
    var groups = currentOptionGroups().filter(function (group) {
      return group.kind !== 'media';
    });
    var preset = currentPreset();
    var title = groups.length === 1 ? groups[0].name : groups.length > 1 ? 'Options' : preset.borderTitle;

    if (els.borderTitle) {
      els.borderTitle.textContent = title;
    }

    if (els.borderHelper) {
      els.borderHelper.textContent = groups.length
        ? preset.helper
        : 'No additional options are required for this product.';
    }

    if (els.borderNext) {
      var borderCanContinue = stepIsAvailable('border') && isDone('border');
      els.borderNext.hidden = !borderCanContinue;
      els.borderNext.disabled = !borderCanContinue;
      els.borderNext.textContent = 'Review print';
    }

    if (!els.borderGrid) {
      return;
    }

    els.borderGrid.innerHTML = '';
    els.borderGrid.hidden = !groups.length;
    els.borderGrid.classList.toggle('has-option-groups', groups.length > 1);

    groups.forEach(function (group) {
      if (groups.length > 1) {
        var groupTitle = document.createElement('h3');
        groupTitle.className = 'order-app-option-group-title';
        groupTitle.textContent = group.name;
        els.borderGrid.appendChild(groupTitle);
      }

      group.values.forEach(function (option) {
        var button = document.createElement('button');
        var label = document.createElement('strong');
        var spec;
        var help;
        var helpText = optionHelpText(option, group);
        var selected = selectedOption(group.kind);
        button.type = 'button';
        button.className = 'order-app-border-card';
        button.setAttribute('data-order-option-kind', group.kind);
        button.setAttribute('data-order-option-value', option.label || option.name);
        label.textContent = option.label || option.name;
        button.appendChild(label);

        if (option.spec) {
          spec = document.createElement('small');
          spec.textContent = option.spec;
          button.appendChild(spec);
        }

        if (helpText) {
          help = document.createElement('span');
          help.className = 'order-app-option-help';
          help.textContent = helpText;
          button.appendChild(help);
        }

        if (selected && normalizeOptionText(selected.label || selected.name) === normalizeOptionText(option.label || option.name)) {
          button.classList.add('is-active');
        }

        els.borderGrid.appendChild(button);
      });
    });
  }

  function renderBatchUploadItems() {
    batchUploadItems.filter(function (item) {
      return item.status !== 'complete';
    }).forEach(function (item) {
      var wrapper = document.createElement('div');
      var preview = document.createElement('div');
      var image = document.createElement('img');
      var status = document.createElement('span');
      var progress = document.createElement('span');
      var progressValue = document.createElement('span');
      var copy = document.createElement('div');
      var name = document.createElement('strong');
      var message = document.createElement('small');

      wrapper.className = 'order-app-upload-queue__item is-' + item.status;
      wrapper.setAttribute('data-order-library-dynamic', 'batch-upload');
      wrapper.setAttribute('data-order-batch-upload', item.id);
      wrapper.setAttribute('data-order-upload-stage', item.stage || item.status);
      preview.className = 'order-app-upload-queue__preview';

      if (item.previewUrl) {
        image.src = item.previewUrl;
      } else {
        image.src = els.uploadTrigger && els.uploadTrigger.querySelector('img')
          ? els.uploadTrigger.querySelector('img').src
          : '';
        image.className = 'is-file-icon';
      }
      image.alt = '';
      preview.appendChild(image);

      status.className = 'order-app-upload-queue__status';
      if (item.status === 'failed') {
        status.textContent = els.uploadProgress.getAttribute('data-attention-title');
      } else {
        status.textContent = batchUploadStageLabel(item);
      }
      preview.appendChild(status);

      if (item.status === 'uploading' && item.stage === 'transfer') {
        progress.className = 'order-app-upload-queue__progress';
        progress.style.setProperty('--order-upload-progress', item.progress + '%');
        progressValue.setAttribute('aria-hidden', 'true');
        progress.appendChild(progressValue);
        preview.appendChild(progress);
      }

      copy.className = 'order-app-upload-queue__copy';
      name.textContent = item.name;
      name.title = item.name;
      message.textContent = friendlyUploadErrorMessage(item.message);
      message.title = friendlyUploadErrorMessage(item.error || item.message);
      copy.appendChild(name);
      copy.appendChild(message);
      wrapper.appendChild(preview);
      wrapper.appendChild(copy);

      if (item.status === 'failed') {
        var actions = document.createElement('div');
        var retry = document.createElement('button');
        var dismiss = document.createElement('button');
        actions.className = 'order-app-upload-queue__actions';
        retry.type = 'button';
        retry.className = 'order-app-secondary-button';
        retry.setAttribute('data-order-batch-retry', item.id);
        var retryWaitSeconds = item.retryAvailableAt
          ? Math.max(0, Math.ceil((item.retryAvailableAt - Date.now()) / 1000))
          : 0;
        retry.disabled = retryWaitSeconds > 0;
        retry.textContent = retryWaitSeconds > 0
          ? 'Retry in ' + retryWaitSeconds + ' sec'
          : 'Retry';
        dismiss.type = 'button';
        dismiss.className = 'order-app-link-button';
        dismiss.setAttribute('data-order-batch-dismiss', item.id);
        dismiss.textContent = 'Remove';
        if (item.retryable !== false) actions.appendChild(retry);
        if (uploadHelpUrl(item.helpLink) && els.uploadHelp) {
          var help = els.uploadHelp.cloneNode(true);
          help.removeAttribute('data-order-upload-help');
          configureUploadHelp(help, item.helpLink);
          actions.appendChild(help);
        }
        actions.appendChild(dismiss);
        wrapper.appendChild(actions);
      }

      els.libraryGrid.appendChild(wrapper);
    });
  }

  function renderLibrarySelectionNotice() {
    var selection = state.librarySelection;
    if (!selection) return;
    if (!librarySelectionIsCurrent(selection)) {
      clearLibrarySelection();
      return;
    }
    var checking = selection.status === 'checking';
    var notice = document.createElement('div');
    var title = document.createElement('strong');
    var copy = document.createElement('span');
    var name = selection.photo && selection.photo.name || 'saved image';
    notice.className = 'order-app-library__empty';
    notice.setAttribute('data-order-library-dynamic', 'message');
    notice.setAttribute('data-order-library-selection-status', selection.status);
    notice.setAttribute('role', checking ? 'status' : 'alert');
    title.textContent = checking ? 'Checking ' + name + '...' : 'Could not use ' + name + '.';
    copy.textContent = checking
      ? 'Checking this saved image before ordering. You can still browse or choose another image.'
      : selection.message;
    notice.appendChild(title);
    notice.appendChild(copy);
    if (!checking) {
      var help = document.createElement('a');
      help.textContent = 'Artwork requirements';
      configureUploadHelp(help, selection.helpLink);
      if (!help.hidden) notice.appendChild(help);
      var retry = document.createElement('button');
      retry.type = 'button';
      retry.className = 'order-app-secondary-button';
      retry.setAttribute('data-order-library-selection-retry', '');
      retry.textContent = 'Check this image again';
      retry.disabled = librarySelectionBlocked();
      notice.appendChild(retry);
    }
    els.libraryGrid.appendChild(notice);
  }

  function renderLibrary() {
    if (!els.libraryGrid) {
      return;
    }

    var signedIn = !!libraryCustomerId();
    var query = state.librarySearch.trim().toLowerCase();
    var view = signedIn && libraryPagerView;
    var filtered = library.filter(function (photo) {
      return !query || photo.name.toLowerCase().indexOf(query) !== -1;
    });
    var pages = view ? view.pages : Math.max(1, Math.ceil(filtered.length / libraryPerPage));
    var page = view ? view.page : Math.min(state.libraryPage, pages - 1);
    var total = view ? view.total : filtered.length;
    var slice = view
      ? view.photos
      : filtered.slice(page * libraryPerPage, page * libraryPerPage + libraryPerPage);
    state.libraryPage = page;
    els.libraryGrid.setAttribute('aria-busy', state.libraryLoading ? 'true' : 'false');

    if (els.imagePicker) {
      els.imagePicker.classList.toggle('is-upload-first', !signedIn || !library.length);
    }

    if (els.imagePickerLabel) {
      els.imagePickerLabel.textContent = signedIn ? 'Your image library' : 'Recent uploads';
      els.imagePickerLabel.hidden = !signedIn && !library.length;
    }

    if (els.uploadTrigger) {
      var uploadTriggerTitle = els.uploadTrigger.querySelector('strong');
      els.uploadTrigger.classList.toggle('is-upload-first', !signedIn || !library.length);
      if (uploadTriggerTitle) {
        uploadTriggerTitle.textContent = 'Upload images';
      }
    }

    if (els.batchUploadSummary) {
      var summaryText = batchUploadSummaryText();
      els.batchUploadSummary.hidden = !summaryText;
      els.batchUploadSummary.textContent = summaryText;
    }

    if (els.libraryGuest) {
      els.libraryGuest.hidden = signedIn;
    }

    if (els.libraryGuestCopy) {
      els.libraryGuestCopy.textContent = library.length
        ? ' to add these images to your account Library.'
        : ' to access your account Library.';
    }

    if (els.libraryClaim) {
      var shouldOfferClaim = signedIn && guestLibraryRaw.length;
      els.libraryClaim.hidden = !shouldOfferClaim;

      if (shouldOfferClaim && els.libraryClaimTitle) {
        els.libraryClaimTitle.textContent = guestLibraryRaw.length === 1
          ? 'You uploaded 1 file before signing in. Add it to your Library?'
          : 'You uploaded ' + guestLibraryRaw.length + ' files before signing in. Add them to your Library?';
      }
      if (shouldOfferClaim && els.libraryClaimCopy) {
        els.libraryClaimCopy.textContent = guestLibraryRaw.length === 1
          ? 'It is currently saved only in this browser session.'
          : 'They are currently saved only in this browser session.';
      }
      if (els.libraryClaimAdd) {
        els.libraryClaimAdd.disabled = state.guestClaiming;
        els.libraryClaimAdd.textContent = state.guestClaiming ? 'Adding...' : 'Add to Library';
      }
      if (els.libraryClaimClear) {
        els.libraryClaimClear.disabled = state.guestClaiming;
        els.libraryClaimClear.textContent = guestLibraryRaw.length === 1 ? 'Clear Upload' : 'Clear Uploads';
      }
      if (els.libraryClaimStatus) {
        els.libraryClaimStatus.hidden = !state.guestClaimError;
        els.libraryClaimStatus.textContent = state.guestClaimError;
      }
    }

    if (els.libraryToolbar) {
      els.libraryToolbar.hidden = !signedIn;
    }

    if (els.librarySearchWrap) {
      els.librarySearchWrap.hidden = !signedIn;
    }

    var existingPhotos = new Map();
    Array.prototype.slice.call(els.libraryGrid.querySelectorAll('[data-order-library-dynamic]')).forEach(function (node) {
      if (node.getAttribute('data-order-library-dynamic') === 'photo') {
        existingPhotos.set(node.getAttribute('data-order-library-photo'), node);
      } else {
        node.remove();
      }
    });
    var visibleIds = new Set(slice.map(photoId));
    existingPhotos.forEach(function (node, id) {
      if (!visibleIds.has(id)) { node.remove(); existingPhotos.delete(id); }
    });

    if (state.libraryLoading || state.libraryError || (query && !total)) {
      var message = document.createElement('div');
      var title = document.createElement('strong');
      var copy = document.createElement('span');

      message.className = 'order-app-library__empty';
      message.setAttribute('data-order-library-dynamic', 'message');

      if (state.libraryError) {
        title.textContent = 'Could not load your files.';
        copy.textContent = state.libraryError;
      } else if (state.libraryLoading) {
        title.textContent = 'Loading your files...';
        copy.textContent = 'Pulling your saved uploads from your Stackhouse account.';
      } else if (query) {
        title.textContent = 'No matching files.';
        copy.textContent = 'Try a different filename search.';
      }

      message.appendChild(title);
      message.appendChild(copy);
      if (state.libraryError) {
        var retry = document.createElement('button');
        retry.type = 'button';
        retry.className = 'order-app-secondary-button';
        retry.setAttribute('data-order-library-retry', '');
        retry.textContent = 'Try again';
        message.appendChild(retry);
      }
      els.libraryGrid.appendChild(message);
    }

    renderLibrarySelectionNotice();
    renderBatchUploadItems();

    slice.forEach(function (photo) {
      var thumbnailSrc = photo.thumbnailSrc || photo.src;
      var existing = existingPhotos.get(photoId(photo));
      // Reuse the actual image node during progress and unrelated builder
      // updates. Expired-preview recovery may already have refreshed its src.
      if (existing && existing.getAttribute('data-library-preview') === thumbnailSrc) {
        existing.disabled = librarySelectionBlocked();
        els.libraryGrid.appendChild(existing);
        return;
      }
      if (existing) existing.remove();
      var button = document.createElement('button');
      var imageWrap = document.createElement('span');
      var image = document.createElement('img');
      var copy = document.createElement('span');
      var name = document.createElement('strong');
      var meta = document.createElement('small');

      button.type = 'button';
      button.className = 'order-app-library__item';
      button.setAttribute('data-order-library-photo', photoId(photo));
      button.setAttribute('data-order-library-dynamic', 'photo');
      button.setAttribute('data-library-preview', thumbnailSrc);
      button.setAttribute('aria-label', 'Choose ' + photo.name);
      button.title = photoMeta(photo) ? photo.name + ' - ' + photoMeta(photo) : photo.name;
      button.disabled = librarySelectionBlocked();

      imageWrap.className = 'order-app-library__item-image';
      image.src = thumbnailSrc;
      image.alt = '';
      image.loading = 'lazy';
      imageWrap.appendChild(image);

      if (photo.lowRes) {
        var badge = document.createElement('span');
        badge.textContent = 'Low-res';
        imageWrap.appendChild(badge);
      }

      copy.className = 'order-app-library__item-copy';
      name.textContent = photo.name;
      meta.textContent = photoMeta(photo);
      copy.appendChild(name);
      copy.appendChild(meta);
      button.appendChild(imageWrap);
      button.appendChild(copy);
      els.libraryGrid.appendChild(button);
      if (window.StackhouseLibraryDemand) window.StackhouseLibraryDemand.watch(image, photo.backend);
    });

    if (els.libraryCount) {
      var start = total ? page * libraryPerPage + 1 : 0;
      var end = Math.min(total, page * libraryPerPage + libraryPerPage);
      if (state.libraryLoading) {
        els.libraryCount.textContent = 'Loading files';
      } else {
        els.libraryCount.textContent = start + '-' + end + ' of ' + total + ((view ? view.query : query) ? ' matches' : ' images');
      }
    }

    if (els.libraryPage) {
      els.libraryPage.textContent = 'Page ' + (page + 1) + ' / ' + pages;
    }

    if (els.librarySort) els.librarySort.value = state.librarySort;

    if (els.libraryPrev) {
      els.libraryPrev.disabled = state.libraryLoading || !!state.libraryError || page === 0;
    }

    if (els.libraryNext) {
      els.libraryNext.disabled = state.libraryLoading || !!state.libraryError || page >= pages - 1;
    }

    if (els.libraryFooter) {
      els.libraryFooter.hidden = !signedIn;
    }
  }

  function render() {
    closeUnavailableOpenStep();
    renderProduct();
    renderPhoto();
    renderSize();
    renderSteps();
    renderReviewState();
    renderDock();
    renderPreview(true);
    renderReviewState();
    persistDraft();
  }

  function renderProduct() {
    var selectingProduct = state.productSelectionPending;
    var assistantStep = state.productAssistantStep;
    var assistantRecommendation = productAssistantRecommendation();
    var showingProducts = selectingProduct && assistantStep === 3;

    root.classList.toggle('is-product-selection-pending', selectingProduct);

    if (els.productTitle) {
      els.productTitle.textContent = selectingProduct
        ? (showingProducts
          ? (state.productAssistantBrowseAll ? 'Choose a print product' : 'Recommended for you')
          : "Let's find the right print")
        : productTitle(state.productHandle);
    }

    if (els.productEdit) {
      els.productEdit.hidden = selectingProduct;
    }

    if (els.productIntro) {
      els.productIntro.hidden = !selectingProduct;
      if (selectingProduct) {
        els.productIntro.textContent = showingProducts
          ? (state.productAssistantBrowseAll ? 'Browse every product available in the new order builder.' : assistantRecommendation.description)
          : (assistantStep === 2 ? 'Great. One more question.' : 'Answer two quick questions and we will point you toward the best place to start.');
      }
    }

    if (els.productAssistant) {
      els.productAssistant.hidden = !selectingProduct;
    }

    if (els.productAssistantProgress) {
      els.productAssistantProgress.hidden = showingProducts;
      els.productAssistantProgress.textContent = 'Question ' + assistantStep + ' of 2';
    }

    if (els.productAssistantBack) {
      els.productAssistantBack.hidden = !selectingProduct || assistantStep === 1;
      els.productAssistantBack.textContent = showingProducts
        ? (state.productAssistantBrowseAll
          ? (state.productAssistantSubject && state.productAssistantFinish ? 'Back to recommendations' : 'Get a recommendation')
          : 'Change answers')
        : 'Back';
    }

    els.productAssistantQuestions.forEach(function (question) {
      question.hidden = !selectingProduct || question.getAttribute('data-order-assistant-question') !== (assistantStep === 1 ? 'subject' : assistantStep === 2 ? 'finish' : '');
    });

    if (els.productAssistantResult) {
      els.productAssistantResult.hidden = !showingProducts || state.productAssistantBrowseAll;
    }

    if (els.productAssistantSkip) {
      els.productAssistantSkip.hidden = !selectingProduct || showingProducts;
    }

    if (selectingProduct) {
      setProductPickerOpen(showingProducts);
    }

    els.productButtons.forEach(function (button) {
      var handle = canonicalHandle(button.getAttribute('data-product-handle'));
      var buttonProduct = productByHandle(button.getAttribute('data-product-handle'));
      var builderReady = productIsBuilderReady(buttonProduct);
      var recommendationIndex = assistantRecommendation.handles.indexOf(handle);
      var recommended = recommendationIndex !== -1;
      var visibleInAssistant = showingProducts && (state.productAssistantBrowseAll || recommended);
      var active = !selectingProduct && builderReady && handle === canonicalHandle(state.productHandle);
      var reason = button.querySelector('[data-order-product-reason]');
      var badge = button.querySelector('[data-order-product-badge]');

      button.hidden = !builderReady || (selectingProduct && !visibleInAssistant);
      button.disabled = !builderReady;
      button.classList.toggle('is-active', active);
      button.classList.toggle('is-recommended', selectingProduct && recommended && !state.productAssistantBrowseAll);
      button.classList.toggle('is-best-match', selectingProduct && recommendationIndex === 0 && !state.productAssistantBrowseAll);
      button.style.order = selectingProduct && recommended && !state.productAssistantBrowseAll ? String(recommendationIndex + 1) : '';
      button.setAttribute('aria-pressed', active ? 'true' : 'false');

      if (badge) {
        badge.hidden = !selectingProduct || recommendationIndex !== 0 || state.productAssistantBrowseAll;
      }

      if (reason) {
        reason.hidden = !selectingProduct || !recommended || state.productAssistantBrowseAll;
        reason.textContent = productAssistantReason(handle);
      }
    });
    if (assistantTelemetry) assistantTelemetry.observe(state, assistantRecommendation.handles.filter(function (handle) {
      return productIsBuilderReady(productByHandle(handle));
    }));
  }

  function renderPhoto() {
    var hasImageState = !!state.photo && !state.choosingReplacement;
    var uploadBusy = state.uploading || state.photo === 'uploading';

    els.photoTabs.forEach(function (button) {
      var active = button.getAttribute('data-order-photo-tab') === state.photoTab;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
      button.tabIndex = active ? 0 : -1;
    });

    if (els.photoTabsGroup) {
      els.photoTabsGroup.hidden = hasImageState;
    }

    if (els.imagePicker) {
      els.imagePicker.hidden = hasImageState;
    }

    if (els.photoUploadPanel) {
      els.photoUploadPanel.hidden = state.photoTab !== 'upload' || hasImageState;
    }

    if (els.photoLibraryPanel) {
      els.photoLibraryPanel.hidden = state.photoTab !== 'library' || hasImageState;
    }

    if (libraryPager) libraryPager.syncOwner();
    if ((!state.photo || state.choosingReplacement) && !state.libraryLoaded && !state.libraryLoading && !state.libraryError) {
      loadCustomerLibrary(false);
    }

    if (!hasImageState) renderLibrary();

    if (els.uploadTrigger) {
      els.uploadTrigger.disabled = uploadBusy;
      els.uploadTrigger.classList.toggle('is-uploading', uploadBusy);
      els.uploadTrigger.setAttribute('aria-busy', uploadBusy ? 'true' : 'false');
    }

    if (els.librarySignIn) {
      els.librarySignIn.href = customerLoginUrl();
    }

    var hasSelectedPhoto = state.photo && state.photo !== 'uploading';

    if (els.fileCard) {
      els.fileCard.hidden = !hasSelectedPhoto;
      var cancelReplacement = root.querySelector('[data-order-photo-cancel-replace]');
      if (cancelReplacement) {
        cancelReplacement.hidden = !state.choosingReplacement;
        cancelReplacement.disabled = librarySelectionBlocked();
      }
    }

    if (els.uploadProgress) {
      els.uploadProgress.hidden = !uploadBusy && !state.uploadError;
      els.uploadProgress.classList.toggle('is-error', !!state.uploadError);
      els.uploadProgress.setAttribute('role', state.uploadError ? 'alert' : 'status');
    }

    if (els.uploadTitle) {
      els.uploadTitle.textContent = state.uploadError
        ? els.uploadProgress.getAttribute('data-attention-title')
        : batchUploadItems.some(batchUploadIsPending) ? batchUploadText('title') : state.uploadTitle || 'Uploading file...';
    }

    if (els.uploadStatus) {
      els.uploadStatus.textContent = batchUploadItems.some(batchUploadIsPending)
        ? batchUploadSummaryText()
        : friendlyUploadErrorMessage(state.uploadStatus || state.uploadError) || 'Creating a validation-ready upload session.';
    }

    if (els.uploadHelp) {
      configureUploadHelp(els.uploadHelp, state.uploadError ? state.uploadHelpLink : '');
    }

    if (els.uploadRetry) {
      els.uploadRetry.hidden = !failedUploadFile || state.uploading;
      els.uploadRetry.disabled = state.uploading || Date.now() < state.failedUploadRetryAvailableAt;
    }

    if (hasSelectedPhoto) {
      els.fileThumb.src = state.photo.src;
      els.fileName.textContent = state.photo.name;
      els.fileMeta.textContent = photoMeta(state.photo);
    }

    if (els.lowresWarning) {
      els.lowresWarning.hidden = !hasSelectedPhoto || !state.photo.lowRes;
    }
    if (els.lowresCopy && hasSelectedPhoto) {
      els.lowresCopy.textContent = 'Preview any size to check the crop. Aim for at least ' + MINIMUM_PRINT_PPI + ' PPI; 300 PPI or more is recommended. Sizes outside our print tolerance cannot be ordered.';
    }

    if (window.StackhouseUploadPolicy && typeof window.StackhouseUploadPolicy.renderDetectedNotices === 'function') {
      window.StackhouseUploadPolicy.renderDetectedNotices(
        hasSelectedPhoto ? (state.photo.backend || state.photo) : {},
        root
      );
    }
  }

  function renderSize() {
    var preset = currentPreset();
    var policy = currentSizePolicy();
    var supportsCustom = supportsCustomSizes();
    var hasSizeChoice;
    var baseResolution;
    var displayResolution;
    var resolutionContext;
    var cropMaximum;
    var customError;

    if (!supportsCustom && state.sizeMode === 'custom') {
      state.sizeMode = 'standard';
    }
    if (!cropRotationAllowed() && state.cropRotation !== 0) {
      state.cropRotation = 0;
      state.cropApplied = state.zoom !== 1 || state.cropX !== 0 || state.cropY !== 0;
    }

    hasSizeChoice = state.sizeMode === 'custom'
      ? !!(parseFloat(state.customW) > 0 && parseFloat(state.customH) > 0)
      : !!state.size;
    customError = customSizeError();
    baseResolution = hasSizeChoice && !customError ? selectedBaseResolution() : null;
    displayResolution = hasSizeChoice && !customError ? selectedCropResolution() || baseResolution : null;
    resolutionContext = state.cropOpen || state.cropApplied || state.zoom !== 1 || state.cropRotation !== 0 ? 'crop' : 'size';
    cropMaximum = cropReady() ? clampZoomToResolution() : DEFAULT_MAX_CROP_ZOOM;

    renderSizes();

    if (els.galleryWrapSizeHelp) {
      var showGalleryWrapSizeHelp = isGalleryWrapProduct();
      els.galleryWrapSizeHelp.hidden = !showGalleryWrapSizeHelp;
      if (!showGalleryWrapSizeHelp && els.galleryWrapSizeHelp.open) {
        els.galleryWrapSizeHelp.removeAttribute('open');
      }
    }

    els.sizeModes.forEach(function (button) {
      var mode = button.getAttribute('data-order-size-mode-option');
      button.hidden = mode === 'custom' && !supportsCustom;
      button.classList.toggle('is-active', mode === state.sizeMode);
    });

    if (els.sizeGrid) {
      els.sizeGrid.hidden = state.sizeMode !== 'standard';
    }

    if (els.customSize) {
      els.customSize.hidden = state.sizeMode !== 'custom';
    }

    if (els.customWidth && els.customWidth.value !== state.customW) {
      els.customWidth.value = state.customW;
    }

    if (els.customHeight && els.customHeight.value !== state.customH) {
      els.customHeight.value = state.customH;
    }

    if (supportsCustom && policy.custom) {
      var limits = customSizeLimits();
      if (els.customWidth) {
        els.customWidth.min = limits.min;
        els.customWidth.max = limits.maxLongSide;
      }
      if (els.customHeight) {
        els.customHeight.min = limits.min;
        els.customHeight.max = limits.maxLongSide;
      }
    }

    if (els.customActual) {
      els.customActual.disabled = !actualPhotoSize();
    }

    if (els.customSwap) {
      els.customSwap.disabled = !(parseFloat(state.customW) > 0 && parseFloat(state.customH) > 0);
    }

    if (els.customApply) {
      els.customApply.disabled = !!customError;
    }

    if (els.resolutionNote) {
      var resolutionUnknown = hasSizeChoice && isDone('photo') && !displayResolution;
      els.resolutionNote.hidden = !displayResolution && !customError && !resolutionUnknown;
      els.resolutionNote.textContent = customError || (displayResolution ? resolutionMessage(displayResolution, resolutionContext) :
        resolutionUnknown ? 'We could not verify this file\'s pixel dimensions. Choose it again or upload a new copy.' : '');
      els.resolutionNote.classList.toggle('is-blocked', !!customError || resolutionUnknown || (!!displayResolution && displayResolution.status === 'blocked'));
      els.resolutionNote.classList.toggle('is-low', !!displayResolution && displayResolution.status === 'low');
      els.resolutionNote.classList.toggle('is-warn', !!displayResolution && displayResolution.status === 'warn');
      els.resolutionNote.classList.toggle('is-good', !!displayResolution && displayResolution.status === 'good');
    }

    if (els.resolutionRecovery) {
      var suggestion = resolutionSizeSuggestion();
      els.resolutionRecovery.hidden = !suggestion;
      if (suggestion) {
        var suggestedLabel = formatInches(suggestion.width) + 'x' + formatInches(suggestion.height) + ' in';
        els.resolutionSuggestion.textContent = 'For at least ' + MINIMUM_PRINT_PPI + ' PPI with this crop, use up to ' + suggestedLabel + '.';
        els.resolutionUseSize.textContent = 'Use ' + suggestedLabel;
      }
    }

    if (els.customLock) {
      els.customLock.setAttribute('aria-pressed', state.customLocked ? 'true' : 'false');
      els.customLock.textContent = state.customLocked ? 'Proportions locked' : 'Proportions unlocked';
    }

    if (els.sizeNext) {
      var canContinue = isDone('size');
      var sizeContinuation = canContinue ? dockContinuation() : null;
      els.sizeNext.hidden = !canContinue || state.cropOpen;
      els.sizeNext.disabled = !canContinue || state.cropOpen || !!(sizeContinuation && sizeContinuation.blocked);
      els.sizeNext.textContent = sizeContinuation ? sizeContinuation.label : 'Review print';
    }

    if (els.cropToggle) {
      els.cropToggle.hidden = !cropReady() || state.cropOpen;
    }

    if (els.cropCard) {
      els.cropCard.hidden = !cropReady() || !state.cropOpen;
      els.cropCard.classList.toggle('has-error', cropError());
    }

    if (els.cropMessage) {
      var cropResolution = selectedCropResolution();
      els.cropMessage.textContent = cropError()
        ? resolutionMessage(cropResolution, 'crop')
        : state.cropAutoOpened
          ? 'This size changes the crop. Check the preview, then select Done cropping to continue.'
          : 'Move the artwork inside the outlined ' + sizeSummary() + ' print area. At 100%, the image is at its widest printable fit' + (cropResolution ? ' at ' + resolutionLabel(cropResolution) : '') + '. Select Done cropping to continue.';
    }

    if (els.zoom && Number(els.zoom.value) !== state.zoom) {
      els.zoom.value = state.zoom;
    }
    if (els.zoom) {
      els.zoom.max = String(cropMaximum);
    }

    if (els.zoomValue) {
      els.zoomValue.textContent = zoomLabel();
    }

    if (els.cropToolbar) {
      var showToolbar = cropReady() && (state.cropOpen || state.open === 'size');
      els.cropToolbar.hidden = !showToolbar;
      els.cropToolbar.classList.toggle('is-editing', state.cropOpen);
    }
    syncCropPositionControl();

    if (els.cropStart) {
      els.cropStart.hidden = !cropReady() || state.cropOpen;
    }

    if (els.cropDone) {
      els.cropDone.hidden = !state.cropOpen;
    }

    if (els.cropRecenter) {
      updateCropRecenterControl();
    }

    if (els.cropRotate) {
      els.cropRotate.disabled = !cropRotationAllowed();
      els.cropRotate.setAttribute('aria-disabled', cropRotationAllowed() ? 'false' : 'true');
      els.cropRotate.title = cropRotationAllowed() ? '' : 'Mini print orientation is selected by product size.';
    }

    if (els.toolbarScale) {
      els.toolbarScale.hidden = !state.cropOpen;
    }

    if (els.zoomOut) {
      els.zoomOut.hidden = !state.cropOpen;
      els.zoomOut.disabled = state.zoom <= 1;
    }

    if (els.zoomIn) {
      els.zoomIn.hidden = !state.cropOpen;
      els.zoomIn.disabled = state.zoom >= cropMaximum - 0.001;
    }

    if (els.toolbarZoom && Number(els.toolbarZoom.value) !== state.zoom) {
      els.toolbarZoom.value = state.zoom;
    }
    if (els.toolbarZoom) {
      els.toolbarZoom.max = String(cropMaximum);
    }

    if (els.toolbarZoomValue) {
      els.toolbarZoomValue.textContent = zoomLabel();
    }
  }

  function renderSteps() {
    sections.forEach(function (section) {
      var key = section.getAttribute('data-order-step');
      var available = stepIsAvailable(key);
      var locked = isLocked(key);
      var header = section.querySelector('[data-order-step-toggle]');
      section.hidden = !available;
      section.classList.toggle('is-open', state.open === key);
      section.classList.toggle('is-locked', locked);
      section.classList.toggle('is-complete', isDone(key));

      if (header) {
        header.setAttribute('aria-expanded', state.open === key ? 'true' : 'false');
        header.setAttribute('aria-disabled', locked ? 'true' : 'false');
      }
    });

    summaryEls.photo.textContent = isDone('photo') ? state.photo.name : '';
    summaryEls.size.textContent = isDone('size') ? sizeSummary() : '';
    summaryEls.paper.textContent = optionSummary('media');
    summaryEls.border.textContent = optionSummary('secondary');
  }

  function sizeSummary() {
    if (state.sizeMode === 'custom') {
      return state.customW + 'x' + state.customH + ' in';
    }
    return state.size ? sizeDisplayLabel(state.size) : '';
  }

  function selectedImageSize() {
    var size = selectedPrintOpeningDimensions();

    return size && size.width > 0 && size.height > 0 ? size : null;
  }

  function borderAddsToFinalSize() {
    var preset = currentPreset();
    var border = selectedOption('border');

    return !!(border && border.inch > 0 && preset.previewMode === 'paper');
  }

  function selectedMattingPackageSize(referenceSize) {
    return orientDimensions(materialDimensions(selectedOption('matting_package'), 'outer'), referenceSize, selectedOption('matting_package'));
  }

  function selectedPresentationMaterialOption(mode) {
    if (mode === 'matting-package') {
      return selectedOption('matting_package');
    }

    if (mode === 'framed-print') {
      return selectedOption('frame_package') || selectedOption('matting_package');
    }

    return null;
  }

  function selectedPresentationOuterSize(mode, referenceSize) {
    var previewMode = mode || currentPreset().previewMode;
    var option = selectedPresentationMaterialOption(previewMode);

    if (previewMode === 'framed-print' && isFramedPrintProduct()) {
      return orientDimensions(selectedSizeDimensions(), referenceSize, option);
    }

    return orientDimensions(materialDimensions(option, 'outer'), referenceSize, option);
  }

  function selectedMiniPrintFinalSize(size) {
    var imageSize = size || selectedImageSize();
    var key = imageSize && (sizeKeyFromText(imageSize.label) || (formatInches(imageSize.width) + 'x' + formatInches(imageSize.height)));
    var insets = MINI_PRINT_BORDER_INSETS;
    var width;
    var height;

    if (canonicalHandle(state.productHandle) !== 'mini-prints' || !key) {
      return null;
    }

    width = imageSize.width + insets.left + insets.right;
    height = imageSize.height + insets.top + insets.bottom;

    return {
      width: width,
      height: height,
      label: formatInches(width) + 'x' + formatInches(height)
    };
  }

  function finalSizeDimensions(size) {
    var imageSize = size || selectedImageSize();
    var presentationOuterSize = selectedPresentationOuterSize(null, imageSize);
    var miniPrintFinalSize = selectedMiniPrintFinalSize(imageSize);
    var border = selectedOption('border');
    var borderInches = borderAddsToFinalSize() ? border.inch : 0;

    if (!imageSize) {
      return null;
    }

    if (miniPrintFinalSize) {
      return miniPrintFinalSize;
    }

    if (presentationOuterSize) {
      return presentationOuterSize;
    }

    return {
      width: imageSize.width + borderInches * 2,
      height: imageSize.height + borderInches * 2,
      label: formatInches(imageSize.width + borderInches * 2) + 'x' + formatInches(imageSize.height + borderInches * 2)
    };
  }

  function blankPreviewInsets() {
    return {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };
  }

  function cropPreviewUsesPrintAreaOnly(preset, handle) {
    var resolvedPreset = preset || currentPreset();
    var resolvedHandle = handle || canonicalHandle(state.productHandle);

    return state.cropOpen && resolvedPreset.previewMode === 'paper' && resolvedHandle !== 'mini-prints';
  }

  function fittedDesktopPaperPreview() {
    return !window.matchMedia('(max-width: 980px)').matches
      && currentPreset().previewMode === 'paper'
      && canonicalHandle(state.productHandle) !== 'mini-prints';
  }

  function previewInsetsFromFinalSize(imageSize, finalSize) {
    var insets = blankPreviewInsets();

    if (!imageSize || !finalSize) {
      return insets;
    }

    insets.left = Math.max(0, (finalSize.width - imageSize.width) / 2);
    insets.right = insets.left;
    insets.top = Math.max(0, (finalSize.height - imageSize.height) / 2);
    insets.bottom = insets.top;

    return insets;
  }

  function previewInsetsInches(imageSize) {
    var preset = currentPreset();
    var handle = canonicalHandle(state.productHandle);
    var finalSize;

    if (!imageSize) {
      return blankPreviewInsets();
    }

    if (handle === 'mini-prints') {
      return Object.assign({}, MINI_PRINT_BORDER_INSETS);
    }

    if (cropPreviewUsesPrintAreaOnly(preset, handle)) {
      return blankPreviewInsets();
    }

    finalSize = finalSizeDimensions(imageSize);

    return previewInsetsFromFinalSize(imageSize, finalSize);
  }

  function previewReserveInsetsInches(imageSize) {
    var preset = currentPreset();
    var handle = canonicalHandle(state.productHandle);
    var borderGroup;
    var reserve = 0;

    if (!imageSize) {
      return blankPreviewInsets();
    }

    if (handle === 'mini-prints') {
      return Object.assign({}, MINI_PRINT_BORDER_INSETS);
    }

    // Fit the selected print, without shrinking it for borders not yet chosen.
    // Use the same image scale when the border is hidden during cropping.
    if (fittedDesktopPaperPreview() || (root.classList.contains('has-mobile-option-preview') &&
        preset.previewMode === 'paper' && handle !== 'mini-prints' && handle !== 'print-box-set')) {
      return previewInsetsFromFinalSize(imageSize, finalSizeDimensions(imageSize));
    }

    if (cropPreviewUsesPrintAreaOnly(preset, handle)) {
      return blankPreviewInsets();
    }

    if (presentationPreviewSurface(preset.previewMode) && selectedPresentationOuterSize(preset.previewMode, imageSize)) {
      return previewInsetsInches(imageSize);
    }

    if (preset.previewMode === 'gallery-wrap') {
      return galleryWrapReserveInsetsInches();
    }

    borderGroup = currentOptionGroups().find(function (group) {
      return group.kind === 'border';
    });

    if (preset.previewMode !== 'paper' || !borderGroup) {
      return blankPreviewInsets();
    }

    borderGroup.values.forEach(function (border) {
      var inches = parseFloat(border && border.inch);

      if (inches > reserve) {
        reserve = inches;
      }
    });

    return {
      top: reserve,
      right: reserve,
      bottom: reserve,
      left: reserve
    };
  }

  function imageSizeFromRatio(ratio) {
    if (!ratio || !(ratio[0] > 0) || !(ratio[1] > 0)) {
      return null;
    }

    return {
      width: ratio[0],
      height: ratio[1],
      label: formatInches(ratio[0]) + 'x' + formatInches(ratio[1])
    };
  }

  function finalSizeSummary(size) {
    var finalSize = finalSizeDimensions(size);

    return finalSize ? finalSize.label + ' in' : sizeSummary();
  }

  function hideCropContext() {
    if (els.cropContext) {
      els.cropContext.hidden = true;
    }
  }

  function renderCropContext(photo, fit, insetsPx, geometry) {
    if (!els.cropContext || !els.cropContextImage) {
      return;
    }

    if (!photo || photo === 'uploading' || !state.cropOpen || !geometry) {
      hideCropContext();
      return;
    }

    els.cropContext.style.setProperty('--order-context-frame-w', geometry.frameW + 'px');
    els.cropContext.style.setProperty('--order-context-frame-h', geometry.frameH + 'px');
    els.cropContext.style.setProperty('--order-context-image-w', geometry.imageW + 'px');
    els.cropContext.style.setProperty('--order-context-image-h', geometry.imageH + 'px');
    els.cropContext.style.setProperty('--order-context-image-left', geometry.left + 'px');
    els.cropContext.style.setProperty('--order-context-image-top', geometry.top + 'px');

    els.cropContextImage.src = photo.src;
    els.cropContextImage.style.transition = cropDrag
      ? 'none'
      : 'top 180ms ease, left 180ms ease, width 180ms ease, height 180ms ease';
    els.cropContextImage.draggable = false;
    els.cropContext.hidden = false;
  }

  function renderPreviewViewToggle(hasPhoto) {
    var showToggle = hasPhoto && currentPreset().previewMode === 'gallery-wrap' && !state.cropOpen && !state.reviewOpen;

    if (state.previewView !== 'mockup') {
      state.previewView = 'layout';
    }

    if (els.previewViewToggle) {
      els.previewViewToggle.hidden = !showToggle;
    }

    if (els.previewStage) {
      els.previewStage.classList.toggle('has-view-toggle', showToggle);
    }

    els.previewViewButtons.forEach(function (button) {
      var view = button.getAttribute('data-order-preview-view');
      button.setAttribute('aria-pressed', view === state.previewView ? 'true' : 'false');
    });
  }

  function renderPreview(syncLayout) {
    if (syncLayout) {
      syncWorkspaceLayout();
    } else {
      scheduleWorkspaceLayout();
    }

    var photo = state.photo;
    var hasPhoto = photo && photo !== 'uploading';

    els.previewEmpty.hidden = !!photo;
    els.previewUploading.hidden = photo !== 'uploading';
    els.previewPrint.hidden = !hasPhoto;
    if (els.cropGuides) {
      els.cropGuides.hidden = !hasPhoto || !state.cropOpen;
    }
    if (!hasPhoto || !state.cropOpen) {
      hideCropContext();
    }

    els.previewStage.classList.toggle('is-crop-open', hasPhoto && state.cropOpen);
    els.previewStage.classList.toggle('has-crop-error', cropError());
    renderPreviewViewToggle(hasPhoto);

    if (els.cropFrameLabel) {
      els.cropFrameLabel.hidden = !hasPhoto || !state.cropOpen;
      els.cropFrameLabel.textContent = hasPreviewSize() ? sizeSummary() + ' print area' : 'Print area';
    }

    if (els.previewFile) {
      els.previewFile.textContent = photo === 'uploading'
        ? 'Uploading...'
        : hasPhoto ? photo.name : 'No image yet';
    }

    if (els.previewSpec) {
      var parts = [];
      if (hasPreviewSize()) {
        var summaryImageSize = hasPhoto ? imageSizeFromRatio(activeRatio().ratio) : selectedImageSize();
        var finalSummary = finalSizeSummary(summaryImageSize);

        parts.push(sizeSummary());
        if (isFramedPrintProduct() && framedPrintMatInsetInches() > 0 && summaryImageSize) {
          parts.push('Opening ' + summaryImageSize.label + ' in');
        } else if (finalSummary !== sizeSummary()) {
          parts.push('Final ' + finalSummary);
        }
      }
      selectedOptionsList().forEach(function (option) {
        parts.push(option.label || option.name);
      });
      els.previewSpec.textContent = parts.length ? parts.join(' - ') : 'Configure to preview';
    }

    if (!hasPhoto) {
      cropOffsetFit = null;
      return;
    }

    var preset = currentPreset();
    var media = selectedOption('media') || (currentOptionGroups().find(function (group) {
      return group.kind === 'media';
    }) || { values: [] }).values[0] || preset.media[0];
    var border = selectedOption('border') || selectedOption('edge_treatment') || { inch: 0, label: '' };
    var ratioData = activeRatio();
    var ratio = ratioData.ratio;
    var previewFit = previewFitForRatio(ratio);
    var fit = previewFit.fit;
    var insetsPx = previewFit.insetsPx;
    var imageSize = imageSizeFromRatio(ratio);
    var finalSize = finalSizeDimensions(imageSize);
    var finalRatio = finalSize ? [finalSize.width, finalSize.height] : ratio;
    var hasCropTransform = state.cropOpen || state.cropApplied || state.cropRotation !== 0;
    var sheetBackground = edgeBackground(preset, media, border);
    var previewGeometry;

    // Geometry and request serialization share one tracked offset scale.
    if (hasCropTransform) {
      clampCropToFit(fit, insetsPx);
    }
    previewGeometry = cropImageGeometry(fit, insetsPx);

    els.previewPrint.className = 'order-app-print is-' + previewClass(preset.previewMode) + ' is-product-' + canonicalHandle(state.productHandle);
    els.previewPrint.classList.toggle('is-crop-editing', state.cropOpen);
    els.previewPrint.style.setProperty('--order-photo-image', 'url("' + photo.src + '")');
    if (els.previewImage && els.previewImage.getAttribute('src') !== photo.src) {
      els.previewImage.src = photo.src;
    }
    renderPresentationMockup(presentationMockupRecipe(preset, photo, imageSize, previewFit, fit, previewGeometry));
    els.previewSheet.style.width = fit.w + 'px';
    els.previewSheet.style.height = fit.h + 'px';
    els.previewSheet.style.aspectRatio = finalRatio[0] + ' / ' + finalRatio[1];
    els.previewSheet.style.background = state.cropOpen ? 'transparent' : sheetBackground;
    els.previewSheet.style.setProperty('--order-border-px', Math.max(insetsPx.top, insetsPx.right, insetsPx.bottom, insetsPx.left) + 'px');
    els.previewSheet.style.setProperty('--order-border-top-px', insetsPx.top + 'px');
    els.previewSheet.style.setProperty('--order-border-right-px', insetsPx.right + 'px');
    els.previewSheet.style.setProperty('--order-border-bottom-px', insetsPx.bottom + 'px');
    els.previewSheet.style.setProperty('--order-border-left-px', insetsPx.left + 'px');
    els.previewSheet.style.setProperty('--order-border-fill', sheetBackground);
    els.previewSheet.style.setProperty('--order-photo-image', 'url("' + photo.src + '")');
    applyPresentationPreviewSurface(preset.previewMode, imageSize, previewFit.imageFit);
    if (previewGeometry) {
      var previewClipInsets = cropPreviewClipInsets(fit, insetsPx, previewGeometry);

      els.previewSheet.style.setProperty('--order-preview-image-w', previewGeometry.imageW + 'px');
      els.previewSheet.style.setProperty('--order-preview-image-h', previewGeometry.imageH + 'px');
      els.previewSheet.style.setProperty('--order-preview-image-left', previewGeometry.left + 'px');
      els.previewSheet.style.setProperty('--order-preview-image-top', previewGeometry.top + 'px');
      els.previewSheet.style.setProperty('--order-preview-clip-top', previewClipInsets.top + 'px');
      els.previewSheet.style.setProperty('--order-preview-clip-right', previewClipInsets.right + 'px');
      els.previewSheet.style.setProperty('--order-preview-clip-bottom', previewClipInsets.bottom + 'px');
      els.previewSheet.style.setProperty('--order-preview-clip-left', previewClipInsets.left + 'px');
    } else {
      els.previewSheet.style.removeProperty('--order-preview-image-w');
      els.previewSheet.style.removeProperty('--order-preview-image-h');
      els.previewSheet.style.removeProperty('--order-preview-image-left');
      els.previewSheet.style.removeProperty('--order-preview-image-top');
      els.previewSheet.style.removeProperty('--order-preview-clip-top');
      els.previewSheet.style.removeProperty('--order-preview-clip-right');
      els.previewSheet.style.removeProperty('--order-preview-clip-bottom');
      els.previewSheet.style.removeProperty('--order-preview-clip-left');
    }
    els.previewImage.style.transform = '';
    els.previewImage.style.transformOrigin = 'center center';
    els.previewImage.style.transition = cropDrag ? 'none' : 'top 180ms ease, left 180ms ease, width 180ms ease, height 180ms ease';
    els.previewImage.draggable = false;
    renderCropContext(photo, fit, insetsPx, previewGeometry);
    els.previewBadge.hidden = !photo.lowRes;
    root.style.setProperty('--order-preview-ratio', ratio[0] + ' / ' + ratio[1]);
  }

  function scheduleWorkspaceLayout() {
    if (workspaceFrame) {
      return;
    }

    workspaceFrame = window.requestAnimationFrame(function () {
      workspaceFrame = null;
      syncWorkspaceLayout();
    });
  }

  var mobileExtras;
  var mobileMovedControls = [];
  var mobilePreviewAnchor;
  var mobilePreviewToggle;
  var mobilePreviewExpanded = false;
  var mobilePreviewScroll = null;

  function mobileHeaderOffset() {
    var header = document.querySelector('#shopify-section-new-header > header');
    return header && /fixed|sticky/.test(getComputedStyle(header).position) ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
  }

  function mobileOptionsOffset() {
    var offset = mobileHeaderOffset();
    if (root.classList.contains('has-mobile-option-preview') && !mobilePreviewExpanded &&
        !root.classList.contains('is-short-viewport')) {
      offset += els.preview.getBoundingClientRect().height;
    }
    return offset;
  }

  function syncMobileControls() {
    var mobile = window.matchMedia('(max-width: 980px)').matches;
    var hasPhoto = !!state.photo && state.photo !== 'uploading';
    var optionPreview = mobile && hasPhoto && !state.cropOpen && !state.reviewOpen &&
      !state.productSelectionPending && (state.open === 'paper' || state.open === 'border');
    if (!mobileExtras) {
      mobileExtras = document.createElement('div');
      mobileExtras.className = 'order-app-mobile-extras';
      els.steps.appendChild(mobileExtras);
      ['[data-order-volume]', '[data-order-dock-summary]', '[data-order-qty]', '[data-order-start-over]'].forEach(function (selector) {
        var node = root.querySelector(selector);
        if (!node) return;
        var anchor = document.createComment('desktop control position');
        node.before(anchor);
        mobileMovedControls.push({ node: node, anchor: anchor });
      });
      mobilePreviewAnchor = document.createComment('desktop preview position');
      els.preview.before(mobilePreviewAnchor);
      mobilePreviewToggle = document.createElement('button');
      mobilePreviewToggle.type = 'button';
      mobilePreviewToggle.className = 'order-app-mobile-preview-toggle';
      mobilePreviewToggle.setAttribute('aria-controls', 'order-app-mobile-preview-stage');
      els.previewStage.id = 'order-app-mobile-preview-stage';
      els.preview.appendChild(mobilePreviewToggle);
      mobilePreviewToggle.addEventListener('click', function () {
        if (!mobilePreviewExpanded) mobilePreviewScroll = window.scrollY;
        mobilePreviewExpanded = !mobilePreviewExpanded;
        renderPreview(true);
        // Expansion is in document flow. Closing returns to the same options position.
        window.scrollTo(0, mobilePreviewExpanded
          ? window.scrollY + els.preview.getBoundingClientRect().top - mobileHeaderOffset() - 8
          : (mobilePreviewScroll || 0));
        mobilePreviewToggle.focus({ preventScroll: true });
      });
      if (typeof ResizeObserver === 'function') new ResizeObserver(measureMobileDock).observe(els.dock);
      if (window.visualViewport) window.visualViewport.addEventListener('resize', measureMobileDock);
    }
    mobileMovedControls.forEach(function (entry) {
      var moveToOptions = mobile && !state.added;
      if (moveToOptions && entry.node.parentNode !== mobileExtras) mobileExtras.appendChild(entry.node);
      if (!moveToOptions && entry.node.parentNode === mobileExtras) entry.anchor.after(entry.node);
    });
    var addedPrint = els.addedProduct && els.addedProduct.parentNode;
    var mobileConfirmation = mobile && state.added && !state.adding && !state.addError && addedPrint;
    if (mobileConfirmation) {
      if (els.preview.nextElementSibling !== addedPrint) addedPrint.before(els.preview);
    } else if (mobile) {
      if (els.preview.nextElementSibling !== els.steps) els.steps.before(els.preview);
    } else if (els.preview.parentNode !== mobilePreviewAnchor.parentNode) {
      mobilePreviewAnchor.after(els.preview);
    }
    mobileExtras.hidden = !mobile;
    if (!optionPreview) {
      mobilePreviewExpanded = false;
      mobilePreviewScroll = null;
    }
    root.classList.toggle('has-mobile-photo', hasPhoto);
    root.classList.toggle('has-mobile-option-preview', !!optionPreview);
    root.classList.toggle('is-mobile-preview-expanded', !!optionPreview && mobilePreviewExpanded);
    mobilePreviewToggle.hidden = !optionPreview;
    mobilePreviewToggle.textContent = mobilePreviewExpanded ? 'Back to options' : 'Expand preview';
    mobilePreviewToggle.setAttribute('aria-expanded', mobilePreviewExpanded ? 'true' : 'false');
    root.style.setProperty('--order-mobile-header-offset', mobileHeaderOffset() + 'px');
    measureMobileDock();
  }

  function revealMobileFocusedControl(event) {
    var target = event.target;
    if (!window.matchMedia('(max-width: 980px)').matches || !els.steps || !els.steps.contains(target)) return;
    window.requestAnimationFrame(function () {
      if (document.activeElement !== target) return;
      var rect = target.getBoundingClientRect();
      var viewport = window.visualViewport;
      var top = Math.max(mobileOptionsOffset(), viewport ? viewport.offsetTop : 0) + 8;
      var dockHeight = getComputedStyle(els.dock).position === 'sticky' ? els.dock.getBoundingClientRect().height : 0;
      var bottom = (viewport ? viewport.offsetTop + viewport.height : window.innerHeight) - dockHeight - 8;
      if (rect.top < top) window.scrollBy(0, rect.top - top);
      else if (rect.bottom > bottom) window.scrollBy(0, Math.min(rect.top - top, rect.bottom - bottom));
    });
  }

  function measureMobileDock() {
    if (!els.dock || !window.matchMedia('(max-width: 980px)').matches) return;
    var height = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    root.classList.toggle('is-short-viewport', height < 480);
    root.style.setProperty('--order-dock-space', Math.ceil(els.dock.getBoundingClientRect().height) + 'px');
  }

  function syncWorkspaceLayout() {
    if (els.steps && els.dock) syncMobileControls();
    if (!els.previewStage) {
      return;
    }

    if (window.matchMedia('(max-width: 980px)').matches) {
      root.classList.remove('is-scrollable-workspace');
      setDocumentScrollLock(false);
      root.style.removeProperty('--order-shell-visible-height');
      els.previewStage.style.removeProperty('--order-preview-stage-height');
      return;
    }

    var rootRect = root.getBoundingClientRect();
    var shellTop = Math.max(0, Math.round(rootRect.top + window.scrollY));
    var viewportHeight = Math.min(window.innerHeight, window.visualViewport ? window.visualViewport.height : window.innerHeight);
    var shellHeight = Math.max(0, Math.floor(viewportHeight - shellTop));
    var layout = root.querySelector('.order-app-layout');
    var layoutTop = layout ? Math.max(0, layout.getBoundingClientRect().top - rootRect.top) : 0;
    var previewExtra = els.preview ? Math.max(0, els.preview.getBoundingClientRect().height - els.previewStage.getBoundingClientRect().height) : 0;
    var minPreviewHeight = parseFloat(getComputedStyle(root).getPropertyValue('--order-preview-min-height')) || 320;
    var dockHeight = els.dock ? els.dock.getBoundingClientRect().height : 0;
    // Browser zoom can leave a wide viewport with too little height for the locked workspace.
    var scrollable = shellHeight < Math.ceil(layoutTop + minPreviewHeight + previewExtra + dockHeight);
    root.classList.toggle('is-scrollable-workspace', scrollable);
    setDocumentScrollLock(!scrollable);

    if (scrollable) {
      root.style.removeProperty('--order-shell-visible-height');
      els.previewStage.style.removeProperty('--order-preview-stage-height');
      return;
    }

    if (window.scrollY !== 0) window.scrollTo(0, 0);

    root.style.setProperty('--order-shell-visible-height', shellHeight + 'px');
    els.previewStage.style.removeProperty('--order-preview-stage-height');
  }

  function setDocumentScrollLock(locked) {
    var value = locked ? 'hidden' : '';
    document.documentElement.style.overflow = value;
    document.body.style.overflow = value;
  }

  function previewFitLimits() {
    var isMobile = window.matchMedia('(max-width: 980px)').matches;
    var inspecting = state.reviewOpen && state.reviewZoom;
    var editing = state.cropOpen || state.reviewOpen;
    var inspectScale = inspecting ? state.reviewZoomScale : 1;
    var optionPreview = root.classList.contains('has-mobile-option-preview');
    var baseMaxW = isMobile ? (inspecting ? 720 : editing ? 280 : optionPreview ? 420 : 220) : (inspecting ? 920 : 900);
    var baseMaxH = isMobile ? (inspecting ? 720 : editing ? 280 : optionPreview ? 420 : 220) : (inspecting ? 720 : 900);
    var maxW = baseMaxW;
    var maxH = baseMaxH;

    if (els.previewStage) {
      var stageRect = els.previewStage.getBoundingClientRect();
      var compact = root.classList.contains('has-mobile-option-preview') && !mobilePreviewExpanded;
      var minimum = isMobile ? 1 : compact ? 48 : 120;
      var gutterX = compact ? 12 : inspecting ? (isMobile ? 24 : 96) : (isMobile ? 40 : 48);
      var gutterY = compact ? 12 : inspecting ? (isMobile ? 24 : 96) : (isMobile ? 30 : 48);

      baseMaxW = Math.min(baseMaxW, Math.max(minimum, Math.floor(stageRect.width - gutterX)));
      baseMaxH = Math.min(baseMaxH, Math.max(minimum, Math.floor(stageRect.height - gutterY)));
      maxW = baseMaxW;
      maxH = baseMaxH;

      if (cropPreviewUsesPrintAreaOnly()) {
        maxW = Math.max(baseMaxW, Math.max(120, Math.floor(stageRect.width - (isMobile ? 16 : 48))));
        maxH = Math.max(baseMaxH, Math.max(120, Math.floor(stageRect.height - (isMobile ? 4 : 48))));
        if (isMobile) {
          // A short landscape stage can be smaller than the normal fit minimum.
          maxW = Math.min(maxW, Math.max(1, Math.floor(stageRect.width - 16)));
          maxH = Math.min(maxH, Math.max(1, Math.floor(stageRect.height - 4)));
          baseMaxW = Math.min(baseMaxW, maxW);
          baseMaxH = Math.min(baseMaxH, maxH);
        }
      }
    }

    if (inspecting) {
      maxW = Math.round(maxW * inspectScale);
      maxH = Math.round(maxH * inspectScale);
      baseMaxW = Math.round(baseMaxW * inspectScale);
      baseMaxH = Math.round(baseMaxH * inspectScale);
    }

    return { maxW: maxW, maxH: maxH, baseMaxW: baseMaxW, baseMaxH: baseMaxH };
  }

  function previewImageFitLimits(ratioW, ratioH) {
    var limits = previewFitLimits();
    var imageSize = imageSizeFromRatio([ratioW, ratioH]);
    var reserve = previewReserveInsetsInches(imageSize);
    var outerW = ratioW + reserve.left + reserve.right;
    var outerH = ratioH + reserve.top + reserve.bottom;
    var scale;

    if (!(outerW > ratioW) && !(outerH > ratioH)) {
      return limits;
    }

    scale = Math.min(
      limits.maxW / outerW,
      limits.maxH / outerH
    );

    return {
      maxW: Math.max(1, ratioW * scale),
      maxH: Math.max(1, ratioH * scale)
    };
  }

  function cropPreviewScale(ratioW, ratioH, limits) {
    var targetSide = Math.min(limits.baseMaxW || limits.maxW, limits.baseMaxH || limits.maxH);
    var targetArea = Math.min(
      targetSide * targetSide,
      limits.maxW * limits.maxW / STANDARD_CROP_MAX_ASPECT,
      limits.maxH * limits.maxH / STANDARD_CROP_MAX_ASPECT
    );

    return Math.min(
      Math.sqrt(targetArea / (ratioW * ratioH)),
      limits.maxW / ratioW,
      limits.maxH / ratioH
    );
  }

  function fitPrint(ratioW, ratioH) {
    var limits = previewImageFitLimits(ratioW, ratioH);
    var scale = cropPreviewUsesPrintAreaOnly() || fittedDesktopPaperPreview()
      ? cropPreviewScale(ratioW, ratioH, limits)
      : Math.min(limits.maxW / ratioW, limits.maxH / ratioH);

    return {
      w: Math.round(ratioW * scale),
      h: Math.round(ratioH * scale)
    };
  }

  function previewClass(mode) {
    if (mode === 'gallery-wrap') {
      return 'gallery-wrap';
    }
    if (mode === 'matting-package') {
      return 'matting-package';
    }
    if (mode === 'framed-print') {
      return 'framed-print';
    }
    if (mode === 'framed') {
      return 'framed';
    }
    return 'paper';
  }

  function presentationPreviewSurface(mode) {
    return PRESENTATION_PREVIEW_SURFACES[mode] || null;
  }

  function presentationFrameWidthPx(surface, option, imageSize, imageFit) {
    var fixedWidth = surface.frameWidthPx || 0;
    var widthInches = materialFrameWidthInches(option) || surface.frameWidthInches || 0;
    var scale = imageSize && imageSize.width > 0 && imageFit ? imageFit.w / imageSize.width : 0;

    if (widthInches > 0 && scale > 0) {
      return Math.max(1, Math.round(widthInches * scale));
    }

    return fixedWidth;
  }

  function applyPresentationPreviewSurface(mode, imageSize, imageFit) {
    var surface = presentationPreviewSurface(mode) || {};
    var option = selectedPresentationMaterialOption(mode);
    var matOption = mode === 'framed-print' ? selectedOption('matting_package') : option;
    var frameOption = mode === 'framed-print' ? selectedOption('frame_package') : option;
    var matColor = materialLayerColor(matOption, 'mat') || surface.matColor || '#ffffff';
    var frameColor = materialLayerColor(frameOption, 'frame') || surface.frameColor || 'transparent';
    var frameWidth = presentationFrameWidthPx(surface, frameOption, imageSize, imageFit);

    els.previewSheet.style.setProperty('--order-presentation-mat', matColor);
    els.previewSheet.style.setProperty('--order-presentation-mat-edge', surface.matEdgeColor || '#e2e2e2');
    els.previewSheet.style.setProperty('--order-presentation-aperture-line', surface.apertureLineColor || 'rgba(72, 72, 72, 0.18)');
    els.previewSheet.style.setProperty('--order-presentation-frame', frameColor);
    els.previewSheet.style.setProperty('--order-presentation-frame-width', frameWidth + 'px');
  }

  function firstOptionForKind(kind) {
    var group = currentOptionGroups().find(function (optionGroup) {
      return optionGroup.kind === kind;
    });

    return group && Array.isArray(group.values) && group.values.length ? group.values[0] : null;
  }

  function selectedOrFirstOption(kind) {
    return selectedOption(kind) || firstOptionForKind(kind);
  }

  function descriptorInches(option) {
    var inches = parseFloat(option && option.inch);

    if (inches > 0) {
      return inches;
    }

    return optionInches(option && (option.label || option.name));
  }

  function galleryWrapDepthInches(useMaximum) {
    var defaultDepth = 1.5;
    var group;
    var depth;

    if (useMaximum) {
      group = currentOptionGroups().find(function (optionGroup) {
        return optionGroup.kind === 'wrap_depth';
      });

      if (group && Array.isArray(group.values)) {
        depth = group.values.reduce(function (max, option) {
          return Math.max(max, descriptorInches(option) || 0);
        }, 0);
      }
    } else {
      depth = descriptorInches(selectedOption('wrap_depth'));
    }

    return depth > 0 ? depth : defaultDepth;
  }

  function galleryWrapReserveInsetsInches() {
    var edge = galleryWrapDepthInches(true);

    return {
      top: edge,
      right: edge,
      bottom: edge,
      left: edge
    };
  }

  function galleryWrapEdgeOption() {
    return selectedOption('edge_treatment') || selectedOption('border');
  }

  function galleryWrapEdgeValue(option) {
    var edge = option && option.edge ? option.edge : edgeCode(option && (option.label || option.name));

    if (edge === 'mirror' || edge === 'white' || edge === 'black') {
      return edge;
    }
    return 'mirror';
  }

  function galleryWrapDepthPixels(imageSize, imageFit) {
    var depth = galleryWrapDepthInches(false);
    var scale = imageSize && imageSize.width > 0 && imageFit ? imageFit.w / imageSize.width : 0;
    var sideWidth = scale > 0 ? depth * scale * 0.62 : 24;
    var sideDepth = scale > 0 ? depth * scale * 0.2 : 8;

    return {
      sideWidth: Math.round(clamp(sideWidth, 12, 48)),
      sideDepth: Math.round(clamp(sideDepth, 4, 18))
    };
  }

  function svgElement(name, attributes) {
    var element = document.createElementNS(SVG_NS, name);

    Object.keys(attributes || {}).forEach(function (key) {
      if (attributes[key] !== null && attributes[key] !== undefined) {
        element.setAttribute(key, String(attributes[key]));
      }
    });

    return element;
  }

  function polygonPoints(points) {
    return points.map(function (point) {
      return Math.round(point[0] * 100) / 100 + ',' + Math.round(point[1] * 100) / 100;
    }).join(' ');
  }

  function appendSvgElement(parent, name, attributes) {
    var element = svgElement(name, attributes);

    parent.appendChild(element);
    return element;
  }

  function ensurePresentationMockup() {
    if (els.presentationMockup && els.presentationMockup.tagName && els.presentationMockup.tagName.toLowerCase() === 'svg') {
      els.presentationMockup.remove();
      els.presentationMockup = null;
    }

    if (!els.presentationMockup) {
      els.presentationMockup = document.createElement('div');
      els.presentationMockup.className = 'order-app-presentation-mockup';
      els.presentationMockup.setAttribute('aria-hidden', 'true');
      els.previewPrint.insertBefore(els.presentationMockup, els.previewSheet);
    }

    return els.presentationMockup;
  }

  function resetPresentationMockupVariables() {
    if (!els.presentationMockup) {
      return;
    }

    [
      '--canvas-object-width',
      '--canvas-object-height',
      '--canvas-front-width',
      '--canvas-front-height',
      '--canvas-side-width',
      '--canvas-side-lift',
      '--canvas-object-shift-x',
      '--canvas-front-rotate',
      '--canvas-seam-inset',
      '--canvas-side-skew',
      '--canvas-shadow-scale',
      '--canvas-shadow-opacity'
    ].forEach(function (prop) {
      els.presentationMockup.style.removeProperty(prop);
    });
  }

  function resetPresentationMockup() {
    if (els.presentationMockup) {
      els.presentationMockup.textContent = '';
      els.presentationMockup.hidden = true;
      els.presentationMockup.className = 'order-app-presentation-mockup';
      resetPresentationMockupVariables();
    }

    els.previewPrint.classList.remove('has-presentation-mockup');
    ['mirror', 'image', 'white', 'black'].forEach(function (edge) {
      els.previewPrint.classList.remove('is-edge-' + edge);
    });
    els.previewPrint.style.removeProperty('width');
    els.previewPrint.style.removeProperty('height');
    els.previewPrint.style.removeProperty('--order-mockup-front-x');
    els.previewPrint.style.removeProperty('--order-mockup-front-y');
    els.previewPrint.style.removeProperty('--order-mockup-front-center-x');
    els.previewPrint.style.removeProperty('--order-mockup-front-center-y');
    els.previewPrint.style.removeProperty('--order-mockup-front-w');
    els.previewPrint.style.removeProperty('--order-mockup-front-h');
    els.previewPrint.classList.remove('is-layout-view', 'is-mockup-view');
  }

  function clearCanvasPreviewImageStyles(imgEl) {
    if (!imgEl) {
      return;
    }

    [
      'display',
      'position',
      'inset',
      'left',
      'top',
      'width',
      'height',
      'max-width',
      'max-height',
      'object-fit',
      'object-position',
      'transform',
      'transform-origin',
      'margin',
      'box-shadow',
      'border-radius'
    ].forEach(function (prop) {
      imgEl.style.removeProperty(prop);
    });
  }

  function fillCanvasPreviewImage(imgEl) {
    if (!imgEl) {
      return;
    }

    clearCanvasPreviewImageStyles(imgEl);
    imgEl.style.setProperty('display', 'block', 'important');
    imgEl.style.setProperty('position', 'absolute', 'important');
    imgEl.style.setProperty('inset', '0', 'important');
    imgEl.style.setProperty('width', '100%', 'important');
    imgEl.style.setProperty('height', '100%', 'important');
    imgEl.style.setProperty('max-width', 'none', 'important');
    imgEl.style.setProperty('max-height', 'none', 'important');
    imgEl.style.setProperty('object-fit', 'cover', 'important');
    imgEl.style.setProperty('object-position', 'center center', 'important');
    imgEl.style.setProperty('transform', 'none', 'important');
    imgEl.style.setProperty('margin', '0', 'important');
    imgEl.style.setProperty('box-shadow', 'none', 'important');
    imgEl.style.setProperty('border-radius', '0', 'important');
  }

  function cropCanvasPreviewImage(imgEl, recipe) {
    if (!imgEl || !recipe || !recipe.artwork || !recipe.front) {
      fillCanvasPreviewImage(imgEl);
      return;
    }

    clearCanvasPreviewImageStyles(imgEl);
    imgEl.style.setProperty('display', 'block', 'important');
    imgEl.style.setProperty('position', 'absolute', 'important');
    imgEl.style.setProperty('left', (recipe.artwork.x - recipe.front.x) + 'px', 'important');
    imgEl.style.setProperty('top', (recipe.artwork.y - recipe.front.y) + 'px', 'important');
    imgEl.style.setProperty('width', recipe.artwork.width + 'px', 'important');
    imgEl.style.setProperty('height', recipe.artwork.height + 'px', 'important');
    imgEl.style.setProperty('max-width', 'none', 'important');
    imgEl.style.setProperty('max-height', 'none', 'important');
    imgEl.style.setProperty('object-fit', 'fill', 'important');
    imgEl.style.setProperty('transform', 'none', 'important');
    imgEl.style.setProperty('margin', '0', 'important');
    imgEl.style.setProperty('box-shadow', 'none', 'important');
    imgEl.style.setProperty('border-radius', '0', 'important');
  }

  function mirrorCanvasSideImage(imgEl, recipe) {
    var live = recipe && recipe.livePreview ? recipe.livePreview : {};
    var localX;
    var localY;
    var sideWidth;

    if (!imgEl || !recipe || !recipe.artwork || !recipe.front) {
      return;
    }

    localX = recipe.artwork.x - recipe.front.x;
    localY = recipe.artwork.y - recipe.front.y;
    sideWidth = live.sidePixelWidth || 0;

    clearCanvasPreviewImageStyles(imgEl);
    imgEl.style.setProperty('display', 'block', 'important');
    imgEl.style.setProperty('position', 'absolute', 'important');
    imgEl.style.setProperty('left', (sideWidth - recipe.artwork.width - localX) + 'px', 'important');
    imgEl.style.setProperty('top', localY + 'px', 'important');
    imgEl.style.setProperty('width', recipe.artwork.width + 'px', 'important');
    imgEl.style.setProperty('height', recipe.artwork.height + 'px', 'important');
    imgEl.style.setProperty('max-width', 'none', 'important');
    imgEl.style.setProperty('max-height', 'none', 'important');
    imgEl.style.setProperty('object-fit', 'fill', 'important');
    imgEl.style.setProperty('object-position', 'left top', 'important');
    imgEl.style.setProperty('transform', 'scaleX(-1)', 'important');
    imgEl.style.setProperty('transform-origin', 'center center', 'important');
    imgEl.style.setProperty('margin', '0', 'important');
    imgEl.style.setProperty('box-shadow', 'none', 'important');
    imgEl.style.setProperty('border-radius', '0', 'important');
  }

  function shouldTryCanvasTexture(sourceImgEl) {
    var src = sourceImgEl && (sourceImgEl.currentSrc || sourceImgEl.src || '');

    if (!src) {
      return false;
    }

    return src.indexOf('data:') === 0 ||
      src.indexOf('blob:') === 0 ||
      src.indexOf(window.location.origin) === 0;
  }

  function ensureCanvasPreviewStructure(mockupEl) {
    var shadowEl;
    var objectEl;
    var sideEl;
    var sideImgEl;
    var frontEl;
    var frontImgEl;

    if (!mockupEl) {
      return null;
    }

    shadowEl = mockupEl.querySelector('.canvas-preview-shadow');
    objectEl = mockupEl.querySelector('.canvas-preview-object');

    if (!shadowEl) {
      shadowEl = document.createElement('div');
      shadowEl.className = 'canvas-preview-shadow';
      mockupEl.appendChild(shadowEl);
    }

    if (!objectEl) {
      objectEl = document.createElement('div');
      objectEl.className = 'canvas-preview-object';

      sideEl = document.createElement('div');
      sideEl.className = 'canvas-preview-side';

      sideImgEl = document.createElement('img');
      sideImgEl.className = 'canvas-preview-side-image';
      sideImgEl.alt = '';
      sideImgEl.setAttribute('aria-hidden', 'true');
      sideEl.appendChild(sideImgEl);

      frontEl = document.createElement('div');
      frontEl.className = 'canvas-preview-front';

      frontImgEl = document.createElement('img');
      frontImgEl.className = 'canvas-preview-front-image';
      frontImgEl.alt = '';
      frontImgEl.setAttribute('aria-hidden', 'true');
      frontEl.appendChild(frontImgEl);

      objectEl.appendChild(sideEl);
      objectEl.appendChild(frontEl);
      mockupEl.appendChild(objectEl);
    } else {
      sideEl = objectEl.querySelector('.canvas-preview-side');
      sideImgEl = objectEl.querySelector('.canvas-preview-side-image');
      frontEl = objectEl.querySelector('.canvas-preview-front');
      frontImgEl = objectEl.querySelector('.canvas-preview-front-image');
    }

    return {
      shadowEl: shadowEl,
      objectEl: objectEl,
      sideEl: sideEl,
      sideImgEl: sideImgEl,
      frontEl: frontEl,
      frontImgEl: frontImgEl
    };
  }

  function generateGalleryFrontTexture(sourceImgEl, recipe) {
    var canvas;
    var ctx;
    var localX;
    var localY;

    if (
      !sourceImgEl ||
      !sourceImgEl.complete ||
      !sourceImgEl.naturalWidth ||
      !sourceImgEl.naturalHeight ||
      !recipe ||
      !recipe.front ||
      !recipe.artwork
    ) {
      return null;
    }

    try {
      canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(recipe.front.width));
      canvas.height = Math.max(1, Math.round(recipe.front.height));
      ctx = canvas.getContext('2d');

      if (!ctx) {
        return null;
      }

      localX = recipe.artwork.x - recipe.front.x;
      localY = recipe.artwork.y - recipe.front.y;
      ctx.drawImage(
        sourceImgEl,
        localX,
        localY,
        recipe.artwork.width,
        recipe.artwork.height
      );

      return {
        canvas: canvas,
        url: canvas.toDataURL('image/png')
      };
    } catch (error) {
      return null;
    }
  }

  function generateCanvasSideTexture(sourceImage, sideLiftPercent) {
    var sourceWidth = sourceImage && (sourceImage.naturalWidth || sourceImage.width);
    var sourceHeight = sourceImage && (sourceImage.naturalHeight || sourceImage.height);
    var outputWidth = 96;
    var outputHeight = 640;
    var canvas;
    var ctx;
    var liftPx;
    var sourceStripWidth;
    var x;

    if (!sourceImage || !sourceWidth || !sourceHeight) {
      return null;
    }

    try {
      liftPx = Math.max(20, Math.min(80, Math.round(outputHeight * (sideLiftPercent / 100))));
      sourceStripWidth = Math.max(12, Math.min(Math.round(sourceWidth * 0.08), 96));
      canvas = document.createElement('canvas');
      canvas.width = outputWidth;
      canvas.height = outputHeight;
      ctx = canvas.getContext('2d');

      if (!ctx) {
        return null;
      }

      for (x = 0; x < outputWidth; x += 1) {
        var t = x / Math.max(1, outputWidth - 1);
        var srcX = Math.max(0, Math.min(sourceWidth - 1, Math.round(sourceStripWidth - 1 - (t * (sourceStripWidth - 1)))));
        var yOffset = Math.round(liftPx * (1 - t));
        var sliceHeight = Math.max(1, outputHeight - (yOffset * 2));

        ctx.drawImage(
          sourceImage,
          srcX,
          0,
          1,
          sourceHeight,
          x,
          yOffset,
          1,
          sliceHeight
        );
      }

      return canvas.toDataURL('image/png');
    } catch (error) {
      return null;
    }
  }

  function galleryWrapEdgeFill(edge) {
    if (edge === 'white') {
      return '#fbfaf6';
    }
    if (edge === 'black') {
      return '#171717';
    }
    return '#d8d0c4';
  }

  function galleryWrapLayoutEdgeFill(edge) {
    return edge === 'mirror' ? galleryWrapEdgeFill(edge) : '#f7f2ea';
  }

  function galleryWrapEdgeAccent(edge) {
    if (edge === 'white') {
      return '#ffffff';
    }
    if (edge === 'black') {
      return '#171717';
    }
    return '#9a6400';
  }

  function galleryWrapEdgeTint(edge) {
    if (edge === 'white') {
      return '#ffffff';
    }
    if (edge === 'black') {
      return '#000000';
    }
    return 'rgba(0, 0, 0, 0)';
  }

  function galleryWrapEdgeSummary(edge, hasSelection) {
    if (!hasSelection) {
      return 'Choose an edge finish';
    }
    if (edge === 'white') {
      return 'White side edge';
    }
    if (edge === 'black') {
      return 'Black side edge';
    }
    return 'Mirrored side edge';
  }

  function galleryWrapMockupReady() {
    return isDone('photo') && isDone('size') && optionGroupsComplete('media') && optionGroupsComplete('secondary') && !cropError();
  }

  function galleryWrapLayoutReady() {
    return isDone('photo') && isDone('size') && !cropError();
  }

  function galleryWrapShadeProfile(edge) {
    if (edge === 'white') {
      return {
        left: [0.08, 0.01],
        right: [0.02, 0.14],
        top: [0.05, 0],
        bottom: [0.04, 0.16],
        shadow: 0.07,
        outline: 'rgba(0,0,0,0.1)'
      };
    }

    if (edge === 'black') {
      return {
        left: [0.04, 0],
        right: [0.02, 0.16],
        top: [0.03, 0],
        bottom: [0.03, 0.18],
        shadow: 0.12,
        outline: 'rgba(255,255,255,0.08)'
      };
    }

    return {
      left: [0.16, 0.03],
      right: [0.05, 0.18],
      top: [0.06, 0.01],
      bottom: [0.04, 0.14],
      outline: 'rgba(0,0,0,0.08)'
    };
  }

  function galleryWrapMockupSizeScale(imageSize) {
    var longSide;
    var minLong = Math.sqrt(8);
    var maxLong = Math.sqrt(40);
    var progress;

    if (!imageSize) {
      return 1;
    }

    longSide = Math.max(imageSize.width || 0, imageSize.height || 0);
    if (!(longSide > 0)) {
      return 1;
    }

    progress = (Math.sqrt(longSide) - minLong) / (maxLong - minLong);
    return clamp(0.72 + clamp(progress, 0, 1) * 0.28, 0.72, 1);
  }

  function galleryWrapMockupRecipe(photo, imageSize, imageFit, sheetFit, previewGeometry) {
    var edge = galleryWrapEdgeValue(galleryWrapEdgeOption());
    var depthInches = galleryWrapDepthInches(false);
    var shortestSide = Math.min(imageSize.width, imageSize.height);
    var aspectRatio = imageSize.width / imageSize.height;
    var sizeScale = galleryWrapMockupSizeScale(imageSize);
    var depthRatio = depthInches > 0 ? depthInches / shortestSide : 0;
    var widthPerInchPct = Math.max(1.1, Math.min(3.2, 16 / shortestSide));
    var sideWidthPct = depthInches > 0 ? depthInches * widthPerInchPct : 0;
    var taperRatio = Math.max(1.45, Math.min(1.85, 16 / shortestSide + 1.05));
    var sideLiftPct = Math.max(2.4, Math.min(11, sideWidthPct * taperRatio));
    var frontMaxWidthPct = Math.min(78, Math.max(70, 76 - (aspectRatio >= 1 ? 2 : 0)));
    var frontWidthPct;
    var frontHeightPct;
    var objectWidthPct;
    var objectHeightPct;
    var frontWidthRatio;
    var sideWidthRatio;
    var shiftXPct;
    var frontRotateDeg;
    var seamInsetPct;
    var shadowScale;
    var shadowOpacity;
    var mockupW;
    var mockupH;
    var objectW;
    var objectH;
    var objectX;
    var objectY;
    var frontX;
    var frontY;
    var frontW;
    var frontH;
    var cropScaleX;
    var cropScaleY;
    var limits = previewFitLimits();
    var mockupScale;

    if (aspectRatio >= 1) {
      frontWidthPct = Math.min(frontMaxWidthPct, 78);
      frontHeightPct = frontWidthPct / aspectRatio;
      if (frontHeightPct > 84) {
        frontHeightPct = 84;
        frontWidthPct = frontHeightPct * aspectRatio;
      }
    } else {
      frontHeightPct = 84;
      frontWidthPct = frontHeightPct * aspectRatio;
      if (frontWidthPct > frontMaxWidthPct) {
        frontWidthPct = frontMaxWidthPct;
        frontHeightPct = frontWidthPct / aspectRatio;
      }
    }

    objectWidthPct = frontWidthPct + sideWidthPct;
    objectHeightPct = frontHeightPct;
    frontWidthRatio = (frontWidthPct / objectWidthPct) * 100;
    sideWidthRatio = (sideWidthPct / objectWidthPct) * 100;
    shiftXPct = Math.max(0.9, Math.min(1.8, 12 / shortestSide));
    frontRotateDeg = Math.max(12, Math.min(18, 120 / shortestSide));
    seamInsetPct = Math.max(0.05, Math.min(0.28, sideLiftPct * 0.025));
    shadowScale = Math.max(0.72, Math.min(0.9, 0.74 + sideWidthPct * 0.01));
    shadowOpacity = Math.max(0.14, Math.min(0.24, 0.14 + depthRatio * 0.25));
    mockupW = Math.ceil((sheetFit.w * sizeScale) / Math.max(0.01, frontWidthPct / 100));
    mockupH = Math.ceil((sheetFit.h * sizeScale) / Math.max(0.01, frontHeightPct / 100));
    // Fit the whole 3D scene uniformly. Independent CSS clamps would squeeze
    // the face while the artwork keeps its original pixel dimensions.
    mockupScale = Math.min(1, limits.maxW / mockupW, limits.maxH / mockupH);
    mockupW *= mockupScale;
    mockupH *= mockupScale;
    objectW = mockupW * (objectWidthPct / 100);
    objectH = mockupH * (objectHeightPct / 100);
    objectX = (mockupW - objectW) / 2 + (mockupW * (shiftXPct / 100));
    objectY = (mockupH - objectH) / 2;
    frontX = objectX + objectW * (sideWidthRatio / 100);
    frontY = objectY;
    frontW = objectW * (frontWidthRatio / 100);
    frontH = objectH;
    cropScaleX = sheetFit && sheetFit.w ? frontW / sheetFit.w : 1;
    cropScaleY = sheetFit && sheetFit.h ? frontH / sheetFit.h : 1;

    return {
      type: 'gallery-wrap',
      edge: edge,
      fill: galleryWrapEdgeFill(edge),
      shade: galleryWrapShadeProfile(edge),
      photoSrc: photo.src,
      width: mockupW,
      height: mockupH,
      front: {
        x: frontX,
        y: frontY,
        width: frontW,
        height: frontH
      },
      livePreview: {
        objectWidthPct: objectWidthPct,
        objectHeightPct: objectHeightPct,
        frontWidthRatio: frontWidthRatio,
        frontHeightRatio: 100,
        sideWidthRatio: sideWidthRatio,
        sidePixelWidth: objectW * (sideWidthRatio / 100),
        sideLiftRatio: sideLiftPct,
        shiftXPct: shiftXPct,
        frontRotateDeg: frontRotateDeg,
        seamInsetPct: seamInsetPct,
        shadowScale: shadowScale,
        shadowOpacity: shadowOpacity,
        sideSkew: 0
      },
      artwork: previewGeometry ? {
        x: frontX + previewGeometry.left * cropScaleX,
        y: frontY + previewGeometry.top * cropScaleY,
        width: previewGeometry.imageW * cropScaleX,
        height: previewGeometry.imageH * cropScaleY
      } : null
    };
  }

  function galleryWrapLayoutRecipe(photo, imageSize, imageFit, sheetFit, previewGeometry) {
    var edgeOption = galleryWrapEdgeOption();
    var edge = galleryWrapEdgeValue(edgeOption);
    var selectedDepth = galleryWrapDepthInches(false);
    var scale = imageSize && imageSize.width > 0 ? imageFit.w / imageSize.width : 0;
    var edgePx = Math.max(1, Math.round(selectedDepth * scale));
    var width = sheetFit.w + edgePx * 2;
    var height = sheetFit.h + edgePx * 2;
    var front = {
      x: edgePx,
      y: edgePx,
      width: sheetFit.w,
      height: sheetFit.h
    };

    return {
      type: 'gallery-wrap-layout',
      edge: edge,
      edgeSelected: !!edgeOption,
      fill: galleryWrapLayoutEdgeFill(edge),
      edgeAccent: galleryWrapEdgeAccent(edge),
      edgeTint: galleryWrapEdgeTint(edge),
      edgeSummary: galleryWrapEdgeSummary(edge, !!edgeOption),
      photoSrc: photo.src,
      width: width,
      height: height,
      selectedDepthInches: selectedDepth,
      edgePx: {
        top: edgePx,
        right: edgePx,
        bottom: edgePx,
        left: edgePx
      },
      depthBox: {
        x: 0,
        y: 0,
        width: width,
        height: height
      },
      front: front,
      artwork: previewGeometry ? {
        x: front.x + previewGeometry.left,
        y: front.y + previewGeometry.top,
        width: previewGeometry.imageW,
        height: previewGeometry.imageH
      } : null
    };
  }

  function presentationMockupRecipe(preset, photo, imageSize, previewFit, sheetFit, previewGeometry) {
    if (preset.previewMode === 'gallery-wrap') {
      if (state.cropOpen) {
        return null;
      }

      if (state.reviewOpen && state.reviewZoom) {
        if (!galleryWrapLayoutReady()) {
          return null;
        }

        return galleryWrapLayoutRecipe(photo, imageSize, previewFit.imageFit, sheetFit, previewGeometry);
      }

      if (state.previewView !== 'mockup') {
        if (!galleryWrapLayoutReady()) {
          return null;
        }

        return galleryWrapLayoutRecipe(photo, imageSize, previewFit.imageFit, sheetFit, previewGeometry);
      }

      if (!galleryWrapMockupReady()) {
        return null;
      }

      return galleryWrapMockupRecipe(photo, imageSize, previewFit.imageFit, sheetFit, previewGeometry);
    }

    return null;
  }

  function appendMockupFace(svg, points, fill, opacity) {
    return appendSvgElement(svg, 'polygon', {
      points: polygonPoints(points),
      fill: fill,
      opacity: opacity === undefined ? 1 : opacity
    });
  }

  function appendMockupImageBox(svg, clipId, photoSrc, box, transform) {
    if (!photoSrc || !box) {
      return null;
    }

    var image = appendSvgElement(svg, 'image', {
      href: photoSrc,
      x: box.x,
      y: box.y,
      width: box.width,
      height: box.height,
      preserveAspectRatio: 'none',
      'clip-path': 'url(#' + clipId + ')'
    });

    if (transform) {
      image.setAttribute('transform', transform);
    }

    return image;
  }

  function appendMockupSideStrip(group, clipId, recipe, box, viewBox, transform) {
    if (!recipe.artwork || !recipe.photoSrc) {
      return null;
    }

    var imageBox = {
      x: recipe.artwork.x - recipe.front.x,
      y: recipe.artwork.y - recipe.front.y + (box.imageOffsetY || 0),
      width: recipe.artwork.width,
      height: recipe.artwork.height
    };
    var wrapper = appendSvgElement(group, 'svg', {
      x: box.x,
      y: box.y,
      width: box.width,
      height: box.height,
      viewBox: viewBox,
      preserveAspectRatio: 'none',
      overflow: 'hidden',
      'clip-path': 'url(#' + clipId + ')'
    });
    var image = appendSvgElement(wrapper, 'image', {
      href: recipe.photoSrc,
      x: imageBox.x,
      y: imageBox.y,
      width: imageBox.width,
      height: imageBox.height,
      preserveAspectRatio: 'none'
    });

    if (transform) {
      image.setAttribute('transform', transform);
    }

    return wrapper;
  }

  function appendSvgStop(parent, offset, opacity) {
    appendSvgElement(parent, 'stop', {
      offset: offset,
      'stop-color': '#000000',
      'stop-opacity': opacity
    });
  }

  function appendMockupGradient(defs, id, attributes, stops) {
    var gradient = appendSvgElement(defs, 'linearGradient', Object.assign({ id: id }, attributes));

    stops.forEach(function (stop) {
      appendSvgStop(gradient, stop.offset, stop.opacity);
    });
  }

  function appendGalleryWrapGradients(defs, shade) {
    var profile = shade || galleryWrapShadeProfile('mirror');

    appendMockupGradient(defs, 'orderGalleryLeftShade', { x1: '100%', y1: '0%', x2: '0%', y2: '0%' }, [
      { offset: '0%', opacity: profile.left[0] },
      { offset: '100%', opacity: profile.left[1] }
    ]);
    appendMockupGradient(defs, 'orderGalleryRightShade', { x1: '0%', y1: '0%', x2: '100%', y2: '0%' }, [
      { offset: '0%', opacity: profile.right[0] },
      { offset: '100%', opacity: profile.right[1] }
    ]);
    appendMockupGradient(defs, 'orderGalleryTopShade', { x1: '0%', y1: '100%', x2: '0%', y2: '0%' }, [
      { offset: '0%', opacity: profile.top[0] },
      { offset: '100%', opacity: profile.top[1] }
    ]);
    appendMockupGradient(defs, 'orderGalleryBottomShade', { x1: '0%', y1: '0%', x2: '0%', y2: '100%' }, [
      { offset: '0%', opacity: profile.bottom[0] },
      { offset: '100%', opacity: profile.bottom[1] }
    ]);
  }

  function appendGalleryImageWrap(group, clipId, recipe, front, side, edges) {
    var sideHeight = Math.max(1, Math.max(edges.bottomEdge, edges.outerBottom) - edges.outerTop);

    return appendMockupSideStrip(group, clipId, recipe, {
      x: edges.outerLeft,
      y: edges.outerTop,
      width: side.width,
      height: sideHeight,
      imageOffsetY: edges.topEdge - edges.outerTop
    }, '0 0 ' + side.width + ' ' + sideHeight, '');
  }

  function appendGalleryMirrorWrap(group, clipIds, recipe, front, side, edges) {
    var sideHeight = Math.max(1, Math.max(edges.bottomEdge, edges.outerBottom) - edges.outerTop);

    appendMockupSideStrip(group, clipIds.left, recipe, {
      x: edges.outerLeft,
      y: edges.outerTop,
      width: side.width,
      height: sideHeight,
      imageOffsetY: edges.topEdge - edges.outerTop
    }, '0 0 ' + side.width + ' ' + sideHeight, 'matrix(-1 0 0 1 ' + side.width + ' 0)');
  }

  function appendGalleryPerspectiveFront(group, clipId, recipe, front, farTopLift, farBottomLift) {
    if (!recipe.artwork || !recipe.photoSrc) {
      return null;
    }

    var stripCount = Math.round(clamp(front.width / 10, 28, 84));
    var stripGroup = appendSvgElement(group, 'g', {
      'clip-path': 'url(#' + clipId + ')'
    });

    for (var index = 0; index < stripCount; index += 1) {
      var x0 = front.x + front.width * (index / stripCount);
      var x1 = front.x + front.width * ((index + 1) / stripCount);
      var xMid = (x0 + x1) / 2;
      var progress = (xMid - front.x) / front.width;
      var top = front.y - farTopLift * progress;
      var bottom = front.y + front.height - farBottomLift * progress;
      var width = Math.max(1, x1 - x0);
      var height = Math.max(1, bottom - top);
      var bleed = 0.7;
      var wrapper = appendSvgElement(stripGroup, 'svg', {
        x: x0 - bleed,
        y: top,
        width: width + bleed * 2,
        height: height,
        viewBox: (x0 - bleed) + ' ' + front.y + ' ' + (width + bleed * 2) + ' ' + front.height,
        preserveAspectRatio: 'none',
        overflow: 'hidden'
      });

      appendSvgElement(wrapper, 'image', {
        href: recipe.photoSrc,
        x: recipe.artwork.x,
        y: recipe.artwork.y,
        width: recipe.artwork.width,
        height: recipe.artwork.height,
        preserveAspectRatio: 'none'
      });
    }

    return stripGroup;
  }

  function appendGalleryLayoutLayer(parent, className) {
    var element = document.createElement('div');

    element.className = className;
    parent.appendChild(element);
    return element;
  }

  function appendGalleryLayoutImage(parent, className) {
    var image = document.createElement('img');

    image.className = className || '';
    image.alt = '';
    image.setAttribute('aria-hidden', 'true');
    parent.appendChild(image);
    return image;
  }

  function appendGalleryLayoutEdgeLabel(parent) {
    var label = document.createElement('span');

    label.className = 'gallery-layout-edge-label';
    label.textContent = 'WRAPPED EDGE';
    parent.appendChild(label);
    return label;
  }

  function applyGalleryLayoutBox(element, box) {
    if (!element || !box) {
      return;
    }

    element.style.left = box.x + 'px';
    element.style.top = box.y + 'px';
    element.style.width = box.width + 'px';
    element.style.height = box.height + 'px';
  }

  function applyGalleryLayoutImage(image, recipe, zone, mirrorAxis) {
    var left;
    var top;
    var transform = '';

    if (!image || !recipe || !recipe.artwork || !zone) {
      return;
    }

    left = recipe.artwork.x - zone.x;
    top = recipe.artwork.y - zone.y;

    if (mirrorAxis === 'x-left') {
      left = 2 * recipe.front.x - recipe.artwork.x - zone.x;
      transform = 'scaleX(-1)';
    } else if (mirrorAxis === 'x-right') {
      left = 2 * (recipe.front.x + recipe.front.width) - recipe.artwork.x - zone.x;
      transform = 'scaleX(-1)';
    } else if (mirrorAxis === 'y-top') {
      top = 2 * recipe.front.y - recipe.artwork.y - zone.y;
      transform = 'scaleY(-1)';
    } else if (mirrorAxis === 'y-bottom') {
      top = 2 * (recipe.front.y + recipe.front.height) - recipe.artwork.y - zone.y;
      transform = 'scaleY(-1)';
    }

    image.src = recipe.photoSrc;
    image.style.left = left + 'px';
    image.style.top = top + 'px';
    image.style.width = recipe.artwork.width + 'px';
    image.style.height = recipe.artwork.height + 'px';
    image.style.transform = transform;
    image.style.transformOrigin = 'left top';
  }

  function galleryLayoutEdgeZone(recipe, edgeName) {
    if (edgeName === 'top') {
      return {
        x: recipe.front.x,
        y: 0,
        width: recipe.front.width,
        height: recipe.edgePx.top
      };
    }

    if (edgeName === 'right') {
      return {
        x: recipe.front.x + recipe.front.width,
        y: recipe.front.y,
        width: recipe.edgePx.right,
        height: recipe.front.height
      };
    }

    if (edgeName === 'bottom') {
      return {
        x: recipe.front.x,
        y: recipe.front.y + recipe.front.height,
        width: recipe.front.width,
        height: recipe.edgePx.bottom
      };
    }

    return {
      x: 0,
      y: recipe.front.y,
      width: recipe.edgePx.left,
      height: recipe.front.height
    };
  }

  function renderGalleryLayoutEdge(mapEl, recipe, edgeName, mirrorAxis) {
    var zone = galleryLayoutEdgeZone(recipe, edgeName);
    var edgeEl = appendGalleryLayoutLayer(mapEl, 'gallery-layout-edge is-' + edgeName);
    var image = appendGalleryLayoutImage(edgeEl, '');
    var shouldRenderSolid = !recipe.edgeSelected;
    var shouldRenderTint = recipe.edgeSelected && recipe.edge !== 'mirror';

    applyGalleryLayoutBox(edgeEl, zone);
    edgeEl.classList.toggle('is-solid', shouldRenderSolid);
    edgeEl.classList.toggle('is-tinted', shouldRenderTint);
    appendGalleryLayoutEdgeLabel(edgeEl);

    if (shouldRenderSolid) {
      return;
    }

    applyGalleryLayoutImage(image, recipe, zone, mirrorAxis);
  }

  function renderGalleryLayoutMap(mockupEl, recipe) {
    var mapEl = appendGalleryLayoutLayer(mockupEl, 'gallery-layout-map');
    var frontEl;
    var frontImg;
    var foldEl;
    var depthEl;
    var faceLabel;

    mapEl.style.setProperty('--gallery-layout-edge-fill', recipe.fill);
    mapEl.style.setProperty('--gallery-edge-accent', recipe.edgeAccent);
    mapEl.style.setProperty('--gallery-edge-tint', recipe.edgeTint);
    mapEl.classList.add('edge-' + recipe.edge);
    mapEl.style.setProperty('--gallery-front-left', recipe.front.x + 'px');
    mapEl.style.setProperty('--gallery-front-top', recipe.front.y + 'px');
    mapEl.style.setProperty('--gallery-front-width', recipe.front.width + 'px');
    mapEl.style.setProperty('--gallery-front-height', recipe.front.height + 'px');
    mapEl.style.setProperty('--gallery-edge-top', recipe.edgePx.top + 'px');
    mapEl.style.setProperty('--gallery-edge-right', recipe.edgePx.right + 'px');
    mapEl.style.setProperty('--gallery-edge-bottom', recipe.edgePx.bottom + 'px');
    mapEl.style.setProperty('--gallery-edge-left', recipe.edgePx.left + 'px');
    mapEl.style.setProperty('--gallery-depth-top', recipe.depthBox.y + 'px');
    mapEl.style.setProperty('--gallery-depth-right', (recipe.width - recipe.depthBox.x - recipe.depthBox.width) + 'px');
    mapEl.style.setProperty('--gallery-depth-bottom', (recipe.height - recipe.depthBox.y - recipe.depthBox.height) + 'px');
    mapEl.style.setProperty('--gallery-depth-left', recipe.depthBox.x + 'px');

    renderGalleryLayoutEdge(mapEl, recipe, 'top', 'y-top');
    renderGalleryLayoutEdge(mapEl, recipe, 'right', 'x-right');
    renderGalleryLayoutEdge(mapEl, recipe, 'bottom', 'y-bottom');
    renderGalleryLayoutEdge(mapEl, recipe, 'left', 'x-left');

    appendGalleryLayoutLayer(mapEl, 'gallery-layout-corner is-top-left');
    appendGalleryLayoutLayer(mapEl, 'gallery-layout-corner is-top-right');
    appendGalleryLayoutLayer(mapEl, 'gallery-layout-corner is-bottom-left');
    appendGalleryLayoutLayer(mapEl, 'gallery-layout-corner is-bottom-right');

    frontEl = appendGalleryLayoutLayer(mapEl, 'gallery-layout-front');
    applyGalleryLayoutBox(frontEl, recipe.front);
    frontImg = appendGalleryLayoutImage(frontEl, '');
    applyGalleryLayoutImage(frontImg, recipe, recipe.front, '');

    foldEl = appendGalleryLayoutLayer(mapEl, 'gallery-layout-fold');
    applyGalleryLayoutBox(foldEl, recipe.front);
    depthEl = appendGalleryLayoutLayer(mapEl, 'gallery-layout-depth');
    applyGalleryLayoutBox(depthEl, recipe.depthBox);

    faceLabel = appendGalleryLayoutLayer(mapEl, 'gallery-layout-label is-face');

    faceLabel.textContent = 'Finished face';

    foldEl.setAttribute('aria-hidden', 'true');
  }

  function renderGalleryWrapMockup(mockupEl, recipe) {
    var structure = ensureCanvasPreviewStructure(mockupEl);
    var live = recipe.livePreview || {};
    var edge = recipe.edge;
    var frontTexture = null;
    var sideTexture = null;

    if (!structure) {
      return;
    }

    mockupEl.classList.add('canvas-preview-active');
    mockupEl.classList.remove('edge-mirrored', 'edge-black', 'edge-white');
    if (edge === 'white') {
      mockupEl.classList.add('edge-white');
    } else if (edge === 'black') {
      mockupEl.classList.add('edge-black');
    } else {
      mockupEl.classList.add('edge-mirrored');
    }

    mockupEl.style.setProperty('--canvas-object-width', live.objectWidthPct + '%');
    mockupEl.style.setProperty('--canvas-object-height', live.objectHeightPct + '%');
    mockupEl.style.setProperty('--canvas-front-width', live.frontWidthRatio + '%');
    mockupEl.style.setProperty('--canvas-front-height', live.frontHeightRatio + '%');
    mockupEl.style.setProperty('--canvas-side-width', live.sideWidthRatio + '%');
    mockupEl.style.setProperty('--canvas-side-lift', live.sideLiftRatio + '%');
    mockupEl.style.setProperty('--canvas-object-shift-x', live.shiftXPct + '%');
    mockupEl.style.setProperty('--canvas-front-rotate', live.frontRotateDeg + 'deg');
    mockupEl.style.setProperty('--canvas-seam-inset', live.seamInsetPct + '%');
    mockupEl.style.setProperty('--canvas-shadow-scale', live.shadowScale);
    mockupEl.style.setProperty('--canvas-shadow-opacity', live.shadowOpacity);
    mockupEl.style.setProperty('--canvas-side-skew', (live.sideSkew || 0) + 'deg');

    frontTexture = shouldTryCanvasTexture(els.previewImage)
      ? generateGalleryFrontTexture(els.previewImage, recipe)
      : null;

    if (frontTexture) {
      structure.frontImgEl.src = frontTexture.url;
      fillCanvasPreviewImage(structure.frontImgEl);
    } else {
      structure.frontImgEl.src = recipe.photoSrc;
      cropCanvasPreviewImage(structure.frontImgEl, recipe);
    }

    if (edge === 'white' || edge === 'black') {
      structure.sideEl.style.background = edge === 'white'
        ? 'linear-gradient(180deg, rgba(255,255,255,0.98), rgba(238,238,238,0.96))'
        : 'linear-gradient(180deg, rgba(24,24,24,0.98), rgba(0,0,0,0.94))';
      structure.sideImgEl.style.display = 'none';
      structure.sideImgEl.removeAttribute('src');
    } else {
      sideTexture = frontTexture ? generateCanvasSideTexture(frontTexture.canvas, live.sideLiftRatio) : null;
      if (sideTexture) {
        structure.sideEl.style.background = 'url("' + sideTexture + '") center / 100% 100% no-repeat';
        structure.sideImgEl.style.display = 'none';
        structure.sideImgEl.removeAttribute('src');
      } else {
        structure.sideEl.style.background = '';
        structure.sideImgEl.style.display = '';
        structure.sideImgEl.src = recipe.photoSrc;
        mirrorCanvasSideImage(structure.sideImgEl, recipe);
      }
    }
  }

  function renderPresentationMockup(recipe) {
    var mockup;

    if (!recipe) {
      resetPresentationMockup();
      return;
    }

    mockup = ensurePresentationMockup();
    mockup.textContent = '';
    mockup.hidden = false;
    mockup.className = 'order-app-presentation-mockup';
    resetPresentationMockupVariables();
    els.previewPrint.classList.add('has-presentation-mockup');
    els.previewPrint.style.width = recipe.width + 'px';
    els.previewPrint.style.height = recipe.height + 'px';
    els.previewPrint.style.setProperty('--order-mockup-front-x', recipe.front.x + 'px');
    els.previewPrint.style.setProperty('--order-mockup-front-y', recipe.front.y + 'px');
    els.previewPrint.style.setProperty('--order-mockup-front-center-x', (recipe.front.x + recipe.front.width / 2) + 'px');
    els.previewPrint.style.setProperty('--order-mockup-front-center-y', (recipe.front.y + recipe.front.height / 2) + 'px');
    els.previewPrint.style.setProperty('--order-mockup-front-w', recipe.front.width + 'px');
    els.previewPrint.style.setProperty('--order-mockup-front-h', recipe.front.height + 'px');

    els.previewPrint.classList.toggle('is-layout-view', recipe.type === 'gallery-wrap-layout');
    els.previewPrint.classList.toggle('is-mockup-view', recipe.type === 'gallery-wrap');

    if (recipe.type === 'gallery-wrap-layout') {
      ['mirror', 'image', 'white', 'black'].forEach(function (edge) {
        els.previewPrint.classList.remove('is-edge-' + edge);
      });
      els.previewPrint.classList.add('is-edge-' + recipe.edge);
      mockup.classList.add('gallery-layout-active');
      renderGalleryLayoutMap(mockup, recipe);
    } else if (recipe.type === 'gallery-wrap') {
      ['mirror', 'image', 'white', 'black'].forEach(function (edge) {
        els.previewPrint.classList.remove('is-edge-' + edge);
      });
      els.previewPrint.classList.add('is-edge-' + recipe.edge);
      renderGalleryWrapMockup(mockup, recipe);
    }
  }

  function edgeBackground(preset, media, border) {
    if (canonicalHandle(state.productHandle) === 'mini-prints') {
      return '#ffffff';
    }
    if (preset.previewMode === 'gallery-wrap') {
      if (border.edge === 'white') {
        return '#ffffff';
      }
      if (border.edge === 'black') {
        return '#161616';
      }
    }
    if (presentationPreviewSurface(preset.previewMode)) {
      return materialLayerColor(selectedPresentationMaterialOption(preset.previewMode), 'mat') || presentationPreviewSurface(preset.previewMode).matColor;
    }
    if (preset.previewMode === 'paper' && border.inch > 0) {
      return '#ffffff';
    }
    return media.sheet || '#f5ead8';
  }

  function hideFloatingWidget(element) {
    if (!element || root.contains(element)) {
      return;
    }

    element.style.setProperty('display', 'none', 'important');
    element.style.setProperty('visibility', 'hidden', 'important');
    element.style.setProperty('opacity', '0', 'important');
    element.style.setProperty('pointer-events', 'none', 'important');
    element.setAttribute('aria-hidden', 'true');

    if (element.matches('iframe#launcher') && element.parentElement && !root.contains(element.parentElement)) {
      element.parentElement.style.setProperty('display', 'none', 'important');
      element.parentElement.style.setProperty('visibility', 'hidden', 'important');
      element.parentElement.style.setProperty('opacity', '0', 'important');
      element.parentElement.style.setProperty('pointer-events', 'none', 'important');
      element.parentElement.setAttribute('aria-hidden', 'true');
    }
  }

  function suppressFloatingWidgets(scope) {
    var target = scope && scope.querySelectorAll ? scope : document;

    floatingWidgetSelectors.forEach(function (selector) {
      target.querySelectorAll(selector).forEach(hideFloatingWidget);
    });

    if (target !== document && target.matches) {
      floatingWidgetSelectors.forEach(function (selector) {
        if (target.matches(selector)) {
          hideFloatingWidget(target);
        }
      });
    }
  }

  function setupFloatingWidgetSuppression() {
    suppressFloatingWidgets(document);
    window.setTimeout(function () { suppressFloatingWidgets(document); }, 300);
    window.setTimeout(function () { suppressFloatingWidgets(document); }, 1200);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node && node.nodeType === 1) {
            suppressFloatingWidgets(node);
          }
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function classicBuilderDestination() {
    var handle = canonicalHandle(state.productHandle);
    var product = currentProduct();
    var destination = '/pages/order-now';
    var parameters = new URLSearchParams();

    if (!state.productSelectionPending && handle) {
      destination = product.url || '/products/' + encodeURIComponent(handle);
      parameters.set('open_modal', 'true');
    }

    parameters.set('builder', 'classic');
    parameters.set('source', 'classic_fallback');
    return destination + '?' + parameters.toString();
  }

  function classicSwitchHasProgress() {
    return Boolean(
      state.photo ||
      state.uploading ||
      state.size ||
      state.sizeMode === 'custom' ||
      selectedOptionsList().length
    );
  }

  function rememberClassicChoice() {
    try {
      window.sessionStorage.setItem(classicChoiceStorageKey, 'classic');
    } catch (error) {
      root.setAttribute('data-order-builder-choice', 'classic');
    }
  }

  function classicSwitchFocusableElements() {
    if (!els.classicModal) return [];
    return Array.prototype.slice.call(els.classicModal.querySelectorAll('a[href], button:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter(function (element) { return element.offsetParent !== null; });
  }

  function closeClassicSwitch(source) {
    if (!els.classicModal || els.classicModal.hidden) return;

    els.classicModal.hidden = true;
    document.body.classList.remove('order-app-switch-is-open');

    if (source) {
      trackBetaBuilderEvent('classic_builder_fallback_cancelled', {
        input_method: source,
        destination_path: classicSwitchDestination
      });
    }

    if (classicSwitchPreviousFocus && classicSwitchPreviousFocus.focus) {
      classicSwitchPreviousFocus.focus({ preventScroll: true });
    }
  }

  function openClassicSwitch() {
    if (!els.classicModal) return;

    classicSwitchDestination = classicBuilderDestination();
    classicSwitchPreviousFocus = document.activeElement;
    els.classicModal.hidden = false;
    document.body.classList.add('order-app-switch-is-open');

    if (els.classicConfirm) els.classicConfirm.href = classicSwitchDestination;
    if (els.classicReason) els.classicReason.value = '';
    if (els.classicDescription) {
      els.classicDescription.textContent = classicSwitchHasProgress()
        ? 'Your selected product will carry over, but your image, crop, size, and option choices will not.'
        : 'We will carry your selected product into the classic builder.';
    }

    trackBetaBuilderEvent('classic_builder_fallback_clicked', {
      input_method: 'text_link',
      status: classicSwitchHasProgress() ? 'progress_will_reset' : 'no_progress',
      destination_path: classicSwitchDestination
    });

    window.setTimeout(function () {
      var focusTarget = els.classicReason || els.classicConfirm || els.classicPanel;
      if (focusTarget && focusTarget.focus) focusTarget.focus({ preventScroll: true });
    }, 0);
  }

  function confirmClassicSwitch(event) {
    var destination = classicSwitchDestination || classicBuilderDestination();
    var reason = els.classicReason ? els.classicReason.value : '';

    if (event) event.preventDefault();
    rememberClassicChoice();
    trackBetaBuilderEvent('classic_builder_fallback_confirmed', {
      input_method: 'confirmation',
      safe_reason: reason,
      status: classicSwitchHasProgress() ? 'progress_reset' : 'no_progress',
      destination_path: destination
    });
    window.location.href = destination;
  }

  function handleClassicSwitchKeydown(event) {
    if (!els.classicModal || els.classicModal.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeClassicSwitch('escape');
      return;
    }
    if (event.key !== 'Tab') return;

    var focusable = classicSwitchFocusableElements();
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function appendReviewRow(list, label, value) {
    var item = document.createElement('div');
    var term = document.createElement('dt');
    var description = document.createElement('dd');

    item.className = 'order-app-review-panel__detail';
    term.textContent = label;
    description.textContent = value || '-';
    item.appendChild(term);
    item.appendChild(description);
    list.appendChild(item);
  }

  function reviewReady() {
    return isDone('photo') && isDone('size') && isDone('paper') && isDone('border') && !cropError() && currentPrice() > 0;
  }

  function normalizeReviewState() {
    if (state.reviewOpen && !reviewReady() && !state.added && !state.adding) {
      state.reviewOpen = false;
    }

    if (!state.reviewOpen || state.added) {
      state.reviewZoom = false;
      state.reviewZoomScale = REVIEW_INSPECT_MIN_ZOOM;
    }
  }

  function clampReviewInspectZoom(value) {
    var zoom = Number(value);

    if (!Number.isFinite(zoom)) {
      zoom = REVIEW_INSPECT_MIN_ZOOM;
    }

    return Math.round(Math.max(REVIEW_INSPECT_MIN_ZOOM, Math.min(REVIEW_INSPECT_MAX_ZOOM, zoom)) * 100) / 100;
  }

  function reviewInspectZoomLabel() {
    return Math.round(state.reviewZoomScale * 100) + '%';
  }

  function renderReviewInspectControls(zooming) {
    if (els.reviewInspector) {
      els.reviewInspector.hidden = !zooming;
    }

    if (els.reviewZoomScale) {
      if (Number(els.reviewZoomScale.value) !== state.reviewZoomScale) {
        els.reviewZoomScale.value = state.reviewZoomScale;
      }
      els.reviewZoomScale.min = String(REVIEW_INSPECT_MIN_ZOOM);
      els.reviewZoomScale.max = String(REVIEW_INSPECT_MAX_ZOOM);
      els.reviewZoomScale.step = String(0.05);
    }

    if (els.reviewZoomValue) {
      els.reviewZoomValue.textContent = reviewInspectZoomLabel();
    }

    if (els.reviewZoomFit) {
      els.reviewZoomFit.disabled = !zooming || state.reviewZoomScale <= REVIEW_INSPECT_MIN_ZOOM;
    }

    if (els.reviewZoomOut) {
      els.reviewZoomOut.disabled = !zooming || state.reviewZoomScale <= REVIEW_INSPECT_MIN_ZOOM;
    }

    if (els.reviewZoomIn) {
      els.reviewZoomIn.disabled = !zooming || state.reviewZoomScale >= REVIEW_INSPECT_MAX_ZOOM;
    }
  }

  function setReviewInspectZoom(value, source) {
    if (!state.reviewOpen || !state.reviewZoom) {
      return;
    }

    state.reviewZoomScale = clampReviewInspectZoom(value);
    renderPreview(true);
    renderReviewInspectControls(true);

    if (source && source !== 'slider' && source !== 'wheel') {
      trackBetaBuilderEvent('review_inspect_zoom_changed', {
        source: source,
        scale: reviewInspectZoomLabel()
      });
    }
  }

  function adjustReviewInspectZoom(delta, source) {
    setReviewInspectZoom(state.reviewZoomScale + delta, source);
  }

  function renderReviewDetails(list, net, off) {
    var groups;
    var reviewImageSize;
    var cropParts = [];

    if (!list) {
      return;
    }

    appendReviewRow(list, 'Image', state.photo && state.photo.name ? state.photo.name : 'Selected image');
    appendReviewRow(list, 'Product', currentPreset().title);
    appendReviewRow(list, isFramedPrintProduct() ? 'Frame size' : 'Size', sizeSummary());
    reviewImageSize = imageSizeFromRatio(activeRatio().ratio);
    if (isFramedPrintProduct()) {
      appendReviewRow(list, 'Print opening', reviewImageSize ? reviewImageSize.label + ' in' : '-');
    } else {
      appendReviewRow(list, 'Final size', finalSizeSummary(reviewImageSize));
    }

    groups = currentOptionGroups();
    groups.forEach(function (group) {
      var selected = selectedOption(group.kind);
      appendReviewRow(list, group.name, selected ? selected.label || selected.name : '-');
    });

    if (state.cropApplied || state.zoom !== 1 || state.cropRotation !== 0) {
      cropParts.push(zoomLabel());
      if (state.cropRotation !== 0) {
        cropParts.push(state.cropRotation + ' deg');
      }
      appendReviewRow(list, 'Crop', cropParts.join(' / '));
    }

    appendReviewRow(list, 'Quantity', String(state.qty));
    var pricing = currentPrintPricing();
    if (pricing && pricing.label) appendReviewRow(list, 'Discount', pricing.label);
    else if (off > 0) appendReviewRow(list, 'Discount', off + '% volume discount');
    appendReviewRow(list, 'Total', moneyText(net));
  }

  function addedCartLabel() {
    var link = els.addedCart;
    var label = link ? link.getAttribute('data-label') : 'View cart';
    var count = state.addedCartItemCount;
    return link && Number.isInteger(count) && count >= 0
      ? link.getAttribute('data-count-label').replace('__COUNT__', String(count))
      : label;
  }

  function renderAddedConfirmation() {
    if (!els.addedPanel) return;
    var added = state.added && !state.adding && !state.addError;
    var wasHidden = els.addedPanel.hidden;
    els.addedPanel.hidden = !added;
    root.classList.toggle('is-added', added);
    if (!added) return;
    els.addedTitle.textContent = els.addedTitle.getAttribute(cartEditKey ? 'data-updated-title' : 'data-title');
    els.addedProduct.textContent = productTitle(state.productHandle);
    els.addedCart.textContent = addedCartLabel();
    els.addedDetails.textContent = '';
    appendReviewRow(els.addedDetails, els.addedDetails.getAttribute('data-size-label'), sizeSummary());
    currentOptionGroups().forEach(function (group) {
      var selected = selectedOption(group.kind);
      appendReviewRow(els.addedDetails, group.name, selected ? selected.label || selected.name : '-');
    });
    appendReviewRow(els.addedDetails, els.addedDetails.getAttribute('data-quantity-label'), String(state.qty));
    if (wasHidden) {
      window.requestAnimationFrame(function () {
        if (!state.added || els.addedPanel.hidden) return;
        els.addedTitle.focus({ preventScroll: true });
        els.addedTitle.scrollIntoView({ block: 'nearest' });
      });
    }
  }

  function renderReviewState() {
    var unit = currentPrice();
    var tier = tierFor(state.qty);
    var off = tier.off;
    var gross = unit * state.qty;
    var net = state.sizeMode === 'custom' ? volumeTotal(unit, state.qty, off) : gross * (1 - off / 100);
    var printPricing = currentPrintPricing();
    if (printPricing) net = printPricing.net;
    var reviewing;
    var zooming;

    normalizeReviewState();

    reviewing = state.reviewOpen;
    zooming = state.reviewOpen && state.reviewZoom;

    root.classList.toggle('is-reviewing', reviewing);
    root.classList.toggle('is-review-zoomed', zooming);

    if (els.configHeader) {
      els.configHeader.hidden = reviewing || state.added;
    }

    if (els.steps) {
      els.steps.hidden = reviewing || state.added;
    }

    if (els.reviewPanel) {
      els.reviewPanel.hidden = !reviewing || zooming || state.added;
    }

    if (els.reviewZoom) {
      els.reviewZoom.hidden = state.added || !reviewing || zooming || !state.photo || state.photo === 'uploading';
    }

    if (els.reviewZoomClose) {
      els.reviewZoomClose.hidden = !zooming;
    }

    renderReviewInspectControls(zooming);

    if (els.previewStage) {
      els.previewStage.removeAttribute('aria-expanded');
    }

    if (reviewing && els.reviewDetails) {
      els.reviewDetails.textContent = '';
      renderReviewDetails(els.reviewDetails, net, off);
    }
    renderAddedConfirmation();
    syncReviewPreparation();
  }

  function enterReviewMode(source) {
    if (!reviewReady() && !state.added) {
      render();
      return;
    }

    state.reviewOpen = true;
    state.reviewZoom = false;
    state.reviewZoomScale = REVIEW_INSPECT_MIN_ZOOM;
    state.open = null;
    setCropOpenPreservingPosition(false);

    if (currentPreset().previewMode === 'gallery-wrap' && galleryWrapMockupReady()) {
      state.previewView = 'mockup';
    }

    render();

    window.requestAnimationFrame(function () {
      if (workspaceUsesDocumentScroll()) {
        window.scrollTo(0, window.scrollY + els.preview.getBoundingClientRect().top - mobileHeaderOffset() - 8);
      }
    });
    trackBetaBuilderEvent('review_step_opened', {
      source: source || ''
    });
  }

  function exitReviewMode(source) {
    var nextStep = stepIsAvailable('border') ? 'border' : 'paper';

    state.reviewOpen = false;
    state.reviewZoom = false;
    state.reviewZoomScale = REVIEW_INSPECT_MIN_ZOOM;
    state.cropOpen = false;
    state.open = nextStep;
    render();
    queueOpenStepIntoView(nextStep);

    trackBetaBuilderEvent('review_step_back_clicked', {
      source: source || ''
    });
  }

  function setReviewZoom(active, source) {
    if (!state.reviewOpen) {
      return;
    }

    state.reviewZoom = !!active;
    state.reviewZoomScale = REVIEW_INSPECT_MIN_ZOOM;
    state.cropOpen = false;
    render();

    trackBetaBuilderEvent(state.reviewZoom ? 'review_inspect_opened' : 'review_inspect_closed', {
      source: source || ''
    });
  }

  function handleReviewKeydown(event) {
    if (!state.reviewOpen) {
      return;
    }

    if (event.key === 'Escape') {
      event.preventDefault();
      if (state.reviewZoom) {
        setReviewZoom(false, 'escape');
      } else {
        exitReviewMode('escape');
      }
      return;
    }
  }

  function dockContinuation() {
    var mediaLabel;
    var borderLabel;

    if (state.adding || state.added || state.reviewOpen) {
      return null;
    }
    if (state.cropOpen) {
      return {
        action: 'apply_crop',
        step: 'size',
        label: 'Done cropping'
      };
    }
    if (cropReady() && cropError()) {
      return {
        step: 'size',
        label: 'Adjust size or crop'
      };
    }
    // On mobile, the sole next action follows the visible step even when defaults
    // already make later options valid. Customers still get to see those choices.
    if (window.matchMedia('(max-width: 980px)').matches && isDone('size')) {
      if (state.open === 'size' && stepIsAvailable('paper')) {
        return { step: 'paper', label: 'Next: choose ' + String(currentPreset().mediaTitle || 'paper').toLowerCase() };
      }
      if ((state.open === 'size' || state.open === 'paper') && isDone('paper') && stepIsAvailable('border')) {
        return { step: 'border', label: 'Next: choose ' + String(currentPreset().borderTitle || 'border').toLowerCase() };
      }
    }
    if (isDone('photo') && !isDone('size')) {
      return {
        step: 'size',
        label: 'Choose a print size'
      };
    }
    if (isDone('size') && !isDone('paper')) {
      mediaLabel = nextMissingOptionLabel('media') || currentPreset().mediaTitle || 'paper';
      return {
        step: 'paper',
        label: 'Next: choose ' + String(mediaLabel).toLowerCase()
      };
    }
    if (isDone('paper') && stepIsAvailable('border') && !isDone('border')) {
      borderLabel = nextMissingOptionLabel('secondary') || currentPreset().borderTitle || 'border';
      return {
        step: 'border',
        label: 'Next: choose ' + String(borderLabel).toLowerCase()
      };
    }
    return null;
  }

  function continueFromDock(continuation) {
    if (!continuation || continuation.blocked) {
      return false;
    }

    if (continuation.action === 'apply_crop') {
      applyCrop();
      trackBetaBuilderEvent('crop_completed', { source: 'dock' });
      return true;
    }

    if (state.cropOpen) {
      return false;
    }

    state.open = continuation.step;
    render();
    queueOpenStepIntoView(state.open);
    trackBetaBuilderEvent('dock_step_next_clicked', {
      next_step: continuation.step,
      label: continuation.label
    });
    return true;
  }

  function renderDock() {
    var configured = isDone('photo') && isDone('size') && isDone('paper') && isDone('border') && !cropError();
    var priceKnown = isDone('size') && currentPrice() > 0;
    var ready = configured && priceKnown;
    var unit = currentPrice();
    var lockedQuantity = fixedQuantity();

    if (lockedQuantity) {
      state.qty = lockedQuantity;
    }

    var tier = tierFor(state.qty);
    var off = tier.off;
    var gross = unit * state.qty;
    var net = state.sizeMode === 'custom' ? volumeTotal(unit, state.qty, off) : gross * (1 - off / 100);
    var printPricing = currentPrintPricing();
    if (printPricing) net = printPricing.net;
    var preset = currentPreset();
    var continuation = dockContinuation();

    els.dock.classList.toggle('is-added', state.added);
    els.dock.classList.toggle('is-adding', state.adding);
    els.dock.classList.toggle('has-error', !!state.addError);
    els.volume.hidden = !priceKnown || state.added || !volumeDiscountsAvailable();

    if (!els.volume.hidden) {
      renderVolume(unit, off);
    }

    if (els.qty) {
      els.qty.hidden = !!lockedQuantity || state.added;
      els.qty.style.opacity = priceKnown ? '1' : '0.5';
    }

    if (els.qtyValue) {
      els.qtyValue.textContent = state.qty;
    }

    if (els.price) {
      els.price.textContent = priceKnown ? moneyText(net) : '';
      els.price.hidden = !priceKnown || state.added;
      els.price.classList.toggle('has-discount', (printPricing ? printPricing.savings > 0 : off > 0) && priceKnown);
    }

    if (els.dockSummary) {
      var main = els.dockSummary.querySelector('strong');
      var sub = els.dockSummary.querySelector('span');

      if (state.adding) {
        main.textContent = cartEditKey ? 'Updating cart...' : state.cartWriteSucceeded ? 'Added to cart' : 'Adding to cart...';
        sub.textContent = 'Preparing your print for checkout.';
      } else if (state.addError) {
        main.textContent = cartEditKey ? 'Could not update cart' : 'Could not add to cart';
        sub.textContent = state.addError;
      } else if (state.added) {
        main.textContent = els.addedTitle ? els.addedTitle.textContent : (cartEditKey ? 'Cart updated' : 'Added to cart');
        sub.textContent = els.addedDescription ? els.addedDescription.textContent : 'Your print stays in the cart. Build another print when you are ready.';
      } else if (configured && state.sizeMode !== 'custom' && !selectedPricingVariant()) {
        main.textContent = 'Combination unavailable';
        sub.textContent = 'This size and paper combination could not be matched. Choose the options again.';
      } else if (state.reviewOpen) {
        main.textContent = 'Review print';
        sub.textContent = state.qty + ' x ' + sizeSummary() + ' ' + preset.title + (printPricing ? (printPricing.label ? ' - ' + printPricing.label : '') : (off > 0 ? ' - ' + off + '% volume discount' : ''));
      } else if (state.cropOpen) {
        main.textContent = sizeSummary() + ' ' + preset.title;
        sub.textContent = 'Finish cropping before choosing the next option.';
      } else {
        main.textContent = isDone('size') ? sizeSummary() + ' ' + preset.title : '-';
        sub.textContent = dockDetails(ready);
      }
    }

    if (els.add) {
      els.add.disabled = !state.cartWriteUncertain && ((cartEditKey && !cartEditSession && !state.added) || state.uploading || state.adding || (continuation && continuation.blocked) || (!continuation && !ready && !state.added));
      els.add.textContent = state.cartWriteUncertain ? 'Check cart' : state.uploading ? (batchUploadItems.some(batchUploadIsPending) ? batchUploadText('title') : 'Preparing image...') : state.adding
        ? (cartEditKey ? 'Updating...' : state.cartWriteSucceeded ? 'Added to cart' : 'Adding...')
        : state.added
          ? addedCartLabel()
          : continuation
            ? continuation.label
            : ready && state.reviewOpen
              ? (cartEditKey ? 'Update cart' : 'Add to Cart')
              : ready
                ? 'Review print'
                : 'Upload an image to continue';
    }

    if (els.startOver) {
      els.startOver.hidden = !state.added;
    }
  }

  function renderVolume(unit, off) {
    var next = nextTier(state.qty);
    var need = next ? next.min - state.qty : 0;
    var max = VOLUME_TIERS[VOLUME_TIERS.length - 1].min;
    var fill = Math.min(100, (state.qty / max) * 100);

    els.volumeText.innerHTML = next
      ? 'Add <b>' + need + ' more</b> ' + (need === 1 ? 'print' : 'prints') + ' to unlock <b>' + next.off + '% off</b>'
      : '<b>Top volume discount unlocked</b> - ' + off + '% off every print';

    els.volumeMeter.style.setProperty('--order-volume-fill', fill + '%');
    els.volumeMeter.innerHTML = '<span class="order-app-volume__meter-bar"></span>';

    VOLUME_TIERS.forEach(function (tier) {
      var point = document.createElement('span');
      point.className = 'order-app-volume__point';
      point.style.left = (tier.min / max * 100) + '%';
      point.classList.toggle('is-reached', state.qty >= tier.min);
      point.title = tier.min + ' prints: ' + tier.off + '% off';
      point.setAttribute('aria-hidden', 'true');
      els.volumeMeter.appendChild(point);
    });
  }

  function dockDetails(ready) {
    var missing = [];
    var baseResolution = selectedBaseResolution();
    var cropResolution = selectedCropResolution();
    var priceKnown = currentPrice() > 0;

    if (!isDone('photo')) {
      missing.push('photo');
    }
    if (!isDone('size')) {
      missing.push('size');
    }
    if (!isDone('paper')) {
      missing.push(nextMissingOptionLabel('media') || currentPreset().mediaTitle.toLowerCase());
    }
    if (!isDone('border')) {
      missing.push(nextMissingOptionLabel('secondary') || currentPreset().borderTitle.toLowerCase());
    }

    if (isDone('photo') && (state.size || (parseFloat(state.customW) > 0 && parseFloat(state.customH) > 0)) && !baseResolution) {
      return 'We could not verify this file\'s pixel dimensions. Choose it again or upload a new copy.';
    }

    if (baseResolution && !baseResolution.allowed) {
      return resolutionMessage(baseResolution, 'size');
    }

    if (cropResolution && !cropResolution.allowed) {
      return resolutionMessage(cropResolution, 'crop');
    }

    if (state.sizeMode === 'custom' && state.customPricePending) {
      return 'Calculating custom price...';
    }

    if (state.sizeMode === 'custom' && state.customPriceError) {
      return state.customPriceError;
    }

    if (state.sizeMode === 'custom' && customSizeError()) {
      return customSizeError();
    }

    if (state.sizeMode === 'custom' && isDone('size') && isDone('paper') && isDone('border') && !priceKnown) {
      return 'Custom pricing is required before checkout.';
    }

    if (!ready) {
      return missing.length + ' step' + (missing.length === 1 ? '' : 's') + ' left';
    }

    var details = [];
    selectedOptionsList().forEach(function (option) {
      details.push(option.label || option.name);
    });
    return details.join(' - ');
  }

  function setSizeMode(mode) {
    if (mode === 'custom' && currentPreset().supportsCustom === false) {
      return;
    }

    customSizeInputCrop = null;
    setCropOpenPreservingPosition(false);
    state.sizeMode = mode;
    resetAddState();
    state.cropAutoOpened = false;

    if (mode === 'custom') {
      state.cropRotation = 0;
      state.cropX = 0;
      state.cropY = 0;
      state.size = null;
      state.customRatio = currentCustomRatio();
      scheduleCustomPricePreview();
    } else {
      ensureVisibleSizeSelection();
      resetCustomPricePreview();
    }

    render();
  }

  function syncGalleryWrapSizeHelpState() {
    if (!els.galleryWrapSizeHelp || !els.galleryWrapSizeHelpToggle) {
      return;
    }

    els.galleryWrapSizeHelpToggle.setAttribute('aria-expanded', els.galleryWrapSizeHelp.open ? 'true' : 'false');
  }

  function closeGalleryWrapSizeHelp(returnFocus) {
    if (!els.galleryWrapSizeHelp || !els.galleryWrapSizeHelp.open) {
      return;
    }

    els.galleryWrapSizeHelp.removeAttribute('open');
    syncGalleryWrapSizeHelpState();
    if (returnFocus && els.galleryWrapSizeHelpToggle) {
      els.galleryWrapSizeHelpToggle.focus({ preventScroll: true });
    }
  }

  function handleGalleryWrapSizeHelpOutsideClick(event) {
    if (!els.galleryWrapSizeHelp || !els.galleryWrapSizeHelp.open || els.galleryWrapSizeHelp.contains(event.target)) {
      return;
    }

    closeGalleryWrapSizeHelp(false);
  }

  function handleGalleryWrapSizeHelpKeydown(event) {
    if (event.key !== 'Escape' || !els.galleryWrapSizeHelp || !els.galleryWrapSizeHelp.open) {
      return;
    }

    event.preventDefault();
    closeGalleryWrapSizeHelp(true);
  }

  function handleGalleryWrapSizeHelpToggleKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') {
      return;
    }

    event.preventDefault();
    if (els.galleryWrapSizeHelp.open) {
      closeGalleryWrapSizeHelp(false);
    } else {
      els.galleryWrapSizeHelp.setAttribute('open', '');
      syncGalleryWrapSizeHelpState();
    }
  }

  function findByName(items, name) {
    for (var i = 0; i < items.length; i += 1) {
      if (items[i].name === name || items[i].label === name) {
        return items[i];
      }
    }
    return null;
  }

  function findPhotoById(id) {
    var targetId = String(id || '');

    for (var i = 0; i < library.length; i += 1) {
      if (photoId(library[i]) === targetId) {
        return library[i];
      }
    }

    return null;
  }

  function findSize(label, expectedBucket) {
    var sizes = expectedBucket ? allCurrentSizes().filter(function (size) {
      return size.bucket === expectedBucket;
    }) : currentSizes();
    var target = String(label || '');

    for (var i = 0; i < sizes.length; i += 1) {
      if (sizeSelectionKey(sizes[i]) === target || sizes[i].label === target || sizeDisplayLabel(sizes[i]) === target) {
        return sizes[i];
      }
    }
    return null;
  }

  function syncCropPositionControl() {
    if (!els.previewSheet || !els.cropToolbar) return;
    var active = state.cropOpen && cropReady();
    var control = els.cropToolbar.querySelector('[data-order-crop-position]');
    if (!control) {
      control = document.createElement('button');
      control.type = 'button';
      control.textContent = 'Position image';
      control.setAttribute('data-order-crop-position', '');
      control.addEventListener('click', function () {
        if (state.cropOpen && cropReady()) els.previewSheet.focus({ preventScroll: true });
      });
      els.cropToolbar.insertBefore(control, els.cropToolbar.firstChild);
    }
    control.hidden = !active;
    els.previewSheet.tabIndex = active ? 0 : -1;
    if (active) {
      els.previewSheet.setAttribute('role', 'group');
      els.previewSheet.setAttribute('aria-label', 'Crop position');
      var help = els.cropToolbar.querySelector('.order-app-crop-toolbar__note');
      if (help) {
        help.id = help.id || (root.id || 'order-app') + '-crop-position-help';
        help.textContent = 'The outlined frame will print; artwork outside it is trimmed. Drag to move, or choose Position image and use arrow keys. Hold Shift for larger moves.';
        els.previewSheet.setAttribute('aria-describedby', help.id);
        control.setAttribute('aria-describedby', help.id);
      }
    } else {
      els.previewSheet.removeAttribute('role');
      els.previewSheet.removeAttribute('aria-label');
      els.previewSheet.removeAttribute('aria-describedby');
    }
  }

  function handleCropPositionKeydown(event) {
    if (!state.cropOpen || !cropReady() || event.target !== els.previewSheet ||
        event.altKey || event.ctrlKey || event.metaKey) return;
    var direction = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] }[event.key];
    if (!direction) return;
    event.preventDefault();
    var distance = event.shiftKey ? 10 : 1;
    clampActiveCrop();
    state.cropX += direction[0] * distance;
    state.cropY += direction[1] * distance;
    resetAddState();
    state.cropApplied = true;
    clampActiveCrop();
    renderPreview();
    updateCropRecenterControl();
    persistDraft();
  }

  function startCropDrag(event) {
    if (!state.cropOpen || !cropReady()) {
      return;
    }

    if (event.button !== undefined && event.button !== 0) {
      return;
    }

    clampActiveCrop();
    cropDrag = {
      pointerId: event.pointerId,
      x: event.clientX,
      y: event.clientY,
      cropX: state.cropX,
      cropY: state.cropY
    };

    if (event.currentTarget && event.currentTarget.setPointerCapture) {
      event.currentTarget.setPointerCapture(event.pointerId);
    }

    if (els.previewStage) {
      els.previewStage.classList.add('is-dragging');
    }

    event.preventDefault();
  }

  function moveCropDrag(event) {
    if (!cropDrag || event.pointerId !== cropDrag.pointerId) {
      return;
    }

    var fitData = activeRatio();
    var previewFit = previewFitForRatio(fitData.ratio);

    syncCropPositionToFit(previewFit.imageFit);
    if (!cropDrag) return;
    state.cropX = cropDrag.cropX + event.clientX - cropDrag.x;
    state.cropY = cropDrag.cropY + event.clientY - cropDrag.y;
    resetAddState();
    state.cropApplied = true;
    clampCropToFit(previewFit.fit, previewFit.insetsPx);
    renderPreview();
    updateCropRecenterControl();
    event.preventDefault();
  }

  function endCropDrag(event) {
    if (!cropDrag || event.pointerId !== cropDrag.pointerId) {
      return;
    }

    cropDrag = null;

    if (els.previewStage) {
      els.previewStage.classList.remove('is-dragging');
    }

    renderPreview();
    updateCropRecenterControl();
    persistDraft();
  }

  root.addEventListener('click', async function (event) {
    if (state.adding) {
      event.preventDefault();
      return;
    }
    var target = event.target;
    var productButton = target.closest('[data-order-product-option]');
    var productResource = target.closest('[data-order-product-resource]');
    var productAssistantAnswer = target.closest('[data-order-assistant-answer]');
    var stepToggle = target.closest('[data-order-step-toggle]');
    var photoTab = target.closest('[data-order-photo-tab]');
    var sizeMode = target.closest('[data-order-size-mode-option]');
    var sizeButton = target.closest('[data-order-size]');
    var sizeNext = target.closest('[data-order-size-next]');
    var paperNext = target.closest('[data-order-paper-next]');
    var borderNext = target.closest('[data-order-border-next]');
    var optionButton = target.closest('[data-order-option-kind]');
    var libraryPhoto = target.closest('[data-order-library-photo]');
    var batchRetry = target.closest('[data-order-batch-retry]');
    var batchDismiss = target.closest('[data-order-batch-dismiss]');
    var cropStart = target.closest('[data-order-crop-start]') || target.closest('[data-order-crop-toggle]');
    var cropDone = target.closest('[data-order-crop-done]') || target.closest('[data-order-crop-apply]');

    if (target.closest('[data-order-classic-builder]')) {
      event.preventDefault();
      openClassicSwitch();
      return;
    }

    if (target.closest('[data-order-classic-confirm]')) {
      confirmClassicSwitch(event);
      return;
    }

    if (target.closest('[data-order-classic-cancel]')) {
      event.preventDefault();
      closeClassicSwitch('button');
      return;
    }

    if (target.closest('[data-order-review-zoom-close]')) {
      setReviewZoom(false, 'button');
      return;
    }

    if (target.closest('[data-order-review-zoom]')) {
      setReviewZoom(true, 'button');
      return;
    }

    if (target.closest('[data-order-review-zoom-fit]')) {
      setReviewInspectZoom(REVIEW_INSPECT_MIN_ZOOM, 'fit');
      return;
    }

    if (target.closest('[data-order-review-zoom-out]')) {
      adjustReviewInspectZoom(-REVIEW_INSPECT_ZOOM_STEP, 'button');
      return;
    }

    if (target.closest('[data-order-review-zoom-in]')) {
      adjustReviewInspectZoom(REVIEW_INSPECT_ZOOM_STEP, 'button');
      return;
    }

    if (target.closest('[data-order-review-back]')) {
      exitReviewMode('button');
      return;
    }

    if (state.reviewOpen && !state.added && !state.reviewZoom && target.closest('[data-order-preview-stage]') && !target.closest('button')) {
      setReviewZoom(true, 'preview');
      return;
    }

    if (target.closest('[data-order-product-edit]')) {
      if (els.productPicker) {
        setProductPickerOpen(els.productPicker.hidden);
      }
      return;
    }

    if (productAssistantAnswer) {
      answerProductAssistant(
        productAssistantAnswer.getAttribute('data-assistant-kind'),
        productAssistantAnswer.getAttribute('data-assistant-value')
      );
      return;
    }

    if (target.closest('[data-order-assistant-back]')) {
      backProductAssistant();
      return;
    }

    if (target.closest('[data-order-assistant-reset]')) {
      resetProductAssistant();
      return;
    }

    if (target.closest('[data-order-assistant-browse]')) {
      browseAllProducts();
      return;
    }

    if (productResource) {
      trackBetaBuilderEvent('product_resource_clicked', {
        resource: productResource.getAttribute('data-product-resource'),
        destination: productResource.getAttribute('href')
      });
      return;
    }

    if (productButton) {
      var assistantHandle = canonicalHandle(productButton.getAttribute('data-product-handle'));
      var assistantRank = productAssistantRecommendation().handles.indexOf(assistantHandle) + 1;
      var assistantSelection = !state.productSelectionPending ? 'direct' : state.productAssistantBrowseAll
        ? 'browse_all' : assistantRank > 0 ? 'recommended' : 'other';
      var assistantSelectionDetails = assistantTelemetry ? Object.assign(assistantTelemetry.snapshot(state), {
        product_handle: assistantHandle, assistant_selection: assistantSelection, assistant_rank: assistantRank
      }) : {};
      setProduct(productButton.getAttribute('data-product-handle'), true);
      if (assistantTelemetry && !state.productSelectionPending && canonicalHandle(state.productHandle) === assistantHandle) {
        assistantTelemetry.action('product_assistant_product_selected', state, assistantSelectionDetails);
      }
      trackBetaBuilderEvent('product_selected', {
        product_handle: productButton.getAttribute('data-product-handle')
      });
      setProductPickerOpen(false);
      return;
    }

    if (stepToggle) {
      setOpen(stepToggle.getAttribute('data-order-step-toggle'));
      return;
    }

    if (photoTab) {
      if (state.photo) {
        return;
      }
      state.photoTab = photoTab.getAttribute('data-order-photo-tab');
      renderPhoto();
      return;
    }

    if (target.closest('[data-order-library-selection-retry]')) {
      event.preventDefault();
      await retryLibrarySelection();
      return;
    }

    if (target.closest('[data-order-library-retry]')) {
      cancelLibraryDeepLink();
      await customerLibraryPager().retry();
      return;
    }

    if (target.closest('[data-order-library-claim-add]')) {
      event.preventDefault();
      await claimGuestUploads();
      return;
    }

    if (target.closest('[data-order-library-claim-clear]')) {
      event.preventDefault();
      await clearGuestUploads();
      return;
    }

    if (batchRetry) {
      event.preventDefault();
      retryBatchUpload(batchRetry.getAttribute('data-order-batch-retry'));
      return;
    }

    if (batchDismiss) {
      event.preventDefault();
      dismissBatchUpload(batchDismiss.getAttribute('data-order-batch-dismiss'));
      return;
    }

    if (target.closest('[data-order-upload-trigger]')) {
      if (state.uploading) {
        return;
      }
      state.uploadTriggerMethod = 'upload_dropzone_click';
      if (els.fileInput) {
        els.fileInput.click();
      }
      return;
    }

    if (libraryPhoto) {
      var picked = findPhotoById(libraryPhoto.getAttribute('data-order-library-photo'));
      if (picked) {
        await selectLibraryPhoto(picked, 'account_image_library');
      }
      return;
    }

    if (target.closest('[data-order-photo-cancel-replace]')) {
      if (librarySelectionBlocked()) return;
      state.choosingReplacement = false;
      state.uploadError = '';
      state.uploadHelpLink = '';
      render();
      return;
    }

    if (target.closest('[data-order-photo-replace]')) {
      if (librarySelectionBlocked()) return;
      state.choosingReplacement = true;
      state.open = 'photo';
      render();
      queueOpenStepIntoView('photo');
      trackBetaBuilderEvent('photo_replacement_started');
      return;
    }

    if (target.closest('[data-order-crop-rotate]')) {
      rotateCrop();
      return;
    }

    if (cropStart) {
      openCropTool();
      trackBetaBuilderEvent('crop_started', { source: 'crop_button' });
      return;
    }

    if (cropDone) {
      applyCrop();
      trackBetaBuilderEvent('crop_completed');
      return;
    }

    if (target.closest('[data-order-crop-recenter]')) {
      recenterCrop();
      return;
    }

    if (target.closest('[data-order-zoom-out]')) {
      zoomBy(-0.05);
      return;
    }

    if (target.closest('[data-order-zoom-in]')) {
      zoomBy(0.05);
      return;
    }

    if (sizeMode) {
      setSizeMode(sizeMode.getAttribute('data-order-size-mode-option'));
      return;
    }

    if (sizeButton) {
      if (sizeButton.disabled || sizeButton.getAttribute('aria-disabled') === 'true') {
        trackBetaBuilderEvent('size_selection_blocked', {
          image_size: sizeButton.getAttribute('data-order-size'),
          error_message: 'Size was disabled for the selected upload.'
        });
        return;
      }
      var selectedSize = findSize(sizeButton.getAttribute('data-order-size'));
      var selectedResolution = resolutionForSize(selectedSize);
      if (selectedSize) {
        var previousRatio = state.committedSizeRatio;
        var cropPosition = captureNormalizedCropPosition();
        state.size = selectedSize;
        state.sizeMode = 'standard';
        pruneSelectedOptions();
        resetAddState();
        resetCustomPricePreview();
        commitSizeRatio(previousRatio, selectedPrintRatio(), cropPosition, 'standard_size');
        renderOptions();
        render();
        trackBetaBuilderEvent('size_selected', {
          image_size: selectedSize.label || selectedSize.key || sizeButton.getAttribute('data-order-size'),
          output_ppi: selectedResolution && selectedResolution.ppi
        });
      }
      return;
    }

    if (target.closest('[data-order-custom-apply]')) {
      if (setCustomSize(state.customW, state.customH, 'custom_apply')) {
        render();
      }
      return;
    }

    if (target.closest('[data-order-resolution-use-size]')) {
      useSuggestedResolutionSize();
      return;
    }

    if (sizeNext) {
      var sizeContinuation;

      if (!isDone('size')) {
        render();
        return;
      }
      if (state.cropOpen) {
        applyCrop();
        trackBetaBuilderEvent('crop_completed', { source: 'size_next' });
        return;
      }

      sizeContinuation = dockContinuation();
      if (!sizeContinuation) {
        enterReviewMode('size_next');
      } else if (sizeContinuation.blocked) {
        render();
        return;
      } else {
        state.open = sizeContinuation.step;
        render();
        queueOpenStepIntoView(state.open);
      }

      trackBetaBuilderEvent('size_next_clicked', {
        image_size: sizeSummary(),
        size_mode: state.sizeMode,
        next_step: sizeContinuation ? sizeContinuation.label : 'Review print'
      });
      return;
    }

    if (paperNext) {
      if (!isDone('paper')) {
        render();
        return;
      }

      if (stepIsAvailable('border') && !isDone('border')) {
        state.open = 'border';
        render();
        queueOpenStepIntoView(state.open);
        trackBetaBuilderEvent('paper_next_clicked', {
          next_step: nextMissingOptionLabel('secondary') || currentPreset().borderTitle || 'Border'
        });
      } else {
        enterReviewMode('paper_next');
        trackBetaBuilderEvent('paper_next_clicked', {
          next_step: 'Review print'
        });
      }
      return;
    }

    if (borderNext) {
      if (!isDone('border')) {
        render();
        return;
      }

      enterReviewMode('border_next');
      trackBetaBuilderEvent('border_next_clicked', {
        next_step: 'Review print'
      });
      return;
    }

    if (target.closest('[data-order-custom-actual]')) {
      setActualSize();
      return;
    }

    if (target.closest('[data-order-custom-swap]')) {
      swapCustomSize();
      return;
    }

    if (target.closest('[data-order-custom-lock]')) {
      toggleCustomLock();
      return;
    }

    if (target.closest('[data-order-crop-cancel]')) {
      closeCropTool();
      return;
    }

    if (optionButton) {
      var optionKindValue = optionButton.getAttribute('data-order-option-kind');
      var optionValue = optionButton.getAttribute('data-order-option-value');
      var previousOptionRatio = selectedPrintRatio();
      var previousOptionCropPosition = captureNormalizedCropPosition();
      var optionGroup = currentOptionGroups().find(function (group) {
        return group.kind === optionKindValue;
      });
      var option = optionGroup && optionGroup.values.find(function (entry) {
        return normalizeOptionText(entry.label || entry.name) === normalizeOptionText(optionValue);
      });

      if (optionGroup && option) {
        setSelectedOption(optionKindValue, option);
        if (isFramedPrintProduct() && optionKindValue === 'matting_package') {
          commitSizeRatio(previousOptionRatio, selectedPrintRatio(), previousOptionCropPosition, 'matting_type');
        }
        resetAddState();
        scheduleCustomPricePreview();
        renderOptions();
        render();
        trackBetaBuilderEvent(optionKindValue === 'media' ? 'media_selected' : 'option_selected', {
          option_name: optionGroup.name || optionKindValue,
          option_value: option.label || option.name || optionValue,
          media: optionKindValue === 'media' ? option.label || option.name || optionValue : '',
          border: optionKindValue !== 'media' ? option.label || option.name || optionValue : ''
        });
      }
      return;
    }

    if (target.closest('[data-order-qty-minus]')) {
      if (isDone('size') && !fixedQuantity()) {
        var previousMinusQty = state.qty;
        state.qty = Math.max(1, state.qty - 1);
        resetAddState();
        render();
        if (state.qty !== previousMinusQty) {
          trackBetaBuilderEvent('quantity_changed', {
            previous_quantity: previousMinusQty,
            next_quantity: state.qty,
            quantity: state.qty,
            input_method: 'minus'
          });
        }
      }
      return;
    }

    if (target.closest('[data-order-qty-plus]')) {
      if (isDone('size') && !fixedQuantity()) {
        var previousPlusQty = state.qty;
        state.qty += 1;
        resetAddState();
        render();
        trackBetaBuilderEvent('quantity_changed', {
          previous_quantity: previousPlusQty,
          next_quantity: state.qty,
          quantity: state.qty,
          input_method: 'plus'
        });
      }
      return;
    }

    if (target.closest('[data-order-added-cart]')) {
      trackBetaBuilderEvent('view_cart_clicked', { destination_path: '/cart', source: 'post_add_confirmation' });
      return;
    }

    if (target.closest('[data-order-start-over]') || target.closest('[data-order-add-another]')) {
      startOverAfterAdd();
      return;
    }

    if (target.closest('[data-order-add]')) {
      if (state.cartWriteUncertain) { window.location.href = (bootstrap.routes && bootstrap.routes.cart) || '/cart'; return; }
      if (state.uploading) return;
      if (state.added) {
        trackBetaBuilderEvent('view_cart_clicked', { destination_path: '/cart' });
        window.location.href = (bootstrap.routes && bootstrap.routes.cart) || '/cart';
        return;
      }
      if (continueFromDock(dockContinuation())) {
        return;
      }
      if (state.reviewOpen && reviewReady()) {
        await addConfiguredItemToCart();
        renderReviewState();
        return;
      }
      if (reviewReady()) {
        enterReviewMode('dock_review');
      }
    }
  });

  if (els.photoTabsGroup) {
    els.photoTabsGroup.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
        return;
      }

      var currentIndex = els.photoTabs.indexOf(document.activeElement);
      if (currentIndex < 0) {
        return;
      }

      event.preventDefault();
      var direction = event.key === 'ArrowRight' ? 1 : -1;
      var nextIndex = (currentIndex + direction + els.photoTabs.length) % els.photoTabs.length;
      var nextTab = els.photoTabs[nextIndex];
      state.photoTab = nextTab.getAttribute('data-order-photo-tab');
      renderPhoto();
      nextTab.focus();
    });
  }

  if (els.librarySearch) {
    els.librarySearch.addEventListener('input', function (event) {
      state.librarySearch = event.target.value;
      state.libraryPage = 0;
      cancelLibraryDeepLink();
      if (libraryCustomerId()) customerLibraryPager().search(state.librarySearch);
      else renderLibrary();
    });
  }

  if (els.librarySort) {
    els.librarySort.addEventListener('change', function (event) {
      state.librarySort = window.StackhouseLibraryPager.normalizeSort(event.target.value);
      state.libraryPage = 0;
      cancelLibraryDeepLink();
      if (libraryCustomerId()) customerLibraryPager().load(state.librarySearch, 0);
    });
  }

  if (els.libraryPrev) {
    els.libraryPrev.addEventListener('click', function () {
      cancelLibraryDeepLink();
      customerLibraryPager().load(state.librarySearch, Math.max(0, state.libraryPage - 1));
    });
  }

  if (els.libraryNext) {
    els.libraryNext.addEventListener('click', function () {
      cancelLibraryDeepLink();
      customerLibraryPager().load(state.librarySearch, state.libraryPage + 1);
    });
  }

  if (els.fileInput) {
    els.fileInput.addEventListener('click', function () {
      trackBetaBuilderEvent('file_picker_opened', {
        input_method: state.uploadTriggerMethod || 'file_input'
      });
    });
    els.fileInput.addEventListener('cancel', function () {
      trackBetaBuilderEvent('file_picker_cancelled', {
        input_method: state.uploadTriggerMethod || 'file_input'
      });
      state.uploadTriggerMethod = '';
    });
    els.fileInput.addEventListener('change', function (event) {
      if (state.uploading) return;
      var files = Array.prototype.slice.call(event.target.files || []);
      var method = state.uploadTriggerMethod || 'file_input';
      event.target.value = '';

      if (files.length > 1) {
        queueBatchUploadFiles(files, method);
      } else if (files.length === 1) {
        clearPreviousBatchUploadItems();
        uploadSelectedFile(files[0], method);
      } else {
        trackBetaBuilderEvent('file_picker_cancelled', {
          input_method: method
        });
      }
      state.uploadTriggerMethod = '';
    });
  }

  if (els.uploadRetry) {
    els.uploadRetry.addEventListener('click', retryFailedUploadProcessing);
  }

  if (els.uploadTrigger) {
    ['dragenter', 'dragover'].forEach(function (eventName) {
      els.uploadTrigger.addEventListener(eventName, function (event) {
        event.preventDefault();
        els.uploadTrigger.classList.add('is-dragging');
      });
    });

    ['dragleave', 'drop'].forEach(function (eventName) {
      els.uploadTrigger.addEventListener(eventName, function () {
        els.uploadTrigger.classList.remove('is-dragging');
      });
    });

    els.uploadTrigger.addEventListener('drop', function (event) {
      event.preventDefault();
      if (state.uploading) return;
      var files = Array.prototype.slice.call(event.dataTransfer && event.dataTransfer.files || []);

      if (files.length > 1) {
        queueBatchUploadFiles(files, 'drag_drop');
      } else if (files.length === 1) {
        clearPreviousBatchUploadItems();
        uploadSelectedFile(files[0], 'drag_drop');
      }
    });
  }

  if (els.customWidth) {
    els.customWidth.addEventListener('input', function (event) {
      updateCustomSizeInput('width', event.target.value);
    });
  }

  if (els.customHeight) {
    els.customHeight.addEventListener('input', function (event) {
      updateCustomSizeInput('height', event.target.value);
    });
  }

  if (els.zoom) {
    els.zoom.addEventListener('input', function (event) {
      setCropZoom(event.target.value);
    });
  }

  if (els.toolbarZoom) {
    els.toolbarZoom.addEventListener('input', function (event) {
      setCropZoom(event.target.value);
    });
  }

  if (els.reviewZoomScale) {
    els.reviewZoomScale.addEventListener('input', function (event) {
      setReviewInspectZoom(event.target.value, 'slider');
    });
  }

  if (els.previewSheet) {
    els.previewSheet.addEventListener('keydown', handleCropPositionKeydown);
    els.previewSheet.addEventListener('pointerdown', startCropDrag);
    window.addEventListener('pointermove', moveCropDrag);
    window.addEventListener('pointerup', endCropDrag);
    window.addEventListener('pointercancel', endCropDrag);
  }

  els.previewViewButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      setPreviewView(button.getAttribute('data-order-preview-view'));
    });
  });

  if (els.previewStage) {
    els.previewStage.addEventListener('wheel', function (event) {
      if (state.reviewOpen && state.reviewZoom && (event.ctrlKey || event.metaKey)) {
        event.preventDefault();
        adjustReviewInspectZoom(event.deltaY > 0 ? -REVIEW_INSPECT_ZOOM_STEP : REVIEW_INSPECT_ZOOM_STEP, 'wheel');
      }
    }, { passive: false });
  }

  if (els.galleryWrapSizeHelp) {
    els.galleryWrapSizeHelp.addEventListener('toggle', syncGalleryWrapSizeHelpState);
    if (els.galleryWrapSizeHelpToggle) {
      els.galleryWrapSizeHelpToggle.addEventListener('keydown', handleGalleryWrapSizeHelpToggleKeydown);
    }
    document.addEventListener('click', handleGalleryWrapSizeHelpOutsideClick);
    window.addEventListener('keydown', handleGalleryWrapSizeHelpKeydown);
  }

  root.addEventListener('pointerdown', function () { if (restoringDraft) draftRestoreCancelled = true; }, true);
  root.addEventListener('keydown', function () { if (restoringDraft) draftRestoreCancelled = true; }, true);
  root.addEventListener('focusin', revealMobileFocusedControl);
  window.addEventListener('pagehide', persistDraft);
  window.addEventListener('resize', function () {
    renderPreview(true);
  });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', function () {
      renderPreview(true);
    });
  }
  window.addEventListener('scroll', scheduleWorkspaceLayout, { passive: true });
  window.addEventListener('keydown', handleClassicSwitchKeydown);
  window.addEventListener('keydown', handleReviewKeydown);

  setupFloatingWidgetSuppression();
  hydrateGuestLibrary();
  library = mergeLibraryPhotos(guestLibraryPhotos);

  if (!productIsBuilderReady(productByHandle(state.productHandle))) {
    state.productHandle = firstBuilderReadyHandle();
    state.productSelectionPending = true;
  } else if (requestedSizeKey) {
    state.size = findSize(requestedSizeKey);
    state.committedSizeRatio = state.size ? normalizePrintRatio(state.size.ratio) : null;
  }

  renderOptions();
  render();
  if (window.StackhouseUploadPolicy) {
    window.StackhouseUploadPolicy.ready().then(function (policy) {
      applyBuilderUploadPolicy(policy);
      if (policy.transport !== 'upload_v2' && uploadV2Enabled() && customerId() && window.StackhouseUploadV2) {
        return window.StackhouseUploadV2.prepare({ apiBaseUrl: apiBaseUrl(), uploadSurface: 'order_builder' })
          .then(function (session) { applyBuilderUploadPolicy(session.policy); });
      }
    }).catch(function () { /* The upload action shows the policy-loading error. */ });
  }
  scheduleWorkspaceLayout();
  if (cartEditKey) restoreCartRecipe();
  else restoreDraft();
  trackBetaBuilderEvent('builder_opened', {
    input_method: requestedParameters.get('source') || 'direct'
  });
  if (isTestPrintProduct()) {
    trackBetaBuilderEvent('test_print_builder_start', {
      test_print: 'Yes',
      input_method: requestedParameters.get('source') || 'direct'
    });
  }

  var publicApi = {
    bootstrap: bootstrap,
    getState: function () {
      return Object.assign({}, state);
    },
    setProduct: setProduct,
    setPhoto: setPhoto
  };

  root.StackhouseOrderApp = publicApi;

  try {
    window.StackhouseOrderApp = publicApi;
  } catch (error) {
    root.setAttribute('data-order-app-api-fallback', 'root');
  }
})();
